//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>

// NOTE:JS: 27.01.2023
// This thing generated with error in line 25138 (mapping trust structure dto from json), 17520 (lack of specialty dto) and 21034 (lack of urgency field in waiting list dto), had to manually fix

//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';

import { Observable } from 'rxjs/Observable';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + '/api/services/app/Account/IsTenantAvailable';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processIsTenantAvailable(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processIsTenantAvailable(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<IsTenantAvailableOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<IsTenantAvailableOutput>;
            });
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = IsTenantAvailableOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<IsTenantAvailableOutput>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + '/api/services/app/Account/Register';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processRegister(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processRegister(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<RegisterOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<RegisterOutput>;
            });
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RegisterOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<RegisterOutput>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendPasswordResetCode(body: SendPasswordResetCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Account/SendPasswordResetCode';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processSendPasswordResetCode(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processSendPasswordResetCode(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processSendPasswordResetCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    resetPassword(body: ResetPasswordInput | undefined): Observable<ResetPasswordOutput> {
        let url_ = this.baseUrl + '/api/services/app/Account/ResetPassword';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processResetPassword(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processResetPassword(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<ResetPasswordOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<ResetPasswordOutput>;
            });
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ResetPasswordOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<ResetPasswordOutput>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendEmailActivationLink(body: SendEmailActivationLinkInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Account/SendEmailActivationLink';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processSendEmailActivationLink(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processSendEmailActivationLink(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processSendEmailActivationLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    activateEmail(body: ActivateEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Account/ActivateEmail';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processActivateEmail(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processActivateEmail(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processActivateEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    impersonate(body: ImpersonateInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + '/api/services/app/Account/Impersonate';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processImpersonate(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processImpersonate(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<ImpersonateOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<ImpersonateOutput>;
            });
    }

    protected processImpersonate(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ImpersonateOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<ImpersonateOutput>(null as any);
    }

    /**
     * @return Success
     */
    backToImpersonator(): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + '/api/services/app/Account/BackToImpersonator';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processBackToImpersonator(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processBackToImpersonator(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<ImpersonateOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<ImpersonateOutput>;
            });
    }

    protected processBackToImpersonator(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ImpersonateOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<ImpersonateOutput>(null as any);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param userName (optional)
     * @param serviceName (optional)
     * @param methodName (optional)
     * @param browserInfo (optional)
     * @param hasException (optional)
     * @param minExecutionDuration (optional)
     * @param maxExecutionDuration (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getAuditLogs(
        startDate: moment.Moment | undefined,
        endDate: moment.Moment | undefined,
        userName: string | undefined,
        serviceName: string | undefined,
        methodName: string | undefined,
        browserInfo: string | undefined,
        hasException: boolean | undefined,
        minExecutionDuration: number | undefined,
        maxExecutionDuration: number | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<AuditLogListDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/AuditLog/GetAuditLogs?';
        if (startDate === null) throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined) url_ += 'StartDate=' + encodeURIComponent(startDate ? '' + startDate.toISOString() : '') + '&';
        if (endDate === null) throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined) url_ += 'EndDate=' + encodeURIComponent(endDate ? '' + endDate.toISOString() : '') + '&';
        if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined) url_ += 'UserName=' + encodeURIComponent('' + userName) + '&';
        if (serviceName === null) throw new Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined) url_ += 'ServiceName=' + encodeURIComponent('' + serviceName) + '&';
        if (methodName === null) throw new Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined) url_ += 'MethodName=' + encodeURIComponent('' + methodName) + '&';
        if (browserInfo === null) throw new Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined) url_ += 'BrowserInfo=' + encodeURIComponent('' + browserInfo) + '&';
        if (hasException === null) throw new Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined) url_ += 'HasException=' + encodeURIComponent('' + hasException) + '&';
        if (minExecutionDuration === null) throw new Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined) url_ += 'MinExecutionDuration=' + encodeURIComponent('' + minExecutionDuration) + '&';
        if (maxExecutionDuration === null) throw new Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined) url_ += 'MaxExecutionDuration=' + encodeURIComponent('' + maxExecutionDuration) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetAuditLogs(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetAuditLogs(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<AuditLogListDtoPagedResultDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<AuditLogListDtoPagedResultDto>;
            });
    }

    protected processGetAuditLogs(response: HttpResponseBase): Observable<AuditLogListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AuditLogListDtoPagedResultDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<AuditLogListDtoPagedResultDto>(null as any);
    }

    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param userName (optional)
     * @param serviceName (optional)
     * @param methodName (optional)
     * @param browserInfo (optional)
     * @param hasException (optional)
     * @param minExecutionDuration (optional)
     * @param maxExecutionDuration (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getAuditLogsToExcel(
        startDate: moment.Moment | undefined,
        endDate: moment.Moment | undefined,
        userName: string | undefined,
        serviceName: string | undefined,
        methodName: string | undefined,
        browserInfo: string | undefined,
        hasException: boolean | undefined,
        minExecutionDuration: number | undefined,
        maxExecutionDuration: number | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/AuditLog/GetAuditLogsToExcel?';
        if (startDate === null) throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined) url_ += 'StartDate=' + encodeURIComponent(startDate ? '' + startDate.toISOString() : '') + '&';
        if (endDate === null) throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined) url_ += 'EndDate=' + encodeURIComponent(endDate ? '' + endDate.toISOString() : '') + '&';
        if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined) url_ += 'UserName=' + encodeURIComponent('' + userName) + '&';
        if (serviceName === null) throw new Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined) url_ += 'ServiceName=' + encodeURIComponent('' + serviceName) + '&';
        if (methodName === null) throw new Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined) url_ += 'MethodName=' + encodeURIComponent('' + methodName) + '&';
        if (browserInfo === null) throw new Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined) url_ += 'BrowserInfo=' + encodeURIComponent('' + browserInfo) + '&';
        if (hasException === null) throw new Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined) url_ += 'HasException=' + encodeURIComponent('' + hasException) + '&';
        if (minExecutionDuration === null) throw new Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined) url_ += 'MinExecutionDuration=' + encodeURIComponent('' + minExecutionDuration) + '&';
        if (maxExecutionDuration === null) throw new Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined) url_ += 'MaxExecutionDuration=' + encodeURIComponent('' + maxExecutionDuration) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetAuditLogsToExcel(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetAuditLogsToExcel(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<FileDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<FileDto>;
            });
    }

    protected processGetAuditLogsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(null as any);
    }
}

@Injectable()
export class CachingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @return Success
     */
    getAllCaches(): Observable<CacheDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Caching/GetAllCaches';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetAllCaches(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetAllCaches(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<CacheDtoListResultDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<CacheDtoListResultDto>;
            });
    }

    protected processGetAllCaches(response: HttpResponseBase): Observable<CacheDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CacheDtoListResultDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<CacheDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    clearCache(body: StringEntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Caching/ClearCache';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processClearCache(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processClearCache(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processClearCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @return Success
     */
    clearAllCaches(): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Caching/ClearAllCaches';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({})
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processClearAllCaches(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processClearAllCaches(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processClearAllCaches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }
}

@Injectable()
export class ChatServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @return Success
     */
    getUserChatFriendsWithSettings(): Observable<GetUserChatFriendsWithSettingsOutput> {
        let url_ = this.baseUrl + '/api/services/app/Chat/GetUserChatFriendsWithSettings';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetUserChatFriendsWithSettings(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetUserChatFriendsWithSettings(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<GetUserChatFriendsWithSettingsOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<GetUserChatFriendsWithSettingsOutput>;
            });
    }

    protected processGetUserChatFriendsWithSettings(response: HttpResponseBase): Observable<GetUserChatFriendsWithSettingsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetUserChatFriendsWithSettingsOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<GetUserChatFriendsWithSettingsOutput>(null as any);
    }

    /**
     * @param tenantId (optional)
     * @param userId (optional)
     * @param minMessageId (optional)
     * @return Success
     */
    getUserChatMessages(
        tenantId: number | undefined,
        userId: number | undefined,
        minMessageId: number | undefined
    ): Observable<ChatMessageDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Chat/GetUserChatMessages?';
        if (tenantId === null) throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined) url_ += 'TenantId=' + encodeURIComponent('' + tenantId) + '&';
        if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined) url_ += 'UserId=' + encodeURIComponent('' + userId) + '&';
        if (minMessageId === null) throw new Error("The parameter 'minMessageId' cannot be null.");
        else if (minMessageId !== undefined) url_ += 'MinMessageId=' + encodeURIComponent('' + minMessageId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetUserChatMessages(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetUserChatMessages(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<ChatMessageDtoListResultDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<ChatMessageDtoListResultDto>;
            });
    }

    protected processGetUserChatMessages(response: HttpResponseBase): Observable<ChatMessageDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ChatMessageDtoListResultDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<ChatMessageDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    markAllUnreadMessagesOfUserAsRead(body: MarkAllUnreadMessagesOfUserAsReadInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Chat/MarkAllUnreadMessagesOfUserAsRead';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processMarkAllUnreadMessagesOfUserAsRead(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processMarkAllUnreadMessagesOfUserAsRead(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processMarkAllUnreadMessagesOfUserAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }
}

@Injectable()
export class CommentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @param sessionId (optional)
     * @return Success
     */
    getCommentSection(sessionId: string | undefined): Observable<CommentSectionDto> {
        let url_ = this.baseUrl + '/api/services/app/Comment/GetCommentSection?';
        if (sessionId === null) throw new Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined) url_ += 'sessionId=' + encodeURIComponent('' + sessionId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetCommentSection(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetCommentSection(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<CommentSectionDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<CommentSectionDto>;
            });
    }

    protected processGetCommentSection(response: HttpResponseBase): Observable<CommentSectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CommentSectionDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<CommentSectionDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addComment(body: NewCommentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Comment/AddComment';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processAddComment(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processAddComment(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processAddComment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }
}

@Injectable()
export class CommonLookupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @param onlyFreeItems (optional)
     * @return Success
     */
    getEditionsForCombobox(onlyFreeItems: boolean | undefined): Observable<SubscribableEditionComboboxItemDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/CommonLookup/GetEditionsForCombobox?';
        if (onlyFreeItems === null) throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined) url_ += 'onlyFreeItems=' + encodeURIComponent('' + onlyFreeItems) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetEditionsForCombobox(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetEditionsForCombobox(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<SubscribableEditionComboboxItemDtoListResultDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<SubscribableEditionComboboxItemDtoListResultDto>;
            });
    }

    protected processGetEditionsForCombobox(response: HttpResponseBase): Observable<SubscribableEditionComboboxItemDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SubscribableEditionComboboxItemDtoListResultDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<SubscribableEditionComboboxItemDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    findUsers(body: FindUsersInput | undefined): Observable<NameValueDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/CommonLookup/FindUsers';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processFindUsers(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processFindUsers(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<NameValueDtoPagedResultDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<NameValueDtoPagedResultDto>;
            });
    }

    protected processFindUsers(response: HttpResponseBase): Observable<NameValueDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NameValueDtoPagedResultDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<NameValueDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getDefaultEditionName(): Observable<GetDefaultEditionNameOutput> {
        let url_ = this.baseUrl + '/api/services/app/CommonLookup/GetDefaultEditionName';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetDefaultEditionName(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetDefaultEditionName(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<GetDefaultEditionNameOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<GetDefaultEditionNameOutput>;
            });
    }

    protected processGetDefaultEditionName(response: HttpResponseBase): Observable<GetDefaultEditionNameOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetDefaultEditionNameOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<GetDefaultEditionNameOutput>(null as any);
    }
}

@Injectable()
export class DemoUiComponentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @param date (optional)
     * @return Success
     */
    sendAndGetDate(date: moment.Moment | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + '/api/services/app/DemoUiComponents/SendAndGetDate?';
        if (date === null) throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined) url_ += 'date=' + encodeURIComponent(date ? '' + date.toISOString() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processSendAndGetDate(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processSendAndGetDate(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<DateToStringOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<DateToStringOutput>;
            });
    }

    protected processSendAndGetDate(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DateToStringOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<DateToStringOutput>(null as any);
    }

    /**
     * @param date (optional)
     * @return Success
     */
    sendAndGetDateTime(date: moment.Moment | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + '/api/services/app/DemoUiComponents/SendAndGetDateTime?';
        if (date === null) throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined) url_ += 'date=' + encodeURIComponent(date ? '' + date.toISOString() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processSendAndGetDateTime(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processSendAndGetDateTime(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<DateToStringOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<DateToStringOutput>;
            });
    }

    protected processSendAndGetDateTime(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DateToStringOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<DateToStringOutput>(null as any);
    }

    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    sendAndGetDateRange(startDate: moment.Moment | undefined, endDate: moment.Moment | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + '/api/services/app/DemoUiComponents/SendAndGetDateRange?';
        if (startDate === null) throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined) url_ += 'startDate=' + encodeURIComponent(startDate ? '' + startDate.toISOString() : '') + '&';
        if (endDate === null) throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined) url_ += 'endDate=' + encodeURIComponent(endDate ? '' + endDate.toISOString() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processSendAndGetDateRange(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processSendAndGetDateRange(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<DateToStringOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<DateToStringOutput>;
            });
    }

    protected processSendAndGetDateRange(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DateToStringOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<DateToStringOutput>(null as any);
    }

    /**
     * @param searchTerm (optional)
     * @return Success
     */
    getCountries(searchTerm: string | undefined): Observable<StringNameValue[]> {
        let url_ = this.baseUrl + '/api/services/app/DemoUiComponents/GetCountries?';
        if (searchTerm === null) throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined) url_ += 'searchTerm=' + encodeURIComponent('' + searchTerm) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetCountries(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetCountries(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<StringNameValue[]>;
                    }
                } else return Observable.throw(response_) as any as Observable<StringNameValue[]>;
            });
    }

    protected processGetCountries(response: HttpResponseBase): Observable<StringNameValue[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200.push(StringNameValue.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<StringNameValue[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendAndGetSelectedCountries(body: StringNameValue[] | undefined): Observable<StringNameValue[]> {
        let url_ = this.baseUrl + '/api/services/app/DemoUiComponents/SendAndGetSelectedCountries';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processSendAndGetSelectedCountries(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processSendAndGetSelectedCountries(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<StringNameValue[]>;
                    }
                } else return Observable.throw(response_) as any as Observable<StringNameValue[]>;
            });
    }

    protected processSendAndGetSelectedCountries(response: HttpResponseBase): Observable<StringNameValue[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200.push(StringNameValue.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<StringNameValue[]>(null as any);
    }

    /**
     * @param input (optional)
     * @return Success
     */
    sendAndGetValue(input: string | undefined): Observable<StringOutput> {
        let url_ = this.baseUrl + '/api/services/app/DemoUiComponents/SendAndGetValue?';
        if (input === null) throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined) url_ += 'input=' + encodeURIComponent('' + input) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processSendAndGetValue(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processSendAndGetValue(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<StringOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<StringOutput>;
            });
    }

    protected processSendAndGetValue(response: HttpResponseBase): Observable<StringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = StringOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<StringOutput>(null as any);
    }
}

@Injectable()
export class EditionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @return Success
     */
    getEditions(): Observable<EditionListDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Edition/GetEditions';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetEditions(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetEditions(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<EditionListDtoListResultDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<EditionListDtoListResultDto>;
            });
    }

    protected processGetEditions(response: HttpResponseBase): Observable<EditionListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EditionListDtoListResultDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<EditionListDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getEditionForEdit(id: number | undefined): Observable<GetEditionEditOutput> {
        let url_ = this.baseUrl + '/api/services/app/Edition/GetEditionForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetEditionForEdit(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetEditionForEdit(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<GetEditionEditOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<GetEditionEditOutput>;
            });
    }

    protected processGetEditionForEdit(response: HttpResponseBase): Observable<GetEditionEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetEditionEditOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<GetEditionEditOutput>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateEdition(body: CreateOrUpdateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Edition/CreateOrUpdateEdition';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processCreateOrUpdateEdition(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processCreateOrUpdateEdition(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processCreateOrUpdateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteEdition(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Edition/DeleteEdition?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({})
        };

        return this.http
            .request('delete', url_, options_)
            .flatMap((response_: any) => {
                return this.processDeleteEdition(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processDeleteEdition(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processDeleteEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param selectedEditionId (optional)
     * @param addAllItem (optional)
     * @param onlyFreeItems (optional)
     * @return Success
     */
    getEditionComboboxItems(
        selectedEditionId: number | undefined,
        addAllItem: boolean | undefined,
        onlyFreeItems: boolean | undefined
    ): Observable<SubscribableEditionComboboxItemDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Edition/GetEditionComboboxItems?';
        if (selectedEditionId === null) throw new Error("The parameter 'selectedEditionId' cannot be null.");
        else if (selectedEditionId !== undefined) url_ += 'selectedEditionId=' + encodeURIComponent('' + selectedEditionId) + '&';
        if (addAllItem === null) throw new Error("The parameter 'addAllItem' cannot be null.");
        else if (addAllItem !== undefined) url_ += 'addAllItem=' + encodeURIComponent('' + addAllItem) + '&';
        if (onlyFreeItems === null) throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined) url_ += 'onlyFreeItems=' + encodeURIComponent('' + onlyFreeItems) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetEditionComboboxItems(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetEditionComboboxItems(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<SubscribableEditionComboboxItemDto[]>;
                    }
                } else return Observable.throw(response_) as any as Observable<SubscribableEditionComboboxItemDto[]>;
            });
    }

    protected processGetEditionComboboxItems(response: HttpResponseBase): Observable<SubscribableEditionComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200.push(SubscribableEditionComboboxItemDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<SubscribableEditionComboboxItemDto[]>(null as any);
    }
}

@Injectable()
export class ServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @return Success
     */
    routes(): Observable<StringStringStringStringOfF__AnonymousType0[]> {
        let url_ = this.baseUrl + '/routes';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'application/json'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processRoutes(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processRoutes(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<StringStringStringStringOfF__AnonymousType0[]>;
                    }
                } else return Observable.throw(response_) as any as Observable<StringStringStringStringOfF__AnonymousType0[]>;
            });
    }

    protected processRoutes(response: HttpResponseBase): Observable<StringStringStringStringOfF__AnonymousType0[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200.push(StringStringStringStringOfF__AnonymousType0.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<StringStringStringStringOfF__AnonymousType0[]>(null as any);
    }
}

@Injectable()
export class FriendshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createFriendshipRequest(body: CreateFriendshipRequestInput | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + '/api/services/app/Friendship/CreateFriendshipRequest';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processCreateFriendshipRequest(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processCreateFriendshipRequest(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<FriendDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<FriendDto>;
            });
    }

    protected processCreateFriendshipRequest(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FriendDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<FriendDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createFriendshipRequestByUserName(body: CreateFriendshipRequestByUserNameInput | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + '/api/services/app/Friendship/CreateFriendshipRequestByUserName';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processCreateFriendshipRequestByUserName(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processCreateFriendshipRequestByUserName(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<FriendDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<FriendDto>;
            });
    }

    protected processCreateFriendshipRequestByUserName(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FriendDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<FriendDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    blockUser(body: BlockUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Friendship/BlockUser';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processBlockUser(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processBlockUser(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processBlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    unblockUser(body: UnblockUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Friendship/UnblockUser';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processUnblockUser(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUnblockUser(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processUnblockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    acceptFriendshipRequest(body: AcceptFriendshipRequestInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Friendship/AcceptFriendshipRequest';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processAcceptFriendshipRequest(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processAcceptFriendshipRequest(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processAcceptFriendshipRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }
}

@Injectable()
export class HostSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<HostSettingsEditDto> {
        let url_ = this.baseUrl + '/api/services/app/HostSettings/GetAllSettings';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetAllSettings(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetAllSettings(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<HostSettingsEditDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<HostSettingsEditDto>;
            });
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<HostSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = HostSettingsEditDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<HostSettingsEditDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAllSettings(body: HostSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/HostSettings/UpdateAllSettings';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('put', url_, options_)
            .flatMap((response_: any) => {
                return this.processUpdateAllSettings(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUpdateAllSettings(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/HostSettings/SendTestEmail';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processSendTestEmail(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processSendTestEmail(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }
}

@Injectable()
export class InstallServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    setup(body: InstallDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Install/Setup';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processSetup(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processSetup(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processSetup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @return Success
     */
    getAppSettingsJson(): Observable<AppSettingsJsonDto> {
        let url_ = this.baseUrl + '/api/services/app/Install/GetAppSettingsJson';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetAppSettingsJson(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetAppSettingsJson(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<AppSettingsJsonDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<AppSettingsJsonDto>;
            });
    }

    protected processGetAppSettingsJson(response: HttpResponseBase): Observable<AppSettingsJsonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AppSettingsJsonDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<AppSettingsJsonDto>(null as any);
    }

    /**
     * @return Success
     */
    checkDatabase(): Observable<CheckDatabaseOutput> {
        let url_ = this.baseUrl + '/api/services/app/Install/CheckDatabase';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processCheckDatabase(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processCheckDatabase(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<CheckDatabaseOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<CheckDatabaseOutput>;
            });
    }

    protected processCheckDatabase(response: HttpResponseBase): Observable<CheckDatabaseOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CheckDatabaseOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<CheckDatabaseOutput>(null as any);
    }
}

@Injectable()
export class InvoiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getInvoiceInfo(id: number | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + '/api/services/app/Invoice/GetInvoiceInfo?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetInvoiceInfo(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetInvoiceInfo(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<InvoiceDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<InvoiceDto>;
            });
    }

    protected processGetInvoiceInfo(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = InvoiceDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<InvoiceDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createInvoice(body: CreateInvoiceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Invoice/CreateInvoice';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processCreateInvoice(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processCreateInvoice(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processCreateInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }
}

@Injectable()
export class LanguageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @return Success
     */
    getLanguages(): Observable<GetLanguagesOutput> {
        let url_ = this.baseUrl + '/api/services/app/Language/GetLanguages';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetLanguages(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetLanguages(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<GetLanguagesOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<GetLanguagesOutput>;
            });
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<GetLanguagesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetLanguagesOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<GetLanguagesOutput>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getLanguageForEdit(id: number | undefined): Observable<GetLanguageForEditOutput> {
        let url_ = this.baseUrl + '/api/services/app/Language/GetLanguageForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetLanguageForEdit(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetLanguageForEdit(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<GetLanguageForEditOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<GetLanguageForEditOutput>;
            });
    }

    protected processGetLanguageForEdit(response: HttpResponseBase): Observable<GetLanguageForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetLanguageForEditOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<GetLanguageForEditOutput>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateLanguage(body: CreateOrUpdateLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Language/CreateOrUpdateLanguage';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processCreateOrUpdateLanguage(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processCreateOrUpdateLanguage(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processCreateOrUpdateLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteLanguage(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Language/DeleteLanguage?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({})
        };

        return this.http
            .request('delete', url_, options_)
            .flatMap((response_: any) => {
                return this.processDeleteLanguage(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processDeleteLanguage(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processDeleteLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    setDefaultLanguage(body: SetDefaultLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Language/SetDefaultLanguage';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processSetDefaultLanguage(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processSetDefaultLanguage(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processSetDefaultLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @param sorting (optional)
     * @param baseLanguageName (optional)
     * @param targetValueFilter (optional)
     * @param filterText (optional)
     * @return Success
     */
    getLanguageTexts(
        maxResultCount: number | undefined,
        skipCount: number | undefined,
        sorting: string | undefined,
        sourceName: string,
        baseLanguageName: string | undefined,
        targetLanguageName: string,
        targetValueFilter: string | undefined,
        filterText: string | undefined
    ): Observable<LanguageTextListDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Language/GetLanguageTexts?';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else url_ += 'SourceName=' + encodeURIComponent('' + sourceName) + '&';
        if (baseLanguageName === null) throw new Error("The parameter 'baseLanguageName' cannot be null.");
        else if (baseLanguageName !== undefined) url_ += 'BaseLanguageName=' + encodeURIComponent('' + baseLanguageName) + '&';
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else url_ += 'TargetLanguageName=' + encodeURIComponent('' + targetLanguageName) + '&';
        if (targetValueFilter === null) throw new Error("The parameter 'targetValueFilter' cannot be null.");
        else if (targetValueFilter !== undefined) url_ += 'TargetValueFilter=' + encodeURIComponent('' + targetValueFilter) + '&';
        if (filterText === null) throw new Error("The parameter 'filterText' cannot be null.");
        else if (filterText !== undefined) url_ += 'FilterText=' + encodeURIComponent('' + filterText) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetLanguageTexts(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetLanguageTexts(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<LanguageTextListDtoPagedResultDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<LanguageTextListDtoPagedResultDto>;
            });
    }

    protected processGetLanguageTexts(response: HttpResponseBase): Observable<LanguageTextListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LanguageTextListDtoPagedResultDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<LanguageTextListDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateLanguageText(body: UpdateLanguageTextInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Language/UpdateLanguageText';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('put', url_, options_)
            .flatMap((response_: any) => {
                return this.processUpdateLanguageText(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUpdateLanguageText(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processUpdateLanguageText(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }
}

@Injectable()
export class ListServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @param currentSessionId (optional)
     * @return Success
     */
    getNextSimilarList(currentSessionId: string | undefined): Observable<SessionDto> {
        let url_ = this.baseUrl + '/api/services/app/List/GetNextSimilarList?';
        if (currentSessionId === null) throw new Error("The parameter 'currentSessionId' cannot be null.");
        else if (currentSessionId !== undefined) url_ += 'currentSessionId=' + encodeURIComponent('' + currentSessionId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetNextSimilarList(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetNextSimilarList(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<SessionDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<SessionDto>;
            });
    }

    protected processGetNextSimilarList(response: HttpResponseBase): Observable<SessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SessionDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<SessionDto>(null as any);
    }

    /**
     * @param currentSessionId (optional)
     * @return Success
     */
    getPreviousSimilarList(currentSessionId: string | undefined): Observable<SessionDto> {
        let url_ = this.baseUrl + '/api/services/app/List/GetPreviousSimilarList?';
        if (currentSessionId === null) throw new Error("The parameter 'currentSessionId' cannot be null.");
        else if (currentSessionId !== undefined) url_ += 'currentSessionId=' + encodeURIComponent('' + currentSessionId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetPreviousSimilarList(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetPreviousSimilarList(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<SessionDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<SessionDto>;
            });
    }

    protected processGetPreviousSimilarList(response: HttpResponseBase): Observable<SessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SessionDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<SessionDto>(null as any);
    }

    /**
     * @param currentSessionId (optional)
     * @param size (optional)
     * @return Success
     */
    getPreviousPerformedSimilarLists(currentSessionId: string | undefined, size: number | undefined): Observable<SessionDto[]> {
        let url_ = this.baseUrl + '/api/services/app/List/GetPreviousPerformedSimilarLists?';
        if (currentSessionId === null) throw new Error("The parameter 'currentSessionId' cannot be null.");
        else if (currentSessionId !== undefined) url_ += 'currentSessionId=' + encodeURIComponent('' + currentSessionId) + '&';
        if (size === null) throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined) url_ += 'size=' + encodeURIComponent('' + size) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetPreviousPerformedSimilarLists(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetPreviousPerformedSimilarLists(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<SessionDto[]>;
                    }
                } else return Observable.throw(response_) as any as Observable<SessionDto[]>;
            });
    }

    protected processGetPreviousPerformedSimilarLists(response: HttpResponseBase): Observable<SessionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200.push(SessionDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<SessionDto[]>(null as any);
    }

    /**
     * @param start (optional)
     * @param end (optional)
     * @return Success
     */
    getListsForDates(start: moment.Moment | undefined, end: moment.Moment | undefined): Observable<SessionDto[]> {
        let url_ = this.baseUrl + '/api/services/app/List/GetListsForDates?';
        if (start === null) throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&';
        if (end === null) throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetListsForDates(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetListsForDates(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<SessionDto[]>;
                    }
                } else return Observable.throw(response_) as any as Observable<SessionDto[]>;
            });
    }

    protected processGetListsForDates(response: HttpResponseBase): Observable<SessionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200.push(SessionDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<SessionDto[]>(null as any);
    }

    /**
     * @param siteIds (optional)
     * @param specialityIds (optional)
     * @param consultantIds (optional)
     * @param start (optional)
     * @param end (optional)
     * @return Success
     */
    getListsFlatReport(
        siteIds: number[] | undefined,
        specialityIds: number[] | undefined,
        consultantIds: number[] | undefined,
        start: moment.Moment | undefined,
        end: moment.Moment | undefined
    ): Observable<SessionsAggregatedByDateDto[]> {
        let url_ = this.baseUrl + '/api/services/app/List/GetListsFlatReport?';
        if (siteIds === null) throw new Error("The parameter 'siteIds' cannot be null.");
        else if (siteIds !== undefined)
            siteIds &&
                siteIds.forEach((item) => {
                    url_ += 'siteIds=' + encodeURIComponent('' + item) + '&';
                });
        if (specialityIds === null) throw new Error("The parameter 'specialityIds' cannot be null.");
        else if (specialityIds !== undefined)
            specialityIds &&
                specialityIds.forEach((item) => {
                    url_ += 'specialityIds=' + encodeURIComponent('' + item) + '&';
                });
        if (consultantIds === null) throw new Error("The parameter 'consultantIds' cannot be null.");
        else if (consultantIds !== undefined)
            consultantIds &&
                consultantIds.forEach((item) => {
                    url_ += 'consultantIds=' + encodeURIComponent('' + item) + '&';
                });
        if (start === null) throw new Error("The parameter 'start' cannot be null.");
        else if (start !== undefined) url_ += 'start=' + encodeURIComponent(start ? '' + start.toISOString() : '') + '&';
        if (end === null) throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined) url_ += 'end=' + encodeURIComponent(end ? '' + end.toISOString() : '') + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetListsFlatReport(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetListsFlatReport(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<SessionsAggregatedByDateDto[]>;
                    }
                } else return Observable.throw(response_) as any as Observable<SessionsAggregatedByDateDto[]>;
            });
    }

    protected processGetListsFlatReport(response: HttpResponseBase): Observable<SessionsAggregatedByDateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200.push(SessionsAggregatedByDateDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<SessionsAggregatedByDateDto[]>(null as any);
    }

    /**
     * @param sessionId (optional)
     * @return Success
     */
    getSessionDetails(sessionId: string | undefined): Observable<SessionWithSimilarListsDto> {
        let url_ = this.baseUrl + '/api/services/app/List/GetSessionDetails?';
        if (sessionId === null) throw new Error("The parameter 'sessionId' cannot be null.");
        else if (sessionId !== undefined) url_ += 'sessionId=' + encodeURIComponent('' + sessionId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetSessionDetails(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetSessionDetails(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<SessionWithSimilarListsDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<SessionWithSimilarListsDto>;
            });
    }

    protected processGetSessionDetails(response: HttpResponseBase): Observable<SessionWithSimilarListsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SessionWithSimilarListsDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<SessionWithSimilarListsDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updatePatientList(body: PatientListDto | undefined): Observable<SessionWithSimilarListsDto> {
        let url_ = this.baseUrl + '/api/services/app/List/UpdatePatientList';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .flatMap((response_: any) => {
                return this.processUpdatePatientList(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUpdatePatientList(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<SessionWithSimilarListsDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<SessionWithSimilarListsDto>;
            });
    }

    protected processUpdatePatientList(response: HttpResponseBase): Observable<SessionWithSimilarListsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SessionWithSimilarListsDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<SessionWithSimilarListsDto>(null as any);
    }
}

@Injectable()
export class MagicNumbersServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @return Success
     */
    getImprovementProgramsList(): Observable<SimpleImprovementProgramDto[]> {
        let url_ = this.baseUrl + '/api/services/app/MagicNumbers/GetImprovementProgramsList';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetImprovementProgramsList(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetImprovementProgramsList(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<SimpleImprovementProgramDto[]>;
                    }
                } else return Observable.throw(response_) as any as Observable<SimpleImprovementProgramDto[]>;
            });
    }

    protected processGetImprovementProgramsList(response: HttpResponseBase): Observable<SimpleImprovementProgramDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200.push(SimpleImprovementProgramDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<SimpleImprovementProgramDto[]>(null as any);
    }

    /**
     * @param programId (optional)
     * @return Success
     */
    getImprovementProgramConfiguration(programId: number | undefined): Observable<ImprovementProgramConfigurationDto> {
        let url_ = this.baseUrl + '/api/services/app/MagicNumbers/GetImprovementProgramConfiguration?';
        if (programId === null) throw new Error("The parameter 'programId' cannot be null.");
        else if (programId !== undefined) url_ += 'programId=' + encodeURIComponent('' + programId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetImprovementProgramConfiguration(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetImprovementProgramConfiguration(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<ImprovementProgramConfigurationDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<ImprovementProgramConfigurationDto>;
            });
    }

    protected processGetImprovementProgramConfiguration(response: HttpResponseBase): Observable<ImprovementProgramConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ImprovementProgramConfigurationDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<ImprovementProgramConfigurationDto>(null as any);
    }

    /**
     * @param specialityIds (optional)
     * @param startDate (optional)
     * @param opportunityPercentage (optional)
     * @return Success
     */
    getMagicValuesForSpecialites(
        specialityIds: number[] | undefined,
        startDate: moment.Moment | undefined,
        opportunityPercentage: number | undefined
    ): Observable<MagicValuesDto[]> {
        let url_ = this.baseUrl + '/api/services/app/MagicNumbers/GetMagicValuesForSpecialites?';
        if (specialityIds === null) throw new Error("The parameter 'specialityIds' cannot be null.");
        else if (specialityIds !== undefined)
            specialityIds &&
                specialityIds.forEach((item) => {
                    url_ += 'specialityIds=' + encodeURIComponent('' + item) + '&';
                });
        if (startDate === null) throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined) url_ += 'startDate=' + encodeURIComponent(startDate ? '' + startDate.toISOString() : '') + '&';
        if (opportunityPercentage === null) throw new Error("The parameter 'opportunityPercentage' cannot be null.");
        else if (opportunityPercentage !== undefined)
            url_ += 'opportunityPercentage=' + encodeURIComponent('' + opportunityPercentage) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetMagicValuesForSpecialites(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetMagicValuesForSpecialites(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<MagicValuesDto[]>;
                    }
                } else return Observable.throw(response_) as any as Observable<MagicValuesDto[]>;
            });
    }

    protected processGetMagicValuesForSpecialites(response: HttpResponseBase): Observable<MagicValuesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200.push(MagicValuesDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<MagicValuesDto[]>(null as any);
    }

    /**
     * @param specialityId (optional)
     * @param startDate (optional)
     * @param opportunityPercentage (optional)
     * @return Success
     */
    getSpecialityMagicValues(
        specialityId: number | undefined,
        startDate: moment.Moment | undefined,
        opportunityPercentage: number | undefined
    ): Observable<MagicValuesDto> {
        let url_ = this.baseUrl + '/api/services/app/MagicNumbers/GetSpecialityMagicValues?';
        if (specialityId === null) throw new Error("The parameter 'specialityId' cannot be null.");
        else if (specialityId !== undefined) url_ += 'specialityId=' + encodeURIComponent('' + specialityId) + '&';
        if (startDate === null) throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined) url_ += 'startDate=' + encodeURIComponent(startDate ? '' + startDate.toISOString() : '') + '&';
        if (opportunityPercentage === null) throw new Error("The parameter 'opportunityPercentage' cannot be null.");
        else if (opportunityPercentage !== undefined)
            url_ += 'opportunityPercentage=' + encodeURIComponent('' + opportunityPercentage) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetSpecialityMagicValues(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetSpecialityMagicValues(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<MagicValuesDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<MagicValuesDto>;
            });
    }

    protected processGetSpecialityMagicValues(response: HttpResponseBase): Observable<MagicValuesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MagicValuesDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<MagicValuesDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdate(body: ImprovementProgramConfigurationDto | undefined): Observable<ImprovementProgramConfigurationDto> {
        let url_ = this.baseUrl + '/api/services/app/MagicNumbers/CreateOrUpdate';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processCreateOrUpdate(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processCreateOrUpdate(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<ImprovementProgramConfigurationDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<ImprovementProgramConfigurationDto>;
            });
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<ImprovementProgramConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ImprovementProgramConfigurationDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<ImprovementProgramConfigurationDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    delete(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + '/api/services/app/MagicNumbers/Delete?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('delete', url_, options_)
            .flatMap((response_: any) => {
                return this.processDelete(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processDelete(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<boolean>;
                    }
                } else return Observable.throw(response_) as any as Observable<boolean>;
            });
    }

    protected processDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<boolean>(null as any);
    }

    /**
     * @param improvementProgramId (optional)
     * @return Success
     */
    getImprovementPrograms(improvementProgramId: number | undefined): Observable<ImprovementProgramsDto> {
        let url_ = this.baseUrl + '/api/services/app/MagicNumbers/GetImprovementPrograms?';
        if (improvementProgramId === null) throw new Error("The parameter 'improvementProgramId' cannot be null.");
        else if (improvementProgramId !== undefined) url_ += 'improvementProgramId=' + encodeURIComponent('' + improvementProgramId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetImprovementPrograms(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetImprovementPrograms(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<ImprovementProgramsDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<ImprovementProgramsDto>;
            });
    }

    protected processGetImprovementPrograms(response: HttpResponseBase): Observable<ImprovementProgramsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ImprovementProgramsDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<ImprovementProgramsDto>(null as any);
    }
}

@Injectable()
export class MappingServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    add(body: MappingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/MappingService/Add';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processAdd(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processAdd(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processAdd(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @return Success
     */
    get(): Observable<MappingsDto> {
        let url_ = this.baseUrl + '/api/services/app/MappingService/Get';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGet(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGet(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<MappingsDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<MappingsDto>;
            });
    }

    protected processGet(response: HttpResponseBase): Observable<MappingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = MappingsDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<MappingsDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    update(body: MappingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/MappingService/Update';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('put', url_, options_)
            .flatMap((response_: any) => {
                return this.processUpdate(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUpdate(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @param state (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getUserNotifications(
        state: UserNotificationState | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<GetNotificationsOutput> {
        let url_ = this.baseUrl + '/api/services/app/Notification/GetUserNotifications?';
        if (state === null) throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined) url_ += 'State=' + encodeURIComponent('' + state) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetUserNotifications(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetUserNotifications(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<GetNotificationsOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<GetNotificationsOutput>;
            });
    }

    protected processGetUserNotifications(response: HttpResponseBase): Observable<GetNotificationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetNotificationsOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<GetNotificationsOutput>(null as any);
    }

    /**
     * @return Success
     */
    setAllNotificationsAsRead(): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Notification/SetAllNotificationsAsRead';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({})
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processSetAllNotificationsAsRead(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processSetAllNotificationsAsRead(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processSetAllNotificationsAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    setNotificationAsRead(body: GuidEntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Notification/SetNotificationAsRead';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processSetNotificationAsRead(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processSetNotificationAsRead(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processSetNotificationAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @return Success
     */
    getNotificationSettings(): Observable<GetNotificationSettingsOutput> {
        let url_ = this.baseUrl + '/api/services/app/Notification/GetNotificationSettings';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetNotificationSettings(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetNotificationSettings(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<GetNotificationSettingsOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<GetNotificationSettingsOutput>;
            });
    }

    protected processGetNotificationSettings(response: HttpResponseBase): Observable<GetNotificationSettingsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetNotificationSettingsOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<GetNotificationSettingsOutput>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateNotificationSettings(body: UpdateNotificationSettingsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Notification/UpdateNotificationSettings';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('put', url_, options_)
            .flatMap((response_: any) => {
                return this.processUpdateNotificationSettings(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUpdateNotificationSettings(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processUpdateNotificationSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }
}

@Injectable()
export class OrganizationUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @return Success
     */
    getOrganizationUnits(): Observable<OrganizationUnitDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/OrganizationUnit/GetOrganizationUnits';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetOrganizationUnits(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetOrganizationUnits(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<OrganizationUnitDtoListResultDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<OrganizationUnitDtoListResultDto>;
            });
    }

    protected processGetOrganizationUnits(response: HttpResponseBase): Observable<OrganizationUnitDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrganizationUnitDtoListResultDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<OrganizationUnitDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getOrganizationUnitUsers(
        id: number | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<OrganizationUnitUserListDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/OrganizationUnit/GetOrganizationUnitUsers?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetOrganizationUnitUsers(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetOrganizationUnitUsers(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<OrganizationUnitUserListDtoPagedResultDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<OrganizationUnitUserListDtoPagedResultDto>;
            });
    }

    protected processGetOrganizationUnitUsers(response: HttpResponseBase): Observable<OrganizationUnitUserListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrganizationUnitUserListDtoPagedResultDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<OrganizationUnitUserListDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrganizationUnit(body: CreateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + '/api/services/app/OrganizationUnit/CreateOrganizationUnit';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processCreateOrganizationUnit(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processCreateOrganizationUnit(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<OrganizationUnitDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<OrganizationUnitDto>;
            });
    }

    protected processCreateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrganizationUnitDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<OrganizationUnitDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateOrganizationUnit(body: UpdateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + '/api/services/app/OrganizationUnit/UpdateOrganizationUnit';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .flatMap((response_: any) => {
                return this.processUpdateOrganizationUnit(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUpdateOrganizationUnit(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<OrganizationUnitDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<OrganizationUnitDto>;
            });
    }

    protected processUpdateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrganizationUnitDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<OrganizationUnitDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    moveOrganizationUnit(body: MoveOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + '/api/services/app/OrganizationUnit/MoveOrganizationUnit';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processMoveOrganizationUnit(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processMoveOrganizationUnit(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<OrganizationUnitDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<OrganizationUnitDto>;
            });
    }

    protected processMoveOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OrganizationUnitDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<OrganizationUnitDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteOrganizationUnit(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/OrganizationUnit/DeleteOrganizationUnit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({})
        };

        return this.http
            .request('delete', url_, options_)
            .flatMap((response_: any) => {
                return this.processDeleteOrganizationUnit(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processDeleteOrganizationUnit(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processDeleteOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param userId (optional)
     * @param organizationUnitId (optional)
     * @return Success
     */
    removeUserFromOrganizationUnit(userId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit?';
        if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined) url_ += 'UserId=' + encodeURIComponent('' + userId) + '&';
        if (organizationUnitId === null) throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined) url_ += 'OrganizationUnitId=' + encodeURIComponent('' + organizationUnitId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({})
        };

        return this.http
            .request('delete', url_, options_)
            .flatMap((response_: any) => {
                return this.processRemoveUserFromOrganizationUnit(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processRemoveUserFromOrganizationUnit(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processRemoveUserFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    addUsersToOrganizationUnit(body: UsersToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processAddUsersToOrganizationUnit(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processAddUsersToOrganizationUnit(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processAddUsersToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    findUsers(body: FindOrganizationUnitUsersInput | undefined): Observable<NameValueDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/OrganizationUnit/FindUsers';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processFindUsers(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processFindUsers(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<NameValueDtoPagedResultDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<NameValueDtoPagedResultDto>;
            });
    }

    protected processFindUsers(response: HttpResponseBase): Observable<NameValueDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NameValueDtoPagedResultDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<NameValueDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class PaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @param upgradeEditionId (optional)
     * @return Success
     */
    getPaymentInfo(upgradeEditionId: number | undefined): Observable<PaymentInfoDto> {
        let url_ = this.baseUrl + '/api/services/app/Payment/GetPaymentInfo?';
        if (upgradeEditionId === null) throw new Error("The parameter 'upgradeEditionId' cannot be null.");
        else if (upgradeEditionId !== undefined) url_ += 'UpgradeEditionId=' + encodeURIComponent('' + upgradeEditionId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetPaymentInfo(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetPaymentInfo(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<PaymentInfoDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<PaymentInfoDto>;
            });
    }

    protected processGetPaymentInfo(response: HttpResponseBase): Observable<PaymentInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PaymentInfoDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<PaymentInfoDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createPayment(body: CreatePaymentDto | undefined): Observable<CreatePaymentResponse> {
        let url_ = this.baseUrl + '/api/services/app/Payment/CreatePayment';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processCreatePayment(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processCreatePayment(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<CreatePaymentResponse>;
                    }
                } else return Observable.throw(response_) as any as Observable<CreatePaymentResponse>;
            });
    }

    protected processCreatePayment(response: HttpResponseBase): Observable<CreatePaymentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CreatePaymentResponse.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<CreatePaymentResponse>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    executePayment(body: ExecutePaymentDto | undefined): Observable<ExecutePaymentResponse> {
        let url_ = this.baseUrl + '/api/services/app/Payment/ExecutePayment';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processExecutePayment(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processExecutePayment(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<ExecutePaymentResponse>;
                    }
                } else return Observable.throw(response_) as any as Observable<ExecutePaymentResponse>;
            });
    }

    protected processExecutePayment(response: HttpResponseBase): Observable<ExecutePaymentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ExecutePaymentResponse.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<ExecutePaymentResponse>(null as any);
    }

    /**
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getPaymentHistory(
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<SubscriptionPaymentListDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Payment/GetPaymentHistory?';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetPaymentHistory(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetPaymentHistory(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<SubscriptionPaymentListDtoPagedResultDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<SubscriptionPaymentListDtoPagedResultDto>;
            });
    }

    protected processGetPaymentHistory(response: HttpResponseBase): Observable<SubscriptionPaymentListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SubscriptionPaymentListDtoPagedResultDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<SubscriptionPaymentListDtoPagedResultDto>(null as any);
    }
}

@Injectable()
export class PermissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<FlatPermissionWithLevelDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Permission/GetAllPermissions';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetAllPermissions(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetAllPermissions(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<FlatPermissionWithLevelDtoListResultDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<FlatPermissionWithLevelDtoListResultDto>;
            });
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<FlatPermissionWithLevelDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FlatPermissionWithLevelDtoListResultDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<FlatPermissionWithLevelDtoListResultDto>(null as any);
    }
}

@Injectable()
export class ProcedureServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    getWaitingLists(body: WaitingListFiltersDto | undefined): Observable<ProcedureDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Procedure/GetWaitingLists';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetWaitingLists(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetWaitingLists(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<ProcedureDto[]>;
                    }
                } else return Observable.throw(response_) as any as Observable<ProcedureDto[]>;
            });
    }

    protected processGetWaitingLists(response: HttpResponseBase): Observable<ProcedureDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200.push(ProcedureDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<ProcedureDto[]>(null as any);
    }
}

@Injectable()
export class ProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @return Success
     */
    getCurrentUserProfileForEdit(): Observable<CurrentUserProfileEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Profile/GetCurrentUserProfileForEdit';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetCurrentUserProfileForEdit(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetCurrentUserProfileForEdit(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<CurrentUserProfileEditDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<CurrentUserProfileEditDto>;
            });
    }

    protected processGetCurrentUserProfileForEdit(response: HttpResponseBase): Observable<CurrentUserProfileEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CurrentUserProfileEditDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<CurrentUserProfileEditDto>(null as any);
    }

    /**
     * @return Success
     */
    updateGoogleAuthenticatorKey(): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + '/api/services/app/Profile/UpdateGoogleAuthenticatorKey';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .flatMap((response_: any) => {
                return this.processUpdateGoogleAuthenticatorKey(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUpdateGoogleAuthenticatorKey(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
            });
    }

    protected processUpdateGoogleAuthenticatorKey(response: HttpResponseBase): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<UpdateGoogleAuthenticatorKeyOutput>(null as any);
    }

    /**
     * @return Success
     */
    sendVerificationSms(): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Profile/SendVerificationSms';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({})
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processSendVerificationSms(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processSendVerificationSms(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processSendVerificationSms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    verifySmsCode(body: VerifySmsCodeInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Profile/VerifySmsCode';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processVerifySmsCode(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processVerifySmsCode(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processVerifySmsCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateCurrentUserProfile(body: CurrentUserProfileEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Profile/UpdateCurrentUserProfile';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('put', url_, options_)
            .flatMap((response_: any) => {
                return this.processUpdateCurrentUserProfile(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUpdateCurrentUserProfile(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processUpdateCurrentUserProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    changePassword(body: ChangePasswordInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Profile/ChangePassword';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processChangePassword(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processChangePassword(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processChangePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateProfilePicture(body: UpdateProfilePictureInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Profile/UpdateProfilePicture';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('put', url_, options_)
            .flatMap((response_: any) => {
                return this.processUpdateProfilePicture(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUpdateProfilePicture(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processUpdateProfilePicture(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @return Success
     */
    getPasswordComplexitySetting(): Observable<GetPasswordComplexitySettingOutput> {
        let url_ = this.baseUrl + '/api/services/app/Profile/GetPasswordComplexitySetting';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetPasswordComplexitySetting(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetPasswordComplexitySetting(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<GetPasswordComplexitySettingOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<GetPasswordComplexitySettingOutput>;
            });
    }

    protected processGetPasswordComplexitySetting(response: HttpResponseBase): Observable<GetPasswordComplexitySettingOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetPasswordComplexitySettingOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<GetPasswordComplexitySettingOutput>(null as any);
    }

    /**
     * @return Success
     */
    getProfilePicture(): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + '/api/services/app/Profile/GetProfilePicture';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetProfilePicture(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetProfilePicture(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<GetProfilePictureOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<GetProfilePictureOutput>;
            });
    }

    protected processGetProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetProfilePictureOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<GetProfilePictureOutput>(null as any);
    }

    /**
     * @param profilePictureId (optional)
     * @param userId (optional)
     * @param tenantId (optional)
     * @return Success
     */
    getFriendProfilePictureById(
        profilePictureId: string | undefined,
        userId: number | undefined,
        tenantId: number | undefined
    ): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + '/api/services/app/Profile/GetFriendProfilePictureById?';
        if (profilePictureId === null) throw new Error("The parameter 'profilePictureId' cannot be null.");
        else if (profilePictureId !== undefined) url_ += 'ProfilePictureId=' + encodeURIComponent('' + profilePictureId) + '&';
        if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined) url_ += 'UserId=' + encodeURIComponent('' + userId) + '&';
        if (tenantId === null) throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined) url_ += 'TenantId=' + encodeURIComponent('' + tenantId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetFriendProfilePictureById(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetFriendProfilePictureById(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<GetProfilePictureOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<GetProfilePictureOutput>;
            });
    }

    protected processGetFriendProfilePictureById(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetProfilePictureOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<GetProfilePictureOutput>(null as any);
    }

    /**
     * @param profilePictureId (optional)
     * @return Success
     */
    getProfilePictureById(profilePictureId: string | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + '/api/services/app/Profile/GetProfilePictureById?';
        if (profilePictureId === null) throw new Error("The parameter 'profilePictureId' cannot be null.");
        else if (profilePictureId !== undefined) url_ += 'profilePictureId=' + encodeURIComponent('' + profilePictureId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetProfilePictureById(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetProfilePictureById(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<GetProfilePictureOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<GetProfilePictureOutput>;
            });
    }

    protected processGetProfilePictureById(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetProfilePictureOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<GetProfilePictureOutput>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Profile/ChangeLanguage';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processChangeLanguage(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processChangeLanguage(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }
}

@Injectable()
export class QualityReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @return Success
     */
    getQualityReport(): Observable<QualityReportItem[]> {
        let url_ = this.baseUrl + '/api/services/app/QualityReport/GetQualityReport';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetQualityReport(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetQualityReport(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<QualityReportItem[]>;
                    }
                } else return Observable.throw(response_) as any as Observable<QualityReportItem[]>;
            });
    }

    protected processGetQualityReport(response: HttpResponseBase): Observable<QualityReportItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200.push(QualityReportItem.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<QualityReportItem[]>(null as any);
    }
}

@Injectable()
export class ReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @return Success
     */
    getEmbedConfig(): Observable<ReportEmbedConfig> {
        let url_ = this.baseUrl + '/api/services/app/Report/GetEmbedConfig';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetEmbedConfig(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetEmbedConfig(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<ReportEmbedConfig>;
                    }
                } else return Observable.throw(response_) as any as Observable<ReportEmbedConfig>;
            });
    }

    protected processGetEmbedConfig(response: HttpResponseBase): Observable<ReportEmbedConfig> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReportEmbedConfig.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<ReportEmbedConfig>(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @param permission (optional)
     * @return Success
     */
    getRoles(permission: string | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Role/GetRoles?';
        if (permission === null) throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined) url_ += 'Permission=' + encodeURIComponent('' + permission) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetRoles(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetRoles(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<RoleListDtoListResultDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<RoleListDtoListResultDto>;
            });
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RoleListDtoListResultDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<RoleListDtoListResultDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + '/api/services/app/Role/GetRoleForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetRoleForEdit(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetRoleForEdit(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<GetRoleForEditOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<GetRoleForEditOutput>;
            });
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetRoleForEditOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<GetRoleForEditOutput>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateRole(body: CreateOrUpdateRoleInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Role/CreateOrUpdateRole';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processCreateOrUpdateRole(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processCreateOrUpdateRole(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processCreateOrUpdateRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteRole(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Role/DeleteRole?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({})
        };

        return this.http
            .request('delete', url_, options_)
            .flatMap((response_: any) => {
                return this.processDeleteRole(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processDeleteRole(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + '/api/services/app/Session/GetCurrentLoginInformations';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetCurrentLoginInformations(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetCurrentLoginInformations(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
            });
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<GetCurrentLoginInformationsOutput>(null as any);
    }

    /**
     * @return Success
     */
    updateUserSignInToken(): Observable<UpdateUserSignInTokenOutput> {
        let url_ = this.baseUrl + '/api/services/app/Session/UpdateUserSignInToken';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('put', url_, options_)
            .flatMap((response_: any) => {
                return this.processUpdateUserSignInToken(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUpdateUserSignInToken(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<UpdateUserSignInTokenOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<UpdateUserSignInTokenOutput>;
            });
    }

    protected processUpdateUserSignInToken(response: HttpResponseBase): Observable<UpdateUserSignInTokenOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateUserSignInTokenOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<UpdateUserSignInTokenOutput>(null as any);
    }
}

@Injectable()
export class SixFourTwoServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @param siteIds (optional)
     * @param specialityIds (optional)
     * @param majorConsultantIds (optional)
     * @param isSpeciality (optional)
     * @return Success
     */
    getSixFourTwoOverview(
        siteIds: number[] | undefined,
        specialityIds: number[] | undefined,
        majorConsultantIds: number[] | undefined,
        isSpeciality: boolean | undefined
    ): Observable<SixFourTwoDto> {
        let url_ = this.baseUrl + '/api/services/app/SixFourTwoService/GetSixFourTwoOverview?';
        if (siteIds === null) throw new Error("The parameter 'siteIds' cannot be null.");
        else if (siteIds !== undefined)
            siteIds &&
                siteIds.forEach((item) => {
                    url_ += 'siteIds=' + encodeURIComponent('' + item) + '&';
                });
        if (specialityIds === null) throw new Error("The parameter 'specialityIds' cannot be null.");
        else if (specialityIds !== undefined)
            specialityIds &&
                specialityIds.forEach((item) => {
                    url_ += 'specialityIds=' + encodeURIComponent('' + item) + '&';
                });
        if (majorConsultantIds === null) throw new Error("The parameter 'majorConsultantIds' cannot be null.");
        else if (majorConsultantIds !== undefined)
            majorConsultantIds &&
                majorConsultantIds.forEach((item) => {
                    url_ += 'majorConsultantIds=' + encodeURIComponent('' + item) + '&';
                });
        if (isSpeciality === null) throw new Error("The parameter 'isSpeciality' cannot be null.");
        else if (isSpeciality !== undefined) url_ += 'isSpeciality=' + encodeURIComponent('' + isSpeciality) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetSixFourTwoOverview(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetSixFourTwoOverview(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<SixFourTwoDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<SixFourTwoDto>;
            });
    }

    protected processGetSixFourTwoOverview(response: HttpResponseBase): Observable<SixFourTwoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SixFourTwoDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<SixFourTwoDto>(null as any);
    }
}

@Injectable()
export class SmartSchedulingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    schedule(body: ScheduleFiltersDto | undefined): Observable<SmartSchedulingWithSummaryDto> {
        let url_ = this.baseUrl + '/api/services/app/SmartScheduling/Schedule';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processSchedule(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processSchedule(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<SmartSchedulingWithSummaryDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<SmartSchedulingWithSummaryDto>;
            });
    }

    protected processSchedule(response: HttpResponseBase): Observable<SmartSchedulingWithSummaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SmartSchedulingWithSummaryDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<SmartSchedulingWithSummaryDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    authorizeAndSave(body: SmartSchedulingAuthorisationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/SmartScheduling/AuthorizeAndSave';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processAuthorizeAndSave(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processAuthorizeAndSave(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processAuthorizeAndSave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    autofillSession(body: AutofillDto | undefined): Observable<AutofillDto> {
        let url_ = this.baseUrl + '/api/services/app/SmartScheduling/AutofillSession';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processAutofillSession(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processAutofillSession(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<AutofillDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<AutofillDto>;
            });
    }

    protected processAutofillSession(response: HttpResponseBase): Observable<AutofillDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AutofillDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<AutofillDto>(null as any);
    }
}

@Injectable()
export class SpecialtyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @return Success
     */
    getAllSpecialties(): Observable<Speciality[]> {
        let url_ = this.baseUrl + '/api/services/app/Specialty/GetAllSpecialties';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetAllSpecialties(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetAllSpecialties(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<Speciality[]>;
                    }
                } else return Observable.throw(response_) as any as Observable<Speciality[]>;
            });
    }

    protected processGetAllSpecialties(response: HttpResponseBase): Observable<Speciality[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200.push(Speciality.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<Speciality[]>(null as any);
    }
}

@Injectable()
export class SubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @param upgradeEditionId (optional)
     * @return Success
     */
    upgradeTenantToEquivalentEdition(upgradeEditionId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Subscription/UpgradeTenantToEquivalentEdition?';
        if (upgradeEditionId === null) throw new Error("The parameter 'upgradeEditionId' cannot be null.");
        else if (upgradeEditionId !== undefined) url_ += 'upgradeEditionId=' + encodeURIComponent('' + upgradeEditionId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({})
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processUpgradeTenantToEquivalentEdition(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUpgradeTenantToEquivalentEdition(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processUpgradeTenantToEquivalentEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createTenantsExternal(body: CreateTenantExternalInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/CreateTenantsExternal';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processCreateTenantsExternal(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processCreateTenantsExternal(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processCreateTenantsExternal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param filter (optional)
     * @param subscriptionEndDateStart (optional)
     * @param subscriptionEndDateEnd (optional)
     * @param creationDateStart (optional)
     * @param creationDateEnd (optional)
     * @param editionId (optional)
     * @param editionIdSpecified (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getTenants(
        filter: string | undefined,
        subscriptionEndDateStart: moment.Moment | undefined,
        subscriptionEndDateEnd: moment.Moment | undefined,
        creationDateStart: moment.Moment | undefined,
        creationDateEnd: moment.Moment | undefined,
        editionId: number | undefined,
        editionIdSpecified: boolean | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<TenantListDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/GetTenants?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        if (subscriptionEndDateStart === null) throw new Error("The parameter 'subscriptionEndDateStart' cannot be null.");
        else if (subscriptionEndDateStart !== undefined)
            url_ +=
                'SubscriptionEndDateStart=' +
                encodeURIComponent(subscriptionEndDateStart ? '' + subscriptionEndDateStart.toISOString() : '') +
                '&';
        if (subscriptionEndDateEnd === null) throw new Error("The parameter 'subscriptionEndDateEnd' cannot be null.");
        else if (subscriptionEndDateEnd !== undefined)
            url_ +=
                'SubscriptionEndDateEnd=' +
                encodeURIComponent(subscriptionEndDateEnd ? '' + subscriptionEndDateEnd.toISOString() : '') +
                '&';
        if (creationDateStart === null) throw new Error("The parameter 'creationDateStart' cannot be null.");
        else if (creationDateStart !== undefined)
            url_ += 'CreationDateStart=' + encodeURIComponent(creationDateStart ? '' + creationDateStart.toISOString() : '') + '&';
        if (creationDateEnd === null) throw new Error("The parameter 'creationDateEnd' cannot be null.");
        else if (creationDateEnd !== undefined)
            url_ += 'CreationDateEnd=' + encodeURIComponent(creationDateEnd ? '' + creationDateEnd.toISOString() : '') + '&';
        if (editionId === null) throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined) url_ += 'EditionId=' + encodeURIComponent('' + editionId) + '&';
        if (editionIdSpecified === null) throw new Error("The parameter 'editionIdSpecified' cannot be null.");
        else if (editionIdSpecified !== undefined) url_ += 'EditionIdSpecified=' + encodeURIComponent('' + editionIdSpecified) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetTenants(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetTenants(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<TenantListDtoPagedResultDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<TenantListDtoPagedResultDto>;
            });
    }

    protected processGetTenants(response: HttpResponseBase): Observable<TenantListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TenantListDtoPagedResultDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<TenantListDtoPagedResultDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createTenant(body: CreateTenantInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/CreateTenant';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processCreateTenant(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processCreateTenant(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processCreateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getTenantForEdit(id: number | undefined): Observable<TenantEditDto> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/GetTenantForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetTenantForEdit(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetTenantForEdit(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<TenantEditDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<TenantEditDto>;
            });
    }

    protected processGetTenantForEdit(response: HttpResponseBase): Observable<TenantEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TenantEditDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<TenantEditDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateTenant(body: TenantEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/UpdateTenant';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('put', url_, options_)
            .flatMap((response_: any) => {
                return this.processUpdateTenant(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUpdateTenant(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processUpdateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteTenant(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/DeleteTenant?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({})
        };

        return this.http
            .request('delete', url_, options_)
            .flatMap((response_: any) => {
                return this.processDeleteTenant(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processDeleteTenant(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processDeleteTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getTenantFeaturesForEdit(id: number | undefined): Observable<GetTenantFeaturesEditOutput> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/GetTenantFeaturesForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetTenantFeaturesForEdit(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetTenantFeaturesForEdit(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<GetTenantFeaturesEditOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<GetTenantFeaturesEditOutput>;
            });
    }

    protected processGetTenantFeaturesForEdit(response: HttpResponseBase): Observable<GetTenantFeaturesEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetTenantFeaturesEditOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<GetTenantFeaturesEditOutput>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateTenantFeatures(body: UpdateTenantFeaturesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/UpdateTenantFeatures';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('put', url_, options_)
            .flatMap((response_: any) => {
                return this.processUpdateTenantFeatures(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUpdateTenantFeatures(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processUpdateTenantFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    resetTenantSpecificFeatures(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/ResetTenantSpecificFeatures';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processResetTenantSpecificFeatures(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processResetTenantSpecificFeatures(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processResetTenantSpecificFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    unlockTenantAdmin(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/Tenant/UnlockTenantAdmin';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processUnlockTenantAdmin(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUnlockTenantAdmin(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processUnlockTenantAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }
}

@Injectable()
export class TenantRegistrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    registerTenant(body: RegisterTenantInput | undefined): Observable<RegisterTenantOutput> {
        let url_ = this.baseUrl + '/api/services/app/TenantRegistration/RegisterTenant';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processRegisterTenant(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processRegisterTenant(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<RegisterTenantOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<RegisterTenantOutput>;
            });
    }

    protected processRegisterTenant(response: HttpResponseBase): Observable<RegisterTenantOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RegisterTenantOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<RegisterTenantOutput>(null as any);
    }

    /**
     * @return Success
     */
    getEditionsForSelect(): Observable<EditionsSelectOutput> {
        let url_ = this.baseUrl + '/api/services/app/TenantRegistration/GetEditionsForSelect';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetEditionsForSelect(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetEditionsForSelect(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<EditionsSelectOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<EditionsSelectOutput>;
            });
    }

    protected processGetEditionsForSelect(response: HttpResponseBase): Observable<EditionsSelectOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EditionsSelectOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<EditionsSelectOutput>(null as any);
    }

    /**
     * @param editionId (optional)
     * @return Success
     */
    getEdition(editionId: number | undefined): Observable<EditionSelectDto> {
        let url_ = this.baseUrl + '/api/services/app/TenantRegistration/GetEdition?';
        if (editionId === null) throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined) url_ += 'editionId=' + encodeURIComponent('' + editionId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetEdition(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetEdition(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<EditionSelectDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<EditionSelectDto>;
            });
    }

    protected processGetEdition(response: HttpResponseBase): Observable<EditionSelectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EditionSelectDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<EditionSelectDto>(null as any);
    }
}

@Injectable()
export class TenantSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<TenantSettingsEditDto> {
        let url_ = this.baseUrl + '/api/services/app/TenantSettings/GetAllSettings';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetAllSettings(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetAllSettings(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<TenantSettingsEditDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<TenantSettingsEditDto>;
            });
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<TenantSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TenantSettingsEditDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<TenantSettingsEditDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAllSettings(body: TenantSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/TenantSettings/UpdateAllSettings';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('put', url_, options_)
            .flatMap((response_: any) => {
                return this.processUpdateAllSettings(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUpdateAllSettings(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @return Success
     */
    clearLogo(): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/TenantSettings/ClearLogo';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({})
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processClearLogo(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processClearLogo(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processClearLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @return Success
     */
    clearCustomCss(): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/TenantSettings/ClearCustomCss';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({})
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processClearCustomCss(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processClearCustomCss(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processClearCustomCss(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/TenantSettings/SendTestEmail';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processSendTestEmail(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processSendTestEmail(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }
}

@Injectable()
export class TimingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @param defaultTimezoneScope (optional)
     * @return Success
     */
    getTimezones(defaultTimezoneScope: SettingScopes | undefined): Observable<NameValueDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/Timing/GetTimezones?';
        if (defaultTimezoneScope === null) throw new Error("The parameter 'defaultTimezoneScope' cannot be null.");
        else if (defaultTimezoneScope !== undefined) url_ += 'DefaultTimezoneScope=' + encodeURIComponent('' + defaultTimezoneScope) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetTimezones(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetTimezones(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<NameValueDtoListResultDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<NameValueDtoListResultDto>;
            });
    }

    protected processGetTimezones(response: HttpResponseBase): Observable<NameValueDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = NameValueDtoListResultDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<NameValueDtoListResultDto>(null as any);
    }

    /**
     * @param selectedTimezoneId (optional)
     * @return Success
     */
    getTimezoneComboboxItems(selectedTimezoneId: string | undefined): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + '/api/services/app/Timing/GetTimezoneComboboxItems?';
        if (selectedTimezoneId === null) throw new Error("The parameter 'selectedTimezoneId' cannot be null.");
        else if (selectedTimezoneId !== undefined) url_ += 'SelectedTimezoneId=' + encodeURIComponent('' + selectedTimezoneId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetTimezoneComboboxItems(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetTimezoneComboboxItems(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<ComboboxItemDto[]>;
                    }
                } else return Observable.throw(response_) as any as Observable<ComboboxItemDto[]>;
            });
    }

    protected processGetTimezoneComboboxItems(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200.push(ComboboxItemDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<ComboboxItemDto[]>(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @return Success
     */
    logout(): Observable<void> {
        let url_ = this.baseUrl + '/api/TokenAuth/Logout';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({})
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processLogout(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processLogout(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processLogout(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + '/api/TokenAuth/Authenticate';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processAuthenticate(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processAuthenticate(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<AuthenticateResultModel>;
                    }
                } else return Observable.throw(response_) as any as Observable<AuthenticateResultModel>;
            });
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AuthenticateResultModel.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<AuthenticateResultModel>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendTwoFactorAuthCode(body: SendTwoFactorAuthCodeModel | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/TokenAuth/SendTwoFactorAuthCode';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processSendTwoFactorAuthCode(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processSendTwoFactorAuthCode(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processSendTwoFactorAuthCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param impersonationToken (optional)
     * @return Success
     */
    impersonatedAuthenticate(impersonationToken: string | undefined): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + '/api/TokenAuth/ImpersonatedAuthenticate?';
        if (impersonationToken === null) throw new Error("The parameter 'impersonationToken' cannot be null.");
        else if (impersonationToken !== undefined) url_ += 'impersonationToken=' + encodeURIComponent('' + impersonationToken) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processImpersonatedAuthenticate(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processImpersonatedAuthenticate(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<ImpersonatedAuthenticateResultModel>;
                    }
                } else return Observable.throw(response_) as any as Observable<ImpersonatedAuthenticateResultModel>;
            });
    }

    protected processImpersonatedAuthenticate(response: HttpResponseBase): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<ImpersonatedAuthenticateResultModel>(null as any);
    }

    /**
     * @param switchAccountToken (optional)
     * @return Success
     */
    linkedAccountAuthenticate(switchAccountToken: string | undefined): Observable<SwitchedAccountAuthenticateResultModel> {
        let url_ = this.baseUrl + '/api/TokenAuth/LinkedAccountAuthenticate?';
        if (switchAccountToken === null) throw new Error("The parameter 'switchAccountToken' cannot be null.");
        else if (switchAccountToken !== undefined) url_ += 'switchAccountToken=' + encodeURIComponent('' + switchAccountToken) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processLinkedAccountAuthenticate(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processLinkedAccountAuthenticate(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<SwitchedAccountAuthenticateResultModel>;
                    }
                } else return Observable.throw(response_) as any as Observable<SwitchedAccountAuthenticateResultModel>;
            });
    }

    protected processLinkedAccountAuthenticate(response: HttpResponseBase): Observable<SwitchedAccountAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SwitchedAccountAuthenticateResultModel.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<SwitchedAccountAuthenticateResultModel>(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + '/api/TokenAuth/GetExternalAuthenticationProviders';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetExternalAuthenticationProviders(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetExternalAuthenticationProviders(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                    }
                } else return Observable.throw(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
            });
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200.push(ExternalLoginProviderInfoModel.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<ExternalLoginProviderInfoModel[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + '/api/TokenAuth/ExternalAuthenticate';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json',
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processExternalAuthenticate(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processExternalAuthenticate(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<ExternalAuthenticateResultModel>;
                    }
                } else return Observable.throw(response_) as any as Observable<ExternalAuthenticateResultModel>;
            });
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<ExternalAuthenticateResultModel>(null as any);
    }

    /**
     * @param message (optional)
     * @param severity (optional)
     * @return Success
     */
    testNotification(message: string | undefined, severity: string | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/TokenAuth/TestNotification?';
        if (message === null) throw new Error("The parameter 'message' cannot be null.");
        else if (message !== undefined) url_ += 'message=' + encodeURIComponent('' + message) + '&';
        if (severity === null) throw new Error("The parameter 'severity' cannot be null.");
        else if (severity !== undefined) url_ += 'severity=' + encodeURIComponent('' + severity) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({})
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processTestNotification(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processTestNotification(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processTestNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }
}

@Injectable()
export class TrustStructureServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @return Success
     */
    getTrustTreeStructure(): Observable<TrustStructureDto> {
        let url_ = this.baseUrl + '/api/services/app/TrustStructure/GetTrustTreeStructure';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetTrustTreeStructure(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetTrustTreeStructure(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<TrustStructureDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<TrustStructureDto>;
            });
    }

    protected processGetTrustTreeStructure(response: HttpResponseBase): Observable<TrustStructureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = TrustStructureDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<TrustStructureDto>(null as any);
    }

    /**
     * @return Success
     */
    getTrustTheatreStructure(): Observable<TrustStructureItemDto[]> {
        let url_ = this.baseUrl + '/api/services/app/TrustStructure/GetTrustTheatreStructure';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetTrustTheatreStructure(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetTrustTheatreStructure(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<TrustStructureItemDto[]>;
                    }
                } else return Observable.throw(response_) as any as Observable<TrustStructureItemDto[]>;
            });
    }

    protected processGetTrustTheatreStructure(response: HttpResponseBase): Observable<TrustStructureItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200.push(TrustStructureItemDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<TrustStructureItemDto[]>(null as any);
    }

    /**
     * @param siteIds (optional)
     * @param consultantIds (optional)
     * @param specialtyIds (optional)
     * @return Success
     */
    getCohorts(
        siteIds: number[] | undefined,
        consultantIds: number[] | undefined,
        specialtyIds: number[] | undefined
    ): Observable<CohortDto[]> {
        let url_ = this.baseUrl + '/api/services/app/TrustStructure/GetCohorts?';
        if (siteIds === null) throw new Error("The parameter 'siteIds' cannot be null.");
        else if (siteIds !== undefined)
            siteIds &&
                siteIds.forEach((item) => {
                    url_ += 'SiteIds=' + encodeURIComponent('' + item) + '&';
                });
        if (consultantIds === null) throw new Error("The parameter 'consultantIds' cannot be null.");
        else if (consultantIds !== undefined)
            consultantIds &&
                consultantIds.forEach((item) => {
                    url_ += 'ConsultantIds=' + encodeURIComponent('' + item) + '&';
                });
        if (specialtyIds === null) throw new Error("The parameter 'specialtyIds' cannot be null.");
        else if (specialtyIds !== undefined)
            specialtyIds &&
                specialtyIds.forEach((item) => {
                    url_ += 'SpecialtyIds=' + encodeURIComponent('' + item) + '&';
                });
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetCohorts(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetCohorts(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<CohortDto[]>;
                    }
                } else return Observable.throw(response_) as any as Observable<CohortDto[]>;
            });
    }

    protected processGetCohorts(response: HttpResponseBase): Observable<CohortDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200.push(CohortDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<CohortDto[]>(null as any);
    }
}

@Injectable()
export class UiCustomizationSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @return Success
     */
    getUiManagementSettings(): Observable<UiCustomizationSettingsEditDto> {
        let url_ = this.baseUrl + '/api/services/app/UiCustomizationSettings/GetUiManagementSettings';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetUiManagementSettings(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetUiManagementSettings(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<UiCustomizationSettingsEditDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<UiCustomizationSettingsEditDto>;
            });
    }

    protected processGetUiManagementSettings(response: HttpResponseBase): Observable<UiCustomizationSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UiCustomizationSettingsEditDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<UiCustomizationSettingsEditDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateUiManagementSettings(body: UiCustomizationSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('put', url_, options_)
            .flatMap((response_: any) => {
                return this.processUpdateUiManagementSettings(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUpdateUiManagementSettings(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processUpdateUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateDefaultUiManagementSettings(body: UiCustomizationSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('put', url_, options_)
            .flatMap((response_: any) => {
                return this.processUpdateDefaultUiManagementSettings(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUpdateDefaultUiManagementSettings(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processUpdateDefaultUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @return Success
     */
    useSystemDefaultSettings(): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({})
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processUseSystemDefaultSettings(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUseSystemDefaultSettings(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processUseSystemDefaultSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @param filter (optional)
     * @param permission (optional)
     * @param role (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    getUsers(
        filter: string | undefined,
        permission: string | undefined,
        role: number | undefined,
        sorting: string | undefined,
        maxResultCount: number | undefined,
        skipCount: number | undefined
    ): Observable<UserListDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/User/GetUsers?';
        if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
        if (permission === null) throw new Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined) url_ += 'Permission=' + encodeURIComponent('' + permission) + '&';
        if (role === null) throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined) url_ += 'Role=' + encodeURIComponent('' + role) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetUsers(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetUsers(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<UserListDtoPagedResultDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<UserListDtoPagedResultDto>;
            });
    }

    protected processGetUsers(response: HttpResponseBase): Observable<UserListDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserListDtoPagedResultDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<UserListDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getUsersToExcel(): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/User/GetUsersToExcel';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetUsersToExcel(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetUsersToExcel(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<FileDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<FileDto>;
            });
    }

    protected processGetUsersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getUserForEdit(id: number | undefined): Observable<GetUserForEditOutput> {
        let url_ = this.baseUrl + '/api/services/app/User/GetUserForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetUserForEdit(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetUserForEdit(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<GetUserForEditOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<GetUserForEditOutput>;
            });
    }

    protected processGetUserForEdit(response: HttpResponseBase): Observable<GetUserForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetUserForEditOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<GetUserForEditOutput>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getUserPermissionsForEdit(id: number | undefined): Observable<GetUserPermissionsForEditOutput> {
        let url_ = this.baseUrl + '/api/services/app/User/GetUserPermissionsForEdit?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetUserPermissionsForEdit(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetUserPermissionsForEdit(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<GetUserPermissionsForEditOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<GetUserPermissionsForEditOutput>;
            });
    }

    protected processGetUserPermissionsForEdit(response: HttpResponseBase): Observable<GetUserPermissionsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetUserPermissionsForEditOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<GetUserPermissionsForEditOutput>(null as any);
    }

    /**
     * @return Success
     */
    getUnmappedEmployees(): Observable<EmployeeDto[]> {
        let url_ = this.baseUrl + '/api/services/app/User/GetUnmappedEmployees';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetUnmappedEmployees(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetUnmappedEmployees(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<EmployeeDto[]>;
                    }
                } else return Observable.throw(response_) as any as Observable<EmployeeDto[]>;
            });
    }

    protected processGetUnmappedEmployees(response: HttpResponseBase): Observable<EmployeeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200) result200.push(EmployeeDto.fromJS(item));
                } else {
                    result200 = <any>null;
                }
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<EmployeeDto[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    resetUserSpecificPermissions(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/User/ResetUserSpecificPermissions';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processResetUserSpecificPermissions(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processResetUserSpecificPermissions(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processResetUserSpecificPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateUserPermissions(body: UpdateUserPermissionsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/User/UpdateUserPermissions';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('put', url_, options_)
            .flatMap((response_: any) => {
                return this.processUpdateUserPermissions(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUpdateUserPermissions(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processUpdateUserPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createOrUpdateUser(body: CreateOrUpdateUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/User/CreateOrUpdateUser';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processCreateOrUpdateUser(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processCreateOrUpdateUser(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processCreateOrUpdateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    deleteUser(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/User/DeleteUser?';
        if (id === null) throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({})
        };

        return this.http
            .request('delete', url_, options_)
            .flatMap((response_: any) => {
                return this.processDeleteUser(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processDeleteUser(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    unlockUser(body: Int64EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/User/UnlockUser';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processUnlockUser(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUnlockUser(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processUnlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param userId (optional)
     * @return Success
     */
    resetUserPassword(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/User/ResetUserPassword?';
        if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({})
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processResetUserPassword(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processResetUserPassword(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processResetUserPassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }
}

@Injectable()
export class UserLinkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @param body (optional)
     * @return Success
     */
    linkToUser(body: LinkToUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/UserLink/LinkToUser';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processLinkToUser(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processLinkToUser(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processLinkToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }

    /**
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @param sorting (optional)
     * @return Success
     */
    getLinkedUsers(
        maxResultCount: number | undefined,
        skipCount: number | undefined,
        sorting: string | undefined
    ): Observable<LinkedUserDtoPagedResultDto> {
        let url_ = this.baseUrl + '/api/services/app/UserLink/GetLinkedUsers?';
        if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
        if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
        if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetLinkedUsers(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetLinkedUsers(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<LinkedUserDtoPagedResultDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<LinkedUserDtoPagedResultDto>;
            });
    }

    protected processGetLinkedUsers(response: HttpResponseBase): Observable<LinkedUserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LinkedUserDtoPagedResultDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<LinkedUserDtoPagedResultDto>(null as any);
    }

    /**
     * @return Success
     */
    getRecentlyUsedLinkedUsers(): Observable<LinkedUserDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/UserLink/GetRecentlyUsedLinkedUsers';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetRecentlyUsedLinkedUsers(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetRecentlyUsedLinkedUsers(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<LinkedUserDtoListResultDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<LinkedUserDtoListResultDto>;
            });
    }

    protected processGetRecentlyUsedLinkedUsers(response: HttpResponseBase): Observable<LinkedUserDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = LinkedUserDtoListResultDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<LinkedUserDtoListResultDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    unlinkUser(body: UnlinkUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + '/api/services/app/UserLink/UnlinkUser';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                'Content-Type': 'application/json-patch+json'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processUnlinkUser(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processUnlinkUser(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<void>;
                    }
                } else return Observable.throw(response_) as any as Observable<void>;
            });
    }

    protected processUnlinkUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return Observable.of<void>(null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<void>(null as any);
    }
}

@Injectable()
export class UserLoginServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @return Success
     */
    getRecentUserLoginAttempts(): Observable<UserLoginAttemptDtoListResultDto> {
        let url_ = this.baseUrl + '/api/services/app/UserLogin/GetRecentUserLoginAttempts';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetRecentUserLoginAttempts(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetRecentUserLoginAttempts(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<UserLoginAttemptDtoListResultDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<UserLoginAttemptDtoListResultDto>;
            });
    }

    protected processGetRecentUserLoginAttempts(response: HttpResponseBase): Observable<UserLoginAttemptDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UserLoginAttemptDtoListResultDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<UserLoginAttemptDtoListResultDto>(null as any);
    }
}

@Injectable()
export class WebLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'http://localhost.com:22742';
    }

    /**
     * @return Success
     */
    getLatestWebLogs(): Observable<GetLatestWebLogsOutput> {
        let url_ = this.baseUrl + '/api/services/app/WebLog/GetLatestWebLogs';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .flatMap((response_: any) => {
                return this.processGetLatestWebLogs(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetLatestWebLogs(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<GetLatestWebLogsOutput>;
                    }
                } else return Observable.throw(response_) as any as Observable<GetLatestWebLogsOutput>;
            });
    }

    protected processGetLatestWebLogs(response: HttpResponseBase): Observable<GetLatestWebLogsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetLatestWebLogsOutput.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<GetLatestWebLogsOutput>(null as any);
    }

    /**
     * @return Success
     */
    downloadWebLogs(): Observable<FileDto> {
        let url_ = this.baseUrl + '/api/services/app/WebLog/DownloadWebLogs';
        url_ = url_.replace(/[?&]$/, '');

        let options_: any = {
            observe: 'response',
            responseType: 'blob',
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('post', url_, options_)
            .flatMap((response_: any) => {
                return this.processDownloadWebLogs(response_);
            })
            .catch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processDownloadWebLogs(response_ as any);
                    } catch (e) {
                        return Observable.throw(e) as any as Observable<FileDto>;
                    }
                } else return Observable.throw(response_) as any as Observable<FileDto>;
            });
    }

    protected processDownloadWebLogs(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                ? (response as any).error
                : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }
        if (status === 200) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                let result200: any = null;
                let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FileDto.fromJS(resultData200);
                return Observable.of(result200);
            });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).flatMap((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Observable.of<FileDto>(null as any);
    }
}

export class AcceptFriendshipRequestInput implements IAcceptFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;

    constructor(data?: IAcceptFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data['userId'];
            this.tenantId = _data['tenantId'];
        }
    }

    static fromJS(data: any): AcceptFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userId'] = this.userId;
        data['tenantId'] = this.tenantId;
        return data;
    }
}

export interface IAcceptFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;
}

export class ActivateEmailInput implements IActivateEmailInput {
    userId: number;
    confirmationCode: string;

    constructor(data?: IActivateEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data['userId'];
            this.confirmationCode = _data['confirmationCode'];
        }
    }

    static fromJS(data: any): ActivateEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userId'] = this.userId;
        data['confirmationCode'] = this.confirmationCode;
        return data;
    }
}

export interface IActivateEmailInput {
    userId: number;
    confirmationCode: string;
}

export class Admission implements IAdmission {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IAdmission) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Admission {
        data = typeof data === 'object' ? data : {};
        let result = new Admission();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAdmission {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class Allergy implements IAllergy {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IAllergy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Allergy {
        data = typeof data === 'object' ? data : {};
        let result = new Allergy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAllergy {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class Anesthetic implements IAnesthetic {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IAnesthetic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Anesthetic {
        data = typeof data === 'object' ? data : {};
        let result = new Anesthetic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAnesthetic {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data['version'];
            this.releaseDate = _data['releaseDate'] ? moment(_data['releaseDate'].toString()) : <any>undefined;
            if (_data['features']) {
                this.features = {} as any;
                for (let key in _data['features']) {
                    if (_data['features'].hasOwnProperty(key)) (<any>this.features)[key] = _data['features'][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['version'] = this.version;
        data['releaseDate'] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        if (this.features) {
            data['features'] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key)) (<any>data['features'])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean } | undefined;
}

export class ApplicationLanguageEditDto implements IApplicationLanguageEditDto {
    id: number | undefined;
    name: string;
    icon: string | undefined;
    isEnabled: boolean;

    constructor(data?: IApplicationLanguageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.icon = _data['icon'];
            this.isEnabled = _data['isEnabled'];
        }
    }

    static fromJS(data: any): ApplicationLanguageEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['icon'] = this.icon;
        data['isEnabled'] = this.isEnabled;
        return data;
    }
}

export interface IApplicationLanguageEditDto {
    id: number | undefined;
    name: string;
    icon: string | undefined;
    isEnabled: boolean;
}

export class ApplicationLanguageListDto implements IApplicationLanguageListDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    icon: string | undefined;
    isDisabled: boolean;

    constructor(data?: IApplicationLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
            this.lastModifierUserId = _data['lastModifierUserId'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.icon = _data['icon'];
            this.isDisabled = _data['isDisabled'];
        }
    }

    static fromJS(data: any): ApplicationLanguageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data['lastModifierUserId'] = this.lastModifierUserId;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['icon'] = this.icon;
        data['isDisabled'] = this.isDisabled;
        return data;
    }
}

export interface IApplicationLanguageListDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    tenantId: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    icon: string | undefined;
    isDisabled: boolean;
}

export class AppSettingsJsonDto implements IAppSettingsJsonDto {
    webSiteUrl: string | undefined;
    serverSiteUrl: string | undefined;
    languages: NameValue[] | undefined;

    constructor(data?: IAppSettingsJsonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webSiteUrl = _data['webSiteUrl'];
            this.serverSiteUrl = _data['serverSiteUrl'];
            if (Array.isArray(_data['languages'])) {
                this.languages = [] as any;
                for (let item of _data['languages']) this.languages.push(NameValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppSettingsJsonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettingsJsonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['webSiteUrl'] = this.webSiteUrl;
        data['serverSiteUrl'] = this.serverSiteUrl;
        if (Array.isArray(this.languages)) {
            data['languages'] = [];
            for (let item of this.languages) data['languages'].push(item.toJSON());
        }
        return data;
    }
}

export interface IAppSettingsJsonDto {
    webSiteUrl: string | undefined;
    serverSiteUrl: string | undefined;
    languages: NameValue[] | undefined;
}

export class Assembly implements IAssembly {
    readonly definedTypes: TypeInfo[] | undefined;
    readonly exportedTypes: Type[] | undefined;
    readonly codeBase: string | undefined;
    entryPoint: MethodInfo;
    readonly fullName: string | undefined;
    readonly imageRuntimeVersion: string | undefined;
    readonly isDynamic: boolean;
    readonly location: string | undefined;
    readonly reflectionOnly: boolean;
    readonly isCollectible: boolean;
    readonly isFullyTrusted: boolean;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly escapedCodeBase: string | undefined;
    manifestModule: Module;
    readonly modules: Module[] | undefined;
    readonly globalAssemblyCache: boolean;
    readonly hostContext: number;
    securityRuleSet: SecurityRuleSet;

    constructor(data?: IAssembly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['definedTypes'])) {
                (<any>this).definedTypes = [] as any;
                for (let item of _data['definedTypes']) (<any>this).definedTypes.push(TypeInfo.fromJS(item));
            }
            if (Array.isArray(_data['exportedTypes'])) {
                (<any>this).exportedTypes = [] as any;
                for (let item of _data['exportedTypes']) (<any>this).exportedTypes.push(Type.fromJS(item));
            }
            (<any>this).codeBase = _data['codeBase'];
            this.entryPoint = _data['entryPoint'] ? MethodInfo.fromJS(_data['entryPoint']) : <any>undefined;
            (<any>this).fullName = _data['fullName'];
            (<any>this).imageRuntimeVersion = _data['imageRuntimeVersion'];
            (<any>this).isDynamic = _data['isDynamic'];
            (<any>this).location = _data['location'];
            (<any>this).reflectionOnly = _data['reflectionOnly'];
            (<any>this).isCollectible = _data['isCollectible'];
            (<any>this).isFullyTrusted = _data['isFullyTrusted'];
            if (Array.isArray(_data['customAttributes'])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data['customAttributes']) (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).escapedCodeBase = _data['escapedCodeBase'];
            this.manifestModule = _data['manifestModule'] ? Module.fromJS(_data['manifestModule']) : <any>undefined;
            if (Array.isArray(_data['modules'])) {
                (<any>this).modules = [] as any;
                for (let item of _data['modules']) (<any>this).modules.push(Module.fromJS(item));
            }
            (<any>this).globalAssemblyCache = _data['globalAssemblyCache'];
            (<any>this).hostContext = _data['hostContext'];
            this.securityRuleSet = _data['securityRuleSet'];
        }
    }

    static fromJS(data: any): Assembly {
        data = typeof data === 'object' ? data : {};
        let result = new Assembly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.definedTypes)) {
            data['definedTypes'] = [];
            for (let item of this.definedTypes) data['definedTypes'].push(item.toJSON());
        }
        if (Array.isArray(this.exportedTypes)) {
            data['exportedTypes'] = [];
            for (let item of this.exportedTypes) data['exportedTypes'].push(item.toJSON());
        }
        data['codeBase'] = this.codeBase;
        data['entryPoint'] = this.entryPoint ? this.entryPoint.toJSON() : <any>undefined;
        data['fullName'] = this.fullName;
        data['imageRuntimeVersion'] = this.imageRuntimeVersion;
        data['isDynamic'] = this.isDynamic;
        data['location'] = this.location;
        data['reflectionOnly'] = this.reflectionOnly;
        data['isCollectible'] = this.isCollectible;
        data['isFullyTrusted'] = this.isFullyTrusted;
        if (Array.isArray(this.customAttributes)) {
            data['customAttributes'] = [];
            for (let item of this.customAttributes) data['customAttributes'].push(item.toJSON());
        }
        data['escapedCodeBase'] = this.escapedCodeBase;
        data['manifestModule'] = this.manifestModule ? this.manifestModule.toJSON() : <any>undefined;
        if (Array.isArray(this.modules)) {
            data['modules'] = [];
            for (let item of this.modules) data['modules'].push(item.toJSON());
        }
        data['globalAssemblyCache'] = this.globalAssemblyCache;
        data['hostContext'] = this.hostContext;
        data['securityRuleSet'] = this.securityRuleSet;
        return data;
    }
}

export interface IAssembly {
    definedTypes: TypeInfo[] | undefined;
    exportedTypes: Type[] | undefined;
    codeBase: string | undefined;
    entryPoint: MethodInfo;
    fullName: string | undefined;
    imageRuntimeVersion: string | undefined;
    isDynamic: boolean;
    location: string | undefined;
    reflectionOnly: boolean;
    isCollectible: boolean;
    isFullyTrusted: boolean;
    customAttributes: CustomAttributeData[] | undefined;
    escapedCodeBase: string | undefined;
    manifestModule: Module;
    modules: Module[] | undefined;
    globalAssemblyCache: boolean;
    hostContext: number;
    securityRuleSet: SecurityRuleSet;
}

export class AuditLogListDto implements IAuditLogListDto {
    id: number;
    userId: number | undefined;
    userName: string | undefined;
    impersonatorTenantId: number | undefined;
    impersonatorUserId: number | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
    executionTime: moment.Moment;
    executionDuration: number;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    exception: string | undefined;
    customData: string | undefined;

    constructor(data?: IAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.userId = _data['userId'];
            this.userName = _data['userName'];
            this.impersonatorTenantId = _data['impersonatorTenantId'];
            this.impersonatorUserId = _data['impersonatorUserId'];
            this.serviceName = _data['serviceName'];
            this.methodName = _data['methodName'];
            this.parameters = _data['parameters'];
            this.executionTime = _data['executionTime'] ? moment(_data['executionTime'].toString()) : <any>undefined;
            this.executionDuration = _data['executionDuration'];
            this.clientIpAddress = _data['clientIpAddress'];
            this.clientName = _data['clientName'];
            this.browserInfo = _data['browserInfo'];
            this.exception = _data['exception'];
            this.customData = _data['customData'];
        }
    }

    static fromJS(data: any): AuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['userId'] = this.userId;
        data['userName'] = this.userName;
        data['impersonatorTenantId'] = this.impersonatorTenantId;
        data['impersonatorUserId'] = this.impersonatorUserId;
        data['serviceName'] = this.serviceName;
        data['methodName'] = this.methodName;
        data['parameters'] = this.parameters;
        data['executionTime'] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
        data['executionDuration'] = this.executionDuration;
        data['clientIpAddress'] = this.clientIpAddress;
        data['clientName'] = this.clientName;
        data['browserInfo'] = this.browserInfo;
        data['exception'] = this.exception;
        data['customData'] = this.customData;
        return data;
    }
}

export interface IAuditLogListDto {
    id: number;
    userId: number | undefined;
    userName: string | undefined;
    impersonatorTenantId: number | undefined;
    impersonatorUserId: number | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
    executionTime: moment.Moment;
    executionDuration: number;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    exception: string | undefined;
    customData: string | undefined;
}

export class AuditLogListDtoPagedResultDto implements IAuditLogListDtoPagedResultDto {
    items: AuditLogListDto[] | undefined;
    totalCount: number;

    constructor(data?: IAuditLogListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(AuditLogListDto.fromJS(item));
            }
            this.totalCount = _data['totalCount'];
        }
    }

    static fromJS(data: any): AuditLogListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        data['totalCount'] = this.totalCount;
        return data;
    }
}

export interface IAuditLogListDtoPagedResultDto {
    items: AuditLogListDto[] | undefined;
    totalCount: number;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode: string | undefined;
    rememberClient: boolean;
    twoFactorRememberClientToken: string | undefined;
    singleSignIn: boolean | undefined;
    returnUrl: string | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data['userNameOrEmailAddress'];
            this.password = _data['password'];
            this.twoFactorVerificationCode = _data['twoFactorVerificationCode'];
            this.rememberClient = _data['rememberClient'];
            this.twoFactorRememberClientToken = _data['twoFactorRememberClientToken'];
            this.singleSignIn = _data['singleSignIn'];
            this.returnUrl = _data['returnUrl'];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userNameOrEmailAddress'] = this.userNameOrEmailAddress;
        data['password'] = this.password;
        data['twoFactorVerificationCode'] = this.twoFactorVerificationCode;
        data['rememberClient'] = this.rememberClient;
        data['twoFactorRememberClientToken'] = this.twoFactorRememberClientToken;
        data['singleSignIn'] = this.singleSignIn;
        data['returnUrl'] = this.returnUrl;
        return data;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode: string | undefined;
    rememberClient: boolean;
    twoFactorRememberClientToken: string | undefined;
    singleSignIn: boolean | undefined;
    returnUrl: string | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    shouldResetPassword: boolean;
    passwordResetCode: string | undefined;
    userId: number;
    requiresTwoFactorVerification: boolean;
    twoFactorAuthProviders: string[] | undefined;
    twoFactorRememberClientToken: string | undefined;
    returnUrl: string | undefined;
    isPhoneConfirmed: boolean;
    phoneNumber: string | undefined;
    twoFactorCodeFailed: boolean;
    isLocked: boolean;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data['accessToken'];
            this.encryptedAccessToken = _data['encryptedAccessToken'];
            this.expireInSeconds = _data['expireInSeconds'];
            this.shouldResetPassword = _data['shouldResetPassword'];
            this.passwordResetCode = _data['passwordResetCode'];
            this.userId = _data['userId'];
            this.requiresTwoFactorVerification = _data['requiresTwoFactorVerification'];
            if (Array.isArray(_data['twoFactorAuthProviders'])) {
                this.twoFactorAuthProviders = [] as any;
                for (let item of _data['twoFactorAuthProviders']) this.twoFactorAuthProviders.push(item);
            }
            this.twoFactorRememberClientToken = _data['twoFactorRememberClientToken'];
            this.returnUrl = _data['returnUrl'];
            this.isPhoneConfirmed = _data['isPhoneConfirmed'];
            this.phoneNumber = _data['phoneNumber'];
            this.twoFactorCodeFailed = _data['twoFactorCodeFailed'];
            this.isLocked = _data['isLocked'];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['accessToken'] = this.accessToken;
        data['encryptedAccessToken'] = this.encryptedAccessToken;
        data['expireInSeconds'] = this.expireInSeconds;
        data['shouldResetPassword'] = this.shouldResetPassword;
        data['passwordResetCode'] = this.passwordResetCode;
        data['userId'] = this.userId;
        data['requiresTwoFactorVerification'] = this.requiresTwoFactorVerification;
        if (Array.isArray(this.twoFactorAuthProviders)) {
            data['twoFactorAuthProviders'] = [];
            for (let item of this.twoFactorAuthProviders) data['twoFactorAuthProviders'].push(item);
        }
        data['twoFactorRememberClientToken'] = this.twoFactorRememberClientToken;
        data['returnUrl'] = this.returnUrl;
        data['isPhoneConfirmed'] = this.isPhoneConfirmed;
        data['phoneNumber'] = this.phoneNumber;
        data['twoFactorCodeFailed'] = this.twoFactorCodeFailed;
        data['isLocked'] = this.isLocked;
        return data;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    shouldResetPassword: boolean;
    passwordResetCode: string | undefined;
    userId: number;
    requiresTwoFactorVerification: boolean;
    twoFactorAuthProviders: string[] | undefined;
    twoFactorRememberClientToken: string | undefined;
    returnUrl: string | undefined;
    isPhoneConfirmed: boolean;
    phoneNumber: string | undefined;
    twoFactorCodeFailed: boolean;
    isLocked: boolean;
}

export class AutofillDto implements IAutofillDto {
    sessionId: string | undefined;
    sessionsWaitingListIds: string[] | undefined;
    availableWaitingListIds: string[] | undefined;

    constructor(data?: IAutofillDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data['sessionId'];
            if (Array.isArray(_data['sessionsWaitingListIds'])) {
                this.sessionsWaitingListIds = [] as any;
                for (let item of _data['sessionsWaitingListIds']) this.sessionsWaitingListIds.push(item);
            }
            if (Array.isArray(_data['availableWaitingListIds'])) {
                this.availableWaitingListIds = [] as any;
                for (let item of _data['availableWaitingListIds']) this.availableWaitingListIds.push(item);
            }
        }
    }

    static fromJS(data: any): AutofillDto {
        data = typeof data === 'object' ? data : {};
        let result = new AutofillDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['sessionId'] = this.sessionId;
        if (Array.isArray(this.sessionsWaitingListIds)) {
            data['sessionsWaitingListIds'] = [];
            for (let item of this.sessionsWaitingListIds) data['sessionsWaitingListIds'].push(item);
        }
        if (Array.isArray(this.availableWaitingListIds)) {
            data['availableWaitingListIds'] = [];
            for (let item of this.availableWaitingListIds) data['availableWaitingListIds'].push(item);
        }
        return data;
    }
}

export interface IAutofillDto {
    sessionId: string | undefined;
    sessionsWaitingListIds: string[] | undefined;
    availableWaitingListIds: string[] | undefined;
}

export class BlockUserInput implements IBlockUserInput {
    userId: number;
    tenantId: number | undefined;

    constructor(data?: IBlockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data['userId'];
            this.tenantId = _data['tenantId'];
        }
    }

    static fromJS(data: any): BlockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new BlockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userId'] = this.userId;
        data['tenantId'] = this.tenantId;
        return data;
    }
}

export interface IBlockUserInput {
    userId: number;
    tenantId: number | undefined;
}

export class CacheDto implements ICacheDto {
    name: string | undefined;

    constructor(data?: ICacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): CacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new CacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        return data;
    }
}

export interface ICacheDto {
    name: string | undefined;
}

export class CacheDtoListResultDto implements ICacheDtoListResultDto {
    items: CacheDto[] | undefined;

    constructor(data?: ICacheDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(CacheDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CacheDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CacheDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }
}

export interface ICacheDtoListResultDto {
    items: CacheDto[] | undefined;
}

export enum CallingConventions {
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _32 = 32,
    _64 = 64
}

export class CancelationType implements ICancelationType {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: ICancelationType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CancelationType {
        data = typeof data === 'object' ? data : {};
        let result = new CancelationType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICancelationType {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class ChangePasswordInput implements IChangePasswordInput {
    currentPassword: string;
    newPassword: string;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data['currentPassword'];
            this.newPassword = _data['newPassword'];
        }
    }

    static fromJS(data: any): ChangePasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['currentPassword'] = this.currentPassword;
        data['newPassword'] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordInput {
    currentPassword: string;
    newPassword: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data['languageName'];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['languageName'] = this.languageName;
        return data;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class ChatMessageDto implements IChatMessageDto {
    id: number;
    userId: number;
    tenantId: number | undefined;
    targetUserId: number;
    targetTenantId: number | undefined;
    side: ChatSide;
    readState: ChatMessageReadState;
    receiverReadState: ChatMessageReadState;
    message: string | undefined;
    creationTime: moment.Moment;
    sharedMessageId: string | undefined;

    constructor(data?: IChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.userId = _data['userId'];
            this.tenantId = _data['tenantId'];
            this.targetUserId = _data['targetUserId'];
            this.targetTenantId = _data['targetTenantId'];
            this.side = _data['side'];
            this.readState = _data['readState'];
            this.receiverReadState = _data['receiverReadState'];
            this.message = _data['message'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.sharedMessageId = _data['sharedMessageId'];
        }
    }

    static fromJS(data: any): ChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['userId'] = this.userId;
        data['tenantId'] = this.tenantId;
        data['targetUserId'] = this.targetUserId;
        data['targetTenantId'] = this.targetTenantId;
        data['side'] = this.side;
        data['readState'] = this.readState;
        data['receiverReadState'] = this.receiverReadState;
        data['message'] = this.message;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['sharedMessageId'] = this.sharedMessageId;
        return data;
    }
}

export interface IChatMessageDto {
    id: number;
    userId: number;
    tenantId: number | undefined;
    targetUserId: number;
    targetTenantId: number | undefined;
    side: ChatSide;
    readState: ChatMessageReadState;
    receiverReadState: ChatMessageReadState;
    message: string | undefined;
    creationTime: moment.Moment;
    sharedMessageId: string | undefined;
}

export class ChatMessageDtoListResultDto implements IChatMessageDtoListResultDto {
    items: ChatMessageDto[] | undefined;

    constructor(data?: IChatMessageDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(ChatMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChatMessageDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }
}

export interface IChatMessageDtoListResultDto {
    items: ChatMessageDto[] | undefined;
}

export enum ChatMessageReadState {
    _1 = 1,
    _2 = 2
}

export enum ChatSide {
    _1 = 1,
    _2 = 2
}

export class CheckDatabaseOutput implements ICheckDatabaseOutput {
    isDatabaseExist: boolean;

    constructor(data?: ICheckDatabaseOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDatabaseExist = _data['isDatabaseExist'];
        }
    }

    static fromJS(data: any): CheckDatabaseOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckDatabaseOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['isDatabaseExist'] = this.isDatabaseExist;
        return data;
    }
}

export interface ICheckDatabaseOutput {
    isDatabaseExist: boolean;
}

export class Cohort implements ICohort {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: ICohort) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Cohort {
        data = typeof data === 'object' ? data : {};
        let result = new Cohort();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICohort {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class CohortDto implements ICohortDto {
    id: number;
    name: string | undefined;

    constructor(data?: ICohortDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): CohortDto {
        data = typeof data === 'object' ? data : {};
        let result = new CohortDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        return data;
    }
}

export interface ICohortDto {
    id: number;
    name: string | undefined;
}

export class ComboboxItemDto implements IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;

    constructor(data?: IComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data['value'];
            this.displayText = _data['displayText'];
            this.isSelected = _data['isSelected'];
        }
    }

    static fromJS(data: any): ComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['value'] = this.value;
        data['displayText'] = this.displayText;
        data['isSelected'] = this.isSelected;
        return data;
    }
}

export interface IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class Comment implements IComment {
    id: number;
    userId: number;
    commentSectionId: number;
    value: string | undefined;
    user: User;
    commentSection: CommentSection;
    creationTime: moment.Moment;

    constructor(data?: IComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.userId = _data['userId'];
            this.commentSectionId = _data['commentSectionId'];
            this.value = _data['value'];
            this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
            this.commentSection = _data['commentSection'] ? CommentSection.fromJS(_data['commentSection']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Comment {
        data = typeof data === 'object' ? data : {};
        let result = new Comment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['userId'] = this.userId;
        data['commentSectionId'] = this.commentSectionId;
        data['value'] = this.value;
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        data['commentSection'] = this.commentSection ? this.commentSection.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IComment {
    id: number;
    userId: number;
    commentSectionId: number;
    value: string | undefined;
    user: User;
    commentSection: CommentSection;
    creationTime: moment.Moment;
}

export class CommentDto implements ICommentDto {
    fullName: string | undefined;
    profilePictureId: string | undefined;
    value: string | undefined;
    creationTime: moment.Moment;

    constructor(data?: ICommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data['fullName'];
            this.profilePictureId = _data['profilePictureId'];
            this.value = _data['value'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['fullName'] = this.fullName;
        data['profilePictureId'] = this.profilePictureId;
        data['value'] = this.value;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICommentDto {
    fullName: string | undefined;
    profilePictureId: string | undefined;
    value: string | undefined;
    creationTime: moment.Moment;
}

export class CommentSection implements ICommentSection {
    id: number;
    sessionId: string | undefined;
    session: Session;
    comments: Comment[] | undefined;

    constructor(data?: ICommentSection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.sessionId = _data['sessionId'];
            this.session = _data['session'] ? Session.fromJS(_data['session']) : <any>undefined;
            if (Array.isArray(_data['comments'])) {
                this.comments = [] as any;
                for (let item of _data['comments']) this.comments.push(Comment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommentSection {
        data = typeof data === 'object' ? data : {};
        let result = new CommentSection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['sessionId'] = this.sessionId;
        data['session'] = this.session ? this.session.toJSON() : <any>undefined;
        if (Array.isArray(this.comments)) {
            data['comments'] = [];
            for (let item of this.comments) data['comments'].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommentSection {
    id: number;
    sessionId: string | undefined;
    session: Session;
    comments: Comment[] | undefined;
}

export class CommentSectionDto implements ICommentSectionDto {
    comments: CommentDto[] | undefined;

    constructor(data?: ICommentSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['comments'])) {
                this.comments = [] as any;
                for (let item of _data['comments']) this.comments.push(CommentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CommentSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CommentSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.comments)) {
            data['comments'] = [];
            for (let item of this.comments) data['comments'].push(item.toJSON());
        }
        return data;
    }
}

export interface ICommentSectionDto {
    comments: CommentDto[] | undefined;
}

export class ConstructorInfo implements IConstructorInfo {
    readonly name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly isCollectible: boolean;
    readonly metadataToken: number;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    readonly isAbstract: boolean;
    readonly isConstructor: boolean;
    readonly isFinal: boolean;
    readonly isHideBySig: boolean;
    readonly isSpecialName: boolean;
    readonly isStatic: boolean;
    readonly isVirtual: boolean;
    readonly isAssembly: boolean;
    readonly isFamily: boolean;
    readonly isFamilyAndAssembly: boolean;
    readonly isFamilyOrAssembly: boolean;
    readonly isPrivate: boolean;
    readonly isPublic: boolean;
    readonly isConstructedGenericMethod: boolean;
    readonly isGenericMethod: boolean;
    readonly isGenericMethodDefinition: boolean;
    readonly containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    readonly isSecurityCritical: boolean;
    readonly isSecuritySafeCritical: boolean;
    readonly isSecurityTransparent: boolean;
    memberType: MemberTypes;

    constructor(data?: IConstructorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data['name'];
            this.declaringType = _data['declaringType'] ? Type.fromJS(_data['declaringType']) : <any>undefined;
            this.reflectedType = _data['reflectedType'] ? Type.fromJS(_data['reflectedType']) : <any>undefined;
            this.module = _data['module'] ? Module.fromJS(_data['module']) : <any>undefined;
            if (Array.isArray(_data['customAttributes'])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data['customAttributes']) (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data['isCollectible'];
            (<any>this).metadataToken = _data['metadataToken'];
            this.attributes = _data['attributes'];
            this.methodImplementationFlags = _data['methodImplementationFlags'];
            this.callingConvention = _data['callingConvention'];
            (<any>this).isAbstract = _data['isAbstract'];
            (<any>this).isConstructor = _data['isConstructor'];
            (<any>this).isFinal = _data['isFinal'];
            (<any>this).isHideBySig = _data['isHideBySig'];
            (<any>this).isSpecialName = _data['isSpecialName'];
            (<any>this).isStatic = _data['isStatic'];
            (<any>this).isVirtual = _data['isVirtual'];
            (<any>this).isAssembly = _data['isAssembly'];
            (<any>this).isFamily = _data['isFamily'];
            (<any>this).isFamilyAndAssembly = _data['isFamilyAndAssembly'];
            (<any>this).isFamilyOrAssembly = _data['isFamilyOrAssembly'];
            (<any>this).isPrivate = _data['isPrivate'];
            (<any>this).isPublic = _data['isPublic'];
            (<any>this).isConstructedGenericMethod = _data['isConstructedGenericMethod'];
            (<any>this).isGenericMethod = _data['isGenericMethod'];
            (<any>this).isGenericMethodDefinition = _data['isGenericMethodDefinition'];
            (<any>this).containsGenericParameters = _data['containsGenericParameters'];
            this.methodHandle = _data['methodHandle'] ? RuntimeMethodHandle.fromJS(_data['methodHandle']) : <any>undefined;
            (<any>this).isSecurityCritical = _data['isSecurityCritical'];
            (<any>this).isSecuritySafeCritical = _data['isSecuritySafeCritical'];
            (<any>this).isSecurityTransparent = _data['isSecurityTransparent'];
            this.memberType = _data['memberType'];
        }
    }

    static fromJS(data: any): ConstructorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['declaringType'] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data['reflectedType'] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data['module'] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data['customAttributes'] = [];
            for (let item of this.customAttributes) data['customAttributes'].push(item.toJSON());
        }
        data['isCollectible'] = this.isCollectible;
        data['metadataToken'] = this.metadataToken;
        data['attributes'] = this.attributes;
        data['methodImplementationFlags'] = this.methodImplementationFlags;
        data['callingConvention'] = this.callingConvention;
        data['isAbstract'] = this.isAbstract;
        data['isConstructor'] = this.isConstructor;
        data['isFinal'] = this.isFinal;
        data['isHideBySig'] = this.isHideBySig;
        data['isSpecialName'] = this.isSpecialName;
        data['isStatic'] = this.isStatic;
        data['isVirtual'] = this.isVirtual;
        data['isAssembly'] = this.isAssembly;
        data['isFamily'] = this.isFamily;
        data['isFamilyAndAssembly'] = this.isFamilyAndAssembly;
        data['isFamilyOrAssembly'] = this.isFamilyOrAssembly;
        data['isPrivate'] = this.isPrivate;
        data['isPublic'] = this.isPublic;
        data['isConstructedGenericMethod'] = this.isConstructedGenericMethod;
        data['isGenericMethod'] = this.isGenericMethod;
        data['isGenericMethodDefinition'] = this.isGenericMethodDefinition;
        data['containsGenericParameters'] = this.containsGenericParameters;
        data['methodHandle'] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data['isSecurityCritical'] = this.isSecurityCritical;
        data['isSecuritySafeCritical'] = this.isSecuritySafeCritical;
        data['isSecurityTransparent'] = this.isSecurityTransparent;
        data['memberType'] = this.memberType;
        return data;
    }
}

export interface IConstructorInfo {
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    memberType: MemberTypes;
}

export class CreateFriendshipRequestByUserNameInput implements ICreateFriendshipRequestByUserNameInput {
    tenancyName: string;
    userName: string | undefined;

    constructor(data?: ICreateFriendshipRequestByUserNameInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data['tenancyName'];
            this.userName = _data['userName'];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestByUserNameInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestByUserNameInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenancyName'] = this.tenancyName;
        data['userName'] = this.userName;
        return data;
    }
}

export interface ICreateFriendshipRequestByUserNameInput {
    tenancyName: string;
    userName: string | undefined;
}

export class CreateFriendshipRequestInput implements ICreateFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;

    constructor(data?: ICreateFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data['userId'];
            this.tenantId = _data['tenantId'];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userId'] = this.userId;
        data['tenantId'] = this.tenantId;
        return data;
    }
}

export interface ICreateFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;
}

export class CreateInvoiceDto implements ICreateInvoiceDto {
    subscriptionPaymentId: number;

    constructor(data?: ICreateInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionPaymentId = _data['subscriptionPaymentId'];
        }
    }

    static fromJS(data: any): CreateInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['subscriptionPaymentId'] = this.subscriptionPaymentId;
        return data;
    }
}

export interface ICreateInvoiceDto {
    subscriptionPaymentId: number;
}

export class CreateOrganizationUnitInput implements ICreateOrganizationUnitInput {
    parentId: number | undefined;
    displayName: string;

    constructor(data?: ICreateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data['parentId'];
            this.displayName = _data['displayName'];
        }
    }

    static fromJS(data: any): CreateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['parentId'] = this.parentId;
        data['displayName'] = this.displayName;
        return data;
    }
}

export interface ICreateOrganizationUnitInput {
    parentId: number | undefined;
    displayName: string;
}

export class CreateOrUpdateEditionDto implements ICreateOrUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[];

    constructor(data?: ICreateOrUpdateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.edition = new EditionEditDto();
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data['edition'] ? EditionEditDto.fromJS(_data['edition']) : new EditionEditDto();
            if (Array.isArray(_data['featureValues'])) {
                this.featureValues = [] as any;
                for (let item of _data['featureValues']) this.featureValues.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['edition'] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data['featureValues'] = [];
            for (let item of this.featureValues) data['featureValues'].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateOrUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
}

export class CreateOrUpdateLanguageInput implements ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto;

    constructor(data?: ICreateOrUpdateLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.language = new ApplicationLanguageEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data['language'] ? ApplicationLanguageEditDto.fromJS(_data['language']) : new ApplicationLanguageEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['language'] = this.language ? this.language.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto;
}

export class CreateOrUpdateRoleInput implements ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[];

    constructor(data?: ICreateOrUpdateRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.role = new RoleEditDto();
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data['role'] ? RoleEditDto.fromJS(_data['role']) : new RoleEditDto();
            if (Array.isArray(_data['grantedPermissionNames'])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data['grantedPermissionNames']) this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateRoleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['role'] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.grantedPermissionNames)) {
            data['grantedPermissionNames'] = [];
            for (let item of this.grantedPermissionNames) data['grantedPermissionNames'].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[];
}

export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
    user: UserEditDto;
    assignedRoleNames: string[];
    sendActivationEmail: boolean;
    setRandomPassword: boolean;
    organizationUnits: number[] | undefined;

    constructor(data?: ICreateOrUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new UserEditDto();
            this.assignedRoleNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data['user'] ? UserEditDto.fromJS(_data['user']) : new UserEditDto();
            if (Array.isArray(_data['assignedRoleNames'])) {
                this.assignedRoleNames = [] as any;
                for (let item of _data['assignedRoleNames']) this.assignedRoleNames.push(item);
            }
            this.sendActivationEmail = _data['sendActivationEmail'];
            this.setRandomPassword = _data['setRandomPassword'];
            if (Array.isArray(_data['organizationUnits'])) {
                this.organizationUnits = [] as any;
                for (let item of _data['organizationUnits']) this.organizationUnits.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.assignedRoleNames)) {
            data['assignedRoleNames'] = [];
            for (let item of this.assignedRoleNames) data['assignedRoleNames'].push(item);
        }
        data['sendActivationEmail'] = this.sendActivationEmail;
        data['setRandomPassword'] = this.setRandomPassword;
        if (Array.isArray(this.organizationUnits)) {
            data['organizationUnits'] = [];
            for (let item of this.organizationUnits) data['organizationUnits'].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateUserInput {
    user: UserEditDto;
    assignedRoleNames: string[];
    sendActivationEmail: boolean;
    setRandomPassword: boolean;
    organizationUnits: number[] | undefined;
}

export class CreatePaymentDto implements ICreatePaymentDto {
    editionId: number;
    editionPaymentType: EditionPaymentType;
    paymentPeriodType: PaymentPeriodType;
    subscriptionPaymentGatewayType: SubscriptionPaymentGatewayType;

    constructor(data?: ICreatePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.editionId = _data['editionId'];
            this.editionPaymentType = _data['editionPaymentType'];
            this.paymentPeriodType = _data['paymentPeriodType'];
            this.subscriptionPaymentGatewayType = _data['subscriptionPaymentGatewayType'];
        }
    }

    static fromJS(data: any): CreatePaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['editionId'] = this.editionId;
        data['editionPaymentType'] = this.editionPaymentType;
        data['paymentPeriodType'] = this.paymentPeriodType;
        data['subscriptionPaymentGatewayType'] = this.subscriptionPaymentGatewayType;
        return data;
    }
}

export interface ICreatePaymentDto {
    editionId: number;
    editionPaymentType: EditionPaymentType;
    paymentPeriodType: PaymentPeriodType;
    subscriptionPaymentGatewayType: SubscriptionPaymentGatewayType;
}

export class CreatePaymentResponse implements ICreatePaymentResponse {
    constructor(data?: ICreatePaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {}

    static fromJS(data: any): CreatePaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICreatePaymentResponse {}

export class CreateTenantExternalInput implements ICreateTenantExternalInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    connectionString: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    clientId: string | undefined;
    groupId: string | undefined;
    reportId: string | undefined;
    createTenantApiKey: string | undefined;

    constructor(data?: ICreateTenantExternalInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data['tenancyName'];
            this.name = _data['name'];
            this.adminEmailAddress = _data['adminEmailAddress'];
            this.adminPassword = _data['adminPassword'];
            this.connectionString = _data['connectionString'];
            this.shouldChangePasswordOnNextLogin = _data['shouldChangePasswordOnNextLogin'];
            this.sendActivationEmail = _data['sendActivationEmail'];
            this.editionId = _data['editionId'];
            this.isActive = _data['isActive'];
            this.subscriptionEndDateUtc = _data['subscriptionEndDateUtc']
                ? moment(_data['subscriptionEndDateUtc'].toString())
                : <any>undefined;
            this.isInTrialPeriod = _data['isInTrialPeriod'];
            this.clientId = _data['clientId'];
            this.groupId = _data['groupId'];
            this.reportId = _data['reportId'];
            this.createTenantApiKey = _data['createTenantApiKey'];
        }
    }

    static fromJS(data: any): CreateTenantExternalInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantExternalInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenancyName'] = this.tenancyName;
        data['name'] = this.name;
        data['adminEmailAddress'] = this.adminEmailAddress;
        data['adminPassword'] = this.adminPassword;
        data['connectionString'] = this.connectionString;
        data['shouldChangePasswordOnNextLogin'] = this.shouldChangePasswordOnNextLogin;
        data['sendActivationEmail'] = this.sendActivationEmail;
        data['editionId'] = this.editionId;
        data['isActive'] = this.isActive;
        data['subscriptionEndDateUtc'] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data['isInTrialPeriod'] = this.isInTrialPeriod;
        data['clientId'] = this.clientId;
        data['groupId'] = this.groupId;
        data['reportId'] = this.reportId;
        data['createTenantApiKey'] = this.createTenantApiKey;
        return data;
    }
}

export interface ICreateTenantExternalInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    connectionString: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    clientId: string | undefined;
    groupId: string | undefined;
    reportId: string | undefined;
    createTenantApiKey: string | undefined;
}

export class CreateTenantInput implements ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    connectionString: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    clientId: string | undefined;
    groupId: string | undefined;
    reportId: string | undefined;

    constructor(data?: ICreateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data['tenancyName'];
            this.name = _data['name'];
            this.adminEmailAddress = _data['adminEmailAddress'];
            this.adminPassword = _data['adminPassword'];
            this.connectionString = _data['connectionString'];
            this.shouldChangePasswordOnNextLogin = _data['shouldChangePasswordOnNextLogin'];
            this.sendActivationEmail = _data['sendActivationEmail'];
            this.editionId = _data['editionId'];
            this.isActive = _data['isActive'];
            this.subscriptionEndDateUtc = _data['subscriptionEndDateUtc']
                ? moment(_data['subscriptionEndDateUtc'].toString())
                : <any>undefined;
            this.isInTrialPeriod = _data['isInTrialPeriod'];
            this.clientId = _data['clientId'];
            this.groupId = _data['groupId'];
            this.reportId = _data['reportId'];
        }
    }

    static fromJS(data: any): CreateTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenancyName'] = this.tenancyName;
        data['name'] = this.name;
        data['adminEmailAddress'] = this.adminEmailAddress;
        data['adminPassword'] = this.adminPassword;
        data['connectionString'] = this.connectionString;
        data['shouldChangePasswordOnNextLogin'] = this.shouldChangePasswordOnNextLogin;
        data['sendActivationEmail'] = this.sendActivationEmail;
        data['editionId'] = this.editionId;
        data['isActive'] = this.isActive;
        data['subscriptionEndDateUtc'] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data['isInTrialPeriod'] = this.isInTrialPeriod;
        data['clientId'] = this.clientId;
        data['groupId'] = this.groupId;
        data['reportId'] = this.reportId;
        return data;
    }
}

export interface ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    connectionString: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    clientId: string | undefined;
    groupId: string | undefined;
    reportId: string | undefined;
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
    title: string | undefined;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    timezone: string | undefined;
    qrCodeSetupImageUrl: string | undefined;
    isGoogleAuthenticatorEnabled: boolean;
    isAdmin: boolean;
    isSmsAuthenticationEnabled: boolean;
    isTwoFactorAuthenticationForced: boolean;
    isTwoFactorEnabled: boolean;

    constructor(data?: ICurrentUserProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data['title'];
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.userName = _data['userName'];
            this.emailAddress = _data['emailAddress'];
            this.phoneNumber = _data['phoneNumber'];
            this.isPhoneNumberConfirmed = _data['isPhoneNumberConfirmed'];
            this.timezone = _data['timezone'];
            this.qrCodeSetupImageUrl = _data['qrCodeSetupImageUrl'];
            this.isGoogleAuthenticatorEnabled = _data['isGoogleAuthenticatorEnabled'];
            this.isAdmin = _data['isAdmin'];
            this.isSmsAuthenticationEnabled = _data['isSmsAuthenticationEnabled'];
            this.isTwoFactorAuthenticationForced = _data['isTwoFactorAuthenticationForced'];
            this.isTwoFactorEnabled = _data['isTwoFactorEnabled'];
        }
    }

    static fromJS(data: any): CurrentUserProfileEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['title'] = this.title;
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['userName'] = this.userName;
        data['emailAddress'] = this.emailAddress;
        data['phoneNumber'] = this.phoneNumber;
        data['isPhoneNumberConfirmed'] = this.isPhoneNumberConfirmed;
        data['timezone'] = this.timezone;
        data['qrCodeSetupImageUrl'] = this.qrCodeSetupImageUrl;
        data['isGoogleAuthenticatorEnabled'] = this.isGoogleAuthenticatorEnabled;
        data['isAdmin'] = this.isAdmin;
        data['isSmsAuthenticationEnabled'] = this.isSmsAuthenticationEnabled;
        data['isTwoFactorAuthenticationForced'] = this.isTwoFactorAuthenticationForced;
        data['isTwoFactorEnabled'] = this.isTwoFactorEnabled;
        return data;
    }
}

export interface ICurrentUserProfileEditDto {
    title: string | undefined;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    timezone: string | undefined;
    qrCodeSetupImageUrl: string | undefined;
    isGoogleAuthenticatorEnabled: boolean;
    isAdmin: boolean;
    isSmsAuthenticationEnabled: boolean;
    isTwoFactorAuthenticationForced: boolean;
    isTwoFactorEnabled: boolean;
}

export class CustomAttributeData implements ICustomAttributeData {
    attributeType: Type;
    constructor_: ConstructorInfo;
    readonly constructorArguments: CustomAttributeTypedArgument[] | undefined;
    readonly namedArguments: CustomAttributeNamedArgument[] | undefined;

    constructor(data?: ICustomAttributeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributeType = _data['attributeType'] ? Type.fromJS(_data['attributeType']) : <any>undefined;
            this.constructor_ = _data['constructor'] ? ConstructorInfo.fromJS(_data['constructor']) : <any>undefined;
            if (Array.isArray(_data['constructorArguments'])) {
                (<any>this).constructorArguments = [] as any;
                for (let item of _data['constructorArguments'])
                    (<any>this).constructorArguments.push(CustomAttributeTypedArgument.fromJS(item));
            }
            if (Array.isArray(_data['namedArguments'])) {
                (<any>this).namedArguments = [] as any;
                for (let item of _data['namedArguments']) (<any>this).namedArguments.push(CustomAttributeNamedArgument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomAttributeData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['attributeType'] = this.attributeType ? this.attributeType.toJSON() : <any>undefined;
        data['constructor'] = this.constructor_ ? this.constructor_.toJSON() : <any>undefined;
        if (Array.isArray(this.constructorArguments)) {
            data['constructorArguments'] = [];
            for (let item of this.constructorArguments) data['constructorArguments'].push(item.toJSON());
        }
        if (Array.isArray(this.namedArguments)) {
            data['namedArguments'] = [];
            for (let item of this.namedArguments) data['namedArguments'].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomAttributeData {
    attributeType: Type;
    constructor_: ConstructorInfo;
    constructorArguments: CustomAttributeTypedArgument[] | undefined;
    namedArguments: CustomAttributeNamedArgument[] | undefined;
}

export class CustomAttributeNamedArgument implements ICustomAttributeNamedArgument {
    memberInfo: MemberInfo;
    typedValue: CustomAttributeTypedArgument;
    readonly memberName: string | undefined;
    readonly isField: boolean;

    constructor(data?: ICustomAttributeNamedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberInfo = _data['memberInfo'] ? MemberInfo.fromJS(_data['memberInfo']) : <any>undefined;
            this.typedValue = _data['typedValue'] ? CustomAttributeTypedArgument.fromJS(_data['typedValue']) : <any>undefined;
            (<any>this).memberName = _data['memberName'];
            (<any>this).isField = _data['isField'];
        }
    }

    static fromJS(data: any): CustomAttributeNamedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeNamedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['memberInfo'] = this.memberInfo ? this.memberInfo.toJSON() : <any>undefined;
        data['typedValue'] = this.typedValue ? this.typedValue.toJSON() : <any>undefined;
        data['memberName'] = this.memberName;
        data['isField'] = this.isField;
        return data;
    }
}

export interface ICustomAttributeNamedArgument {
    memberInfo: MemberInfo;
    typedValue: CustomAttributeTypedArgument;
    memberName: string | undefined;
    isField: boolean;
}

export class CustomAttributeTypedArgument implements ICustomAttributeTypedArgument {
    argumentType: Type;
    readonly value: any | undefined;

    constructor(data?: ICustomAttributeTypedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.argumentType = _data['argumentType'] ? Type.fromJS(_data['argumentType']) : <any>undefined;
            (<any>this).value = _data['value'];
        }
    }

    static fromJS(data: any): CustomAttributeTypedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeTypedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['argumentType'] = this.argumentType ? this.argumentType.toJSON() : <any>undefined;
        data['value'] = this.value;
        return data;
    }
}

export interface ICustomAttributeTypedArgument {
    argumentType: Type;
    value: any | undefined;
}

export class DateToStringOutput implements IDateToStringOutput {
    dateString: string | undefined;

    constructor(data?: IDateToStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateString = _data['dateString'];
        }
    }

    static fromJS(data: any): DateToStringOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DateToStringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['dateString'] = this.dateString;
        return data;
    }
}

export interface IDateToStringOutput {
    dateString: string | undefined;
}

export class EditionEditDto implements IEditionEditDto {
    id: number | undefined;
    displayName: string;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    expiringEditionId: number | undefined;

    constructor(data?: IEditionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.displayName = _data['displayName'];
            this.monthlyPrice = _data['monthlyPrice'];
            this.annualPrice = _data['annualPrice'];
            this.trialDayCount = _data['trialDayCount'];
            this.waitingDayAfterExpire = _data['waitingDayAfterExpire'];
            this.expiringEditionId = _data['expiringEditionId'];
        }
    }

    static fromJS(data: any): EditionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['displayName'] = this.displayName;
        data['monthlyPrice'] = this.monthlyPrice;
        data['annualPrice'] = this.annualPrice;
        data['trialDayCount'] = this.trialDayCount;
        data['waitingDayAfterExpire'] = this.waitingDayAfterExpire;
        data['expiringEditionId'] = this.expiringEditionId;
        return data;
    }
}

export interface IEditionEditDto {
    id: number | undefined;
    displayName: string;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    expiringEditionId: number | undefined;
}

export class EditionInfoDto implements IEditionInfoDto {
    id: number;
    displayName: string | undefined;
    trialDayCount: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    isHighestEdition: boolean;
    isFree: boolean;

    constructor(data?: IEditionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.displayName = _data['displayName'];
            this.trialDayCount = _data['trialDayCount'];
            this.monthlyPrice = _data['monthlyPrice'];
            this.annualPrice = _data['annualPrice'];
            this.isHighestEdition = _data['isHighestEdition'];
            this.isFree = _data['isFree'];
        }
    }

    static fromJS(data: any): EditionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['displayName'] = this.displayName;
        data['trialDayCount'] = this.trialDayCount;
        data['monthlyPrice'] = this.monthlyPrice;
        data['annualPrice'] = this.annualPrice;
        data['isHighestEdition'] = this.isHighestEdition;
        data['isFree'] = this.isFree;
        return data;
    }
}

export interface IEditionInfoDto {
    id: number;
    displayName: string | undefined;
    trialDayCount: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    isHighestEdition: boolean;
    isFree: boolean;
}

export class EditionListDto implements IEditionListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    creationTime: moment.Moment;

    constructor(data?: IEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEditionListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    creationTime: moment.Moment;
}

export class EditionListDtoListResultDto implements IEditionListDtoListResultDto {
    items: EditionListDto[] | undefined;

    constructor(data?: IEditionListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(EditionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditionListDtoListResultDto {
    items: EditionListDto[] | undefined;
}

export enum EditionPaymentType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3
}

export class EditionSelectDto implements IEditionSelectDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    expiringEditionId: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    isFree: boolean;
    additionalData: { [key: string]: { [key: string]: string } } | undefined;

    constructor(data?: IEditionSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.expiringEditionId = _data['expiringEditionId'];
            this.monthlyPrice = _data['monthlyPrice'];
            this.annualPrice = _data['annualPrice'];
            this.trialDayCount = _data['trialDayCount'];
            this.waitingDayAfterExpire = _data['waitingDayAfterExpire'];
            this.isFree = _data['isFree'];
            if (_data['additionalData']) {
                this.additionalData = {} as any;
                for (let key in _data['additionalData']) {
                    if (_data['additionalData'].hasOwnProperty(key))
                        (<any>this.additionalData)[key] = _data['additionalData'][key] !== undefined ? _data['additionalData'][key] : {};
                }
            }
        }
    }

    static fromJS(data: any): EditionSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['expiringEditionId'] = this.expiringEditionId;
        data['monthlyPrice'] = this.monthlyPrice;
        data['annualPrice'] = this.annualPrice;
        data['trialDayCount'] = this.trialDayCount;
        data['waitingDayAfterExpire'] = this.waitingDayAfterExpire;
        data['isFree'] = this.isFree;
        if (this.additionalData) {
            data['additionalData'] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key)) (<any>data['additionalData'])[key] = (<any>this.additionalData)[key];
            }
        }
        return data;
    }
}

export interface IEditionSelectDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    expiringEditionId: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    isFree: boolean;
    additionalData: { [key: string]: { [key: string]: string } } | undefined;
}

export class EditionsSelectOutput implements IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures: EditionWithFeaturesDto[] | undefined;
    tenantEditionId: number | undefined;

    constructor(data?: IEditionsSelectOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['allFeatures'])) {
                this.allFeatures = [] as any;
                for (let item of _data['allFeatures']) this.allFeatures.push(FlatFeatureSelectDto.fromJS(item));
            }
            if (Array.isArray(_data['editionsWithFeatures'])) {
                this.editionsWithFeatures = [] as any;
                for (let item of _data['editionsWithFeatures']) this.editionsWithFeatures.push(EditionWithFeaturesDto.fromJS(item));
            }
            this.tenantEditionId = _data['tenantEditionId'];
        }
    }

    static fromJS(data: any): EditionsSelectOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EditionsSelectOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allFeatures)) {
            data['allFeatures'] = [];
            for (let item of this.allFeatures) data['allFeatures'].push(item.toJSON());
        }
        if (Array.isArray(this.editionsWithFeatures)) {
            data['editionsWithFeatures'] = [];
            for (let item of this.editionsWithFeatures) data['editionsWithFeatures'].push(item.toJSON());
        }
        data['tenantEditionId'] = this.tenantEditionId;
        return data;
    }
}

export interface IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures: EditionWithFeaturesDto[] | undefined;
    tenantEditionId: number | undefined;
}

export class EditionWithFeaturesDto implements IEditionWithFeaturesDto {
    edition: EditionSelectDto;
    featureValues: NameValueDto[] | undefined;

    constructor(data?: IEditionWithFeaturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data['edition'] ? EditionSelectDto.fromJS(_data['edition']) : <any>undefined;
            if (Array.isArray(_data['featureValues'])) {
                this.featureValues = [] as any;
                for (let item of _data['featureValues']) this.featureValues.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionWithFeaturesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionWithFeaturesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['edition'] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data['featureValues'] = [];
            for (let item of this.featureValues) data['featureValues'].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditionWithFeaturesDto {
    edition: EditionSelectDto;
    featureValues: NameValueDto[] | undefined;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;

    constructor(data?: IEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultFromAddress = _data['defaultFromAddress'];
            this.defaultFromDisplayName = _data['defaultFromDisplayName'];
            this.smtpHost = _data['smtpHost'];
            this.smtpPort = _data['smtpPort'];
            this.smtpUserName = _data['smtpUserName'];
            this.smtpPassword = _data['smtpPassword'];
            this.smtpDomain = _data['smtpDomain'];
            this.smtpEnableSsl = _data['smtpEnableSsl'];
            this.smtpUseDefaultCredentials = _data['smtpUseDefaultCredentials'];
        }
    }

    static fromJS(data: any): EmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['defaultFromAddress'] = this.defaultFromAddress;
        data['defaultFromDisplayName'] = this.defaultFromDisplayName;
        data['smtpHost'] = this.smtpHost;
        data['smtpPort'] = this.smtpPort;
        data['smtpUserName'] = this.smtpUserName;
        data['smtpPassword'] = this.smtpPassword;
        data['smtpDomain'] = this.smtpDomain;
        data['smtpEnableSsl'] = this.smtpEnableSsl;
        data['smtpUseDefaultCredentials'] = this.smtpUseDefaultCredentials;
        return data;
    }
}

export interface IEmailSettingsEditDto {
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
}

export class EmbedToken implements IEmbedToken {
    token: string | undefined;
    tokenId: string | undefined;
    expiration: moment.Moment | undefined;

    constructor(data?: IEmbedToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data['token'];
            this.tokenId = _data['tokenId'];
            this.expiration = _data['expiration'] ? moment(_data['expiration'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmbedToken {
        data = typeof data === 'object' ? data : {};
        let result = new EmbedToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['token'] = this.token;
        data['tokenId'] = this.tokenId;
        data['expiration'] = this.expiration ? this.expiration.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmbedToken {
    token: string | undefined;
    tokenId: string | undefined;
    expiration: moment.Moment | undefined;
}

export class Employee implements IEmployee {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    userId: number | undefined;
    user: User;
    source: ExtractSource;
    specialities: SpecialityConsultantMapping[] | undefined;

    constructor(data?: IEmployee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
            this.userId = _data['userId'];
            this.user = _data['user'] ? User.fromJS(_data['user']) : <any>undefined;
            this.source = _data['source'] ? ExtractSource.fromJS(_data['source']) : <any>undefined;
            if (Array.isArray(_data['specialities'])) {
                this.specialities = [] as any;
                for (let item of _data['specialities']) this.specialities.push(SpecialityConsultantMapping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Employee {
        data = typeof data === 'object' ? data : {};
        let result = new Employee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data['userId'] = this.userId;
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        data['source'] = this.source ? this.source.toJSON() : <any>undefined;
        if (Array.isArray(this.specialities)) {
            data['specialities'] = [];
            for (let item of this.specialities) data['specialities'].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmployee {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    userId: number | undefined;
    user: User;
    source: ExtractSource;
    specialities: SpecialityConsultantMapping[] | undefined;
}

export class EmployeeDto implements IEmployeeDto {
    id: number;
    importedName: string | undefined;
    title: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    isPooled: boolean | undefined;
    extractSource: string | undefined;
    userId: number | undefined;
    profilePictureId: string | undefined;
    specialties: SpecialityDto[] | undefined;

    constructor(data?: IEmployeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.importedName = _data['importedName'];
            this.title = _data['title'];
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.isPooled = _data['isPooled'];
            this.extractSource = _data['extractSource'];
            this.userId = _data['userId'];
            this.profilePictureId = _data['profilePictureId'];
            if (Array.isArray(_data['specialties'])) {
                this.specialties = [] as any;
                for (let item of _data['specialties']) this.specialties.push(SpecialityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['importedName'] = this.importedName;
        data['title'] = this.title;
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['isPooled'] = this.isPooled;
        data['extractSource'] = this.extractSource;
        data['userId'] = this.userId;
        data['profilePictureId'] = this.profilePictureId;
        if (Array.isArray(this.specialties)) {
            data['specialties'] = [];
            for (let item of this.specialties) data['specialties'].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmployeeDto {
    id: number;
    importedName: string | undefined;
    title: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    isPooled: boolean | undefined;
    extractSource: string | undefined;
    userId: number | undefined;
    profilePictureId: string | undefined;
    specialties: SpecialityDto[] | undefined;
}

export class EmployeeRole implements IEmployeeRole {
    id: EmployeeRoleTypes;
    name: string | undefined;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IEmployeeRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeRole {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEmployeeRole {
    id: EmployeeRoleTypes;
    name: string | undefined;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export enum EmployeeRoleTypes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3
}

export class EntityDto implements IEntityDto {
    id: number;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        return data;
    }
}

export interface IEntityDto {
    id: number;
}

export enum EventAttributes {
    _0 = 0,
    _512 = 512,
    _1024 = 1024
}

export class EventInfo implements IEventInfo {
    readonly name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly isCollectible: boolean;
    readonly metadataToken: number;
    memberType: MemberTypes;
    attributes: EventAttributes;
    readonly isSpecialName: boolean;
    addMethod: MethodInfo;
    removeMethod: MethodInfo;
    raiseMethod: MethodInfo;
    readonly isMulticast: boolean;
    eventHandlerType: Type;

    constructor(data?: IEventInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data['name'];
            this.declaringType = _data['declaringType'] ? Type.fromJS(_data['declaringType']) : <any>undefined;
            this.reflectedType = _data['reflectedType'] ? Type.fromJS(_data['reflectedType']) : <any>undefined;
            this.module = _data['module'] ? Module.fromJS(_data['module']) : <any>undefined;
            if (Array.isArray(_data['customAttributes'])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data['customAttributes']) (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data['isCollectible'];
            (<any>this).metadataToken = _data['metadataToken'];
            this.memberType = _data['memberType'];
            this.attributes = _data['attributes'];
            (<any>this).isSpecialName = _data['isSpecialName'];
            this.addMethod = _data['addMethod'] ? MethodInfo.fromJS(_data['addMethod']) : <any>undefined;
            this.removeMethod = _data['removeMethod'] ? MethodInfo.fromJS(_data['removeMethod']) : <any>undefined;
            this.raiseMethod = _data['raiseMethod'] ? MethodInfo.fromJS(_data['raiseMethod']) : <any>undefined;
            (<any>this).isMulticast = _data['isMulticast'];
            this.eventHandlerType = _data['eventHandlerType'] ? Type.fromJS(_data['eventHandlerType']) : <any>undefined;
        }
    }

    static fromJS(data: any): EventInfo {
        data = typeof data === 'object' ? data : {};
        let result = new EventInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['declaringType'] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data['reflectedType'] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data['module'] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data['customAttributes'] = [];
            for (let item of this.customAttributes) data['customAttributes'].push(item.toJSON());
        }
        data['isCollectible'] = this.isCollectible;
        data['metadataToken'] = this.metadataToken;
        data['memberType'] = this.memberType;
        data['attributes'] = this.attributes;
        data['isSpecialName'] = this.isSpecialName;
        data['addMethod'] = this.addMethod ? this.addMethod.toJSON() : <any>undefined;
        data['removeMethod'] = this.removeMethod ? this.removeMethod.toJSON() : <any>undefined;
        data['raiseMethod'] = this.raiseMethod ? this.raiseMethod.toJSON() : <any>undefined;
        data['isMulticast'] = this.isMulticast;
        data['eventHandlerType'] = this.eventHandlerType ? this.eventHandlerType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEventInfo {
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    memberType: MemberTypes;
    attributes: EventAttributes;
    isSpecialName: boolean;
    addMethod: MethodInfo;
    removeMethod: MethodInfo;
    raiseMethod: MethodInfo;
    isMulticast: boolean;
    eventHandlerType: Type;
}

export class EventType implements IEventType {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IEventType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EventType {
        data = typeof data === 'object' ? data : {};
        let result = new EventType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IEventType {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class ExcludedWaitingList implements IExcludedWaitingList {
    id: number;
    waitingListId: string | undefined;
    sessionId: string | undefined;
    waitingList: WaitingList;
    session: Session;

    constructor(data?: IExcludedWaitingList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.waitingListId = _data['waitingListId'];
            this.sessionId = _data['sessionId'];
            this.waitingList = _data['waitingList'] ? WaitingList.fromJS(_data['waitingList']) : <any>undefined;
            this.session = _data['session'] ? Session.fromJS(_data['session']) : <any>undefined;
        }
    }

    static fromJS(data: any): ExcludedWaitingList {
        data = typeof data === 'object' ? data : {};
        let result = new ExcludedWaitingList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['waitingListId'] = this.waitingListId;
        data['sessionId'] = this.sessionId;
        data['waitingList'] = this.waitingList ? this.waitingList.toJSON() : <any>undefined;
        data['session'] = this.session ? this.session.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExcludedWaitingList {
    id: number;
    waitingListId: string | undefined;
    sessionId: string | undefined;
    waitingList: WaitingList;
    session: Session;
}

export class ExcludedWaitingListsDto implements IExcludedWaitingListsDto {
    sessionId: string | undefined;
    waitingListId: string | undefined;

    constructor(data?: IExcludedWaitingListsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data['sessionId'];
            this.waitingListId = _data['waitingListId'];
        }
    }

    static fromJS(data: any): ExcludedWaitingListsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcludedWaitingListsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['sessionId'] = this.sessionId;
        data['waitingListId'] = this.waitingListId;
        return data;
    }
}

export interface IExcludedWaitingListsDto {
    sessionId: string | undefined;
    waitingListId: string | undefined;
}

export class ExecutePaymentDto implements IExecutePaymentDto {
    gateway: SubscriptionPaymentGatewayType;
    editionPaymentType: EditionPaymentType;
    editionId: number;
    paymentPeriodType: PaymentPeriodType;
    additionalData: { [key: string]: string } | undefined;

    constructor(data?: IExecutePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gateway = _data['gateway'];
            this.editionPaymentType = _data['editionPaymentType'];
            this.editionId = _data['editionId'];
            this.paymentPeriodType = _data['paymentPeriodType'];
            if (_data['additionalData']) {
                this.additionalData = {} as any;
                for (let key in _data['additionalData']) {
                    if (_data['additionalData'].hasOwnProperty(key)) (<any>this.additionalData)[key] = _data['additionalData'][key];
                }
            }
        }
    }

    static fromJS(data: any): ExecutePaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExecutePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['gateway'] = this.gateway;
        data['editionPaymentType'] = this.editionPaymentType;
        data['editionId'] = this.editionId;
        data['paymentPeriodType'] = this.paymentPeriodType;
        if (this.additionalData) {
            data['additionalData'] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key)) (<any>data['additionalData'])[key] = (<any>this.additionalData)[key];
            }
        }
        return data;
    }
}

export interface IExecutePaymentDto {
    gateway: SubscriptionPaymentGatewayType;
    editionPaymentType: EditionPaymentType;
    editionId: number;
    paymentPeriodType: PaymentPeriodType;
    additionalData: { [key: string]: string } | undefined;
}

export class ExecutePaymentResponse implements IExecutePaymentResponse {
    constructor(data?: IExecutePaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {}

    static fromJS(data: any): ExecutePaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExecutePaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IExecutePaymentResponse {}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
    returnUrl: string | undefined;
    singleSignIn: boolean | undefined;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data['authProvider'];
            this.providerKey = _data['providerKey'];
            this.providerAccessCode = _data['providerAccessCode'];
            this.returnUrl = _data['returnUrl'];
            this.singleSignIn = _data['singleSignIn'];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['authProvider'] = this.authProvider;
        data['providerKey'] = this.providerKey;
        data['providerAccessCode'] = this.providerAccessCode;
        data['returnUrl'] = this.returnUrl;
        data['singleSignIn'] = this.singleSignIn;
        return data;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
    returnUrl: string | undefined;
    singleSignIn: boolean | undefined;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
    returnUrl: string | undefined;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data['accessToken'];
            this.encryptedAccessToken = _data['encryptedAccessToken'];
            this.expireInSeconds = _data['expireInSeconds'];
            this.waitingForActivation = _data['waitingForActivation'];
            this.returnUrl = _data['returnUrl'];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['accessToken'] = this.accessToken;
        data['encryptedAccessToken'] = this.encryptedAccessToken;
        data['expireInSeconds'] = this.expireInSeconds;
        data['waitingForActivation'] = this.waitingForActivation;
        data['returnUrl'] = this.returnUrl;
        return data;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
    returnUrl: string | undefined;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.clientId = _data['clientId'];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['clientId'] = this.clientId;
        return data;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class ExtractSource implements IExtractSource {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IExtractSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ExtractSource {
        data = typeof data === 'object' ? data : {};
        let result = new ExtractSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IExtractSource {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class FeatureInputTypeDto implements IFeatureInputTypeDto {
    name: string | undefined;
    attributes: { [key: string]: any } | undefined;
    validator: IValueValidator;
    itemSource: LocalizableComboboxItemSourceDto;

    constructor(data?: IFeatureInputTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            if (_data['attributes']) {
                this.attributes = {} as any;
                for (let key in _data['attributes']) {
                    if (_data['attributes'].hasOwnProperty(key)) (<any>this.attributes)[key] = _data['attributes'][key];
                }
            }
            this.validator = _data['validator'] ? IValueValidator.fromJS(_data['validator']) : <any>undefined;
            this.itemSource = _data['itemSource'] ? LocalizableComboboxItemSourceDto.fromJS(_data['itemSource']) : <any>undefined;
        }
    }

    static fromJS(data: any): FeatureInputTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureInputTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        if (this.attributes) {
            data['attributes'] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key)) (<any>data['attributes'])[key] = (<any>this.attributes)[key];
            }
        }
        data['validator'] = this.validator ? this.validator.toJSON() : <any>undefined;
        data['itemSource'] = this.itemSource ? this.itemSource.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFeatureInputTypeDto {
    name: string | undefined;
    attributes: { [key: string]: any } | undefined;
    validator: IValueValidator;
    itemSource: LocalizableComboboxItemSourceDto;
}

export enum FieldAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _1024 = 1024,
    _4096 = 4096,
    _8192 = 8192,
    _32768 = 32768,
    _38144 = 38144
}

export class FieldInfo implements IFieldInfo {
    readonly name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly isCollectible: boolean;
    readonly metadataToken: number;
    memberType: MemberTypes;
    attributes: FieldAttributes;
    fieldType: Type;
    readonly isInitOnly: boolean;
    readonly isLiteral: boolean;
    readonly isNotSerialized: boolean;
    readonly isPinvokeImpl: boolean;
    readonly isSpecialName: boolean;
    readonly isStatic: boolean;
    readonly isAssembly: boolean;
    readonly isFamily: boolean;
    readonly isFamilyAndAssembly: boolean;
    readonly isFamilyOrAssembly: boolean;
    readonly isPrivate: boolean;
    readonly isPublic: boolean;
    readonly isSecurityCritical: boolean;
    readonly isSecuritySafeCritical: boolean;
    readonly isSecurityTransparent: boolean;
    fieldHandle: RuntimeFieldHandle;

    constructor(data?: IFieldInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data['name'];
            this.declaringType = _data['declaringType'] ? Type.fromJS(_data['declaringType']) : <any>undefined;
            this.reflectedType = _data['reflectedType'] ? Type.fromJS(_data['reflectedType']) : <any>undefined;
            this.module = _data['module'] ? Module.fromJS(_data['module']) : <any>undefined;
            if (Array.isArray(_data['customAttributes'])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data['customAttributes']) (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data['isCollectible'];
            (<any>this).metadataToken = _data['metadataToken'];
            this.memberType = _data['memberType'];
            this.attributes = _data['attributes'];
            this.fieldType = _data['fieldType'] ? Type.fromJS(_data['fieldType']) : <any>undefined;
            (<any>this).isInitOnly = _data['isInitOnly'];
            (<any>this).isLiteral = _data['isLiteral'];
            (<any>this).isNotSerialized = _data['isNotSerialized'];
            (<any>this).isPinvokeImpl = _data['isPinvokeImpl'];
            (<any>this).isSpecialName = _data['isSpecialName'];
            (<any>this).isStatic = _data['isStatic'];
            (<any>this).isAssembly = _data['isAssembly'];
            (<any>this).isFamily = _data['isFamily'];
            (<any>this).isFamilyAndAssembly = _data['isFamilyAndAssembly'];
            (<any>this).isFamilyOrAssembly = _data['isFamilyOrAssembly'];
            (<any>this).isPrivate = _data['isPrivate'];
            (<any>this).isPublic = _data['isPublic'];
            (<any>this).isSecurityCritical = _data['isSecurityCritical'];
            (<any>this).isSecuritySafeCritical = _data['isSecuritySafeCritical'];
            (<any>this).isSecurityTransparent = _data['isSecurityTransparent'];
            this.fieldHandle = _data['fieldHandle'] ? RuntimeFieldHandle.fromJS(_data['fieldHandle']) : <any>undefined;
        }
    }

    static fromJS(data: any): FieldInfo {
        data = typeof data === 'object' ? data : {};
        let result = new FieldInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['declaringType'] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data['reflectedType'] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data['module'] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data['customAttributes'] = [];
            for (let item of this.customAttributes) data['customAttributes'].push(item.toJSON());
        }
        data['isCollectible'] = this.isCollectible;
        data['metadataToken'] = this.metadataToken;
        data['memberType'] = this.memberType;
        data['attributes'] = this.attributes;
        data['fieldType'] = this.fieldType ? this.fieldType.toJSON() : <any>undefined;
        data['isInitOnly'] = this.isInitOnly;
        data['isLiteral'] = this.isLiteral;
        data['isNotSerialized'] = this.isNotSerialized;
        data['isPinvokeImpl'] = this.isPinvokeImpl;
        data['isSpecialName'] = this.isSpecialName;
        data['isStatic'] = this.isStatic;
        data['isAssembly'] = this.isAssembly;
        data['isFamily'] = this.isFamily;
        data['isFamilyAndAssembly'] = this.isFamilyAndAssembly;
        data['isFamilyOrAssembly'] = this.isFamilyOrAssembly;
        data['isPrivate'] = this.isPrivate;
        data['isPublic'] = this.isPublic;
        data['isSecurityCritical'] = this.isSecurityCritical;
        data['isSecuritySafeCritical'] = this.isSecuritySafeCritical;
        data['isSecurityTransparent'] = this.isSecurityTransparent;
        data['fieldHandle'] = this.fieldHandle ? this.fieldHandle.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFieldInfo {
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    memberType: MemberTypes;
    attributes: FieldAttributes;
    fieldType: Type;
    isInitOnly: boolean;
    isLiteral: boolean;
    isNotSerialized: boolean;
    isPinvokeImpl: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    fieldHandle: RuntimeFieldHandle;
}

export class FileDto implements IFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data['fileName'];
            this.fileType = _data['fileType'];
            this.fileToken = _data['fileToken'];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['fileName'] = this.fileName;
        data['fileType'] = this.fileType;
        data['fileToken'] = this.fileToken;
        return data;
    }
}

export interface IFileDto {
    fileName: string;
    fileType: string;
    fileToken: string;
}

export class FindOrganizationUnitUsersInput implements IFindOrganizationUnitUsersInput {
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
    organizationUnitId: number;

    constructor(data?: IFindOrganizationUnitUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data['maxResultCount'];
            this.skipCount = _data['skipCount'];
            this.filter = _data['filter'];
            this.organizationUnitId = _data['organizationUnitId'];
        }
    }

    static fromJS(data: any): FindOrganizationUnitUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['maxResultCount'] = this.maxResultCount;
        data['skipCount'] = this.skipCount;
        data['filter'] = this.filter;
        data['organizationUnitId'] = this.organizationUnitId;
        return data;
    }
}

export interface IFindOrganizationUnitUsersInput {
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
    organizationUnitId: number;
}

export class FindUsersInput implements IFindUsersInput {
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
    tenantId: number | undefined;

    constructor(data?: IFindUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data['maxResultCount'];
            this.skipCount = _data['skipCount'];
            this.filter = _data['filter'];
            this.tenantId = _data['tenantId'];
        }
    }

    static fromJS(data: any): FindUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['maxResultCount'] = this.maxResultCount;
        data['skipCount'] = this.skipCount;
        data['filter'] = this.filter;
        data['tenantId'] = this.tenantId;
        return data;
    }
}

export interface IFindUsersInput {
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
    tenantId: number | undefined;
}

export class FlatFeatureDto implements IFlatFeatureDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: FeatureInputTypeDto;

    constructor(data?: IFlatFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data['parentName'];
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.description = _data['description'];
            this.defaultValue = _data['defaultValue'];
            this.inputType = _data['inputType'] ? FeatureInputTypeDto.fromJS(_data['inputType']) : <any>undefined;
        }
    }

    static fromJS(data: any): FlatFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['parentName'] = this.parentName;
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['description'] = this.description;
        data['defaultValue'] = this.defaultValue;
        data['inputType'] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFlatFeatureDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: FeatureInputTypeDto;
}

export class FlatFeatureSelectDto implements IFlatFeatureSelectDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: IInputType;
    textHtmlColor: string | undefined;

    constructor(data?: IFlatFeatureSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data['parentName'];
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.description = _data['description'];
            this.defaultValue = _data['defaultValue'];
            this.inputType = _data['inputType'] ? IInputType.fromJS(_data['inputType']) : <any>undefined;
            this.textHtmlColor = _data['textHtmlColor'];
        }
    }

    static fromJS(data: any): FlatFeatureSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['parentName'] = this.parentName;
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['description'] = this.description;
        data['defaultValue'] = this.defaultValue;
        data['inputType'] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        data['textHtmlColor'] = this.textHtmlColor;
        return data;
    }
}

export interface IFlatFeatureSelectDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: IInputType;
    textHtmlColor: string | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data['parentName'];
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.description = _data['description'];
            this.isGrantedByDefault = _data['isGrantedByDefault'];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['parentName'] = this.parentName;
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['description'] = this.description;
        data['isGrantedByDefault'] = this.isGrantedByDefault;
        return data;
    }
}

export interface IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class FlatPermissionWithLevelDto implements IFlatPermissionWithLevelDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
    level: number;

    constructor(data?: IFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data['parentName'];
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.description = _data['description'];
            this.isGrantedByDefault = _data['isGrantedByDefault'];
            this.level = _data['level'];
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['parentName'] = this.parentName;
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['description'] = this.description;
        data['isGrantedByDefault'] = this.isGrantedByDefault;
        data['level'] = this.level;
        return data;
    }
}

export interface IFlatPermissionWithLevelDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
    level: number;
}

export class FlatPermissionWithLevelDtoListResultDto implements IFlatPermissionWithLevelDtoListResultDto {
    items: FlatPermissionWithLevelDto[] | undefined;

    constructor(data?: IFlatPermissionWithLevelDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(FlatPermissionWithLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionWithLevelDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }
}

export interface IFlatPermissionWithLevelDtoListResultDto {
    items: FlatPermissionWithLevelDto[] | undefined;
}

export class FriendDto implements IFriendDto {
    friendUserId: number;
    friendTenantId: number | undefined;
    friendUserName: string | undefined;
    friendTenancyName: string | undefined;
    friendProfilePictureId: string | undefined;
    unreadMessageCount: number;
    isOnline: boolean;
    state: FriendshipState;

    constructor(data?: IFriendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.friendUserId = _data['friendUserId'];
            this.friendTenantId = _data['friendTenantId'];
            this.friendUserName = _data['friendUserName'];
            this.friendTenancyName = _data['friendTenancyName'];
            this.friendProfilePictureId = _data['friendProfilePictureId'];
            this.unreadMessageCount = _data['unreadMessageCount'];
            this.isOnline = _data['isOnline'];
            this.state = _data['state'];
        }
    }

    static fromJS(data: any): FriendDto {
        data = typeof data === 'object' ? data : {};
        let result = new FriendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['friendUserId'] = this.friendUserId;
        data['friendTenantId'] = this.friendTenantId;
        data['friendUserName'] = this.friendUserName;
        data['friendTenancyName'] = this.friendTenancyName;
        data['friendProfilePictureId'] = this.friendProfilePictureId;
        data['unreadMessageCount'] = this.unreadMessageCount;
        data['isOnline'] = this.isOnline;
        data['state'] = this.state;
        return data;
    }
}

export interface IFriendDto {
    friendUserId: number;
    friendTenantId: number | undefined;
    friendUserName: string | undefined;
    friendTenancyName: string | undefined;
    friendProfilePictureId: string | undefined;
    unreadMessageCount: number;
    isOnline: boolean;
    state: FriendshipState;
}

export enum FriendshipState {
    _1 = 1,
    _2 = 2
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
    timezone: string | undefined;
    timezoneForComparison: string | undefined;

    constructor(data?: IGeneralSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timezone = _data['timezone'];
            this.timezoneForComparison = _data['timezoneForComparison'];
        }
    }

    static fromJS(data: any): GeneralSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['timezone'] = this.timezone;
        data['timezoneForComparison'] = this.timezoneForComparison;
        return data;
    }
}

export interface IGeneralSettingsEditDto {
    timezone: string | undefined;
    timezoneForComparison: string | undefined;
}

export enum GenericParameterAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _28 = 28
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    application: ApplicationInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data['user'] ? UserLoginInfoDto.fromJS(_data['user']) : <any>undefined;
            this.tenant = _data['tenant'] ? TenantLoginInfoDto.fromJS(_data['tenant']) : <any>undefined;
            this.application = _data['application'] ? ApplicationInfoDto.fromJS(_data['application']) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        data['tenant'] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data['application'] = this.application ? this.application.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
    application: ApplicationInfoDto;
}

export class GetDefaultEditionNameOutput implements IGetDefaultEditionNameOutput {
    name: string | undefined;

    constructor(data?: IGetDefaultEditionNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): GetDefaultEditionNameOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDefaultEditionNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        return data;
    }
}

export interface IGetDefaultEditionNameOutput {
    name: string | undefined;
}

export class GetEditionEditOutput implements IGetEditionEditOutput {
    edition: EditionEditDto;
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;

    constructor(data?: IGetEditionEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data['edition'] ? EditionEditDto.fromJS(_data['edition']) : <any>undefined;
            if (Array.isArray(_data['featureValues'])) {
                this.featureValues = [] as any;
                for (let item of _data['featureValues']) this.featureValues.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data['features'])) {
                this.features = [] as any;
                for (let item of _data['features']) this.features.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['edition'] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data['featureValues'] = [];
            for (let item of this.featureValues) data['featureValues'].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data['features'] = [];
            for (let item of this.features) data['features'].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEditionEditOutput {
    edition: EditionEditDto;
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class GetLanguageForEditOutput implements IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto;
    languageNames: ComboboxItemDto[] | undefined;
    flags: ComboboxItemDto[] | undefined;

    constructor(data?: IGetLanguageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data['language'] ? ApplicationLanguageEditDto.fromJS(_data['language']) : <any>undefined;
            if (Array.isArray(_data['languageNames'])) {
                this.languageNames = [] as any;
                for (let item of _data['languageNames']) this.languageNames.push(ComboboxItemDto.fromJS(item));
            }
            if (Array.isArray(_data['flags'])) {
                this.flags = [] as any;
                for (let item of _data['flags']) this.flags.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguageForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['language'] = this.language ? this.language.toJSON() : <any>undefined;
        if (Array.isArray(this.languageNames)) {
            data['languageNames'] = [];
            for (let item of this.languageNames) data['languageNames'].push(item.toJSON());
        }
        if (Array.isArray(this.flags)) {
            data['flags'] = [];
            for (let item of this.flags) data['flags'].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto;
    languageNames: ComboboxItemDto[] | undefined;
    flags: ComboboxItemDto[] | undefined;
}

export class GetLanguagesOutput implements IGetLanguagesOutput {
    items: ApplicationLanguageListDto[] | undefined;
    defaultLanguageName: string | undefined;

    constructor(data?: IGetLanguagesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(ApplicationLanguageListDto.fromJS(item));
            }
            this.defaultLanguageName = _data['defaultLanguageName'];
        }
    }

    static fromJS(data: any): GetLanguagesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguagesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        data['defaultLanguageName'] = this.defaultLanguageName;
        return data;
    }
}

export interface IGetLanguagesOutput {
    items: ApplicationLanguageListDto[] | undefined;
    defaultLanguageName: string | undefined;
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
    latestWebLogLines: string[] | undefined;

    constructor(data?: IGetLatestWebLogsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['latestWebLogLines'])) {
                this.latestWebLogLines = [] as any;
                for (let item of _data['latestWebLogLines']) this.latestWebLogLines.push(item);
            }
        }
    }

    static fromJS(data: any): GetLatestWebLogsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.latestWebLogLines)) {
            data['latestWebLogLines'] = [];
            for (let item of this.latestWebLogLines) data['latestWebLogLines'].push(item);
        }
        return data;
    }
}

export interface IGetLatestWebLogsOutput {
    latestWebLogLines: string[] | undefined;
}

export class GetNotificationSettingsOutput implements IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[] | undefined;

    constructor(data?: IGetNotificationSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data['receiveNotifications'];
            if (Array.isArray(_data['notifications'])) {
                this.notifications = [] as any;
                for (let item of _data['notifications']) this.notifications.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['receiveNotifications'] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data['notifications'] = [];
            for (let item of this.notifications) data['notifications'].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[] | undefined;
}

export class GetNotificationsOutput implements IGetNotificationsOutput {
    items: UserNotification[] | undefined;
    totalCount: number;
    unreadCount: number;

    constructor(data?: IGetNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(UserNotification.fromJS(item));
            }
            this.totalCount = _data['totalCount'];
            this.unreadCount = _data['unreadCount'];
        }
    }

    static fromJS(data: any): GetNotificationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        data['totalCount'] = this.totalCount;
        data['unreadCount'] = this.unreadCount;
        return data;
    }
}

export interface IGetNotificationsOutput {
    items: UserNotification[] | undefined;
    totalCount: number;
    unreadCount: number;
}

export class GetPasswordComplexitySettingOutput implements IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting;

    constructor(data?: IGetPasswordComplexitySettingOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.setting = _data['setting'] ? PasswordComplexitySetting.fromJS(_data['setting']) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPasswordComplexitySettingOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPasswordComplexitySettingOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['setting'] = this.setting ? this.setting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
    profilePicture: string | undefined;

    constructor(data?: IGetProfilePictureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePicture = _data['profilePicture'];
        }
    }

    static fromJS(data: any): GetProfilePictureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['profilePicture'] = this.profilePicture;
        return data;
    }
}

export interface IGetProfilePictureOutput {
    profilePicture: string | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data['role'] ? RoleEditDto.fromJS(_data['role']) : <any>undefined;
            if (Array.isArray(_data['permissions'])) {
                this.permissions = [] as any;
                for (let item of _data['permissions']) this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data['grantedPermissionNames'])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data['grantedPermissionNames']) this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['role'] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data['permissions'] = [];
            for (let item of this.permissions) data['permissions'].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data['grantedPermissionNames'] = [];
            for (let item of this.grantedPermissionNames) data['grantedPermissionNames'].push(item);
        }
        return data;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GetTenantFeaturesEditOutput implements IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;

    constructor(data?: IGetTenantFeaturesEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['featureValues'])) {
                this.featureValues = [] as any;
                for (let item of _data['featureValues']) this.featureValues.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data['features'])) {
                this.features = [] as any;
                for (let item of _data['features']) this.features.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantFeaturesEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantFeaturesEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureValues)) {
            data['featureValues'] = [];
            for (let item of this.featureValues) data['featureValues'].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data['features'] = [];
            for (let item of this.features) data['features'].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class GetUserChatFriendsWithSettingsOutput implements IGetUserChatFriendsWithSettingsOutput {
    serverTime: moment.Moment;
    friends: FriendDto[] | undefined;

    constructor(data?: IGetUserChatFriendsWithSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverTime = _data['serverTime'] ? moment(_data['serverTime'].toString()) : <any>undefined;
            if (Array.isArray(_data['friends'])) {
                this.friends = [] as any;
                for (let item of _data['friends']) this.friends.push(FriendDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserChatFriendsWithSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserChatFriendsWithSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['serverTime'] = this.serverTime ? this.serverTime.toISOString() : <any>undefined;
        if (Array.isArray(this.friends)) {
            data['friends'] = [];
            for (let item of this.friends) data['friends'].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserChatFriendsWithSettingsOutput {
    serverTime: moment.Moment;
    friends: FriendDto[] | undefined;
}

export class GetUserForEditOutput implements IGetUserForEditOutput {
    profilePictureId: string | undefined;
    user: UserEditDto;
    roles: UserRoleDto[] | undefined;
    allOrganizationUnits: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits: string[] | undefined;

    constructor(data?: IGetUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePictureId = _data['profilePictureId'];
            this.user = _data['user'] ? UserEditDto.fromJS(_data['user']) : <any>undefined;
            if (Array.isArray(_data['roles'])) {
                this.roles = [] as any;
                for (let item of _data['roles']) this.roles.push(UserRoleDto.fromJS(item));
            }
            if (Array.isArray(_data['allOrganizationUnits'])) {
                this.allOrganizationUnits = [] as any;
                for (let item of _data['allOrganizationUnits']) this.allOrganizationUnits.push(OrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(_data['memberedOrganizationUnits'])) {
                this.memberedOrganizationUnits = [] as any;
                for (let item of _data['memberedOrganizationUnits']) this.memberedOrganizationUnits.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['profilePictureId'] = this.profilePictureId;
        data['user'] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data['roles'] = [];
            for (let item of this.roles) data['roles'].push(item.toJSON());
        }
        if (Array.isArray(this.allOrganizationUnits)) {
            data['allOrganizationUnits'] = [];
            for (let item of this.allOrganizationUnits) data['allOrganizationUnits'].push(item.toJSON());
        }
        if (Array.isArray(this.memberedOrganizationUnits)) {
            data['memberedOrganizationUnits'] = [];
            for (let item of this.memberedOrganizationUnits) data['memberedOrganizationUnits'].push(item);
        }
        return data;
    }
}

export interface IGetUserForEditOutput {
    profilePictureId: string | undefined;
    user: UserEditDto;
    roles: UserRoleDto[] | undefined;
    allOrganizationUnits: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits: string[] | undefined;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;

    constructor(data?: IGetUserPermissionsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['permissions'])) {
                this.permissions = [] as any;
                for (let item of _data['permissions']) this.permissions.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data['grantedPermissionNames'])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data['grantedPermissionNames']) this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPermissionsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data['permissions'] = [];
            for (let item of this.permissions) data['permissions'].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data['grantedPermissionNames'] = [];
            for (let item of this.grantedPermissionNames) data['grantedPermissionNames'].push(item);
        }
        return data;
    }
}

export interface IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GuidEntityDto implements IGuidEntityDto {
    id: string;

    constructor(data?: IGuidEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): GuidEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuidEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        return data;
    }
}

export interface IGuidEntityDto {
    id: string;
}

export class HostBillingSettingsEditDto implements IHostBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;

    constructor(data?: IHostBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data['legalName'];
            this.address = _data['address'];
        }
    }

    static fromJS(data: any): HostBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['legalName'] = this.legalName;
        data['address'] = this.address;
        return data;
    }
}

export interface IHostBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
}

export class HostSettingsEditDto implements IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: HostBillingSettingsEditDto;

    constructor(data?: IHostSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.general = new GeneralSettingsEditDto();
            this.userManagement = new HostUserManagementSettingsEditDto();
            this.email = new EmailSettingsEditDto();
            this.tenantManagement = new TenantManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data['general'] ? GeneralSettingsEditDto.fromJS(_data['general']) : new GeneralSettingsEditDto();
            this.userManagement = _data['userManagement']
                ? HostUserManagementSettingsEditDto.fromJS(_data['userManagement'])
                : new HostUserManagementSettingsEditDto();
            this.email = _data['email'] ? EmailSettingsEditDto.fromJS(_data['email']) : new EmailSettingsEditDto();
            this.tenantManagement = _data['tenantManagement']
                ? TenantManagementSettingsEditDto.fromJS(_data['tenantManagement'])
                : new TenantManagementSettingsEditDto();
            this.security = _data['security'] ? SecuritySettingsEditDto.fromJS(_data['security']) : new SecuritySettingsEditDto();
            this.billing = _data['billing'] ? HostBillingSettingsEditDto.fromJS(_data['billing']) : <any>undefined;
        }
    }

    static fromJS(data: any): HostSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['general'] = this.general ? this.general.toJSON() : <any>undefined;
        data['userManagement'] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data['email'] = this.email ? this.email.toJSON() : <any>undefined;
        data['tenantManagement'] = this.tenantManagement ? this.tenantManagement.toJSON() : <any>undefined;
        data['security'] = this.security ? this.security.toJSON() : <any>undefined;
        data['billing'] = this.billing ? this.billing.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: HostBillingSettingsEditDto;
}

export class HostUserManagementSettingsEditDto implements IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean;
    smsVerificationEnabled: boolean;

    constructor(data?: IHostUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEmailConfirmationRequiredForLogin = _data['isEmailConfirmationRequiredForLogin'];
            this.smsVerificationEnabled = _data['smsVerificationEnabled'];
        }
    }

    static fromJS(data: any): HostUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['isEmailConfirmationRequiredForLogin'] = this.isEmailConfirmationRequiredForLogin;
        data['smsVerificationEnabled'] = this.smsVerificationEnabled;
        return data;
    }
}

export interface IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean;
    smsVerificationEnabled: boolean;
}

export class ICustomAttributeProvider implements IICustomAttributeProvider {
    constructor(data?: IICustomAttributeProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {}

    static fromJS(data: any): ICustomAttributeProvider {
        data = typeof data === 'object' ? data : {};
        let result = new ICustomAttributeProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IICustomAttributeProvider {}

export class IInputType implements IIInputType {
    readonly name: string | undefined;
    readonly attributes: { [key: string]: any } | undefined;
    validator: IValueValidator;

    constructor(data?: IIInputType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data['name'];
            if (_data['attributes']) {
                (<any>this).attributes = {} as any;
                for (let key in _data['attributes']) {
                    if (_data['attributes'].hasOwnProperty(key)) (<any>(<any>this).attributes)[key] = _data['attributes'][key];
                }
            }
            this.validator = _data['validator'] ? IValueValidator.fromJS(_data['validator']) : <any>undefined;
        }
    }

    static fromJS(data: any): IInputType {
        data = typeof data === 'object' ? data : {};
        let result = new IInputType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        if (this.attributes) {
            data['attributes'] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key)) (<any>data['attributes'])[key] = (<any>this.attributes)[key];
            }
        }
        data['validator'] = this.validator ? this.validator.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIInputType {
    name: string | undefined;
    attributes: { [key: string]: any } | undefined;
    validator: IValueValidator;
}

export class ImpersonatedAuthenticateResultModel implements IImpersonatedAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;

    constructor(data?: IImpersonatedAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data['accessToken'];
            this.encryptedAccessToken = _data['encryptedAccessToken'];
            this.expireInSeconds = _data['expireInSeconds'];
        }
    }

    static fromJS(data: any): ImpersonatedAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonatedAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['accessToken'] = this.accessToken;
        data['encryptedAccessToken'] = this.encryptedAccessToken;
        data['expireInSeconds'] = this.expireInSeconds;
        return data;
    }
}

export interface IImpersonatedAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class ImpersonateInput implements IImpersonateInput {
    tenantId: number | undefined;
    userId: number;

    constructor(data?: IImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.userId = _data['userId'];
        }
    }

    static fromJS(data: any): ImpersonateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['userId'] = this.userId;
        return data;
    }
}

export interface IImpersonateInput {
    tenantId: number | undefined;
    userId: number;
}

export class ImpersonateOutput implements IImpersonateOutput {
    impersonationToken: string | undefined;
    tenancyName: string | undefined;

    constructor(data?: IImpersonateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.impersonationToken = _data['impersonationToken'];
            this.tenancyName = _data['tenancyName'];
        }
    }

    static fromJS(data: any): ImpersonateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['impersonationToken'] = this.impersonationToken;
        data['tenancyName'] = this.tenancyName;
        return data;
    }
}

export interface IImpersonateOutput {
    impersonationToken: string | undefined;
    tenancyName: string | undefined;
}

export class ImprovementProgram implements IImprovementProgram {
    id: number;
    name: string | undefined;
    programStartDate: moment.Moment;
    weeksDuration: number;
    opportunitySteps: OpportunityStep[] | undefined;
    improvementProgramSpeciality: ImprovementProgramSpeciality[] | undefined;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    type: ImprovementProgramType;

    constructor(data?: IImprovementProgram) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.programStartDate = _data['programStartDate'] ? moment(_data['programStartDate'].toString()) : <any>undefined;
            this.weeksDuration = _data['weeksDuration'];
            if (Array.isArray(_data['opportunitySteps'])) {
                this.opportunitySteps = [] as any;
                for (let item of _data['opportunitySteps']) this.opportunitySteps.push(OpportunityStep.fromJS(item));
            }
            if (Array.isArray(_data['improvementProgramSpeciality'])) {
                this.improvementProgramSpeciality = [] as any;
                for (let item of _data['improvementProgramSpeciality'])
                    this.improvementProgramSpeciality.push(ImprovementProgramSpeciality.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
            this.type = _data['type'];
        }
    }

    static fromJS(data: any): ImprovementProgram {
        data = typeof data === 'object' ? data : {};
        let result = new ImprovementProgram();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['programStartDate'] = this.programStartDate ? this.programStartDate.toISOString() : <any>undefined;
        data['weeksDuration'] = this.weeksDuration;
        if (Array.isArray(this.opportunitySteps)) {
            data['opportunitySteps'] = [];
            for (let item of this.opportunitySteps) data['opportunitySteps'].push(item.toJSON());
        }
        if (Array.isArray(this.improvementProgramSpeciality)) {
            data['improvementProgramSpeciality'] = [];
            for (let item of this.improvementProgramSpeciality) data['improvementProgramSpeciality'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data['type'] = this.type;
        return data;
    }
}

export interface IImprovementProgram {
    id: number;
    name: string | undefined;
    programStartDate: moment.Moment;
    weeksDuration: number;
    opportunitySteps: OpportunityStep[] | undefined;
    improvementProgramSpeciality: ImprovementProgramSpeciality[] | undefined;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    type: ImprovementProgramType;
}

export class ImprovementProgramConfigurationDto implements IImprovementProgramConfigurationDto {
    id: number;
    name: string | undefined;
    programStartDate: moment.Moment;
    weeksDuration: number;
    specialities: SpecialityMagicValuesPairDto[] | undefined;
    opportunitySteps: OpportunityStepDto[] | undefined;
    type: number;

    constructor(data?: IImprovementProgramConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.programStartDate = _data['programStartDate'] ? moment(_data['programStartDate'].toString()) : <any>undefined;
            this.weeksDuration = _data['weeksDuration'];
            if (Array.isArray(_data['specialities'])) {
                this.specialities = [] as any;
                for (let item of _data['specialities']) this.specialities.push(SpecialityMagicValuesPairDto.fromJS(item));
            }
            if (Array.isArray(_data['opportunitySteps'])) {
                this.opportunitySteps = [] as any;
                for (let item of _data['opportunitySteps']) this.opportunitySteps.push(OpportunityStepDto.fromJS(item));
            }
            this.type = _data['type'];
        }
    }

    static fromJS(data: any): ImprovementProgramConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImprovementProgramConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['programStartDate'] = this.programStartDate ? this.programStartDate.toISOString() : <any>undefined;
        data['weeksDuration'] = this.weeksDuration;
        if (Array.isArray(this.specialities)) {
            data['specialities'] = [];
            for (let item of this.specialities) data['specialities'].push(item.toJSON());
        }
        if (Array.isArray(this.opportunitySteps)) {
            data['opportunitySteps'] = [];
            for (let item of this.opportunitySteps) data['opportunitySteps'].push(item.toJSON());
        }
        data['type'] = this.type;
        return data;
    }
}

export interface IImprovementProgramConfigurationDto {
    id: number;
    name: string | undefined;
    programStartDate: moment.Moment;
    weeksDuration: number;
    specialities: SpecialityMagicValuesPairDto[] | undefined;
    opportunitySteps: OpportunityStepDto[] | undefined;
    type: number;
}

export class ImprovementProgramDto implements IImprovementProgramDto {
    startDate: moment.Moment;
    magicSessions: number;
    magicNumber: number;
    totalPlannedSessions: number;
    totalActualSessions: number;
    totalPlannedCases: number;
    totalActualCases: number;
    plannedAcps: number;
    actualAcps: number;
    improvementProgramWeeks: ImprovementProgramWeekDto[] | undefined;
    speciality: SpecialityDto;

    constructor(data?: IImprovementProgramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data['startDate'] ? moment(_data['startDate'].toString()) : <any>undefined;
            this.magicSessions = _data['magicSessions'];
            this.magicNumber = _data['magicNumber'];
            this.totalPlannedSessions = _data['totalPlannedSessions'];
            this.totalActualSessions = _data['totalActualSessions'];
            this.totalPlannedCases = _data['totalPlannedCases'];
            this.totalActualCases = _data['totalActualCases'];
            this.plannedAcps = _data['plannedAcps'];
            this.actualAcps = _data['actualAcps'];
            this.speciality = _data['speciality'];
            if (Array.isArray(_data['improvementProgramWeeks'])) {
                this.improvementProgramWeeks = [] as any;
                for (let item of _data['improvementProgramWeeks'])
                    this.improvementProgramWeeks.push(ImprovementProgramWeekDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ImprovementProgramDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImprovementProgramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data['magicSessions'] = this.magicSessions;
        data['magicNumber'] = this.magicNumber;
        data['totalPlannedSessions'] = this.totalPlannedSessions;
        data['totalActualSessions'] = this.totalActualSessions;
        data['totalPlannedCases'] = this.totalPlannedCases;
        data['totalActualCases'] = this.totalActualCases;
        data['plannedAcps'] = this.plannedAcps;
        data['actualAcps'] = this.actualAcps;
        if (Array.isArray(this.improvementProgramWeeks)) {
            data['improvementProgramWeeks'] = [];
            for (let item of this.improvementProgramWeeks) data['improvementProgramWeeks'].push(item.toJSON());
        }
        return data;
    }
}

export interface IImprovementProgramDto {
    startDate: moment.Moment;
    magicSessions: number;
    magicNumber: number;
    totalPlannedSessions: number;
    totalActualSessions: number;
    totalPlannedCases: number;
    totalActualCases: number;
    plannedAcps: number;
    actualAcps: number;
    improvementProgramWeeks: ImprovementProgramWeekDto[] | undefined;
}

export class ImprovementProgramsDto implements IImprovementProgramsDto {
    name: string | undefined;
    improvementPrograms: ImprovementProgramDto[] | undefined;
    improvementProgramType: ImprovementProgramType;

    constructor(data?: IImprovementProgramsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            if (Array.isArray(_data['improvementPrograms'])) {
                this.improvementPrograms = [] as any;
                for (let item of _data['improvementPrograms']) this.improvementPrograms.push(ImprovementProgramDto.fromJS(item));
            }
            this.improvementProgramType = _data['improvementProgramType'];
        }
    }

    static fromJS(data: any): ImprovementProgramsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImprovementProgramsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        if (Array.isArray(this.improvementPrograms)) {
            data['improvementPrograms'] = [];
            for (let item of this.improvementPrograms) data['improvementPrograms'].push(item.toJSON());
        }
        data['improvementProgramType'] = this.improvementProgramType;
        return data;
    }
}

export interface IImprovementProgramsDto {
    name: string | undefined;
    improvementPrograms: ImprovementProgramDto[] | undefined;
    improvementProgramType: ImprovementProgramType;
}

export class ImprovementProgramSpeciality implements IImprovementProgramSpeciality {
    improvementProgramId: number;
    improvementProgram: ImprovementProgram;
    specialityId: number;
    speciality: Speciality;
    plannedSessions: number;
    improvementTarget: number;
    plannedAcps: number;

    constructor(data?: IImprovementProgramSpeciality) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.improvementProgramId = _data['improvementProgramId'];
            this.improvementProgram = _data['improvementProgram'] ? ImprovementProgram.fromJS(_data['improvementProgram']) : <any>undefined;
            this.specialityId = _data['specialityId'];
            this.speciality = _data['speciality'] ? Speciality.fromJS(_data['speciality']) : <any>undefined;
            this.plannedSessions = _data['plannedSessions'];
            this.improvementTarget = _data['improvementTarget'];
            this.plannedAcps = _data['plannedAcps'];
        }
    }

    static fromJS(data: any): ImprovementProgramSpeciality {
        data = typeof data === 'object' ? data : {};
        let result = new ImprovementProgramSpeciality();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['improvementProgramId'] = this.improvementProgramId;
        data['improvementProgram'] = this.improvementProgram ? this.improvementProgram.toJSON() : <any>undefined;
        data['specialityId'] = this.specialityId;
        data['speciality'] = this.speciality ? this.speciality.toJSON() : <any>undefined;
        data['plannedSessions'] = this.plannedSessions;
        data['improvementTarget'] = this.improvementTarget;
        data['plannedAcps'] = this.plannedAcps;
        return data;
    }
}

export interface IImprovementProgramSpeciality {
    improvementProgramId: number;
    improvementProgram: ImprovementProgram;
    specialityId: number;
    speciality: Speciality;
    plannedSessions: number;
    improvementTarget: number;
    plannedAcps: number;
}

export enum ImprovementProgramType {
    _1 = 1,
    _2 = 2
}

export class ImprovementProgramWeekDto implements IImprovementProgramWeekDto {
    week: moment.Moment;
    opportunityPercentage: number;
    plannedSessions: number;
    plannedImprovementTarget: number;
    plannedAcps: number;
    actualSessions: number;
    bookedCases: number;
    actualCases: number;

    constructor(data?: IImprovementProgramWeekDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.week = _data['week'] ? moment(_data['week'].toString()) : <any>undefined;
            this.opportunityPercentage = _data['opportunityPercentage'];
            this.plannedSessions = _data['plannedSessions'];
            this.plannedImprovementTarget = _data['plannedImprovementTarget'];
            this.plannedAcps = _data['plannedAcps'];
            this.actualSessions = _data['actualSessions'];
            this.bookedCases = _data['bookedCases'];
            this.actualCases = _data['actualCases'];
        }
    }

    static fromJS(data: any): ImprovementProgramWeekDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImprovementProgramWeekDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['week'] = this.week ? this.week.toISOString() : <any>undefined;
        data['opportunityPercentage'] = this.opportunityPercentage;
        data['plannedSessions'] = this.plannedSessions;
        data['plannedImprovementTarget'] = this.plannedImprovementTarget;
        data['plannedAcps'] = this.plannedAcps;
        data['actualSessions'] = this.actualSessions;
        data['bookedCases'] = this.bookedCases;
        data['actualCases'] = this.actualCases;
        return data;
    }
}

export interface IImprovementProgramWeekDto {
    week: moment.Moment;
    opportunityPercentage: number;
    plannedSessions: number;
    plannedImprovementTarget: number;
    plannedAcps: number;
    actualSessions: number;
    bookedCases: number;
    actualCases: number;
}

export class InstallDto implements IInstallDto {
    connectionString: string;
    adminPassword: string;
    webSiteUrl: string;
    serverUrl: string | undefined;
    defaultLanguage: string;
    smtpSettings: EmailSettingsEditDto;
    billInfo: HostBillingSettingsEditDto;

    constructor(data?: IInstallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionString = _data['connectionString'];
            this.adminPassword = _data['adminPassword'];
            this.webSiteUrl = _data['webSiteUrl'];
            this.serverUrl = _data['serverUrl'];
            this.defaultLanguage = _data['defaultLanguage'];
            this.smtpSettings = _data['smtpSettings'] ? EmailSettingsEditDto.fromJS(_data['smtpSettings']) : <any>undefined;
            this.billInfo = _data['billInfo'] ? HostBillingSettingsEditDto.fromJS(_data['billInfo']) : <any>undefined;
        }
    }

    static fromJS(data: any): InstallDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['connectionString'] = this.connectionString;
        data['adminPassword'] = this.adminPassword;
        data['webSiteUrl'] = this.webSiteUrl;
        data['serverUrl'] = this.serverUrl;
        data['defaultLanguage'] = this.defaultLanguage;
        data['smtpSettings'] = this.smtpSettings ? this.smtpSettings.toJSON() : <any>undefined;
        data['billInfo'] = this.billInfo ? this.billInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInstallDto {
    connectionString: string;
    adminPassword: string;
    webSiteUrl: string;
    serverUrl: string | undefined;
    defaultLanguage: string;
    smtpSettings: EmailSettingsEditDto;
    billInfo: HostBillingSettingsEditDto;
}

export class Int64EntityDto implements IInt64EntityDto {
    id: number;

    constructor(data?: IInt64EntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): Int64EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new Int64EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        return data;
    }
}

export interface IInt64EntityDto {
    id: number;
}

export class IntPtr implements IIntPtr {
    constructor(data?: IIntPtr) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {}

    static fromJS(data: any): IntPtr {
        data = typeof data === 'object' ? data : {};
        let result = new IntPtr();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IIntPtr {}

export class InvoiceDto implements IInvoiceDto {
    amount: number;
    editionDisplayName: string | undefined;
    invoiceNo: string | undefined;
    invoiceDate: moment.Moment;
    tenantLegalName: string | undefined;
    tenantAddress: string[] | undefined;
    tenantTaxNo: string | undefined;
    hostLegalName: string | undefined;
    hostAddress: string[] | undefined;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data['amount'];
            this.editionDisplayName = _data['editionDisplayName'];
            this.invoiceNo = _data['invoiceNo'];
            this.invoiceDate = _data['invoiceDate'] ? moment(_data['invoiceDate'].toString()) : <any>undefined;
            this.tenantLegalName = _data['tenantLegalName'];
            if (Array.isArray(_data['tenantAddress'])) {
                this.tenantAddress = [] as any;
                for (let item of _data['tenantAddress']) this.tenantAddress.push(item);
            }
            this.tenantTaxNo = _data['tenantTaxNo'];
            this.hostLegalName = _data['hostLegalName'];
            if (Array.isArray(_data['hostAddress'])) {
                this.hostAddress = [] as any;
                for (let item of _data['hostAddress']) this.hostAddress.push(item);
            }
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['amount'] = this.amount;
        data['editionDisplayName'] = this.editionDisplayName;
        data['invoiceNo'] = this.invoiceNo;
        data['invoiceDate'] = this.invoiceDate ? this.invoiceDate.toISOString() : <any>undefined;
        data['tenantLegalName'] = this.tenantLegalName;
        if (Array.isArray(this.tenantAddress)) {
            data['tenantAddress'] = [];
            for (let item of this.tenantAddress) data['tenantAddress'].push(item);
        }
        data['tenantTaxNo'] = this.tenantTaxNo;
        data['hostLegalName'] = this.hostLegalName;
        if (Array.isArray(this.hostAddress)) {
            data['hostAddress'] = [];
            for (let item of this.hostAddress) data['hostAddress'].push(item);
        }
        return data;
    }
}

export interface IInvoiceDto {
    amount: number;
    editionDisplayName: string | undefined;
    invoiceNo: string | undefined;
    invoiceDate: moment.Moment;
    tenantLegalName: string | undefined;
    tenantAddress: string[] | undefined;
    tenantTaxNo: string | undefined;
    hostLegalName: string | undefined;
    hostAddress: string[] | undefined;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data['tenancyName'];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenancyName'] = this.tenancyName;
        return data;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
    serverRootAddress: string | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data['state'];
            this.tenantId = _data['tenantId'];
            this.serverRootAddress = _data['serverRootAddress'];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['state'] = this.state;
        data['tenantId'] = this.tenantId;
        data['serverRootAddress'] = this.serverRootAddress;
        return data;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
    serverRootAddress: string | undefined;
}

export class IValueValidator implements IIValueValidator {
    readonly name: string | undefined;
    readonly attributes: { [key: string]: any } | undefined;

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data['name'];
            if (_data['attributes']) {
                (<any>this).attributes = {} as any;
                for (let key in _data['attributes']) {
                    if (_data['attributes'].hasOwnProperty(key)) (<any>(<any>this).attributes)[key] = _data['attributes'][key];
                }
            }
        }
    }

    static fromJS(data: any): IValueValidator {
        data = typeof data === 'object' ? data : {};
        let result = new IValueValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        if (this.attributes) {
            data['attributes'] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key)) (<any>data['attributes'])[key] = (<any>this.attributes)[key];
            }
        }
        return data;
    }
}

export interface IIValueValidator {
    name: string | undefined;
    attributes: { [key: string]: any } | undefined;
}

export class LanguageTextListDto implements ILanguageTextListDto {
    key: string | undefined;
    baseValue: string | undefined;
    targetValue: string | undefined;

    constructor(data?: ILanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data['key'];
            this.baseValue = _data['baseValue'];
            this.targetValue = _data['targetValue'];
        }
    }

    static fromJS(data: any): LanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['key'] = this.key;
        data['baseValue'] = this.baseValue;
        data['targetValue'] = this.targetValue;
        return data;
    }
}

export interface ILanguageTextListDto {
    key: string | undefined;
    baseValue: string | undefined;
    targetValue: string | undefined;
}

export class LanguageTextListDtoPagedResultDto implements ILanguageTextListDtoPagedResultDto {
    items: LanguageTextListDto[] | undefined;
    totalCount: number;

    constructor(data?: ILanguageTextListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(LanguageTextListDto.fromJS(item));
            }
            this.totalCount = _data['totalCount'];
        }
    }

    static fromJS(data: any): LanguageTextListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        data['totalCount'] = this.totalCount;
        return data;
    }
}

export interface ILanguageTextListDtoPagedResultDto {
    items: LanguageTextListDto[] | undefined;
    totalCount: number;
}

export enum LayoutKind {
    _0 = 0,
    _2 = 2,
    _3 = 3
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
    isModuleEnabled: boolean;
    isEnabled: boolean;
    domain: string | undefined;
    userName: string | undefined;
    password: string | undefined;

    constructor(data?: ILdapSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isModuleEnabled = _data['isModuleEnabled'];
            this.isEnabled = _data['isEnabled'];
            this.domain = _data['domain'];
            this.userName = _data['userName'];
            this.password = _data['password'];
        }
    }

    static fromJS(data: any): LdapSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['isModuleEnabled'] = this.isModuleEnabled;
        data['isEnabled'] = this.isEnabled;
        data['domain'] = this.domain;
        data['userName'] = this.userName;
        data['password'] = this.password;
        return data;
    }
}

export interface ILdapSettingsEditDto {
    isModuleEnabled: boolean;
    isEnabled: boolean;
    domain: string | undefined;
    userName: string | undefined;
    password: string | undefined;
}

export class LinkedUserDto implements ILinkedUserDto {
    id: number;
    tenantId: number | undefined;
    tenancyName: string | undefined;
    username: string | undefined;
    lastLoginTime: moment.Moment | undefined;

    constructor(data?: ILinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.tenantId = _data['tenantId'];
            this.tenancyName = _data['tenancyName'];
            this.username = _data['username'];
            this.lastLoginTime = _data['lastLoginTime'] ? moment(_data['lastLoginTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): LinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['tenantId'] = this.tenantId;
        data['tenancyName'] = this.tenancyName;
        data['username'] = this.username;
        data['lastLoginTime'] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ILinkedUserDto {
    id: number;
    tenantId: number | undefined;
    tenancyName: string | undefined;
    username: string | undefined;
    lastLoginTime: moment.Moment | undefined;
}

export class LinkedUserDtoListResultDto implements ILinkedUserDtoListResultDto {
    items: LinkedUserDto[] | undefined;

    constructor(data?: ILinkedUserDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LinkedUserDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedUserDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }
}

export interface ILinkedUserDtoListResultDto {
    items: LinkedUserDto[] | undefined;
}

export class LinkedUserDtoPagedResultDto implements ILinkedUserDtoPagedResultDto {
    items: LinkedUserDto[] | undefined;
    totalCount: number;

    constructor(data?: ILinkedUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(LinkedUserDto.fromJS(item));
            }
            this.totalCount = _data['totalCount'];
        }
    }

    static fromJS(data: any): LinkedUserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedUserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        data['totalCount'] = this.totalCount;
        return data;
    }
}

export interface ILinkedUserDtoPagedResultDto {
    items: LinkedUserDto[] | undefined;
    totalCount: number;
}

export class LinkToUserInput implements ILinkToUserInput {
    tenancyName: string | undefined;
    usernameOrEmailAddress: string;
    password: string;

    constructor(data?: ILinkToUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data['tenancyName'];
            this.usernameOrEmailAddress = _data['usernameOrEmailAddress'];
            this.password = _data['password'];
        }
    }

    static fromJS(data: any): LinkToUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new LinkToUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenancyName'] = this.tenancyName;
        data['usernameOrEmailAddress'] = this.usernameOrEmailAddress;
        data['password'] = this.password;
        return data;
    }
}

export interface ILinkToUserInput {
    tenancyName: string | undefined;
    usernameOrEmailAddress: string;
    password: string;
}

export class LocalizableComboboxItemDto implements ILocalizableComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;

    constructor(data?: ILocalizableComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data['value'];
            this.displayText = _data['displayText'];
        }
    }

    static fromJS(data: any): LocalizableComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['value'] = this.value;
        data['displayText'] = this.displayText;
        return data;
    }
}

export interface ILocalizableComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
}

export class LocalizableComboboxItemSourceDto implements ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[] | undefined;

    constructor(data?: ILocalizableComboboxItemSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(LocalizableComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalizableComboboxItemSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[] | undefined;
}

export class MagicValuesDto implements IMagicValuesDto {
    specialityId: number;
    plannedSessions: number;
    plannedImprovementTarget: number;
    plannedAcps: number;

    constructor(data?: IMagicValuesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.specialityId = _data['specialityId'];
            this.plannedSessions = _data['plannedSessions'];
            this.plannedImprovementTarget = _data['plannedImprovementTarget'];
            this.plannedAcps = _data['plannedAcps'];
        }
    }

    static fromJS(data: any): MagicValuesDto {
        data = typeof data === 'object' ? data : {};
        let result = new MagicValuesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['specialityId'] = this.specialityId;
        data['plannedSessions'] = this.plannedSessions;
        data['plannedImprovementTarget'] = this.plannedImprovementTarget;
        data['plannedAcps'] = this.plannedAcps;
        return data;
    }
}

export interface IMagicValuesDto {
    specialityId: number;
    plannedSessions: number;
    plannedImprovementTarget: number;
    plannedAcps: number;
}

export class MappingsDto implements IMappingsDto {
    constructor(data?: IMappingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {}

    static fromJS(data: any): MappingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MappingsDto(data);
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IMappingsDto {}

export class MarkAllUnreadMessagesOfUserAsReadInput implements IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId: number | undefined;
    userId: number;

    constructor(data?: IMarkAllUnreadMessagesOfUserAsReadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.userId = _data['userId'];
        }
    }

    static fromJS(data: any): MarkAllUnreadMessagesOfUserAsReadInput {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAllUnreadMessagesOfUserAsReadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['userId'] = this.userId;
        return data;
    }
}

export interface IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId: number | undefined;
    userId: number;
}

export class MemberInfo implements IMemberInfo {
    memberType: MemberTypes;
    declaringType: Type;
    reflectedType: Type;
    readonly name: string | undefined;
    module: Module;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly isCollectible: boolean;
    readonly metadataToken: number;

    constructor(data?: IMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data['memberType'];
            this.declaringType = _data['declaringType'] ? Type.fromJS(_data['declaringType']) : <any>undefined;
            this.reflectedType = _data['reflectedType'] ? Type.fromJS(_data['reflectedType']) : <any>undefined;
            (<any>this).name = _data['name'];
            this.module = _data['module'] ? Module.fromJS(_data['module']) : <any>undefined;
            if (Array.isArray(_data['customAttributes'])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data['customAttributes']) (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data['isCollectible'];
            (<any>this).metadataToken = _data['metadataToken'];
        }
    }

    static fromJS(data: any): MemberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['memberType'] = this.memberType;
        data['declaringType'] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data['reflectedType'] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data['name'] = this.name;
        data['module'] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data['customAttributes'] = [];
            for (let item of this.customAttributes) data['customAttributes'].push(item.toJSON());
        }
        data['isCollectible'] = this.isCollectible;
        data['metadataToken'] = this.metadataToken;
        return data;
    }
}

export interface IMemberInfo {
    memberType: MemberTypes;
    declaringType: Type;
    reflectedType: Type;
    name: string | undefined;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
}

export enum MemberTypes {
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _191 = 191
}

export class MetadataType implements IMetadataType {
    id: number;
    name: string | undefined;
    abbreviation: string | undefined;
    valueType: MetadataValueType;
    isEnabled: boolean;
    order: number;
    trueTooltipText: string | undefined;
    falseTooltipText: string | undefined;
    unknownTooltipText: string | undefined;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    includeFilter: boolean;

    constructor(data?: IMetadataType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.abbreviation = _data['abbreviation'];
            this.valueType = _data['valueType'];
            this.isEnabled = _data['isEnabled'];
            this.order = _data['order'];
            this.trueTooltipText = _data['trueTooltipText'];
            this.falseTooltipText = _data['falseTooltipText'];
            this.unknownTooltipText = _data['unknownTooltipText'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
            this.includeFilter = _data['includeFilter'];
        }
    }

    static fromJS(data: any): MetadataType {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['abbreviation'] = this.abbreviation;
        data['valueType'] = this.valueType;
        data['isEnabled'] = this.isEnabled;
        data['order'] = this.order;
        data['trueTooltipText'] = this.trueTooltipText;
        data['falseTooltipText'] = this.falseTooltipText;
        data['unknownTooltipText'] = this.unknownTooltipText;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data['includeFilter'] = this.includeFilter;
        return data;
    }
}

export interface IMetadataType {
    id: number;
    name: string | undefined;
    abbreviation: string | undefined;
    valueType: MetadataValueType;
    isEnabled: boolean;
    order: number;
    trueTooltipText: string | undefined;
    falseTooltipText: string | undefined;
    unknownTooltipText: string | undefined;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    includeFilter: boolean;
}

export class MetadataTypeDto implements IMetadataTypeDto {
    id: number;
    name: string | undefined;
    abbreviation: string | undefined;
    valueType: MetadataValueType;
    isEnabled: boolean;
    order: number;
    trueTooltipText: string | undefined;
    falseTooltipText: string | undefined;
    unknownTooltipText: string | undefined;
    includeFilter: boolean;

    constructor(data?: IMetadataTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.abbreviation = _data['abbreviation'];
            this.valueType = _data['valueType'];
            this.isEnabled = _data['isEnabled'];
            this.order = _data['order'];
            this.trueTooltipText = _data['trueTooltipText'];
            this.falseTooltipText = _data['falseTooltipText'];
            this.unknownTooltipText = _data['unknownTooltipText'];
            this.includeFilter = _data['includeFilter'];
        }
    }

    static fromJS(data: any): MetadataTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['abbreviation'] = this.abbreviation;
        data['valueType'] = this.valueType;
        data['isEnabled'] = this.isEnabled;
        data['order'] = this.order;
        data['trueTooltipText'] = this.trueTooltipText;
        data['falseTooltipText'] = this.falseTooltipText;
        data['unknownTooltipText'] = this.unknownTooltipText;
        data['includeFilter'] = this.includeFilter;
        return data;
    }
}

export interface IMetadataTypeDto {
    id: number;
    name: string | undefined;
    abbreviation: string | undefined;
    valueType: MetadataValueType;
    isEnabled: boolean;
    order: number;
    trueTooltipText: string | undefined;
    falseTooltipText: string | undefined;
    unknownTooltipText: string | undefined;
    includeFilter: boolean;
}

export class MetadataValue implements IMetadataValue {
    id: number;
    type: MetadataType;
    value: string | undefined;
    patient: Patient;
    procedure: Procedure;
    waitingList: WaitingList;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IMetadataValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.type = _data['type'] ? MetadataType.fromJS(_data['type']) : <any>undefined;
            this.value = _data['value'];
            this.patient = _data['patient'] ? Patient.fromJS(_data['patient']) : <any>undefined;
            this.procedure = _data['procedure'] ? Procedure.fromJS(_data['procedure']) : <any>undefined;
            this.waitingList = _data['waitingList'] ? WaitingList.fromJS(_data['waitingList']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MetadataValue {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['type'] = this.type ? this.type.toJSON() : <any>undefined;
        data['value'] = this.value;
        data['patient'] = this.patient ? this.patient.toJSON() : <any>undefined;
        data['procedure'] = this.procedure ? this.procedure.toJSON() : <any>undefined;
        data['waitingList'] = this.waitingList ? this.waitingList.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMetadataValue {
    id: number;
    type: MetadataType;
    value: string | undefined;
    patient: Patient;
    procedure: Procedure;
    waitingList: WaitingList;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class MetadataValueDto implements IMetadataValueDto {
    value: string | undefined;

    constructor(data?: IMetadataValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data['value'];
        }
    }

    static fromJS(data: any): MetadataValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new MetadataValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['value'] = this.value;
        return data;
    }
}

export interface IMetadataValueDto {
    value: string | undefined;
}

export enum MetadataValueType {
    _0 = 0,
    _1 = 1
}

export enum MethodAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _1024 = 1024,
    _2048 = 2048,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
    _53248 = 53248
}

export class MethodBase implements IMethodBase {
    memberType: MemberTypes;
    readonly name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly isCollectible: boolean;
    readonly metadataToken: number;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    readonly isAbstract: boolean;
    readonly isConstructor: boolean;
    readonly isFinal: boolean;
    readonly isHideBySig: boolean;
    readonly isSpecialName: boolean;
    readonly isStatic: boolean;
    readonly isVirtual: boolean;
    readonly isAssembly: boolean;
    readonly isFamily: boolean;
    readonly isFamilyAndAssembly: boolean;
    readonly isFamilyOrAssembly: boolean;
    readonly isPrivate: boolean;
    readonly isPublic: boolean;
    readonly isConstructedGenericMethod: boolean;
    readonly isGenericMethod: boolean;
    readonly isGenericMethodDefinition: boolean;
    readonly containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    readonly isSecurityCritical: boolean;
    readonly isSecuritySafeCritical: boolean;
    readonly isSecurityTransparent: boolean;

    constructor(data?: IMethodBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberType = _data['memberType'];
            (<any>this).name = _data['name'];
            this.declaringType = _data['declaringType'] ? Type.fromJS(_data['declaringType']) : <any>undefined;
            this.reflectedType = _data['reflectedType'] ? Type.fromJS(_data['reflectedType']) : <any>undefined;
            this.module = _data['module'] ? Module.fromJS(_data['module']) : <any>undefined;
            if (Array.isArray(_data['customAttributes'])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data['customAttributes']) (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data['isCollectible'];
            (<any>this).metadataToken = _data['metadataToken'];
            this.attributes = _data['attributes'];
            this.methodImplementationFlags = _data['methodImplementationFlags'];
            this.callingConvention = _data['callingConvention'];
            (<any>this).isAbstract = _data['isAbstract'];
            (<any>this).isConstructor = _data['isConstructor'];
            (<any>this).isFinal = _data['isFinal'];
            (<any>this).isHideBySig = _data['isHideBySig'];
            (<any>this).isSpecialName = _data['isSpecialName'];
            (<any>this).isStatic = _data['isStatic'];
            (<any>this).isVirtual = _data['isVirtual'];
            (<any>this).isAssembly = _data['isAssembly'];
            (<any>this).isFamily = _data['isFamily'];
            (<any>this).isFamilyAndAssembly = _data['isFamilyAndAssembly'];
            (<any>this).isFamilyOrAssembly = _data['isFamilyOrAssembly'];
            (<any>this).isPrivate = _data['isPrivate'];
            (<any>this).isPublic = _data['isPublic'];
            (<any>this).isConstructedGenericMethod = _data['isConstructedGenericMethod'];
            (<any>this).isGenericMethod = _data['isGenericMethod'];
            (<any>this).isGenericMethodDefinition = _data['isGenericMethodDefinition'];
            (<any>this).containsGenericParameters = _data['containsGenericParameters'];
            this.methodHandle = _data['methodHandle'] ? RuntimeMethodHandle.fromJS(_data['methodHandle']) : <any>undefined;
            (<any>this).isSecurityCritical = _data['isSecurityCritical'];
            (<any>this).isSecuritySafeCritical = _data['isSecuritySafeCritical'];
            (<any>this).isSecurityTransparent = _data['isSecurityTransparent'];
        }
    }

    static fromJS(data: any): MethodBase {
        data = typeof data === 'object' ? data : {};
        let result = new MethodBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['memberType'] = this.memberType;
        data['name'] = this.name;
        data['declaringType'] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data['reflectedType'] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data['module'] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data['customAttributes'] = [];
            for (let item of this.customAttributes) data['customAttributes'].push(item.toJSON());
        }
        data['isCollectible'] = this.isCollectible;
        data['metadataToken'] = this.metadataToken;
        data['attributes'] = this.attributes;
        data['methodImplementationFlags'] = this.methodImplementationFlags;
        data['callingConvention'] = this.callingConvention;
        data['isAbstract'] = this.isAbstract;
        data['isConstructor'] = this.isConstructor;
        data['isFinal'] = this.isFinal;
        data['isHideBySig'] = this.isHideBySig;
        data['isSpecialName'] = this.isSpecialName;
        data['isStatic'] = this.isStatic;
        data['isVirtual'] = this.isVirtual;
        data['isAssembly'] = this.isAssembly;
        data['isFamily'] = this.isFamily;
        data['isFamilyAndAssembly'] = this.isFamilyAndAssembly;
        data['isFamilyOrAssembly'] = this.isFamilyOrAssembly;
        data['isPrivate'] = this.isPrivate;
        data['isPublic'] = this.isPublic;
        data['isConstructedGenericMethod'] = this.isConstructedGenericMethod;
        data['isGenericMethod'] = this.isGenericMethod;
        data['isGenericMethodDefinition'] = this.isGenericMethodDefinition;
        data['containsGenericParameters'] = this.containsGenericParameters;
        data['methodHandle'] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data['isSecurityCritical'] = this.isSecurityCritical;
        data['isSecuritySafeCritical'] = this.isSecuritySafeCritical;
        data['isSecurityTransparent'] = this.isSecurityTransparent;
        return data;
    }
}

export interface IMethodBase {
    memberType: MemberTypes;
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
}

export enum MethodImplAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _32 = 32,
    _64 = 64,
    _128 = 128,
    _256 = 256,
    _512 = 512,
    _4096 = 4096,
    _65535 = 65535
}

export class MethodInfo implements IMethodInfo {
    readonly name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly isCollectible: boolean;
    readonly metadataToken: number;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    readonly isAbstract: boolean;
    readonly isConstructor: boolean;
    readonly isFinal: boolean;
    readonly isHideBySig: boolean;
    readonly isSpecialName: boolean;
    readonly isStatic: boolean;
    readonly isVirtual: boolean;
    readonly isAssembly: boolean;
    readonly isFamily: boolean;
    readonly isFamilyAndAssembly: boolean;
    readonly isFamilyOrAssembly: boolean;
    readonly isPrivate: boolean;
    readonly isPublic: boolean;
    readonly isConstructedGenericMethod: boolean;
    readonly isGenericMethod: boolean;
    readonly isGenericMethodDefinition: boolean;
    readonly containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    readonly isSecurityCritical: boolean;
    readonly isSecuritySafeCritical: boolean;
    readonly isSecurityTransparent: boolean;
    memberType: MemberTypes;
    returnParameter: ParameterInfo;
    returnType: Type;
    returnTypeCustomAttributes: ICustomAttributeProvider;

    constructor(data?: IMethodInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data['name'];
            this.declaringType = _data['declaringType'] ? Type.fromJS(_data['declaringType']) : <any>undefined;
            this.reflectedType = _data['reflectedType'] ? Type.fromJS(_data['reflectedType']) : <any>undefined;
            this.module = _data['module'] ? Module.fromJS(_data['module']) : <any>undefined;
            if (Array.isArray(_data['customAttributes'])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data['customAttributes']) (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data['isCollectible'];
            (<any>this).metadataToken = _data['metadataToken'];
            this.attributes = _data['attributes'];
            this.methodImplementationFlags = _data['methodImplementationFlags'];
            this.callingConvention = _data['callingConvention'];
            (<any>this).isAbstract = _data['isAbstract'];
            (<any>this).isConstructor = _data['isConstructor'];
            (<any>this).isFinal = _data['isFinal'];
            (<any>this).isHideBySig = _data['isHideBySig'];
            (<any>this).isSpecialName = _data['isSpecialName'];
            (<any>this).isStatic = _data['isStatic'];
            (<any>this).isVirtual = _data['isVirtual'];
            (<any>this).isAssembly = _data['isAssembly'];
            (<any>this).isFamily = _data['isFamily'];
            (<any>this).isFamilyAndAssembly = _data['isFamilyAndAssembly'];
            (<any>this).isFamilyOrAssembly = _data['isFamilyOrAssembly'];
            (<any>this).isPrivate = _data['isPrivate'];
            (<any>this).isPublic = _data['isPublic'];
            (<any>this).isConstructedGenericMethod = _data['isConstructedGenericMethod'];
            (<any>this).isGenericMethod = _data['isGenericMethod'];
            (<any>this).isGenericMethodDefinition = _data['isGenericMethodDefinition'];
            (<any>this).containsGenericParameters = _data['containsGenericParameters'];
            this.methodHandle = _data['methodHandle'] ? RuntimeMethodHandle.fromJS(_data['methodHandle']) : <any>undefined;
            (<any>this).isSecurityCritical = _data['isSecurityCritical'];
            (<any>this).isSecuritySafeCritical = _data['isSecuritySafeCritical'];
            (<any>this).isSecurityTransparent = _data['isSecurityTransparent'];
            this.memberType = _data['memberType'];
            this.returnParameter = _data['returnParameter'] ? ParameterInfo.fromJS(_data['returnParameter']) : <any>undefined;
            this.returnType = _data['returnType'] ? Type.fromJS(_data['returnType']) : <any>undefined;
            this.returnTypeCustomAttributes = _data['returnTypeCustomAttributes']
                ? ICustomAttributeProvider.fromJS(_data['returnTypeCustomAttributes'])
                : <any>undefined;
        }
    }

    static fromJS(data: any): MethodInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MethodInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['declaringType'] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data['reflectedType'] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data['module'] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data['customAttributes'] = [];
            for (let item of this.customAttributes) data['customAttributes'].push(item.toJSON());
        }
        data['isCollectible'] = this.isCollectible;
        data['metadataToken'] = this.metadataToken;
        data['attributes'] = this.attributes;
        data['methodImplementationFlags'] = this.methodImplementationFlags;
        data['callingConvention'] = this.callingConvention;
        data['isAbstract'] = this.isAbstract;
        data['isConstructor'] = this.isConstructor;
        data['isFinal'] = this.isFinal;
        data['isHideBySig'] = this.isHideBySig;
        data['isSpecialName'] = this.isSpecialName;
        data['isStatic'] = this.isStatic;
        data['isVirtual'] = this.isVirtual;
        data['isAssembly'] = this.isAssembly;
        data['isFamily'] = this.isFamily;
        data['isFamilyAndAssembly'] = this.isFamilyAndAssembly;
        data['isFamilyOrAssembly'] = this.isFamilyOrAssembly;
        data['isPrivate'] = this.isPrivate;
        data['isPublic'] = this.isPublic;
        data['isConstructedGenericMethod'] = this.isConstructedGenericMethod;
        data['isGenericMethod'] = this.isGenericMethod;
        data['isGenericMethodDefinition'] = this.isGenericMethodDefinition;
        data['containsGenericParameters'] = this.containsGenericParameters;
        data['methodHandle'] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data['isSecurityCritical'] = this.isSecurityCritical;
        data['isSecuritySafeCritical'] = this.isSecuritySafeCritical;
        data['isSecurityTransparent'] = this.isSecurityTransparent;
        data['memberType'] = this.memberType;
        data['returnParameter'] = this.returnParameter ? this.returnParameter.toJSON() : <any>undefined;
        data['returnType'] = this.returnType ? this.returnType.toJSON() : <any>undefined;
        data['returnTypeCustomAttributes'] = this.returnTypeCustomAttributes ? this.returnTypeCustomAttributes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMethodInfo {
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    memberType: MemberTypes;
    returnParameter: ParameterInfo;
    returnType: Type;
    returnTypeCustomAttributes: ICustomAttributeProvider;
}

export class Module implements IModule {
    assembly: Assembly;
    readonly fullyQualifiedName: string | undefined;
    readonly name: string | undefined;
    readonly mdStreamVersion: number;
    readonly moduleVersionId: string;
    readonly scopeName: string | undefined;
    moduleHandle: ModuleHandle;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly metadataToken: number;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assembly = _data['assembly'] ? Assembly.fromJS(_data['assembly']) : <any>undefined;
            (<any>this).fullyQualifiedName = _data['fullyQualifiedName'];
            (<any>this).name = _data['name'];
            (<any>this).mdStreamVersion = _data['mdStreamVersion'];
            (<any>this).moduleVersionId = _data['moduleVersionId'];
            (<any>this).scopeName = _data['scopeName'];
            this.moduleHandle = _data['moduleHandle'] ? ModuleHandle.fromJS(_data['moduleHandle']) : <any>undefined;
            if (Array.isArray(_data['customAttributes'])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data['customAttributes']) (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).metadataToken = _data['metadataToken'];
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['assembly'] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data['fullyQualifiedName'] = this.fullyQualifiedName;
        data['name'] = this.name;
        data['mdStreamVersion'] = this.mdStreamVersion;
        data['moduleVersionId'] = this.moduleVersionId;
        data['scopeName'] = this.scopeName;
        data['moduleHandle'] = this.moduleHandle ? this.moduleHandle.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data['customAttributes'] = [];
            for (let item of this.customAttributes) data['customAttributes'].push(item.toJSON());
        }
        data['metadataToken'] = this.metadataToken;
        return data;
    }
}

export interface IModule {
    assembly: Assembly;
    fullyQualifiedName: string | undefined;
    name: string | undefined;
    mdStreamVersion: number;
    moduleVersionId: string;
    scopeName: string | undefined;
    moduleHandle: ModuleHandle;
    customAttributes: CustomAttributeData[] | undefined;
    metadataToken: number;
}

export class ModuleHandle implements IModuleHandle {
    readonly mdStreamVersion: number;

    constructor(data?: IModuleHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).mdStreamVersion = _data['mdStreamVersion'];
        }
    }

    static fromJS(data: any): ModuleHandle {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['mdStreamVersion'] = this.mdStreamVersion;
        return data;
    }
}

export interface IModuleHandle {
    mdStreamVersion: number;
}

export class MoveOrganizationUnitInput implements IMoveOrganizationUnitInput {
    id: number;
    newParentId: number | undefined;

    constructor(data?: IMoveOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.newParentId = _data['newParentId'];
        }
    }

    static fromJS(data: any): MoveOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new MoveOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['newParentId'] = this.newParentId;
        return data;
    }
}

export interface IMoveOrganizationUnitInput {
    id: number;
    newParentId: number | undefined;
}

export class NameValue implements INameValue {
    name: string | undefined;
    value: string | undefined;

    constructor(data?: INameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.value = _data['value'];
        }
    }

    static fromJS(data: any): NameValue {
        data = typeof data === 'object' ? data : {};
        let result = new NameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['value'] = this.value;
        return data;
    }
}

export interface INameValue {
    name: string | undefined;
    value: string | undefined;
}

export class NameValueDto implements INameValueDto {
    name: string | undefined;
    value: string | undefined;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.value = _data['value'];
        }
    }

    static fromJS(data: any): NameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['value'] = this.value;
        return data;
    }
}

export interface INameValueDto {
    name: string | undefined;
    value: string | undefined;
}

export class NameValueDtoListResultDto implements INameValueDtoListResultDto {
    items: NameValueDto[] | undefined;

    constructor(data?: INameValueDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): NameValueDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }
}

export interface INameValueDtoListResultDto {
    items: NameValueDto[] | undefined;
}

export class NameValueDtoPagedResultDto implements INameValueDtoPagedResultDto {
    items: NameValueDto[] | undefined;
    totalCount: number;

    constructor(data?: INameValueDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(NameValueDto.fromJS(item));
            }
            this.totalCount = _data['totalCount'];
        }
    }

    static fromJS(data: any): NameValueDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        data['totalCount'] = this.totalCount;
        return data;
    }
}

export interface INameValueDtoPagedResultDto {
    items: NameValueDto[] | undefined;
    totalCount: number;
}

export class NewCommentDto implements INewCommentDto {
    value: string | undefined;
    sessionId: string | undefined;

    constructor(data?: INewCommentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data['value'];
            this.sessionId = _data['sessionId'];
        }
    }

    static fromJS(data: any): NewCommentDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewCommentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['value'] = this.value;
        data['sessionId'] = this.sessionId;
        return data;
    }
}

export interface INewCommentDto {
    value: string | undefined;
    sessionId: string | undefined;
}

export class NotificationData implements INotificationData {
    readonly type: string | undefined;
    properties: { [key: string]: any } | undefined;

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).type = _data['type'];
            if (_data['properties']) {
                this.properties = {} as any;
                for (let key in _data['properties']) {
                    if (_data['properties'].hasOwnProperty(key)) (<any>this.properties)[key] = _data['properties'][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['type'] = this.type;
        if (this.properties) {
            data['properties'] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key)) (<any>data['properties'])[key] = (<any>this.properties)[key];
            }
        }
        return data;
    }
}

export interface INotificationData {
    type: string | undefined;
    properties: { [key: string]: any } | undefined;
}

export enum NotificationSeverity {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4
}

export class NotificationSubscriptionDto implements INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean;

    constructor(data?: INotificationSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.isSubscribed = _data['isSubscribed'];
        }
    }

    static fromJS(data: any): NotificationSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['isSubscribed'] = this.isSubscribed;
        return data;
    }
}

export interface INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean;
}

export class NotificationSubscriptionWithDisplayNameDto implements INotificationSubscriptionWithDisplayNameDto {
    name: string;
    isSubscribed: boolean;
    displayName: string | undefined;
    description: string | undefined;

    constructor(data?: INotificationSubscriptionWithDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.isSubscribed = _data['isSubscribed'];
            this.displayName = _data['displayName'];
            this.description = _data['description'];
        }
    }

    static fromJS(data: any): NotificationSubscriptionWithDisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['isSubscribed'] = this.isSubscribed;
        data['displayName'] = this.displayName;
        data['description'] = this.description;
        return data;
    }
}

export interface INotificationSubscriptionWithDisplayNameDto {
    name: string;
    isSubscribed: boolean;
    displayName: string | undefined;
    description: string | undefined;
}

export class OpcsCode implements IOpcsCode {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    description: string | undefined;
    income: number;
    daysOfStay: number | undefined;

    constructor(data?: IOpcsCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
            this.description = _data['description'];
            this.income = _data['income'];
            this.daysOfStay = _data['daysOfStay'];
        }
    }

    static fromJS(data: any): OpcsCode {
        data = typeof data === 'object' ? data : {};
        let result = new OpcsCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data['description'] = this.description;
        data['income'] = this.income;
        data['daysOfStay'] = this.daysOfStay;
        return data;
    }
}

export interface IOpcsCode {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    description: string | undefined;
    income: number;
    daysOfStay: number | undefined;
}

export class OpportunityStep implements IOpportunityStep {
    id: number;
    startWeekNumber: number;
    endWeekNumber: number;
    opportunityPercentage: number;
    improvementProgram: ImprovementProgram;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IOpportunityStep) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.startWeekNumber = _data['startWeekNumber'];
            this.endWeekNumber = _data['endWeekNumber'];
            this.opportunityPercentage = _data['opportunityPercentage'];
            this.improvementProgram = _data['improvementProgram'] ? ImprovementProgram.fromJS(_data['improvementProgram']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OpportunityStep {
        data = typeof data === 'object' ? data : {};
        let result = new OpportunityStep();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['startWeekNumber'] = this.startWeekNumber;
        data['endWeekNumber'] = this.endWeekNumber;
        data['opportunityPercentage'] = this.opportunityPercentage;
        data['improvementProgram'] = this.improvementProgram ? this.improvementProgram.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOpportunityStep {
    id: number;
    startWeekNumber: number;
    endWeekNumber: number;
    opportunityPercentage: number;
    improvementProgram: ImprovementProgram;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class OpportunityStepDto implements IOpportunityStepDto {
    weekNumber: number;
    opportunityPercentage: number;

    constructor(data?: IOpportunityStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekNumber = _data['weekNumber'];
            this.opportunityPercentage = _data['opportunityPercentage'];
        }
    }

    static fromJS(data: any): OpportunityStepDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpportunityStepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['weekNumber'] = this.weekNumber;
        data['opportunityPercentage'] = this.opportunityPercentage;
        return data;
    }
}

export interface IOpportunityStepDto {
    weekNumber: number;
    opportunityPercentage: number;
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number;

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
            this.lastModifierUserId = _data['lastModifierUserId'];
            this.parentId = _data['parentId'];
            this.code = _data['code'];
            this.displayName = _data['displayName'];
            this.memberCount = _data['memberCount'];
        }
    }

    static fromJS(data: any): OrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data['lastModifierUserId'] = this.lastModifierUserId;
        data['parentId'] = this.parentId;
        data['code'] = this.code;
        data['displayName'] = this.displayName;
        data['memberCount'] = this.memberCount;
        return data;
    }
}

export interface IOrganizationUnitDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number;
}

export class OrganizationUnitDtoListResultDto implements IOrganizationUnitDtoListResultDto {
    items: OrganizationUnitDto[] | undefined;

    constructor(data?: IOrganizationUnitDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(OrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationUnitDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrganizationUnitDtoListResultDto {
    items: OrganizationUnitDto[] | undefined;
}

export class OrganizationUnitUserListDto implements IOrganizationUnitUserListDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    addedTime: moment.Moment;

    constructor(data?: IOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.userName = _data['userName'];
            this.emailAddress = _data['emailAddress'];
            this.profilePictureId = _data['profilePictureId'];
            this.addedTime = _data['addedTime'] ? moment(_data['addedTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['userName'] = this.userName;
        data['emailAddress'] = this.emailAddress;
        data['profilePictureId'] = this.profilePictureId;
        data['addedTime'] = this.addedTime ? this.addedTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOrganizationUnitUserListDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    addedTime: moment.Moment;
}

export class OrganizationUnitUserListDtoPagedResultDto implements IOrganizationUnitUserListDtoPagedResultDto {
    items: OrganizationUnitUserListDto[] | undefined;
    totalCount: number;

    constructor(data?: IOrganizationUnitUserListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(OrganizationUnitUserListDto.fromJS(item));
            }
            this.totalCount = _data['totalCount'];
        }
    }

    static fromJS(data: any): OrganizationUnitUserListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitUserListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        data['totalCount'] = this.totalCount;
        return data;
    }
}

export interface IOrganizationUnitUserListDtoPagedResultDto {
    items: OrganizationUnitUserListDto[] | undefined;
    totalCount: number;
}

export enum ParameterAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _16 = 16,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
    _61440 = 61440
}

export class ParameterInfo implements IParameterInfo {
    attributes: ParameterAttributes;
    member: MemberInfo;
    readonly name: string | undefined;
    parameterType: Type;
    readonly position: number;
    readonly isIn: boolean;
    readonly isLcid: boolean;
    readonly isOptional: boolean;
    readonly isOut: boolean;
    readonly isRetval: boolean;
    readonly defaultValue: any | undefined;
    readonly rawDefaultValue: any | undefined;
    readonly hasDefaultValue: boolean;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly metadataToken: number;

    constructor(data?: IParameterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributes = _data['attributes'];
            this.member = _data['member'] ? MemberInfo.fromJS(_data['member']) : <any>undefined;
            (<any>this).name = _data['name'];
            this.parameterType = _data['parameterType'] ? Type.fromJS(_data['parameterType']) : <any>undefined;
            (<any>this).position = _data['position'];
            (<any>this).isIn = _data['isIn'];
            (<any>this).isLcid = _data['isLcid'];
            (<any>this).isOptional = _data['isOptional'];
            (<any>this).isOut = _data['isOut'];
            (<any>this).isRetval = _data['isRetval'];
            (<any>this).defaultValue = _data['defaultValue'];
            (<any>this).rawDefaultValue = _data['rawDefaultValue'];
            (<any>this).hasDefaultValue = _data['hasDefaultValue'];
            if (Array.isArray(_data['customAttributes'])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data['customAttributes']) (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).metadataToken = _data['metadataToken'];
        }
    }

    static fromJS(data: any): ParameterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['attributes'] = this.attributes;
        data['member'] = this.member ? this.member.toJSON() : <any>undefined;
        data['name'] = this.name;
        data['parameterType'] = this.parameterType ? this.parameterType.toJSON() : <any>undefined;
        data['position'] = this.position;
        data['isIn'] = this.isIn;
        data['isLcid'] = this.isLcid;
        data['isOptional'] = this.isOptional;
        data['isOut'] = this.isOut;
        data['isRetval'] = this.isRetval;
        data['defaultValue'] = this.defaultValue;
        data['rawDefaultValue'] = this.rawDefaultValue;
        data['hasDefaultValue'] = this.hasDefaultValue;
        if (Array.isArray(this.customAttributes)) {
            data['customAttributes'] = [];
            for (let item of this.customAttributes) data['customAttributes'].push(item.toJSON());
        }
        data['metadataToken'] = this.metadataToken;
        return data;
    }
}

export interface IParameterInfo {
    attributes: ParameterAttributes;
    member: MemberInfo;
    name: string | undefined;
    parameterType: Type;
    position: number;
    isIn: boolean;
    isLcid: boolean;
    isOptional: boolean;
    isOut: boolean;
    isRetval: boolean;
    defaultValue: any | undefined;
    rawDefaultValue: any | undefined;
    hasDefaultValue: boolean;
    customAttributes: CustomAttributeData[] | undefined;
    metadataToken: number;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
    requireDigit: boolean;
    requireLowercase: boolean;
    requireNonAlphanumeric: boolean;
    requireUppercase: boolean;
    requiredLength: number;

    constructor(data?: IPasswordComplexitySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requireDigit = _data['requireDigit'];
            this.requireLowercase = _data['requireLowercase'];
            this.requireNonAlphanumeric = _data['requireNonAlphanumeric'];
            this.requireUppercase = _data['requireUppercase'];
            this.requiredLength = _data['requiredLength'];
        }
    }

    static fromJS(data: any): PasswordComplexitySetting {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['requireDigit'] = this.requireDigit;
        data['requireLowercase'] = this.requireLowercase;
        data['requireNonAlphanumeric'] = this.requireNonAlphanumeric;
        data['requireUppercase'] = this.requireUppercase;
        data['requiredLength'] = this.requiredLength;
        return data;
    }
}

export interface IPasswordComplexitySetting {
    requireDigit: boolean;
    requireLowercase: boolean;
    requireNonAlphanumeric: boolean;
    requireUppercase: boolean;
    requiredLength: number;
}

export class Pathway implements IPathway {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    pathwayThresholds: PathwayThreshold[] | undefined;

    constructor(data?: IPathway) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
            if (Array.isArray(_data['pathwayThresholds'])) {
                this.pathwayThresholds = [] as any;
                for (let item of _data['pathwayThresholds']) this.pathwayThresholds.push(PathwayThreshold.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Pathway {
        data = typeof data === 'object' ? data : {};
        let result = new Pathway();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        if (Array.isArray(this.pathwayThresholds)) {
            data['pathwayThresholds'] = [];
            for (let item of this.pathwayThresholds) data['pathwayThresholds'].push(item.toJSON());
        }
        return data;
    }
}

export interface IPathway {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    pathwayThresholds: PathwayThreshold[] | undefined;
}

export class PathwayThreshold implements IPathwayThreshold {
    id: number;
    pathway: Pathway;
    pathwayId: number;
    timeSpan: number;
    priority: number;
    timeUnit: TimeUnitTypes;
    thresholdType: ThresholdTypes;

    constructor(data?: IPathwayThreshold) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.pathway = _data['pathway'] ? Pathway.fromJS(_data['pathway']) : <any>undefined;
            this.pathwayId = _data['pathwayId'];
            this.timeSpan = _data['timeSpan'];
            this.priority = _data['priority'];
            this.timeUnit = _data['timeUnit'];
            this.thresholdType = _data['thresholdType'];
        }
    }

    static fromJS(data: any): PathwayThreshold {
        data = typeof data === 'object' ? data : {};
        let result = new PathwayThreshold();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['pathway'] = this.pathway ? this.pathway.toJSON() : <any>undefined;
        data['pathwayId'] = this.pathwayId;
        data['timeSpan'] = this.timeSpan;
        data['priority'] = this.priority;
        data['timeUnit'] = this.timeUnit;
        data['thresholdType'] = this.thresholdType;
        return data;
    }
}

export interface IPathwayThreshold {
    id: number;
    pathway: Pathway;
    pathwayId: number;
    timeSpan: number;
    priority: number;
    timeUnit: TimeUnitTypes;
    thresholdType: ThresholdTypes;
}

export class Patient implements IPatient {
    id: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    age: number | undefined;
    hospitalNumber: string | undefined;
    hasMrsa: boolean | undefined;
    hasDiabetes: boolean | undefined;
    readonly isPaediatric: boolean;
    procedures: Procedure[] | undefined;
    allergies: PatientAllergy[] | undefined;
    metadataValues: MetadataValue[] | undefined;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IPatient) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.age = _data['age'];
            this.hospitalNumber = _data['hospitalNumber'];
            this.hasMrsa = _data['hasMrsa'];
            this.hasDiabetes = _data['hasDiabetes'];
            (<any>this).isPaediatric = _data['isPaediatric'];
            if (Array.isArray(_data['procedures'])) {
                this.procedures = [] as any;
                for (let item of _data['procedures']) this.procedures.push(Procedure.fromJS(item));
            }
            if (Array.isArray(_data['allergies'])) {
                this.allergies = [] as any;
                for (let item of _data['allergies']) this.allergies.push(PatientAllergy.fromJS(item));
            }
            if (Array.isArray(_data['metadataValues'])) {
                this.metadataValues = [] as any;
                for (let item of _data['metadataValues']) this.metadataValues.push(MetadataValue.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Patient {
        data = typeof data === 'object' ? data : {};
        let result = new Patient();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['age'] = this.age;
        data['hospitalNumber'] = this.hospitalNumber;
        data['hasMrsa'] = this.hasMrsa;
        data['hasDiabetes'] = this.hasDiabetes;
        data['isPaediatric'] = this.isPaediatric;
        if (Array.isArray(this.procedures)) {
            data['procedures'] = [];
            for (let item of this.procedures) data['procedures'].push(item.toJSON());
        }
        if (Array.isArray(this.allergies)) {
            data['allergies'] = [];
            for (let item of this.allergies) data['allergies'].push(item.toJSON());
        }
        if (Array.isArray(this.metadataValues)) {
            data['metadataValues'] = [];
            for (let item of this.metadataValues) data['metadataValues'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPatient {
    id: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    age: number | undefined;
    hospitalNumber: string | undefined;
    hasMrsa: boolean | undefined;
    hasDiabetes: boolean | undefined;
    isPaediatric: boolean;
    procedures: Procedure[] | undefined;
    allergies: PatientAllergy[] | undefined;
    metadataValues: MetadataValue[] | undefined;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class PatientAllergy implements IPatientAllergy {
    rank: number;
    patientId: string | undefined;
    allergyId: number;
    patient: Patient;
    allergy: Allergy;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IPatientAllergy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rank = _data['rank'];
            this.patientId = _data['patientId'];
            this.allergyId = _data['allergyId'];
            this.patient = _data['patient'] ? Patient.fromJS(_data['patient']) : <any>undefined;
            this.allergy = _data['allergy'] ? Allergy.fromJS(_data['allergy']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PatientAllergy {
        data = typeof data === 'object' ? data : {};
        let result = new PatientAllergy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['rank'] = this.rank;
        data['patientId'] = this.patientId;
        data['allergyId'] = this.allergyId;
        data['patient'] = this.patient ? this.patient.toJSON() : <any>undefined;
        data['allergy'] = this.allergy ? this.allergy.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IPatientAllergy {
    rank: number;
    patientId: string | undefined;
    allergyId: number;
    patient: Patient;
    allergy: Allergy;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class PatientDto implements IPatientDto {
    id: string | undefined;
    age: number | undefined;
    name: string | undefined;
    surname: string | undefined;
    hospitalNumber: string | undefined;
    hasMrsa: boolean | undefined;
    hasDiabetes: boolean | undefined;
    hasDependantAllergies: boolean | undefined;
    readonly isPaediatric: boolean;

    constructor(data?: IPatientDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.age = _data['age'];
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.hospitalNumber = _data['hospitalNumber'];
            this.hasMrsa = _data['hasMrsa'];
            this.hasDiabetes = _data['hasDiabetes'];
            this.hasDependantAllergies = _data['hasDependantAllergies'];
            (<any>this).isPaediatric = _data['isPaediatric'];
        }
    }

    static fromJS(data: any): PatientDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['age'] = this.age;
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['hospitalNumber'] = this.hospitalNumber;
        data['hasMrsa'] = this.hasMrsa;
        data['hasDiabetes'] = this.hasDiabetes;
        data['hasDependantAllergies'] = this.hasDependantAllergies;
        data['isPaediatric'] = this.isPaediatric;
        return data;
    }
}

export interface IPatientDto {
    id: string | undefined;
    age: number | undefined;
    name: string | undefined;
    surname: string | undefined;
    hospitalNumber: string | undefined;
    hasMrsa: boolean | undefined;
    hasDiabetes: boolean | undefined;
    hasDependantAllergies: boolean | undefined;
    isPaediatric: boolean;
}

export class PatientListDto implements IPatientListDto {
    sessionId: string | undefined;
    updatedProcedures: UpdateProcedureDto[] | undefined;

    constructor(data?: IPatientListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionId = _data['sessionId'];
            if (Array.isArray(_data['updatedProcedures'])) {
                this.updatedProcedures = [] as any;
                for (let item of _data['updatedProcedures']) this.updatedProcedures.push(UpdateProcedureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatientListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatientListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['sessionId'] = this.sessionId;
        if (Array.isArray(this.updatedProcedures)) {
            data['updatedProcedures'] = [];
            for (let item of this.updatedProcedures) data['updatedProcedures'].push(item.toJSON());
        }
        return data;
    }
}

export interface IPatientListDto {
    sessionId: string | undefined;
    updatedProcedures: UpdateProcedureDto[] | undefined;
}

export class PaymentInfoDto implements IPaymentInfoDto {
    edition: EditionSelectDto;
    additionalPrice: number;

    constructor(data?: IPaymentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data['edition'] ? EditionSelectDto.fromJS(_data['edition']) : <any>undefined;
            this.additionalPrice = _data['additionalPrice'];
        }
    }

    static fromJS(data: any): PaymentInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['edition'] = this.edition ? this.edition.toJSON() : <any>undefined;
        data['additionalPrice'] = this.additionalPrice;
        return data;
    }
}

export interface IPaymentInfoDto {
    edition: EditionSelectDto;
    additionalPrice: number;
}

export enum PaymentPeriodType {
    _30 = 30,
    _365 = 365
}

export class PeriodsOverviewDto implements IPeriodsOverviewDto {
    name: string | undefined;
    id: number;
    utilisations: UtilisationDto[] | undefined;

    constructor(data?: IPeriodsOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.id = _data['id'];
            if (Array.isArray(_data['utilisations'])) {
                this.utilisations = [] as any;
                for (let item of _data['utilisations']) this.utilisations.push(UtilisationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PeriodsOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodsOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['id'] = this.id;
        if (Array.isArray(this.utilisations)) {
            data['utilisations'] = [];
            for (let item of this.utilisations) data['utilisations'].push(item.toJSON());
        }
        return data;
    }
}

export interface IPeriodsOverviewDto {
    name: string | undefined;
    id: number;
    utilisations: UtilisationDto[] | undefined;
}

export class Procedure implements IProcedure {
    id: string | undefined;
    actualProcedureDescription: string | undefined;
    isEmergency: boolean | undefined;
    isCancelled: boolean | undefined;
    cancellationDescription: string | undefined;
    anestheticsDescription: string | undefined;
    isWli: boolean | undefined;
    order: number | undefined;
    comment: string | undefined;
    procedureTimesId: number | undefined;
    waitingListId: string | undefined;
    specialityId: number | undefined;
    sessionId: string | undefined;
    originalSessionId: string | undefined;
    isSmartScheduled: boolean;
    employees: ProcedurePersonelRole[] | undefined;
    opcsCodes: ProcedureOpcsCode[] | undefined;
    events: ProcedureEvent[] | undefined;
    speciality: Speciality;
    session: Session;
    originalSession: Session;
    patient: Patient;
    cancelationType: CancelationType;
    admission: Admission;
    anesthetic: Anesthetic;
    actualProcedureCode: OpcsCode;
    procedureTimes: ProcedureTimes;
    waitingList: WaitingList;
    recoveryBay: RecoveryBay;
    metadataValues: MetadataValue[] | undefined;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IProcedure) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.actualProcedureDescription = _data['actualProcedureDescription'];
            this.isEmergency = _data['isEmergency'];
            this.isCancelled = _data['isCancelled'];
            this.cancellationDescription = _data['cancellationDescription'];
            this.anestheticsDescription = _data['anestheticsDescription'];
            this.isWli = _data['isWli'];
            this.order = _data['order'];
            this.comment = _data['comment'];
            this.procedureTimesId = _data['procedureTimesId'];
            this.waitingListId = _data['waitingListId'];
            this.specialityId = _data['specialityId'];
            this.sessionId = _data['sessionId'];
            this.originalSessionId = _data['originalSessionId'];
            this.isSmartScheduled = _data['isSmartScheduled'];
            if (Array.isArray(_data['employees'])) {
                this.employees = [] as any;
                for (let item of _data['employees']) this.employees.push(ProcedurePersonelRole.fromJS(item));
            }
            if (Array.isArray(_data['opcsCodes'])) {
                this.opcsCodes = [] as any;
                for (let item of _data['opcsCodes']) this.opcsCodes.push(ProcedureOpcsCode.fromJS(item));
            }
            if (Array.isArray(_data['events'])) {
                this.events = [] as any;
                for (let item of _data['events']) this.events.push(ProcedureEvent.fromJS(item));
            }
            this.speciality = _data['speciality'] ? Speciality.fromJS(_data['speciality']) : <any>undefined;
            this.session = _data['session'] ? Session.fromJS(_data['session']) : <any>undefined;
            this.originalSession = _data['originalSession'] ? Session.fromJS(_data['originalSession']) : <any>undefined;
            this.patient = _data['patient'] ? Patient.fromJS(_data['patient']) : <any>undefined;
            this.cancelationType = _data['cancelationType'] ? CancelationType.fromJS(_data['cancelationType']) : <any>undefined;
            this.admission = _data['admission'] ? Admission.fromJS(_data['admission']) : <any>undefined;
            this.anesthetic = _data['anesthetic'] ? Anesthetic.fromJS(_data['anesthetic']) : <any>undefined;
            this.actualProcedureCode = _data['actualProcedureCode'] ? OpcsCode.fromJS(_data['actualProcedureCode']) : <any>undefined;
            this.procedureTimes = _data['procedureTimes'] ? ProcedureTimes.fromJS(_data['procedureTimes']) : <any>undefined;
            this.waitingList = _data['waitingList'] ? WaitingList.fromJS(_data['waitingList']) : <any>undefined;
            this.recoveryBay = _data['recoveryBay'] ? RecoveryBay.fromJS(_data['recoveryBay']) : <any>undefined;
            if (Array.isArray(_data['metadataValues'])) {
                this.metadataValues = [] as any;
                for (let item of _data['metadataValues']) this.metadataValues.push(MetadataValue.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Procedure {
        data = typeof data === 'object' ? data : {};
        let result = new Procedure();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['actualProcedureDescription'] = this.actualProcedureDescription;
        data['isEmergency'] = this.isEmergency;
        data['isCancelled'] = this.isCancelled;
        data['cancellationDescription'] = this.cancellationDescription;
        data['anestheticsDescription'] = this.anestheticsDescription;
        data['isWli'] = this.isWli;
        data['order'] = this.order;
        data['comment'] = this.comment;
        data['procedureTimesId'] = this.procedureTimesId;
        data['waitingListId'] = this.waitingListId;
        data['specialityId'] = this.specialityId;
        data['sessionId'] = this.sessionId;
        data['originalSessionId'] = this.originalSessionId;
        data['isSmartScheduled'] = this.isSmartScheduled;
        if (Array.isArray(this.employees)) {
            data['employees'] = [];
            for (let item of this.employees) data['employees'].push(item.toJSON());
        }
        if (Array.isArray(this.opcsCodes)) {
            data['opcsCodes'] = [];
            for (let item of this.opcsCodes) data['opcsCodes'].push(item.toJSON());
        }
        if (Array.isArray(this.events)) {
            data['events'] = [];
            for (let item of this.events) data['events'].push(item.toJSON());
        }
        data['speciality'] = this.speciality ? this.speciality.toJSON() : <any>undefined;
        data['session'] = this.session ? this.session.toJSON() : <any>undefined;
        data['originalSession'] = this.originalSession ? this.originalSession.toJSON() : <any>undefined;
        data['patient'] = this.patient ? this.patient.toJSON() : <any>undefined;
        data['cancelationType'] = this.cancelationType ? this.cancelationType.toJSON() : <any>undefined;
        data['admission'] = this.admission ? this.admission.toJSON() : <any>undefined;
        data['anesthetic'] = this.anesthetic ? this.anesthetic.toJSON() : <any>undefined;
        data['actualProcedureCode'] = this.actualProcedureCode ? this.actualProcedureCode.toJSON() : <any>undefined;
        data['procedureTimes'] = this.procedureTimes ? this.procedureTimes.toJSON() : <any>undefined;
        data['waitingList'] = this.waitingList ? this.waitingList.toJSON() : <any>undefined;
        data['recoveryBay'] = this.recoveryBay ? this.recoveryBay.toJSON() : <any>undefined;
        if (Array.isArray(this.metadataValues)) {
            data['metadataValues'] = [];
            for (let item of this.metadataValues) data['metadataValues'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProcedure {
    id: string | undefined;
    actualProcedureDescription: string | undefined;
    isEmergency: boolean | undefined;
    isCancelled: boolean | undefined;
    cancellationDescription: string | undefined;
    anestheticsDescription: string | undefined;
    isWli: boolean | undefined;
    order: number | undefined;
    comment: string | undefined;
    procedureTimesId: number | undefined;
    waitingListId: string | undefined;
    specialityId: number | undefined;
    sessionId: string | undefined;
    originalSessionId: string | undefined;
    isSmartScheduled: boolean;
    employees: ProcedurePersonelRole[] | undefined;
    opcsCodes: ProcedureOpcsCode[] | undefined;
    events: ProcedureEvent[] | undefined;
    speciality: Speciality;
    session: Session;
    originalSession: Session;
    patient: Patient;
    cancelationType: CancelationType;
    admission: Admission;
    anesthetic: Anesthetic;
    actualProcedureCode: OpcsCode;
    procedureTimes: ProcedureTimes;
    waitingList: WaitingList;
    recoveryBay: RecoveryBay;
    metadataValues: MetadataValue[] | undefined;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class ProcedureDto implements IProcedureDto {
    id: string | undefined;
    actualProcedureCode: OpcsCode;
    actualProcedureDescription: string | undefined;
    isCancelled: boolean;
    intendedProcedureCode: OpcsCode;
    speciality: Speciality;
    patient: PatientDto;
    workflowStatus: WorkflowStatus;
    pathway: Pathway;
    cancelationType: CancelationType;
    admission: string | undefined;
    anesthetic: Anesthetic;
    procedureTimes: ProcedureTimes;
    opcsCodes: ProcedureOpcsCode[] | undefined;
    order: number | undefined;
    sessionId: string | undefined;
    originalSessionId: string | undefined;
    waitingList: WaitingListDto;
    isSmartScheduled: boolean;
    calculatedOpcsCode: OpcsCode;
    readonly estimatedIncome: number;
    metadataValues: { [key: string]: MetadataValueDto } | undefined;
    missingIntendedProcedureCodeReason: string | undefined;
    comment: string | undefined;
    urgency: any;

    constructor(data?: IProcedureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.actualProcedureCode = _data['actualProcedureCode'] ? OpcsCode.fromJS(_data['actualProcedureCode']) : <any>undefined;
            this.actualProcedureDescription = _data['actualProcedureDescription'];
            this.isCancelled = _data['isCancelled'];
            this.urgency = _data['urgency'];
            this.intendedProcedureCode = _data['intendedProcedureCode'] ? OpcsCode.fromJS(_data['intendedProcedureCode']) : <any>undefined;
            this.speciality = _data['speciality'] ? Speciality.fromJS(_data['speciality']) : <any>undefined;
            this.patient = _data['patient'] ? PatientDto.fromJS(_data['patient']) : <any>undefined;
            this.workflowStatus = _data['workflowStatus'] ? WorkflowStatus.fromJS(_data['workflowStatus']) : <any>undefined;
            this.pathway = _data['pathway'] ? Pathway.fromJS(_data['pathway']) : <any>undefined;
            this.cancelationType = _data['cancelationType'] ? CancelationType.fromJS(_data['cancelationType']) : <any>undefined;
            this.admission = _data['admission'];
            this.anesthetic = _data['anesthetic'] ? Anesthetic.fromJS(_data['anesthetic']) : <any>undefined;
            this.procedureTimes = _data['procedureTimes'] ? ProcedureTimes.fromJS(_data['procedureTimes']) : <any>undefined;
            if (Array.isArray(_data['opcsCodes'])) {
                this.opcsCodes = [] as any;
                for (let item of _data['opcsCodes']) this.opcsCodes.push(ProcedureOpcsCode.fromJS(item));
            }
            this.order = _data['order'];
            this.sessionId = _data['sessionId'];
            this.originalSessionId = _data['originalSessionId'];
            this.waitingList = _data['waitingList'] ? WaitingListDto.fromJS(_data['waitingList']) : <any>undefined;
            this.isSmartScheduled = _data['isSmartScheduled'];
            this.calculatedOpcsCode = _data['calculatedOpcsCode'] ? OpcsCode.fromJS(_data['calculatedOpcsCode']) : <any>undefined;
            (<any>this).estimatedIncome = _data['estimatedIncome'];
            if (_data['metadataValues']) {
                this.metadataValues = {} as any;
                for (let key in _data['metadataValues']) {
                    if (_data['metadataValues'].hasOwnProperty(key))
                        (<any>this.metadataValues)[key] = _data['metadataValues'][key]
                            ? MetadataValueDto.fromJS(_data['metadataValues'][key])
                            : new MetadataValueDto();
                }
            }
            this.missingIntendedProcedureCodeReason = _data['missingIntendedProcedureCodeReason'];
            this.comment = _data['comment'];
        }
    }

    static fromJS(data: any): ProcedureDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['actualProcedureCode'] = this.actualProcedureCode ? this.actualProcedureCode.toJSON() : <any>undefined;
        data['actualProcedureDescription'] = this.actualProcedureDescription;
        data['isCancelled'] = this.isCancelled;
        data['intendedProcedureCode'] = this.intendedProcedureCode ? this.intendedProcedureCode.toJSON() : <any>undefined;
        data['speciality'] = this.speciality ? this.speciality.toJSON() : <any>undefined;
        data['patient'] = this.patient ? this.patient.toJSON() : <any>undefined;
        data['workflowStatus'] = this.workflowStatus ? this.workflowStatus.toJSON() : <any>undefined;
        data['pathway'] = this.pathway ? this.pathway.toJSON() : <any>undefined;
        data['cancelationType'] = this.cancelationType ? this.cancelationType.toJSON() : <any>undefined;
        data['admission'] = this.admission;
        data['anesthetic'] = this.anesthetic ? this.anesthetic.toJSON() : <any>undefined;
        data['procedureTimes'] = this.procedureTimes ? this.procedureTimes.toJSON() : <any>undefined;
        if (Array.isArray(this.opcsCodes)) {
            data['opcsCodes'] = [];
            for (let item of this.opcsCodes) data['opcsCodes'].push(item.toJSON());
        }
        data['order'] = this.order;
        data['sessionId'] = this.sessionId;
        data['originalSessionId'] = this.originalSessionId;
        data['waitingList'] = this.waitingList ? this.waitingList.toJSON() : <any>undefined;
        data['isSmartScheduled'] = this.isSmartScheduled;
        data['calculatedOpcsCode'] = this.calculatedOpcsCode ? this.calculatedOpcsCode.toJSON() : <any>undefined;
        data['estimatedIncome'] = this.estimatedIncome;
        if (this.metadataValues) {
            data['metadataValues'] = {};
            for (let key in this.metadataValues) {
                if (this.metadataValues.hasOwnProperty(key))
                    (<any>data['metadataValues'])[key] = this.metadataValues[key] ? this.metadataValues[key].toJSON() : <any>undefined;
            }
        }
        data['missingIntendedProcedureCodeReason'] = this.missingIntendedProcedureCodeReason;
        data['comment'] = this.comment;
        return data;
    }
}

export interface IProcedureDto {
    id: string | undefined;
    actualProcedureCode: OpcsCode;
    actualProcedureDescription: string | undefined;
    isCancelled: boolean;
    intendedProcedureCode: OpcsCode;
    speciality: Speciality;
    patient: PatientDto;
    workflowStatus: WorkflowStatus;
    pathway: Pathway;
    cancelationType: CancelationType;
    admission: string | undefined;
    anesthetic: Anesthetic;
    procedureTimes: ProcedureTimes;
    opcsCodes: ProcedureOpcsCode[] | undefined;
    order: number | undefined;
    sessionId: string | undefined;
    originalSessionId: string | undefined;
    waitingList: WaitingListDto;
    isSmartScheduled: boolean;
    calculatedOpcsCode: OpcsCode;
    estimatedIncome: number;
    metadataValues: { [key: string]: MetadataValueDto } | undefined;
    missingIntendedProcedureCodeReason: string | undefined;
    comment: string | undefined;
}

export class ProcedureEvent implements IProcedureEvent {
    occurrence: moment.Moment;
    procedureId: string | undefined;
    typeId: number;
    procedure: Procedure;
    type: EventType;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IProcedureEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.occurrence = _data['occurrence'] ? moment(_data['occurrence'].toString()) : <any>undefined;
            this.procedureId = _data['procedureId'];
            this.typeId = _data['typeId'];
            this.procedure = _data['procedure'] ? Procedure.fromJS(_data['procedure']) : <any>undefined;
            this.type = _data['type'] ? EventType.fromJS(_data['type']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProcedureEvent {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['occurrence'] = this.occurrence ? this.occurrence.toISOString() : <any>undefined;
        data['procedureId'] = this.procedureId;
        data['typeId'] = this.typeId;
        data['procedure'] = this.procedure ? this.procedure.toJSON() : <any>undefined;
        data['type'] = this.type ? this.type.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProcedureEvent {
    occurrence: moment.Moment;
    procedureId: string | undefined;
    typeId: number;
    procedure: Procedure;
    type: EventType;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class ProcedureOpcsCode implements IProcedureOpcsCode {
    rank: number;
    procedureId: string | undefined;
    opcsCodeId: number;
    procedure: Procedure;
    opcsCode: OpcsCode;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IProcedureOpcsCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rank = _data['rank'];
            this.procedureId = _data['procedureId'];
            this.opcsCodeId = _data['opcsCodeId'];
            this.procedure = _data['procedure'] ? Procedure.fromJS(_data['procedure']) : <any>undefined;
            this.opcsCode = _data['opcsCode'] ? OpcsCode.fromJS(_data['opcsCode']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProcedureOpcsCode {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureOpcsCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['rank'] = this.rank;
        data['procedureId'] = this.procedureId;
        data['opcsCodeId'] = this.opcsCodeId;
        data['procedure'] = this.procedure ? this.procedure.toJSON() : <any>undefined;
        data['opcsCode'] = this.opcsCode ? this.opcsCode.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProcedureOpcsCode {
    rank: number;
    procedureId: string | undefined;
    opcsCodeId: number;
    procedure: Procedure;
    opcsCode: OpcsCode;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class ProcedurePersonelRole implements IProcedurePersonelRole {
    procedureId: string | undefined;
    employeeId: number;
    roleId: EmployeeRoleTypes;
    procedure: Procedure;
    employee: Employee;
    role: EmployeeRole;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IProcedurePersonelRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.procedureId = _data['procedureId'];
            this.employeeId = _data['employeeId'];
            this.roleId = _data['roleId'];
            this.procedure = _data['procedure'] ? Procedure.fromJS(_data['procedure']) : <any>undefined;
            this.employee = _data['employee'] ? Employee.fromJS(_data['employee']) : <any>undefined;
            this.role = _data['role'] ? EmployeeRole.fromJS(_data['role']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProcedurePersonelRole {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedurePersonelRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['procedureId'] = this.procedureId;
        data['employeeId'] = this.employeeId;
        data['roleId'] = this.roleId;
        data['procedure'] = this.procedure ? this.procedure.toJSON() : <any>undefined;
        data['employee'] = this.employee ? this.employee.toJSON() : <any>undefined;
        data['role'] = this.role ? this.role.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProcedurePersonelRole {
    procedureId: string | undefined;
    employeeId: number;
    roleId: EmployeeRoleTypes;
    procedure: Procedure;
    employee: Employee;
    role: EmployeeRole;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class ProcedureTimes implements IProcedureTimes {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    procedureId: string | undefined;
    suggestedTime: number;
    estimatedTime: number | undefined;
    actualTime: number | undefined;
    suggestedTimeCalculationType: SuggestedTimeCalculationType;

    constructor(data?: IProcedureTimes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
            this.lastModifierUserId = _data['lastModifierUserId'];
            this.procedureId = _data['procedureId'];
            this.suggestedTime = _data['suggestedTime'];
            this.estimatedTime = _data['estimatedTime'];
            this.actualTime = _data['actualTime'];
            this.suggestedTimeCalculationType = _data['suggestedTimeCalculationType'];
        }
    }

    static fromJS(data: any): ProcedureTimes {
        data = typeof data === 'object' ? data : {};
        let result = new ProcedureTimes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data['lastModifierUserId'] = this.lastModifierUserId;
        data['procedureId'] = this.procedureId;
        data['suggestedTime'] = this.suggestedTime;
        data['estimatedTime'] = this.estimatedTime;
        data['actualTime'] = this.actualTime;
        data['suggestedTimeCalculationType'] = this.suggestedTimeCalculationType;
        return data;
    }
}

export interface IProcedureTimes {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    procedureId: string | undefined;
    suggestedTime: number;
    estimatedTime: number | undefined;
    actualTime: number | undefined;
    suggestedTimeCalculationType: SuggestedTimeCalculationType;
}

export enum PropertyAttributes {
    _0 = 0,
    _512 = 512,
    _1024 = 1024,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _32768 = 32768,
    _62464 = 62464
}

export class PropertyInfo implements IPropertyInfo {
    readonly name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly isCollectible: boolean;
    readonly metadataToken: number;
    memberType: MemberTypes;
    propertyType: Type;
    attributes: PropertyAttributes;
    readonly isSpecialName: boolean;
    readonly canRead: boolean;
    readonly canWrite: boolean;
    getMethod: MethodInfo;
    setMethod: MethodInfo;

    constructor(data?: IPropertyInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data['name'];
            this.declaringType = _data['declaringType'] ? Type.fromJS(_data['declaringType']) : <any>undefined;
            this.reflectedType = _data['reflectedType'] ? Type.fromJS(_data['reflectedType']) : <any>undefined;
            this.module = _data['module'] ? Module.fromJS(_data['module']) : <any>undefined;
            if (Array.isArray(_data['customAttributes'])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data['customAttributes']) (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data['isCollectible'];
            (<any>this).metadataToken = _data['metadataToken'];
            this.memberType = _data['memberType'];
            this.propertyType = _data['propertyType'] ? Type.fromJS(_data['propertyType']) : <any>undefined;
            this.attributes = _data['attributes'];
            (<any>this).isSpecialName = _data['isSpecialName'];
            (<any>this).canRead = _data['canRead'];
            (<any>this).canWrite = _data['canWrite'];
            this.getMethod = _data['getMethod'] ? MethodInfo.fromJS(_data['getMethod']) : <any>undefined;
            this.setMethod = _data['setMethod'] ? MethodInfo.fromJS(_data['setMethod']) : <any>undefined;
        }
    }

    static fromJS(data: any): PropertyInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['declaringType'] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data['reflectedType'] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data['module'] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data['customAttributes'] = [];
            for (let item of this.customAttributes) data['customAttributes'].push(item.toJSON());
        }
        data['isCollectible'] = this.isCollectible;
        data['metadataToken'] = this.metadataToken;
        data['memberType'] = this.memberType;
        data['propertyType'] = this.propertyType ? this.propertyType.toJSON() : <any>undefined;
        data['attributes'] = this.attributes;
        data['isSpecialName'] = this.isSpecialName;
        data['canRead'] = this.canRead;
        data['canWrite'] = this.canWrite;
        data['getMethod'] = this.getMethod ? this.getMethod.toJSON() : <any>undefined;
        data['setMethod'] = this.setMethod ? this.setMethod.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPropertyInfo {
    name: string | undefined;
    declaringType: Type;
    reflectedType: Type;
    module: Module;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    memberType: MemberTypes;
    propertyType: Type;
    attributes: PropertyAttributes;
    isSpecialName: boolean;
    canRead: boolean;
    canWrite: boolean;
    getMethod: MethodInfo;
    setMethod: MethodInfo;
}

export class QualityReportItem implements IQualityReportItem {
    visitDate: moment.Moment | undefined;
    specialty: string | undefined;
    consultant: string | undefined;
    theatreCode: string | undefined;
    isEmergency: boolean;
    startTime: moment.Moment | undefined;
    patientName: string | undefined;
    patientSurname: string | undefined;
    hospitalNumber: string | undefined;
    waitingListStatus: string | undefined;
    codeStatus: string | undefined;
    suggestedTIme: number;
    timePrediction: string | undefined;
    waitingListId: string | undefined;
    procedureId: string | undefined;

    constructor(data?: IQualityReportItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.visitDate = _data['visitDate'] ? moment(_data['visitDate'].toString()) : <any>undefined;
            this.specialty = _data['specialty'];
            this.consultant = _data['consultant'];
            this.theatreCode = _data['theatreCode'];
            this.isEmergency = _data['isEmergency'];
            this.startTime = _data['startTime'] ? moment(_data['startTime'].toString()) : <any>undefined;
            this.patientName = _data['patientName'];
            this.patientSurname = _data['patientSurname'];
            this.hospitalNumber = _data['hospitalNumber'];
            this.waitingListStatus = _data['waitingListStatus'];
            this.codeStatus = _data['codeStatus'];
            this.suggestedTIme = _data['suggestedTIme'];
            this.timePrediction = _data['timePrediction'];
            this.waitingListId = _data['waitingListId'];
            this.procedureId = _data['procedureId'];
        }
    }

    static fromJS(data: any): QualityReportItem {
        data = typeof data === 'object' ? data : {};
        let result = new QualityReportItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['visitDate'] = this.visitDate ? this.visitDate.toISOString() : <any>undefined;
        data['specialty'] = this.specialty;
        data['consultant'] = this.consultant;
        data['theatreCode'] = this.theatreCode;
        data['isEmergency'] = this.isEmergency;
        data['startTime'] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data['patientName'] = this.patientName;
        data['patientSurname'] = this.patientSurname;
        data['hospitalNumber'] = this.hospitalNumber;
        data['waitingListStatus'] = this.waitingListStatus;
        data['codeStatus'] = this.codeStatus;
        data['suggestedTIme'] = this.suggestedTIme;
        data['timePrediction'] = this.timePrediction;
        data['waitingListId'] = this.waitingListId;
        data['procedureId'] = this.procedureId;
        return data;
    }
}

export interface IQualityReportItem {
    visitDate: moment.Moment | undefined;
    specialty: string | undefined;
    consultant: string | undefined;
    theatreCode: string | undefined;
    isEmergency: boolean;
    startTime: moment.Moment | undefined;
    patientName: string | undefined;
    patientSurname: string | undefined;
    hospitalNumber: string | undefined;
    waitingListStatus: string | undefined;
    codeStatus: string | undefined;
    suggestedTIme: number;
    timePrediction: string | undefined;
    waitingListId: string | undefined;
    procedureId: string | undefined;
}

export class RecoveryBay implements IRecoveryBay {
    id: number;
    name: string | undefined;
    capacity: number;
    type: RecoveryBayTypes;
    site: Site;
    theatres: Theatre[] | undefined;
    recoveringCases: Procedure[] | undefined;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IRecoveryBay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.capacity = _data['capacity'];
            this.type = _data['type'];
            this.site = _data['site'] ? Site.fromJS(_data['site']) : <any>undefined;
            if (Array.isArray(_data['theatres'])) {
                this.theatres = [] as any;
                for (let item of _data['theatres']) this.theatres.push(Theatre.fromJS(item));
            }
            if (Array.isArray(_data['recoveringCases'])) {
                this.recoveringCases = [] as any;
                for (let item of _data['recoveringCases']) this.recoveringCases.push(Procedure.fromJS(item));
            }
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecoveryBay {
        data = typeof data === 'object' ? data : {};
        let result = new RecoveryBay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['capacity'] = this.capacity;
        data['type'] = this.type;
        data['site'] = this.site ? this.site.toJSON() : <any>undefined;
        if (Array.isArray(this.theatres)) {
            data['theatres'] = [];
            for (let item of this.theatres) data['theatres'].push(item.toJSON());
        }
        if (Array.isArray(this.recoveringCases)) {
            data['recoveringCases'] = [];
            for (let item of this.recoveringCases) data['recoveringCases'].push(item.toJSON());
        }
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRecoveryBay {
    id: number;
    name: string | undefined;
    capacity: number;
    type: RecoveryBayTypes;
    site: Site;
    theatres: Theatre[] | undefined;
    recoveringCases: Procedure[] | undefined;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export enum RecoveryBayTypes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _8 = 8,
    _255 = 255
}

export class RegisterInput implements IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.userName = _data['userName'];
            this.emailAddress = _data['emailAddress'];
            this.password = _data['password'];
            this.captchaResponse = _data['captchaResponse'];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['userName'] = this.userName;
        data['emailAddress'] = this.emailAddress;
        data['password'] = this.password;
        data['captchaResponse'] = this.captchaResponse;
        return data;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data['canLogin'];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['canLogin'] = this.canLogin;
        return data;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class RegisterTenantInput implements IRegisterTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    captchaResponse: string | undefined;
    subscriptionStartType: SubscriptionStartType;
    gateway: SubscriptionPaymentGatewayType;
    editionId: number | undefined;
    paymentId: string | undefined;

    constructor(data?: IRegisterTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data['tenancyName'];
            this.name = _data['name'];
            this.adminEmailAddress = _data['adminEmailAddress'];
            this.adminPassword = _data['adminPassword'];
            this.captchaResponse = _data['captchaResponse'];
            this.subscriptionStartType = _data['subscriptionStartType'];
            this.gateway = _data['gateway'];
            this.editionId = _data['editionId'];
            this.paymentId = _data['paymentId'];
        }
    }

    static fromJS(data: any): RegisterTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenancyName'] = this.tenancyName;
        data['name'] = this.name;
        data['adminEmailAddress'] = this.adminEmailAddress;
        data['adminPassword'] = this.adminPassword;
        data['captchaResponse'] = this.captchaResponse;
        data['subscriptionStartType'] = this.subscriptionStartType;
        data['gateway'] = this.gateway;
        data['editionId'] = this.editionId;
        data['paymentId'] = this.paymentId;
        return data;
    }
}

export interface IRegisterTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    captchaResponse: string | undefined;
    subscriptionStartType: SubscriptionStartType;
    gateway: SubscriptionPaymentGatewayType;
    editionId: number | undefined;
    paymentId: string | undefined;
}

export class RegisterTenantOutput implements IRegisterTenantOutput {
    tenantId: number;
    tenancyName: string | undefined;
    name: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    isTenantActive: boolean;
    isActive: boolean;
    isEmailConfirmationRequired: boolean;

    constructor(data?: IRegisterTenantOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.tenancyName = _data['tenancyName'];
            this.name = _data['name'];
            this.userName = _data['userName'];
            this.emailAddress = _data['emailAddress'];
            this.isTenantActive = _data['isTenantActive'];
            this.isActive = _data['isActive'];
            this.isEmailConfirmationRequired = _data['isEmailConfirmationRequired'];
        }
    }

    static fromJS(data: any): RegisterTenantOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['tenancyName'] = this.tenancyName;
        data['name'] = this.name;
        data['userName'] = this.userName;
        data['emailAddress'] = this.emailAddress;
        data['isTenantActive'] = this.isTenantActive;
        data['isActive'] = this.isActive;
        data['isEmailConfirmationRequired'] = this.isEmailConfirmationRequired;
        return data;
    }
}

export interface IRegisterTenantOutput {
    tenantId: number;
    tenancyName: string | undefined;
    name: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    isTenantActive: boolean;
    isActive: boolean;
    isEmailConfirmationRequired: boolean;
}

export class ReportEmbedConfig implements IReportEmbedConfig {
    readonly errorMessage: string | undefined;
    readonly isEffectiveIdentityRequired: boolean | undefined;
    readonly isEffectiveIdentityRolesRequired: boolean | undefined;
    embedToken: EmbedToken;
    readonly embedUrl: string | undefined;
    readonly id: string | undefined;

    constructor(data?: IReportEmbedConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).errorMessage = _data['errorMessage'];
            (<any>this).isEffectiveIdentityRequired = _data['isEffectiveIdentityRequired'];
            (<any>this).isEffectiveIdentityRolesRequired = _data['isEffectiveIdentityRolesRequired'];
            this.embedToken = _data['embedToken'] ? EmbedToken.fromJS(_data['embedToken']) : <any>undefined;
            (<any>this).embedUrl = _data['embedUrl'];
            (<any>this).id = _data['id'];
        }
    }

    static fromJS(data: any): ReportEmbedConfig {
        data = typeof data === 'object' ? data : {};
        let result = new ReportEmbedConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['errorMessage'] = this.errorMessage;
        data['isEffectiveIdentityRequired'] = this.isEffectiveIdentityRequired;
        data['isEffectiveIdentityRolesRequired'] = this.isEffectiveIdentityRolesRequired;
        data['embedToken'] = this.embedToken ? this.embedToken.toJSON() : <any>undefined;
        data['embedUrl'] = this.embedUrl;
        data['id'] = this.id;
        return data;
    }
}

export interface IReportEmbedConfig {
    errorMessage: string | undefined;
    isEffectiveIdentityRequired: boolean | undefined;
    isEffectiveIdentityRolesRequired: boolean | undefined;
    embedToken: EmbedToken;
    embedUrl: string | undefined;
    id: string | undefined;
}

export class ResetPasswordInput implements IResetPasswordInput {
    userId: number;
    resetCode: string;
    password: string;
    returnUrl: string | undefined;
    singleSignIn: string | undefined;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data['userId'];
            this.resetCode = _data['resetCode'];
            this.password = _data['password'];
            this.returnUrl = _data['returnUrl'];
            this.singleSignIn = _data['singleSignIn'];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userId'] = this.userId;
        data['resetCode'] = this.resetCode;
        data['password'] = this.password;
        data['returnUrl'] = this.returnUrl;
        data['singleSignIn'] = this.singleSignIn;
        return data;
    }
}

export interface IResetPasswordInput {
    userId: number;
    resetCode: string;
    password: string;
    returnUrl: string | undefined;
    singleSignIn: string | undefined;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
    canLogin: boolean;
    userName: string | undefined;

    constructor(data?: IResetPasswordOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data['canLogin'];
            this.userName = _data['userName'];
        }
    }

    static fromJS(data: any): ResetPasswordOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['canLogin'] = this.canLogin;
        data['userName'] = this.userName;
        return data;
    }
}

export interface IResetPasswordOutput {
    canLogin: boolean;
    userName: string | undefined;
}

export class RoleEditDto implements IRoleEditDto {
    id: number | undefined;
    displayName: string;
    isDefault: boolean;
    limitedSpecialtyAccess: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.displayName = _data['displayName'];
            this.isDefault = _data['isDefault'];
            this.limitedSpecialtyAccess = _data['limitedSpecialtyAccess'];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['displayName'] = this.displayName;
        data['isDefault'] = this.isDefault;
        data['limitedSpecialtyAccess'] = this.limitedSpecialtyAccess;
        return data;
    }
}

export interface IRoleEditDto {
    id: number | undefined;
    displayName: string;
    isDefault: boolean;
    limitedSpecialtyAccess: boolean;
}

export class RoleListDto implements IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    limitedSpecialtyAccess: boolean;
    creationTime: moment.Moment;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.displayName = _data['displayName'];
            this.isStatic = _data['isStatic'];
            this.isDefault = _data['isDefault'];
            this.limitedSpecialtyAccess = _data['limitedSpecialtyAccess'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['displayName'] = this.displayName;
        data['isStatic'] = this.isStatic;
        data['isDefault'] = this.isDefault;
        data['limitedSpecialtyAccess'] = this.limitedSpecialtyAccess;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    limitedSpecialtyAccess: boolean;
    creationTime: moment.Moment;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class RuntimeFieldHandle implements IRuntimeFieldHandle {
    value: IntPtr;

    constructor(data?: IRuntimeFieldHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data['value'] ? IntPtr.fromJS(_data['value']) : <any>undefined;
        }
    }

    static fromJS(data: any): RuntimeFieldHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeFieldHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['value'] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRuntimeFieldHandle {
    value: IntPtr;
}

export class RuntimeMethodHandle implements IRuntimeMethodHandle {
    value: IntPtr;

    constructor(data?: IRuntimeMethodHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data['value'] ? IntPtr.fromJS(_data['value']) : <any>undefined;
        }
    }

    static fromJS(data: any): RuntimeMethodHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeMethodHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['value'] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRuntimeMethodHandle {
    value: IntPtr;
}

export class RuntimeTypeHandle implements IRuntimeTypeHandle {
    value: IntPtr;

    constructor(data?: IRuntimeTypeHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data['value'] ? IntPtr.fromJS(_data['value']) : <any>undefined;
        }
    }

    static fromJS(data: any): RuntimeTypeHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeTypeHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['value'] = this.value ? this.value.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRuntimeTypeHandle {
    value: IntPtr;
}

export class ScheduleFiltersDto implements IScheduleFiltersDto {
    siteIds: number[] | undefined;
    specialityIds: number[] | undefined;
    consultantIds: number[] | undefined;
    exclude: ExcludedWaitingListsDto[] | undefined;
    dateRangeStart: moment.Moment;
    dateRangeEnd: moment.Moment;
    scheduleOptions: ScheduleOptionsDto;

    constructor(data?: IScheduleFiltersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['siteIds'])) {
                this.siteIds = [] as any;
                for (let item of _data['siteIds']) this.siteIds.push(item);
            }
            if (Array.isArray(_data['specialityIds'])) {
                this.specialityIds = [] as any;
                for (let item of _data['specialityIds']) this.specialityIds.push(item);
            }
            if (Array.isArray(_data['consultantIds'])) {
                this.consultantIds = [] as any;
                for (let item of _data['consultantIds']) this.consultantIds.push(item);
            }
            if (Array.isArray(_data['exclude'])) {
                this.exclude = [] as any;
                for (let item of _data['exclude']) this.exclude.push(ExcludedWaitingListsDto.fromJS(item));
            }
            this.dateRangeStart = _data['dateRangeStart'] ? moment(_data['dateRangeStart'].toString()) : <any>undefined;
            this.dateRangeEnd = _data['dateRangeEnd'] ? moment(_data['dateRangeEnd'].toString()) : <any>undefined;
            this.scheduleOptions = _data['scheduleOptions'] ? ScheduleOptionsDto.fromJS(_data['scheduleOptions']) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduleFiltersDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleFiltersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.siteIds)) {
            data['siteIds'] = [];
            for (let item of this.siteIds) data['siteIds'].push(item);
        }
        if (Array.isArray(this.specialityIds)) {
            data['specialityIds'] = [];
            for (let item of this.specialityIds) data['specialityIds'].push(item);
        }
        if (Array.isArray(this.consultantIds)) {
            data['consultantIds'] = [];
            for (let item of this.consultantIds) data['consultantIds'].push(item);
        }
        if (Array.isArray(this.exclude)) {
            data['exclude'] = [];
            for (let item of this.exclude) data['exclude'].push(item.toJSON());
        }
        data['dateRangeStart'] = this.dateRangeStart ? this.dateRangeStart.toISOString() : <any>undefined;
        data['dateRangeEnd'] = this.dateRangeEnd ? this.dateRangeEnd.toISOString() : <any>undefined;
        data['scheduleOptions'] = this.scheduleOptions ? this.scheduleOptions.toJSON() : <any>undefined;
        return data;
    }
}

export interface IScheduleFiltersDto {
    siteIds: number[] | undefined;
    specialityIds: number[] | undefined;
    consultantIds: number[] | undefined;
    exclude: ExcludedWaitingListsDto[] | undefined;
    dateRangeStart: moment.Moment;
    dateRangeEnd: moment.Moment;
    scheduleOptions: ScheduleOptionsDto;
}

export class ScheduleOptionsDto implements IScheduleOptionsDto {
    putPaediatricsFirst: boolean;
    putMrsaLast: boolean;
    putDaycaseSeparately: boolean;
    putInpatientSeparately: boolean;
    putPaediatricSeparately: boolean;

    constructor(data?: IScheduleOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.putPaediatricsFirst = _data['putPaediatricsFirst'];
            this.putMrsaLast = _data['putMrsaLast'];
            this.putDaycaseSeparately = _data['putDaycaseSeparately'];
            this.putInpatientSeparately = _data['putInpatientSeparately'];
            this.putPaediatricSeparately = _data['putPaediatricSeparately'];
        }
    }

    static fromJS(data: any): ScheduleOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['putPaediatricsFirst'] = this.putPaediatricsFirst;
        data['putMrsaLast'] = this.putMrsaLast;
        data['putDaycaseSeparately'] = this.putDaycaseSeparately;
        data['putInpatientSeparately'] = this.putInpatientSeparately;
        data['putPaediatricSeparately'] = this.putPaediatricSeparately;
        return data;
    }
}

export interface IScheduleOptionsDto {
    putPaediatricsFirst: boolean;
    putMrsaLast: boolean;
    putDaycaseSeparately: boolean;
    putInpatientSeparately: boolean;
    putPaediatricSeparately: boolean;
}

export enum SecurityRuleSet {
    _0 = 0,
    _1 = 1,
    _2 = 2
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting;
    defaultPasswordComplexity: PasswordComplexitySetting;
    userLockOut: UserLockOutSettingsEditDto;
    twoFactorLogin: TwoFactorLoginSettingsEditDto;

    constructor(data?: ISecuritySettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useDefaultPasswordComplexitySettings = _data['useDefaultPasswordComplexitySettings'];
            this.passwordComplexity = _data['passwordComplexity']
                ? PasswordComplexitySetting.fromJS(_data['passwordComplexity'])
                : <any>undefined;
            this.defaultPasswordComplexity = _data['defaultPasswordComplexity']
                ? PasswordComplexitySetting.fromJS(_data['defaultPasswordComplexity'])
                : <any>undefined;
            this.userLockOut = _data['userLockOut'] ? UserLockOutSettingsEditDto.fromJS(_data['userLockOut']) : <any>undefined;
            this.twoFactorLogin = _data['twoFactorLogin'] ? TwoFactorLoginSettingsEditDto.fromJS(_data['twoFactorLogin']) : <any>undefined;
        }
    }

    static fromJS(data: any): SecuritySettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['useDefaultPasswordComplexitySettings'] = this.useDefaultPasswordComplexitySettings;
        data['passwordComplexity'] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data['defaultPasswordComplexity'] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : <any>undefined;
        data['userLockOut'] = this.userLockOut ? this.userLockOut.toJSON() : <any>undefined;
        data['twoFactorLogin'] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISecuritySettingsEditDto {
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting;
    defaultPasswordComplexity: PasswordComplexitySetting;
    userLockOut: UserLockOutSettingsEditDto;
    twoFactorLogin: TwoFactorLoginSettingsEditDto;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
    emailAddress: string;

    constructor(data?: ISendEmailActivationLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data['emailAddress'];
        }
    }

    static fromJS(data: any): SendEmailActivationLinkInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['emailAddress'] = this.emailAddress;
        return data;
    }
}

export interface ISendEmailActivationLinkInput {
    emailAddress: string;
}

export class SendPasswordResetCodeInput implements ISendPasswordResetCodeInput {
    emailAddress: string;

    constructor(data?: ISendPasswordResetCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data['emailAddress'];
        }
    }

    static fromJS(data: any): SendPasswordResetCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['emailAddress'] = this.emailAddress;
        return data;
    }
}

export interface ISendPasswordResetCodeInput {
    emailAddress: string;
}

export class SendTestEmailInput implements ISendTestEmailInput {
    emailAddress: string;

    constructor(data?: ISendTestEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data['emailAddress'];
        }
    }

    static fromJS(data: any): SendTestEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendTestEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['emailAddress'] = this.emailAddress;
        return data;
    }
}

export interface ISendTestEmailInput {
    emailAddress: string;
}

export class SendTwoFactorAuthCodeModel implements ISendTwoFactorAuthCodeModel {
    userId: number;
    provider: string;
    phoneNumber: string | undefined;

    constructor(data?: ISendTwoFactorAuthCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data['userId'];
            this.provider = _data['provider'];
            this.phoneNumber = _data['phoneNumber'];
        }
    }

    static fromJS(data: any): SendTwoFactorAuthCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendTwoFactorAuthCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userId'] = this.userId;
        data['provider'] = this.provider;
        data['phoneNumber'] = this.phoneNumber;
        return data;
    }
}

export interface ISendTwoFactorAuthCodeModel {
    userId: number;
    provider: string;
    phoneNumber: string | undefined;
}

export class Session implements ISession {
    id: string | undefined;
    visitDate: moment.Moment | undefined;
    plannedStartTime: moment.Moment | undefined;
    plannedEndTime: moment.Moment | undefined;
    actualStartTime: moment.Moment | undefined;
    actualEndTime: moment.Moment | undefined;
    plannedDuration: number | undefined;
    isEmergency: boolean;
    isWli: boolean | undefined;
    isModified: boolean;
    majorConsultantId: number | undefined;
    majorAnaesthetistId: number | undefined;
    majorSpecialityId: number | undefined;
    site: Site;
    procedures: Procedure[] | undefined;
    originalProcedures: Procedure[] | undefined;
    theatre: Theatre;
    majorConsultant: Employee;
    majorAnaesthetist: Employee;
    majorSpeciality: Speciality;
    excluded: ExcludedWaitingList[] | undefined;
    commentSection: CommentSection;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: ISession) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.visitDate = _data['visitDate'] ? moment(_data['visitDate'].toString()) : <any>undefined;
            this.plannedStartTime = _data['plannedStartTime'] ? moment(_data['plannedStartTime'].toString()) : <any>undefined;
            this.plannedEndTime = _data['plannedEndTime'] ? moment(_data['plannedEndTime'].toString()) : <any>undefined;
            this.actualStartTime = _data['actualStartTime'] ? moment(_data['actualStartTime'].toString()) : <any>undefined;
            this.actualEndTime = _data['actualEndTime'] ? moment(_data['actualEndTime'].toString()) : <any>undefined;
            this.plannedDuration = _data['plannedDuration'];
            this.isEmergency = _data['isEmergency'];
            this.isWli = _data['isWli'];
            this.isModified = _data['isModified'];
            this.majorConsultantId = _data['majorConsultantId'];
            this.majorAnaesthetistId = _data['majorAnaesthetistId'];
            this.majorSpecialityId = _data['majorSpecialityId'];
            this.site = _data['site'] ? Site.fromJS(_data['site']) : <any>undefined;
            if (Array.isArray(_data['procedures'])) {
                this.procedures = [] as any;
                for (let item of _data['procedures']) this.procedures.push(Procedure.fromJS(item));
            }
            if (Array.isArray(_data['originalProcedures'])) {
                this.originalProcedures = [] as any;
                for (let item of _data['originalProcedures']) this.originalProcedures.push(Procedure.fromJS(item));
            }
            this.theatre = _data['theatre'] ? Theatre.fromJS(_data['theatre']) : <any>undefined;
            this.majorConsultant = _data['majorConsultant'] ? Employee.fromJS(_data['majorConsultant']) : <any>undefined;
            this.majorAnaesthetist = _data['majorAnaesthetist'] ? Employee.fromJS(_data['majorAnaesthetist']) : <any>undefined;
            this.majorSpeciality = _data['majorSpeciality'] ? Speciality.fromJS(_data['majorSpeciality']) : <any>undefined;
            if (Array.isArray(_data['excluded'])) {
                this.excluded = [] as any;
                for (let item of _data['excluded']) this.excluded.push(ExcludedWaitingList.fromJS(item));
            }
            this.commentSection = _data['commentSection'] ? CommentSection.fromJS(_data['commentSection']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Session {
        data = typeof data === 'object' ? data : {};
        let result = new Session();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['visitDate'] = this.visitDate ? this.visitDate.toISOString() : <any>undefined;
        data['plannedStartTime'] = this.plannedStartTime ? this.plannedStartTime.toISOString() : <any>undefined;
        data['plannedEndTime'] = this.plannedEndTime ? this.plannedEndTime.toISOString() : <any>undefined;
        data['actualStartTime'] = this.actualStartTime ? this.actualStartTime.toISOString() : <any>undefined;
        data['actualEndTime'] = this.actualEndTime ? this.actualEndTime.toISOString() : <any>undefined;
        data['plannedDuration'] = this.plannedDuration;
        data['isEmergency'] = this.isEmergency;
        data['isWli'] = this.isWli;
        data['isModified'] = this.isModified;
        data['majorConsultantId'] = this.majorConsultantId;
        data['majorAnaesthetistId'] = this.majorAnaesthetistId;
        data['majorSpecialityId'] = this.majorSpecialityId;
        data['site'] = this.site ? this.site.toJSON() : <any>undefined;
        if (Array.isArray(this.procedures)) {
            data['procedures'] = [];
            for (let item of this.procedures) data['procedures'].push(item.toJSON());
        }
        if (Array.isArray(this.originalProcedures)) {
            data['originalProcedures'] = [];
            for (let item of this.originalProcedures) data['originalProcedures'].push(item.toJSON());
        }
        data['theatre'] = this.theatre ? this.theatre.toJSON() : <any>undefined;
        data['majorConsultant'] = this.majorConsultant ? this.majorConsultant.toJSON() : <any>undefined;
        data['majorAnaesthetist'] = this.majorAnaesthetist ? this.majorAnaesthetist.toJSON() : <any>undefined;
        data['majorSpeciality'] = this.majorSpeciality ? this.majorSpeciality.toJSON() : <any>undefined;
        if (Array.isArray(this.excluded)) {
            data['excluded'] = [];
            for (let item of this.excluded) data['excluded'].push(item.toJSON());
        }
        data['commentSection'] = this.commentSection ? this.commentSection.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISession {
    id: string | undefined;
    visitDate: moment.Moment | undefined;
    plannedStartTime: moment.Moment | undefined;
    plannedEndTime: moment.Moment | undefined;
    actualStartTime: moment.Moment | undefined;
    actualEndTime: moment.Moment | undefined;
    plannedDuration: number | undefined;
    isEmergency: boolean;
    isWli: boolean | undefined;
    isModified: boolean;
    majorConsultantId: number | undefined;
    majorAnaesthetistId: number | undefined;
    majorSpecialityId: number | undefined;
    site: Site;
    procedures: Procedure[] | undefined;
    originalProcedures: Procedure[] | undefined;
    theatre: Theatre;
    majorConsultant: Employee;
    majorAnaesthetist: Employee;
    majorSpeciality: Speciality;
    excluded: ExcludedWaitingList[] | undefined;
    commentSection: CommentSection;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class SessionDto implements ISessionDto {
    id: string | undefined;
    isEmergency: boolean;
    isWli: boolean | undefined;
    visitDate: moment.Moment | undefined;
    plannedStartTime: moment.Moment | undefined;
    plannedEndTime: moment.Moment | undefined;
    plannedDuration: number | undefined;
    actualStartTime: moment.Moment | undefined;
    actualEndTime: moment.Moment | undefined;
    site: Site;
    theatre: Theatre;
    majorAnaesthetist: EmployeeDto;
    majorConsultant: EmployeeDto;
    majorSpeciality: Speciality;
    bookedUtilisation: number;
    actualUtilisation: number | undefined;
    isAnaesthetist: boolean;
    isPreassessment: boolean;
    proceduresBooked: number;
    proceduresPerformed: number | undefined;
    estimatedIncome: number;
    isModified: boolean;
    isHistorical: boolean;

    constructor(data?: ISessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.isEmergency = _data['isEmergency'];
            this.isWli = _data['isWli'];
            this.visitDate = _data['visitDate'] ? moment(_data['visitDate'].toString()) : <any>undefined;
            this.plannedStartTime = _data['plannedStartTime'] ? moment(_data['plannedStartTime'].toString()) : <any>undefined;
            this.plannedEndTime = _data['plannedEndTime'] ? moment(_data['plannedEndTime'].toString()) : <any>undefined;
            this.plannedDuration = _data['plannedDuration'];
            this.actualStartTime = _data['actualStartTime'] ? moment(_data['actualStartTime'].toString()) : <any>undefined;
            this.actualEndTime = _data['actualEndTime'] ? moment(_data['actualEndTime'].toString()) : <any>undefined;
            this.site = _data['site'] ? Site.fromJS(_data['site']) : <any>undefined;
            this.theatre = _data['theatre'] ? Theatre.fromJS(_data['theatre']) : <any>undefined;
            this.majorAnaesthetist = _data['majorAnaesthetist'] ? EmployeeDto.fromJS(_data['majorAnaesthetist']) : <any>undefined;
            this.majorConsultant = _data['majorConsultant'] ? EmployeeDto.fromJS(_data['majorConsultant']) : <any>undefined;
            this.majorSpeciality = _data['majorSpeciality'] ? Speciality.fromJS(_data['majorSpeciality']) : <any>undefined;
            this.bookedUtilisation = _data['bookedUtilisation'];
            this.actualUtilisation = _data['actualUtilisation'];
            this.isAnaesthetist = _data['isAnaesthetist'];
            this.isPreassessment = _data['isPreassessment'];
            this.proceduresBooked = _data['proceduresBooked'];
            this.proceduresPerformed = _data['proceduresPerformed'];
            this.estimatedIncome = _data['estimatedIncome'];
            this.isModified = _data['isModified'];
            this.isHistorical = _data['isHistorical'];
        }
    }

    static fromJS(data: any): SessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['isEmergency'] = this.isEmergency;
        data['isWli'] = this.isWli;
        data['visitDate'] = this.visitDate ? this.visitDate.toISOString() : <any>undefined;
        data['plannedStartTime'] = this.plannedStartTime ? this.plannedStartTime.toISOString() : <any>undefined;
        data['plannedEndTime'] = this.plannedEndTime ? this.plannedEndTime.toISOString() : <any>undefined;
        data['plannedDuration'] = this.plannedDuration;
        data['actualStartTime'] = this.actualStartTime ? this.actualStartTime.toISOString() : <any>undefined;
        data['actualEndTime'] = this.actualEndTime ? this.actualEndTime.toISOString() : <any>undefined;
        data['site'] = this.site ? this.site.toJSON() : <any>undefined;
        data['theatre'] = this.theatre ? this.theatre.toJSON() : <any>undefined;
        data['majorAnaesthetist'] = this.majorAnaesthetist ? this.majorAnaesthetist.toJSON() : <any>undefined;
        data['majorConsultant'] = this.majorConsultant ? this.majorConsultant.toJSON() : <any>undefined;
        data['majorSpeciality'] = this.majorSpeciality ? this.majorSpeciality.toJSON() : <any>undefined;
        data['bookedUtilisation'] = this.bookedUtilisation;
        data['actualUtilisation'] = this.actualUtilisation;
        data['isAnaesthetist'] = this.isAnaesthetist;
        data['isPreassessment'] = this.isPreassessment;
        data['proceduresBooked'] = this.proceduresBooked;
        data['proceduresPerformed'] = this.proceduresPerformed;
        data['estimatedIncome'] = this.estimatedIncome;
        data['isModified'] = this.isModified;
        data['isHistorical'] = this.isHistorical;
        return data;
    }
}

export interface ISessionDto {
    id: string | undefined;
    isEmergency: boolean;
    isWli: boolean | undefined;
    visitDate: moment.Moment | undefined;
    plannedStartTime: moment.Moment | undefined;
    plannedEndTime: moment.Moment | undefined;
    plannedDuration: number | undefined;
    actualStartTime: moment.Moment | undefined;
    actualEndTime: moment.Moment | undefined;
    site: Site;
    theatre: Theatre;
    majorAnaesthetist: EmployeeDto;
    majorConsultant: EmployeeDto;
    majorSpeciality: Speciality;
    bookedUtilisation: number;
    actualUtilisation: number | undefined;
    isAnaesthetist: boolean;
    isPreassessment: boolean;
    proceduresBooked: number;
    proceduresPerformed: number | undefined;
    estimatedIncome: number;
    isModified: boolean;
    isHistorical: boolean;
}

export class SessionsAggregatedByDateDto implements ISessionsAggregatedByDateDto {
    date: moment.Moment | undefined;
    sessions: SessionWithProceduresDto[] | undefined;

    constructor(data?: ISessionsAggregatedByDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data['date'] ? moment(_data['date'].toString()) : <any>undefined;
            if (Array.isArray(_data['sessions'])) {
                this.sessions = [] as any;
                for (let item of _data['sessions']) this.sessions.push(SessionWithProceduresDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SessionsAggregatedByDateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionsAggregatedByDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['date'] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.sessions)) {
            data['sessions'] = [];
            for (let item of this.sessions) data['sessions'].push(item.toJSON());
        }
        return data;
    }
}

export interface ISessionsAggregatedByDateDto {
    date: moment.Moment | undefined;
    sessions: SessionWithProceduresDto[] | undefined;
}

export class SessionWithProceduresDto implements ISessionWithProceduresDto {
    id: string | undefined;
    isEmergency: boolean;
    isWli: boolean | undefined;
    visitDate: moment.Moment | undefined;
    plannedStartTime: moment.Moment | undefined;
    plannedEndTime: moment.Moment | undefined;
    plannedDuration: number | undefined;
    actualStartTime: moment.Moment | undefined;
    actualEndTime: moment.Moment | undefined;
    site: Site;
    theatre: Theatre;
    majorAnaesthetist: EmployeeDto;
    majorConsultant: EmployeeDto;
    majorSpeciality: Speciality;
    actualUtilisation: number | undefined;
    isAnaesthetist: boolean;
    isPreassessment: boolean;
    proceduresBooked: number;
    proceduresPerformed: number | undefined;
    estimatedIncome: number;
    isModified: boolean;
    isHistorical: boolean;
    procedures: ProcedureDto[] | undefined;
    readonly bookedUtilisation: number;

    constructor(data?: ISessionWithProceduresDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.isEmergency = _data['isEmergency'];
            this.isWli = _data['isWli'];
            this.visitDate = _data['visitDate'] ? moment(_data['visitDate'].toString()) : <any>undefined;
            this.plannedStartTime = _data['plannedStartTime'] ? moment(_data['plannedStartTime'].toString()) : <any>undefined;
            this.plannedEndTime = _data['plannedEndTime'] ? moment(_data['plannedEndTime'].toString()) : <any>undefined;
            this.plannedDuration = _data['plannedDuration'];
            this.actualStartTime = _data['actualStartTime'] ? moment(_data['actualStartTime'].toString()) : <any>undefined;
            this.actualEndTime = _data['actualEndTime'] ? moment(_data['actualEndTime'].toString()) : <any>undefined;
            this.site = _data['site'] ? Site.fromJS(_data['site']) : <any>undefined;
            this.theatre = _data['theatre'] ? Theatre.fromJS(_data['theatre']) : <any>undefined;
            this.majorAnaesthetist = _data['majorAnaesthetist'] ? EmployeeDto.fromJS(_data['majorAnaesthetist']) : <any>undefined;
            this.majorConsultant = _data['majorConsultant'] ? EmployeeDto.fromJS(_data['majorConsultant']) : <any>undefined;
            this.majorSpeciality = _data['majorSpeciality'] ? Speciality.fromJS(_data['majorSpeciality']) : <any>undefined;
            this.actualUtilisation = _data['actualUtilisation'];
            this.isAnaesthetist = _data['isAnaesthetist'];
            this.isPreassessment = _data['isPreassessment'];
            this.proceduresBooked = _data['proceduresBooked'];
            this.proceduresPerformed = _data['proceduresPerformed'];
            this.estimatedIncome = _data['estimatedIncome'];
            this.isModified = _data['isModified'];
            this.isHistorical = _data['isHistorical'];
            if (Array.isArray(_data['procedures'])) {
                this.procedures = [] as any;
                for (let item of _data['procedures']) this.procedures.push(ProcedureDto.fromJS(item));
            }
            (<any>this).bookedUtilisation = _data['bookedUtilisation'];
        }
    }

    static fromJS(data: any): SessionWithProceduresDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionWithProceduresDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['isEmergency'] = this.isEmergency;
        data['isWli'] = this.isWli;
        data['visitDate'] = this.visitDate ? this.visitDate.toISOString() : <any>undefined;
        data['plannedStartTime'] = this.plannedStartTime ? this.plannedStartTime.toISOString() : <any>undefined;
        data['plannedEndTime'] = this.plannedEndTime ? this.plannedEndTime.toISOString() : <any>undefined;
        data['plannedDuration'] = this.plannedDuration;
        data['actualStartTime'] = this.actualStartTime ? this.actualStartTime.toISOString() : <any>undefined;
        data['actualEndTime'] = this.actualEndTime ? this.actualEndTime.toISOString() : <any>undefined;
        data['site'] = this.site ? this.site.toJSON() : <any>undefined;
        data['theatre'] = this.theatre ? this.theatre.toJSON() : <any>undefined;
        data['majorAnaesthetist'] = this.majorAnaesthetist ? this.majorAnaesthetist.toJSON() : <any>undefined;
        data['majorConsultant'] = this.majorConsultant ? this.majorConsultant.toJSON() : <any>undefined;
        data['majorSpeciality'] = this.majorSpeciality ? this.majorSpeciality.toJSON() : <any>undefined;
        data['actualUtilisation'] = this.actualUtilisation;
        data['isAnaesthetist'] = this.isAnaesthetist;
        data['isPreassessment'] = this.isPreassessment;
        data['proceduresBooked'] = this.proceduresBooked;
        data['proceduresPerformed'] = this.proceduresPerformed;
        data['estimatedIncome'] = this.estimatedIncome;
        data['isModified'] = this.isModified;
        data['isHistorical'] = this.isHistorical;
        if (Array.isArray(this.procedures)) {
            data['procedures'] = [];
            for (let item of this.procedures) data['procedures'].push(item.toJSON());
        }
        data['bookedUtilisation'] = this.bookedUtilisation;
        return data;
    }
}

export interface ISessionWithProceduresDto {
    id: string | undefined;
    isEmergency: boolean;
    isWli: boolean | undefined;
    visitDate: moment.Moment | undefined;
    plannedStartTime: moment.Moment | undefined;
    plannedEndTime: moment.Moment | undefined;
    plannedDuration: number | undefined;
    actualStartTime: moment.Moment | undefined;
    actualEndTime: moment.Moment | undefined;
    site: Site;
    theatre: Theatre;
    majorAnaesthetist: EmployeeDto;
    majorConsultant: EmployeeDto;
    majorSpeciality: Speciality;
    actualUtilisation: number | undefined;
    isAnaesthetist: boolean;
    isPreassessment: boolean;
    proceduresBooked: number;
    proceduresPerformed: number | undefined;
    estimatedIncome: number;
    isModified: boolean;
    isHistorical: boolean;
    procedures: ProcedureDto[] | undefined;
    bookedUtilisation: number;
}

export class SessionWithSimilarListsDto implements ISessionWithSimilarListsDto {
    id: string | undefined;
    isEmergency: boolean;
    isWli: boolean | undefined;
    visitDate: moment.Moment | undefined;
    plannedStartTime: moment.Moment | undefined;
    plannedEndTime: moment.Moment | undefined;
    plannedDuration: number | undefined;
    actualStartTime: moment.Moment | undefined;
    actualEndTime: moment.Moment | undefined;
    site: Site;
    theatre: Theatre;
    majorAnaesthetist: EmployeeDto;
    majorConsultant: EmployeeDto;
    majorSpeciality: Speciality;
    bookedUtilisation: number;
    actualUtilisation: number | undefined;
    isAnaesthetist: boolean;
    isPreassessment: boolean;
    proceduresBooked: number;
    proceduresPerformed: number | undefined;
    estimatedIncome: number;
    isModified: boolean;
    isHistorical: boolean;
    procedures: ProcedureDto[] | undefined;
    nextSimilarSessionId: string | undefined;
    previousSimilarSessionId: string | undefined;

    constructor(data?: ISessionWithSimilarListsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.isEmergency = _data['isEmergency'];
            this.isWli = _data['isWli'];
            this.visitDate = _data['visitDate'] ? moment(_data['visitDate'].toString()) : <any>undefined;
            this.plannedStartTime = _data['plannedStartTime'] ? moment(_data['plannedStartTime'].toString()) : <any>undefined;
            this.plannedEndTime = _data['plannedEndTime'] ? moment(_data['plannedEndTime'].toString()) : <any>undefined;
            this.plannedDuration = _data['plannedDuration'];
            this.actualStartTime = _data['actualStartTime'] ? moment(_data['actualStartTime'].toString()) : <any>undefined;
            this.actualEndTime = _data['actualEndTime'] ? moment(_data['actualEndTime'].toString()) : <any>undefined;
            this.site = _data['site'] ? Site.fromJS(_data['site']) : <any>undefined;
            this.theatre = _data['theatre'] ? Theatre.fromJS(_data['theatre']) : <any>undefined;
            this.majorAnaesthetist = _data['majorAnaesthetist'] ? EmployeeDto.fromJS(_data['majorAnaesthetist']) : <any>undefined;
            this.majorConsultant = _data['majorConsultant'] ? EmployeeDto.fromJS(_data['majorConsultant']) : <any>undefined;
            this.majorSpeciality = _data['majorSpeciality'] ? Speciality.fromJS(_data['majorSpeciality']) : <any>undefined;
            this.bookedUtilisation = _data['bookedUtilisation'];
            this.actualUtilisation = _data['actualUtilisation'];
            this.isAnaesthetist = _data['isAnaesthetist'];
            this.isPreassessment = _data['isPreassessment'];
            this.proceduresBooked = _data['proceduresBooked'];
            this.proceduresPerformed = _data['proceduresPerformed'];
            this.estimatedIncome = _data['estimatedIncome'];
            this.isModified = _data['isModified'];
            this.isHistorical = _data['isHistorical'];
            if (Array.isArray(_data['procedures'])) {
                this.procedures = [] as any;
                for (let item of _data['procedures']) this.procedures.push(ProcedureDto.fromJS(item));
            }
            this.nextSimilarSessionId = _data['nextSimilarSessionId'];
            this.previousSimilarSessionId = _data['previousSimilarSessionId'];
        }
    }

    static fromJS(data: any): SessionWithSimilarListsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionWithSimilarListsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['isEmergency'] = this.isEmergency;
        data['isWli'] = this.isWli;
        data['visitDate'] = this.visitDate ? this.visitDate.toISOString() : <any>undefined;
        data['plannedStartTime'] = this.plannedStartTime ? this.plannedStartTime.toISOString() : <any>undefined;
        data['plannedEndTime'] = this.plannedEndTime ? this.plannedEndTime.toISOString() : <any>undefined;
        data['plannedDuration'] = this.plannedDuration;
        data['actualStartTime'] = this.actualStartTime ? this.actualStartTime.toISOString() : <any>undefined;
        data['actualEndTime'] = this.actualEndTime ? this.actualEndTime.toISOString() : <any>undefined;
        data['site'] = this.site ? this.site.toJSON() : <any>undefined;
        data['theatre'] = this.theatre ? this.theatre.toJSON() : <any>undefined;
        data['majorAnaesthetist'] = this.majorAnaesthetist ? this.majorAnaesthetist.toJSON() : <any>undefined;
        data['majorConsultant'] = this.majorConsultant ? this.majorConsultant.toJSON() : <any>undefined;
        data['majorSpeciality'] = this.majorSpeciality ? this.majorSpeciality.toJSON() : <any>undefined;
        data['bookedUtilisation'] = this.bookedUtilisation;
        data['actualUtilisation'] = this.actualUtilisation;
        data['isAnaesthetist'] = this.isAnaesthetist;
        data['isPreassessment'] = this.isPreassessment;
        data['proceduresBooked'] = this.proceduresBooked;
        data['proceduresPerformed'] = this.proceduresPerformed;
        data['estimatedIncome'] = this.estimatedIncome;
        data['isModified'] = this.isModified;
        data['isHistorical'] = this.isHistorical;
        if (Array.isArray(this.procedures)) {
            data['procedures'] = [];
            for (let item of this.procedures) data['procedures'].push(item.toJSON());
        }
        data['nextSimilarSessionId'] = this.nextSimilarSessionId;
        data['previousSimilarSessionId'] = this.previousSimilarSessionId;
        return data;
    }
}

export interface ISessionWithSimilarListsDto {
    id: string | undefined;
    isEmergency: boolean;
    isWli: boolean | undefined;
    visitDate: moment.Moment | undefined;
    plannedStartTime: moment.Moment | undefined;
    plannedEndTime: moment.Moment | undefined;
    plannedDuration: number | undefined;
    actualStartTime: moment.Moment | undefined;
    actualEndTime: moment.Moment | undefined;
    site: Site;
    theatre: Theatre;
    majorAnaesthetist: EmployeeDto;
    majorConsultant: EmployeeDto;
    majorSpeciality: Speciality;
    bookedUtilisation: number;
    actualUtilisation: number | undefined;
    isAnaesthetist: boolean;
    isPreassessment: boolean;
    proceduresBooked: number;
    proceduresPerformed: number | undefined;
    estimatedIncome: number;
    isModified: boolean;
    isHistorical: boolean;
    procedures: ProcedureDto[] | undefined;
    nextSimilarSessionId: string | undefined;
    previousSimilarSessionId: string | undefined;
}

export class SetDefaultLanguageInput implements ISetDefaultLanguageInput {
    name: string;

    constructor(data?: ISetDefaultLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): SetDefaultLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        return data;
    }
}

export interface ISetDefaultLanguageInput {
    name: string;
}

export class Setting implements ISetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
            this.lastModifierUserId = _data['lastModifierUserId'];
            this.tenantId = _data['tenantId'];
            this.userId = _data['userId'];
            this.name = _data['name'];
            this.value = _data['value'];
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data['lastModifierUserId'] = this.lastModifierUserId;
        data['tenantId'] = this.tenantId;
        data['userId'] = this.userId;
        data['name'] = this.name;
        data['value'] = this.value;
        return data;
    }
}

export interface ISetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    tenantId: number | undefined;
    userId: number | undefined;
    name: string;
    value: string | undefined;
}

export enum SettingScopes {
    _1 = 1,
    _2 = 2,
    _4 = 4,
    _7 = 7
}

export class SimpleImprovementProgramDto implements ISimpleImprovementProgramDto {
    id: number;
    name: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    startOpportunity: number;
    endOpportunity: number;
    specialities: string[] | undefined;
    finished: boolean;

    constructor(data?: ISimpleImprovementProgramDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.startDate = _data['startDate'] ? moment(_data['startDate'].toString()) : <any>undefined;
            this.endDate = _data['endDate'] ? moment(_data['endDate'].toString()) : <any>undefined;
            this.startOpportunity = _data['startOpportunity'];
            this.endOpportunity = _data['endOpportunity'];
            if (Array.isArray(_data['specialities'])) {
                this.specialities = [] as any;
                for (let item of _data['specialities']) this.specialities.push(item);
            }
            this.finished = _data['finished'];
        }
    }

    static fromJS(data: any): SimpleImprovementProgramDto {
        data = typeof data === 'object' ? data : {};
        let result = new SimpleImprovementProgramDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data['startOpportunity'] = this.startOpportunity;
        data['endOpportunity'] = this.endOpportunity;
        if (Array.isArray(this.specialities)) {
            data['specialities'] = [];
            for (let item of this.specialities) data['specialities'].push(item);
        }
        data['finished'] = this.finished;
        return data;
    }
}

export interface ISimpleImprovementProgramDto {
    id: number;
    name: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment;
    startOpportunity: number;
    endOpportunity: number;
    specialities: string[] | undefined;
    finished: boolean;
}

export class Site implements ISite {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: ISite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Site {
        data = typeof data === 'object' ? data : {};
        let result = new Site();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISite {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class SixFourTwoDto implements ISixFourTwoDto {
    sixWeeksOverview: PeriodsOverviewDto[] | undefined;
    sixFourTwoOverview: PeriodsOverviewDto[] | undefined;

    constructor(data?: ISixFourTwoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['sixWeeksOverview'])) {
                this.sixWeeksOverview = [] as any;
                for (let item of _data['sixWeeksOverview']) this.sixWeeksOverview.push(PeriodsOverviewDto.fromJS(item));
            }
            if (Array.isArray(_data['sixFourTwoOverview'])) {
                this.sixFourTwoOverview = [] as any;
                for (let item of _data['sixFourTwoOverview']) this.sixFourTwoOverview.push(PeriodsOverviewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SixFourTwoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SixFourTwoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sixWeeksOverview)) {
            data['sixWeeksOverview'] = [];
            for (let item of this.sixWeeksOverview) data['sixWeeksOverview'].push(item.toJSON());
        }
        if (Array.isArray(this.sixFourTwoOverview)) {
            data['sixFourTwoOverview'] = [];
            for (let item of this.sixFourTwoOverview) data['sixFourTwoOverview'].push(item.toJSON());
        }
        return data;
    }
}

export interface ISixFourTwoDto {
    sixWeeksOverview: PeriodsOverviewDto[] | undefined;
    sixFourTwoOverview: PeriodsOverviewDto[] | undefined;
}

export class SmartSchedulingAuthorisationDto implements ISmartSchedulingAuthorisationDto {
    smartSchedulingsPerDay: SessionsAggregatedByDateDto[] | undefined;
    exclude: ExcludedWaitingListsDto[] | undefined;

    constructor(data?: ISmartSchedulingAuthorisationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['smartSchedulingsPerDay'])) {
                this.smartSchedulingsPerDay = [] as any;
                for (let item of _data['smartSchedulingsPerDay'])
                    this.smartSchedulingsPerDay.push(SessionsAggregatedByDateDto.fromJS(item));
            }
            if (Array.isArray(_data['exclude'])) {
                this.exclude = [] as any;
                for (let item of _data['exclude']) this.exclude.push(ExcludedWaitingListsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SmartSchedulingAuthorisationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmartSchedulingAuthorisationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.smartSchedulingsPerDay)) {
            data['smartSchedulingsPerDay'] = [];
            for (let item of this.smartSchedulingsPerDay) data['smartSchedulingsPerDay'].push(item.toJSON());
        }
        if (Array.isArray(this.exclude)) {
            data['exclude'] = [];
            for (let item of this.exclude) data['exclude'].push(item.toJSON());
        }
        return data;
    }
}

export interface ISmartSchedulingAuthorisationDto {
    smartSchedulingsPerDay: SessionsAggregatedByDateDto[] | undefined;
    exclude: ExcludedWaitingListsDto[] | undefined;
}

export class SmartSchedulingWithSummaryDto implements ISmartSchedulingWithSummaryDto {
    smartSchedulings: SessionsAggregatedByDateDto[] | undefined;
    numberOfFilledLists: number;
    numberOfPatientsInSmartScheduling: number;
    numberOfPatientsInPTL: number;
    bookedUtilisationBeforeChanges: number;
    bookedUtilisationAfterChanges: number;
    numberOfBreachingInPTL: number;
    numberOfBreachingInSmartScheduling: number;

    constructor(data?: ISmartSchedulingWithSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['smartSchedulings'])) {
                this.smartSchedulings = [] as any;
                for (let item of _data['smartSchedulings']) this.smartSchedulings.push(SessionsAggregatedByDateDto.fromJS(item));
            }
            this.numberOfFilledLists = _data['numberOfFilledLists'];
            this.numberOfPatientsInSmartScheduling = _data['numberOfPatientsInSmartScheduling'];
            this.numberOfPatientsInPTL = _data['numberOfPatientsInPTL'];
            this.bookedUtilisationBeforeChanges = _data['bookedUtilisationBeforeChanges'];
            this.bookedUtilisationAfterChanges = _data['bookedUtilisationAfterChanges'];
            this.numberOfBreachingInPTL = _data['numberOfBreachingInPTL'];
            this.numberOfBreachingInSmartScheduling = _data['numberOfBreachingInSmartScheduling'];
        }
    }

    static fromJS(data: any): SmartSchedulingWithSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmartSchedulingWithSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.smartSchedulings)) {
            data['smartSchedulings'] = [];
            for (let item of this.smartSchedulings) data['smartSchedulings'].push(item.toJSON());
        }
        data['numberOfFilledLists'] = this.numberOfFilledLists;
        data['numberOfPatientsInSmartScheduling'] = this.numberOfPatientsInSmartScheduling;
        data['numberOfPatientsInPTL'] = this.numberOfPatientsInPTL;
        data['bookedUtilisationBeforeChanges'] = this.bookedUtilisationBeforeChanges;
        data['bookedUtilisationAfterChanges'] = this.bookedUtilisationAfterChanges;
        data['numberOfBreachingInPTL'] = this.numberOfBreachingInPTL;
        data['numberOfBreachingInSmartScheduling'] = this.numberOfBreachingInSmartScheduling;
        return data;
    }
}

export interface ISmartSchedulingWithSummaryDto {
    smartSchedulings: SessionsAggregatedByDateDto[] | undefined;
    numberOfFilledLists: number;
    numberOfPatientsInSmartScheduling: number;
    numberOfPatientsInPTL: number;
    bookedUtilisationBeforeChanges: number;
    bookedUtilisationAfterChanges: number;
    numberOfBreachingInPTL: number;
    numberOfBreachingInSmartScheduling: number;
}

export class Speciality implements ISpeciality {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    abbreviation: string | undefined;
    improvementProgramSpeciality: ImprovementProgramSpeciality[] | undefined;
    employees: SpecialityConsultantMapping[] | undefined;

    constructor(data?: ISpeciality) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
            this.abbreviation = _data['abbreviation'];
            if (Array.isArray(_data['improvementProgramSpeciality'])) {
                this.improvementProgramSpeciality = [] as any;
                for (let item of _data['improvementProgramSpeciality'])
                    this.improvementProgramSpeciality.push(ImprovementProgramSpeciality.fromJS(item));
            }
            if (Array.isArray(_data['employees'])) {
                this.employees = [] as any;
                for (let item of _data['employees']) this.employees.push(SpecialityConsultantMapping.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Speciality {
        data = typeof data === 'object' ? data : {};
        let result = new Speciality();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data['abbreviation'] = this.abbreviation;
        if (Array.isArray(this.improvementProgramSpeciality)) {
            data['improvementProgramSpeciality'] = [];
            for (let item of this.improvementProgramSpeciality) data['improvementProgramSpeciality'].push(item.toJSON());
        }
        if (Array.isArray(this.employees)) {
            data['employees'] = [];
            for (let item of this.employees) data['employees'].push(item.toJSON());
        }
        return data;
    }
}

export interface ISpeciality {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
    abbreviation: string | undefined;
    improvementProgramSpeciality: ImprovementProgramSpeciality[] | undefined;
    employees: SpecialityConsultantMapping[] | undefined;
}

export class SpecialityConsultantMapping implements ISpecialityConsultantMapping {
    specialityId: number;
    consultantId: number;
    speciality: Speciality;
    consultant: Employee;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: ISpecialityConsultantMapping) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.specialityId = _data['specialityId'];
            this.consultantId = _data['consultantId'];
            this.speciality = _data['speciality'] ? Speciality.fromJS(_data['speciality']) : <any>undefined;
            this.consultant = _data['consultant'] ? Employee.fromJS(_data['consultant']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SpecialityConsultantMapping {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialityConsultantMapping();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['specialityId'] = this.specialityId;
        data['consultantId'] = this.consultantId;
        data['speciality'] = this.speciality ? this.speciality.toJSON() : <any>undefined;
        data['consultant'] = this.consultant ? this.consultant.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISpecialityConsultantMapping {
    specialityId: number;
    consultantId: number;
    speciality: Speciality;
    consultant: Employee;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class SpecialityDto implements ISpecialityDto {
    id: number;
    name: string | undefined;

    constructor(data?: ISpecialityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
        }
    }

    static fromJS(data: any): SpecialityDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        return data;
    }
}

export interface ISpecialityDto {
    id: number;
    name: string | undefined;
}

export class SpecialityMagicValuesPairDto implements ISpecialityMagicValuesPairDto {
    specialityId: number;
    magicValues: MagicValuesDto;

    constructor(data?: ISpecialityMagicValuesPairDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.specialityId = _data['specialityId'];
            this.magicValues = _data['magicValues'] ? MagicValuesDto.fromJS(_data['magicValues']) : <any>undefined;
        }
    }

    static fromJS(data: any): SpecialityMagicValuesPairDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialityMagicValuesPairDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['specialityId'] = this.specialityId;
        data['magicValues'] = this.magicValues ? this.magicValues.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISpecialityMagicValuesPairDto {
    specialityId: number;
    magicValues: MagicValuesDto;
}

export class SpecialtyEditDto implements ISpecialtyEditDto {
    id: number;
    name: string | undefined;
    abbreviation: string | undefined;

    constructor(data?: ISpecialtyEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.abbreviation = _data['abbreviation'];
        }
    }

    static fromJS(data: any): SpecialtyEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialtyEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['abbreviation'] = this.abbreviation;
        return data;
    }
}

export interface ISpecialtyEditDto {
    id: number;
    name: string | undefined;
    abbreviation: string | undefined;
}

export class StringEntityDto implements IStringEntityDto {
    id: string | undefined;

    constructor(data?: IStringEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
        }
    }

    static fromJS(data: any): StringEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new StringEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        return data;
    }
}

export interface IStringEntityDto {
    id: string | undefined;
}

export class StringNameValue implements IStringNameValue {
    name: string | undefined;
    value: string | undefined;

    constructor(data?: IStringNameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data['name'];
            this.value = _data['value'];
        }
    }

    static fromJS(data: any): StringNameValue {
        data = typeof data === 'object' ? data : {};
        let result = new StringNameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        data['value'] = this.value;
        return data;
    }
}

export interface IStringNameValue {
    name: string | undefined;
    value: string | undefined;
}

export class StringOutput implements IStringOutput {
    output: string | undefined;

    constructor(data?: IStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.output = _data['output'];
        }
    }

    static fromJS(data: any): StringOutput {
        data = typeof data === 'object' ? data : {};
        let result = new StringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['output'] = this.output;
        return data;
    }
}

export interface IStringOutput {
    output: string | undefined;
}

export class StringStringStringStringOfF__AnonymousType0 implements IStringStringStringStringOfF__AnonymousType0 {
    readonly method: string | undefined;
    readonly route: string | undefined;
    readonly action: string | undefined;
    readonly controllerMethod: string | undefined;

    constructor(data?: IStringStringStringStringOfF__AnonymousType0) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).method = _data['method'];
            (<any>this).route = _data['route'];
            (<any>this).action = _data['action'];
            (<any>this).controllerMethod = _data['controllerMethod'];
        }
    }

    static fromJS(data: any): StringStringStringStringOfF__AnonymousType0 {
        data = typeof data === 'object' ? data : {};
        let result = new StringStringStringStringOfF__AnonymousType0();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['method'] = this.method;
        data['route'] = this.route;
        data['action'] = this.action;
        data['controllerMethod'] = this.controllerMethod;
        return data;
    }
}

export interface IStringStringStringStringOfF__AnonymousType0 {
    method: string | undefined;
    route: string | undefined;
    action: string | undefined;
    controllerMethod: string | undefined;
}

export class StructLayoutAttribute implements IStructLayoutAttribute {
    readonly typeId: any | undefined;
    value: LayoutKind;

    constructor(data?: IStructLayoutAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).typeId = _data['typeId'];
            this.value = _data['value'];
        }
    }

    static fromJS(data: any): StructLayoutAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new StructLayoutAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['typeId'] = this.typeId;
        data['value'] = this.value;
        return data;
    }
}

export interface IStructLayoutAttribute {
    typeId: any | undefined;
    value: LayoutKind;
}

export class SubscribableEditionComboboxItemDto implements ISubscribableEditionComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
    isFree: boolean | undefined;

    constructor(data?: ISubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data['value'];
            this.displayText = _data['displayText'];
            this.isSelected = _data['isSelected'];
            this.isFree = _data['isFree'];
        }
    }

    static fromJS(data: any): SubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['value'] = this.value;
        data['displayText'] = this.displayText;
        data['isSelected'] = this.isSelected;
        data['isFree'] = this.isFree;
        return data;
    }
}

export interface ISubscribableEditionComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
    isFree: boolean | undefined;
}

export class SubscribableEditionComboboxItemDtoListResultDto implements ISubscribableEditionComboboxItemDtoListResultDto {
    items: SubscribableEditionComboboxItemDto[] | undefined;

    constructor(data?: ISubscribableEditionComboboxItemDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscribableEditionComboboxItemDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribableEditionComboboxItemDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }
}

export interface ISubscribableEditionComboboxItemDtoListResultDto {
    items: SubscribableEditionComboboxItemDto[] | undefined;
}

export enum SubscriptionPaymentGatewayType {
    _1 = 1
}

export class SubscriptionPaymentListDto implements ISubscriptionPaymentListDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    gateway: string | undefined;
    amount: number;
    editionId: number;
    dayCount: number;
    paymentPeriodType: string | undefined;
    paymentId: string | undefined;
    payerId: string | undefined;
    status: string | undefined;
    editionDisplayName: string | undefined;
    tenantId: number;
    invoiceNo: string | undefined;

    constructor(data?: ISubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
            this.lastModifierUserId = _data['lastModifierUserId'];
            this.gateway = _data['gateway'];
            this.amount = _data['amount'];
            this.editionId = _data['editionId'];
            this.dayCount = _data['dayCount'];
            this.paymentPeriodType = _data['paymentPeriodType'];
            this.paymentId = _data['paymentId'];
            this.payerId = _data['payerId'];
            this.status = _data['status'];
            this.editionDisplayName = _data['editionDisplayName'];
            this.tenantId = _data['tenantId'];
            this.invoiceNo = _data['invoiceNo'];
        }
    }

    static fromJS(data: any): SubscriptionPaymentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data['lastModifierUserId'] = this.lastModifierUserId;
        data['gateway'] = this.gateway;
        data['amount'] = this.amount;
        data['editionId'] = this.editionId;
        data['dayCount'] = this.dayCount;
        data['paymentPeriodType'] = this.paymentPeriodType;
        data['paymentId'] = this.paymentId;
        data['payerId'] = this.payerId;
        data['status'] = this.status;
        data['editionDisplayName'] = this.editionDisplayName;
        data['tenantId'] = this.tenantId;
        data['invoiceNo'] = this.invoiceNo;
        return data;
    }
}

export interface ISubscriptionPaymentListDto {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    gateway: string | undefined;
    amount: number;
    editionId: number;
    dayCount: number;
    paymentPeriodType: string | undefined;
    paymentId: string | undefined;
    payerId: string | undefined;
    status: string | undefined;
    editionDisplayName: string | undefined;
    tenantId: number;
    invoiceNo: string | undefined;
}

export class SubscriptionPaymentListDtoPagedResultDto implements ISubscriptionPaymentListDtoPagedResultDto {
    items: SubscriptionPaymentListDto[] | undefined;
    totalCount: number;

    constructor(data?: ISubscriptionPaymentListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(SubscriptionPaymentListDto.fromJS(item));
            }
            this.totalCount = _data['totalCount'];
        }
    }

    static fromJS(data: any): SubscriptionPaymentListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPaymentListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        data['totalCount'] = this.totalCount;
        return data;
    }
}

export interface ISubscriptionPaymentListDtoPagedResultDto {
    items: SubscriptionPaymentListDto[] | undefined;
    totalCount: number;
}

export enum SubscriptionStartType {
    _1 = 1,
    _2 = 2,
    _3 = 3
}

export enum SuggestedTimeCalculationType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4
}

export class SwitchedAccountAuthenticateResultModel implements ISwitchedAccountAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;

    constructor(data?: ISwitchedAccountAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data['accessToken'];
            this.encryptedAccessToken = _data['encryptedAccessToken'];
            this.expireInSeconds = _data['expireInSeconds'];
        }
    }

    static fromJS(data: any): SwitchedAccountAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchedAccountAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['accessToken'] = this.accessToken;
        data['encryptedAccessToken'] = this.encryptedAccessToken;
        data['expireInSeconds'] = this.expireInSeconds;
        return data;
    }
}

export interface ISwitchedAccountAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3
}

export class TenantBillingSettingsEditDto implements ITenantBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
    taxVatNo: string | undefined;

    constructor(data?: ITenantBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data['legalName'];
            this.address = _data['address'];
            this.taxVatNo = _data['taxVatNo'];
        }
    }

    static fromJS(data: any): TenantBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['legalName'] = this.legalName;
        data['address'] = this.address;
        data['taxVatNo'] = this.taxVatNo;
        return data;
    }
}

export interface ITenantBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
    taxVatNo: string | undefined;
}

export class TenantEditDto implements ITenantEditDto {
    id: number;
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    reportSettingsId: number;
    clientId: string | undefined;
    groupId: string | undefined;
    reportId: string | undefined;

    constructor(data?: ITenantEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.tenancyName = _data['tenancyName'];
            this.name = _data['name'];
            this.connectionString = _data['connectionString'];
            this.editionId = _data['editionId'];
            this.isActive = _data['isActive'];
            this.subscriptionEndDateUtc = _data['subscriptionEndDateUtc']
                ? moment(_data['subscriptionEndDateUtc'].toString())
                : <any>undefined;
            this.isInTrialPeriod = _data['isInTrialPeriod'];
            this.reportSettingsId = _data['reportSettingsId'];
            this.clientId = _data['clientId'];
            this.groupId = _data['groupId'];
            this.reportId = _data['reportId'];
        }
    }

    static fromJS(data: any): TenantEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['tenancyName'] = this.tenancyName;
        data['name'] = this.name;
        data['connectionString'] = this.connectionString;
        data['editionId'] = this.editionId;
        data['isActive'] = this.isActive;
        data['subscriptionEndDateUtc'] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data['isInTrialPeriod'] = this.isInTrialPeriod;
        data['reportSettingsId'] = this.reportSettingsId;
        data['clientId'] = this.clientId;
        data['groupId'] = this.groupId;
        data['reportId'] = this.reportId;
        return data;
    }
}

export interface ITenantEditDto {
    id: number;
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    reportSettingsId: number;
    clientId: string | undefined;
    groupId: string | undefined;
    reportId: string | undefined;
}

export class TenantListDto implements ITenantListDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
    editionDisplayName: string | undefined;
    connectionString: string | undefined;
    isActive: boolean;
    creationTime: moment.Moment;
    subscriptionEndDateUtc: moment.Moment | undefined;
    editionId: number | undefined;
    isInTrialPeriod: boolean;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.tenancyName = _data['tenancyName'];
            this.name = _data['name'];
            this.editionDisplayName = _data['editionDisplayName'];
            this.connectionString = _data['connectionString'];
            this.isActive = _data['isActive'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.subscriptionEndDateUtc = _data['subscriptionEndDateUtc']
                ? moment(_data['subscriptionEndDateUtc'].toString())
                : <any>undefined;
            this.editionId = _data['editionId'];
            this.isInTrialPeriod = _data['isInTrialPeriod'];
        }
    }

    static fromJS(data: any): TenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['tenancyName'] = this.tenancyName;
        data['name'] = this.name;
        data['editionDisplayName'] = this.editionDisplayName;
        data['connectionString'] = this.connectionString;
        data['isActive'] = this.isActive;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['subscriptionEndDateUtc'] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data['editionId'] = this.editionId;
        data['isInTrialPeriod'] = this.isInTrialPeriod;
        return data;
    }
}

export interface ITenantListDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
    editionDisplayName: string | undefined;
    connectionString: string | undefined;
    isActive: boolean;
    creationTime: moment.Moment;
    subscriptionEndDateUtc: moment.Moment | undefined;
    editionId: number | undefined;
    isInTrialPeriod: boolean;
}

export class TenantListDtoPagedResultDto implements ITenantListDtoPagedResultDto {
    items: TenantListDto[] | undefined;
    totalCount: number;

    constructor(data?: ITenantListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(TenantListDto.fromJS(item));
            }
            this.totalCount = _data['totalCount'];
        }
    }

    static fromJS(data: any): TenantListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        data['totalCount'] = this.totalCount;
        return data;
    }
}

export interface ITenantListDtoPagedResultDto {
    items: TenantListDto[] | undefined;
    totalCount: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
    lastTheatreImport: moment.Moment | undefined;
    lastPtlImport: moment.Moment | undefined;
    lastPasImport: moment.Moment | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    customCssId: string | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    edition: EditionInfoDto;
    creationTime: moment.Moment;
    paymentPeriodType: PaymentPeriodType;
    subscriptionDateString: string | undefined;
    creationTimeString: string | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.tenancyName = _data['tenancyName'];
            this.name = _data['name'];
            this.lastTheatreImport = _data['lastTheatreImport'] ? moment(_data['lastTheatreImport'].toString()) : <any>undefined;
            this.lastPtlImport = _data['lastPtlImport'] ? moment(_data['lastPtlImport'].toString()) : <any>undefined;
            this.lastPasImport = _data['lastPasImport'] ? moment(_data['lastPasImport'].toString()) : <any>undefined;
            this.logoId = _data['logoId'];
            this.logoFileType = _data['logoFileType'];
            this.customCssId = _data['customCssId'];
            this.subscriptionEndDateUtc = _data['subscriptionEndDateUtc']
                ? moment(_data['subscriptionEndDateUtc'].toString())
                : <any>undefined;
            this.isInTrialPeriod = _data['isInTrialPeriod'];
            this.edition = _data['edition'] ? EditionInfoDto.fromJS(_data['edition']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.paymentPeriodType = _data['paymentPeriodType'];
            this.subscriptionDateString = _data['subscriptionDateString'];
            this.creationTimeString = _data['creationTimeString'];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['tenancyName'] = this.tenancyName;
        data['name'] = this.name;
        data['lastTheatreImport'] = this.lastTheatreImport ? this.lastTheatreImport.toISOString() : <any>undefined;
        data['lastPtlImport'] = this.lastPtlImport ? this.lastPtlImport.toISOString() : <any>undefined;
        data['lastPasImport'] = this.lastPasImport ? this.lastPasImport.toISOString() : <any>undefined;
        data['logoId'] = this.logoId;
        data['logoFileType'] = this.logoFileType;
        data['customCssId'] = this.customCssId;
        data['subscriptionEndDateUtc'] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : <any>undefined;
        data['isInTrialPeriod'] = this.isInTrialPeriod;
        data['edition'] = this.edition ? this.edition.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['paymentPeriodType'] = this.paymentPeriodType;
        data['subscriptionDateString'] = this.subscriptionDateString;
        data['creationTimeString'] = this.creationTimeString;
        return data;
    }
}

export interface ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
    lastTheatreImport: moment.Moment | undefined;
    lastPtlImport: moment.Moment | undefined;
    lastPasImport: moment.Moment | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    customCssId: string | undefined;
    subscriptionEndDateUtc: moment.Moment | undefined;
    isInTrialPeriod: boolean;
    edition: EditionInfoDto;
    creationTime: moment.Moment;
    paymentPeriodType: PaymentPeriodType;
    subscriptionDateString: string | undefined;
    creationTimeString: string | undefined;
}

export class TenantManagementSettingsEditDto implements ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredTenantActiveByDefault: boolean;
    useCaptchaOnRegistration: boolean;
    defaultEditionId: number | undefined;

    constructor(data?: ITenantManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data['allowSelfRegistration'];
            this.isNewRegisteredTenantActiveByDefault = _data['isNewRegisteredTenantActiveByDefault'];
            this.useCaptchaOnRegistration = _data['useCaptchaOnRegistration'];
            this.defaultEditionId = _data['defaultEditionId'];
        }
    }

    static fromJS(data: any): TenantManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['allowSelfRegistration'] = this.allowSelfRegistration;
        data['isNewRegisteredTenantActiveByDefault'] = this.isNewRegisteredTenantActiveByDefault;
        data['useCaptchaOnRegistration'] = this.useCaptchaOnRegistration;
        data['defaultEditionId'] = this.defaultEditionId;
        return data;
    }
}

export interface ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredTenantActiveByDefault: boolean;
    useCaptchaOnRegistration: boolean;
    defaultEditionId: number | undefined;
}

export class TenantNotification implements ITenantNotification {
    id: string;
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData;
    entityType: Type;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: NotificationSeverity;
    creationTime: moment.Moment;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.tenantId = _data['tenantId'];
            this.notificationName = _data['notificationName'];
            this.data = _data['data'] ? NotificationData.fromJS(_data['data']) : <any>undefined;
            this.entityType = _data['entityType'] ? Type.fromJS(_data['entityType']) : <any>undefined;
            this.entityTypeName = _data['entityTypeName'];
            this.entityId = _data['entityId'];
            this.severity = _data['severity'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantNotification {
        data = typeof data === 'object' ? data : {};
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['tenantId'] = this.tenantId;
        data['notificationName'] = this.notificationName;
        data['data'] = this.data ? this.data.toJSON() : <any>undefined;
        data['entityType'] = this.entityType ? this.entityType.toJSON() : <any>undefined;
        data['entityTypeName'] = this.entityTypeName;
        data['entityId'] = this.entityId;
        data['severity'] = this.severity;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITenantNotification {
    id: string;
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData;
    entityType: Type;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: NotificationSeverity;
    creationTime: moment.Moment;
}

export class TenantPathwaySettingsEditDto implements ITenantPathwaySettingsEditDto {
    pathwayId: number;
    id: number;
    name: string | undefined;
    timeSpan: number;
    priority: number;
    timeUnit: TimeUnitTypes;
    thresholdType: ThresholdTypes;
    delete: boolean;

    constructor(data?: ITenantPathwaySettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pathwayId = _data['pathwayId'];
            this.id = _data['id'];
            this.name = _data['name'];
            this.timeSpan = _data['timeSpan'];
            this.priority = _data['priority'];
            this.timeUnit = _data['timeUnit'];
            this.thresholdType = _data['thresholdType'];
            this.delete = _data['delete'];
        }
    }

    static fromJS(data: any): TenantPathwaySettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantPathwaySettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['pathwayId'] = this.pathwayId;
        data['id'] = this.id;
        data['name'] = this.name;
        data['timeSpan'] = this.timeSpan;
        data['priority'] = this.priority;
        data['timeUnit'] = this.timeUnit;
        data['thresholdType'] = this.thresholdType;
        data['delete'] = this.delete;
        return data;
    }
}

export interface ITenantPathwaySettingsEditDto {
    pathwayId: number;
    id: number;
    name: string | undefined;
    timeSpan: number;
    priority: number;
    timeUnit: TimeUnitTypes;
    thresholdType: ThresholdTypes;
    delete: boolean;
}

export class TenantSettingsEditDto implements ITenantSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: TenantUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    ldap: LdapSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: TenantBillingSettingsEditDto;
    smartScheduling: TenantSmartSchedulingSettingsEditDto;
    pathwayPriorities: TenantPathwaySettingsEditDto[] | undefined;
    ptlAdditionalData: MetadataTypeDto[] | undefined;
    specialties: SpecialtyEditDto[] | undefined;

    constructor(data?: ITenantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userManagement = new TenantUserManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data['general'] ? GeneralSettingsEditDto.fromJS(_data['general']) : <any>undefined;
            this.userManagement = _data['userManagement']
                ? TenantUserManagementSettingsEditDto.fromJS(_data['userManagement'])
                : new TenantUserManagementSettingsEditDto();
            this.email = _data['email'] ? EmailSettingsEditDto.fromJS(_data['email']) : <any>undefined;
            this.ldap = _data['ldap'] ? LdapSettingsEditDto.fromJS(_data['ldap']) : <any>undefined;
            this.security = _data['security'] ? SecuritySettingsEditDto.fromJS(_data['security']) : new SecuritySettingsEditDto();
            this.billing = _data['billing'] ? TenantBillingSettingsEditDto.fromJS(_data['billing']) : <any>undefined;
            this.smartScheduling = _data['smartScheduling']
                ? TenantSmartSchedulingSettingsEditDto.fromJS(_data['smartScheduling'])
                : <any>undefined;
            if (Array.isArray(_data['pathwayPriorities'])) {
                this.pathwayPriorities = [] as any;
                for (let item of _data['pathwayPriorities']) this.pathwayPriorities.push(TenantPathwaySettingsEditDto.fromJS(item));
            }
            if (Array.isArray(_data['ptlAdditionalData'])) {
                this.ptlAdditionalData = [] as any;
                for (let item of _data['ptlAdditionalData']) this.ptlAdditionalData.push(MetadataTypeDto.fromJS(item));
            }
            if (Array.isArray(_data['specialties'])) {
                this.specialties = [] as any;
                for (let item of _data['specialties']) this.specialties.push(SpecialtyEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenantSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['general'] = this.general ? this.general.toJSON() : <any>undefined;
        data['userManagement'] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data['email'] = this.email ? this.email.toJSON() : <any>undefined;
        data['ldap'] = this.ldap ? this.ldap.toJSON() : <any>undefined;
        data['security'] = this.security ? this.security.toJSON() : <any>undefined;
        data['billing'] = this.billing ? this.billing.toJSON() : <any>undefined;
        data['smartScheduling'] = this.smartScheduling ? this.smartScheduling.toJSON() : <any>undefined;
        if (Array.isArray(this.pathwayPriorities)) {
            data['pathwayPriorities'] = [];
            for (let item of this.pathwayPriorities) data['pathwayPriorities'].push(item.toJSON());
        }
        if (Array.isArray(this.ptlAdditionalData)) {
            data['ptlAdditionalData'] = [];
            for (let item of this.ptlAdditionalData) data['ptlAdditionalData'].push(item.toJSON());
        }
        if (Array.isArray(this.specialties)) {
            data['specialties'] = [];
            for (let item of this.specialties) data['specialties'].push(item.toJSON());
        }
        return data;
    }
}

export interface ITenantSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: TenantUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    ldap: LdapSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: TenantBillingSettingsEditDto;
    smartScheduling: TenantSmartSchedulingSettingsEditDto;
    pathwayPriorities: TenantPathwaySettingsEditDto[] | undefined;
    ptlAdditionalData: MetadataTypeDto[] | undefined;
    specialties: SpecialtyEditDto[] | undefined;
}

export class TenantSmartSchedulingSettingsEditDto implements ITenantSmartSchedulingSettingsEditDto {
    weeksRange: number;
    overbookLimit: number;

    constructor(data?: ITenantSmartSchedulingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weeksRange = _data['weeksRange'];
            this.overbookLimit = _data['overbookLimit'];
        }
    }

    static fromJS(data: any): TenantSmartSchedulingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSmartSchedulingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['weeksRange'] = this.weeksRange;
        data['overbookLimit'] = this.overbookLimit;
        return data;
    }
}

export interface ITenantSmartSchedulingSettingsEditDto {
    weeksRange: number;
    overbookLimit: number;
}

export class TenantUserManagementSettingsEditDto implements ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredUserActiveByDefault: boolean;
    isEmailConfirmationRequiredForLogin: boolean;
    useCaptchaOnRegistration: boolean;

    constructor(data?: ITenantUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data['allowSelfRegistration'];
            this.isNewRegisteredUserActiveByDefault = _data['isNewRegisteredUserActiveByDefault'];
            this.isEmailConfirmationRequiredForLogin = _data['isEmailConfirmationRequiredForLogin'];
            this.useCaptchaOnRegistration = _data['useCaptchaOnRegistration'];
        }
    }

    static fromJS(data: any): TenantUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['allowSelfRegistration'] = this.allowSelfRegistration;
        data['isNewRegisteredUserActiveByDefault'] = this.isNewRegisteredUserActiveByDefault;
        data['isEmailConfirmationRequiredForLogin'] = this.isEmailConfirmationRequiredForLogin;
        data['useCaptchaOnRegistration'] = this.useCaptchaOnRegistration;
        return data;
    }
}

export interface ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredUserActiveByDefault: boolean;
    isEmailConfirmationRequiredForLogin: boolean;
    useCaptchaOnRegistration: boolean;
}

export class Theatre implements ITheatre {
    id: number;
    theatreCode: string;
    recoveryBay: RecoveryBay;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: ITheatre) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.theatreCode = _data['theatreCode'];
            this.recoveryBay = _data['recoveryBay'] ? RecoveryBay.fromJS(_data['recoveryBay']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): Theatre {
        data = typeof data === 'object' ? data : {};
        let result = new Theatre();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['theatreCode'] = this.theatreCode;
        data['recoveryBay'] = this.recoveryBay ? this.recoveryBay.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface ITheatre {
    id: number;
    theatreCode: string;
    recoveryBay: RecoveryBay;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export enum ThresholdTypes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4
}

export enum TimeUnitTypes {
    _1 = 1,
    _2 = 2
}

export class TrustStructureDto implements ITrustStructureDto {
    constructor(data?: ITrustStructureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {}

    static fromJS(data: any): TrustStructureDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrustStructureDto(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ITrustStructureDto {}

export class TrustStructureItemDto implements ITrustStructureItemDto {
    id: number;
    name: string | undefined;
    title: string | undefined;
    parentIds: number[] | undefined;

    constructor(data?: ITrustStructureItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.title = _data['title'];
            if (Array.isArray(_data['parentIds'])) {
                this.parentIds = [] as any;
                for (let item of _data['parentIds']) this.parentIds.push(item);
            }
        }
    }

    static fromJS(data: any): TrustStructureItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrustStructureItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['title'] = this.title;
        if (Array.isArray(this.parentIds)) {
            data['parentIds'] = [];
            for (let item of this.parentIds) data['parentIds'].push(item);
        }
        return data;
    }
}

export interface ITrustStructureItemDto {
    id: number;
    name: string | undefined;
    title: string | undefined;
    parentIds: number[] | undefined;
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    isEnabled: boolean;
    isEmailProviderEnabled: boolean;
    isSmsProviderEnabled: boolean;
    isRememberBrowserEnabled: boolean;
    isGoogleAuthenticatorEnabled: boolean;
    twoFactorRoles: TwoFactorRolesDto[] | undefined;

    constructor(data?: ITwoFactorLoginSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabledForApplication = _data['isEnabledForApplication'];
            this.isEnabled = _data['isEnabled'];
            this.isEmailProviderEnabled = _data['isEmailProviderEnabled'];
            this.isSmsProviderEnabled = _data['isSmsProviderEnabled'];
            this.isRememberBrowserEnabled = _data['isRememberBrowserEnabled'];
            this.isGoogleAuthenticatorEnabled = _data['isGoogleAuthenticatorEnabled'];
            if (Array.isArray(_data['twoFactorRoles'])) {
                this.twoFactorRoles = [] as any;
                for (let item of _data['twoFactorRoles']) this.twoFactorRoles.push(TwoFactorRolesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TwoFactorLoginSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['isEnabledForApplication'] = this.isEnabledForApplication;
        data['isEnabled'] = this.isEnabled;
        data['isEmailProviderEnabled'] = this.isEmailProviderEnabled;
        data['isSmsProviderEnabled'] = this.isSmsProviderEnabled;
        data['isRememberBrowserEnabled'] = this.isRememberBrowserEnabled;
        data['isGoogleAuthenticatorEnabled'] = this.isGoogleAuthenticatorEnabled;
        if (Array.isArray(this.twoFactorRoles)) {
            data['twoFactorRoles'] = [];
            for (let item of this.twoFactorRoles) data['twoFactorRoles'].push(item.toJSON());
        }
        return data;
    }
}

export interface ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    isEnabled: boolean;
    isEmailProviderEnabled: boolean;
    isSmsProviderEnabled: boolean;
    isRememberBrowserEnabled: boolean;
    isGoogleAuthenticatorEnabled: boolean;
    twoFactorRoles: TwoFactorRolesDto[] | undefined;
}

export class TwoFactorRolesDto implements ITwoFactorRolesDto {
    roleId: number;
    roleName: string | undefined;
    isForced: boolean;

    constructor(data?: ITwoFactorRolesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data['roleId'];
            this.roleName = _data['roleName'];
            this.isForced = _data['isForced'];
        }
    }

    static fromJS(data: any): TwoFactorRolesDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorRolesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['roleId'] = this.roleId;
        data['roleName'] = this.roleName;
        data['isForced'] = this.isForced;
        return data;
    }
}

export interface ITwoFactorRolesDto {
    roleId: number;
    roleName: string | undefined;
    isForced: boolean;
}

export class Type implements IType {
    readonly name: string | undefined;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly isCollectible: boolean;
    readonly metadataToken: number;
    readonly isInterface: boolean;
    memberType: MemberTypes;
    readonly namespace: string | undefined;
    readonly assemblyQualifiedName: string | undefined;
    readonly fullName: string | undefined;
    assembly: Assembly;
    module: Module;
    readonly isNested: boolean;
    declaringType: Type;
    declaringMethod: MethodBase;
    reflectedType: Type;
    underlyingSystemType: Type;
    readonly isTypeDefinition: boolean;
    readonly isArray: boolean;
    readonly isByRef: boolean;
    readonly isPointer: boolean;
    readonly isConstructedGenericType: boolean;
    readonly isGenericParameter: boolean;
    readonly isGenericTypeParameter: boolean;
    readonly isGenericMethodParameter: boolean;
    readonly isGenericType: boolean;
    readonly isGenericTypeDefinition: boolean;
    readonly isSZArray: boolean;
    readonly isVariableBoundArray: boolean;
    readonly isByRefLike: boolean;
    readonly hasElementType: boolean;
    readonly genericTypeArguments: Type[] | undefined;
    readonly genericParameterPosition: number;
    genericParameterAttributes: GenericParameterAttributes;
    attributes: TypeAttributes;
    readonly isAbstract: boolean;
    readonly isImport: boolean;
    readonly isSealed: boolean;
    readonly isSpecialName: boolean;
    readonly isClass: boolean;
    readonly isNestedAssembly: boolean;
    readonly isNestedFamANDAssem: boolean;
    readonly isNestedFamily: boolean;
    readonly isNestedFamORAssem: boolean;
    readonly isNestedPrivate: boolean;
    readonly isNestedPublic: boolean;
    readonly isNotPublic: boolean;
    readonly isPublic: boolean;
    readonly isAutoLayout: boolean;
    readonly isExplicitLayout: boolean;
    readonly isLayoutSequential: boolean;
    readonly isAnsiClass: boolean;
    readonly isAutoClass: boolean;
    readonly isUnicodeClass: boolean;
    readonly isCOMObject: boolean;
    readonly isContextful: boolean;
    readonly isEnum: boolean;
    readonly isMarshalByRef: boolean;
    readonly isPrimitive: boolean;
    readonly isValueType: boolean;
    readonly isSignatureType: boolean;
    readonly isSecurityCritical: boolean;
    readonly isSecuritySafeCritical: boolean;
    readonly isSecurityTransparent: boolean;
    structLayoutAttribute: StructLayoutAttribute;
    typeInitializer: ConstructorInfo;
    typeHandle: RuntimeTypeHandle;
    readonly guid: string;
    baseType: Type;
    readonly isSerializable: boolean;
    readonly containsGenericParameters: boolean;
    readonly isVisible: boolean;

    constructor(data?: IType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data['name'];
            if (Array.isArray(_data['customAttributes'])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data['customAttributes']) (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data['isCollectible'];
            (<any>this).metadataToken = _data['metadataToken'];
            (<any>this).isInterface = _data['isInterface'];
            this.memberType = _data['memberType'];
            (<any>this).namespace = _data['namespace'];
            (<any>this).assemblyQualifiedName = _data['assemblyQualifiedName'];
            (<any>this).fullName = _data['fullName'];
            this.assembly = _data['assembly'] ? Assembly.fromJS(_data['assembly']) : <any>undefined;
            this.module = _data['module'] ? Module.fromJS(_data['module']) : <any>undefined;
            (<any>this).isNested = _data['isNested'];
            this.declaringType = _data['declaringType'] ? Type.fromJS(_data['declaringType']) : <any>undefined;
            this.declaringMethod = _data['declaringMethod'] ? MethodBase.fromJS(_data['declaringMethod']) : <any>undefined;
            this.reflectedType = _data['reflectedType'] ? Type.fromJS(_data['reflectedType']) : <any>undefined;
            this.underlyingSystemType = _data['underlyingSystemType'] ? Type.fromJS(_data['underlyingSystemType']) : <any>undefined;
            (<any>this).isTypeDefinition = _data['isTypeDefinition'];
            (<any>this).isArray = _data['isArray'];
            (<any>this).isByRef = _data['isByRef'];
            (<any>this).isPointer = _data['isPointer'];
            (<any>this).isConstructedGenericType = _data['isConstructedGenericType'];
            (<any>this).isGenericParameter = _data['isGenericParameter'];
            (<any>this).isGenericTypeParameter = _data['isGenericTypeParameter'];
            (<any>this).isGenericMethodParameter = _data['isGenericMethodParameter'];
            (<any>this).isGenericType = _data['isGenericType'];
            (<any>this).isGenericTypeDefinition = _data['isGenericTypeDefinition'];
            (<any>this).isSZArray = _data['isSZArray'];
            (<any>this).isVariableBoundArray = _data['isVariableBoundArray'];
            (<any>this).isByRefLike = _data['isByRefLike'];
            (<any>this).hasElementType = _data['hasElementType'];
            if (Array.isArray(_data['genericTypeArguments'])) {
                (<any>this).genericTypeArguments = [] as any;
                for (let item of _data['genericTypeArguments']) (<any>this).genericTypeArguments.push(Type.fromJS(item));
            }
            (<any>this).genericParameterPosition = _data['genericParameterPosition'];
            this.genericParameterAttributes = _data['genericParameterAttributes'];
            this.attributes = _data['attributes'];
            (<any>this).isAbstract = _data['isAbstract'];
            (<any>this).isImport = _data['isImport'];
            (<any>this).isSealed = _data['isSealed'];
            (<any>this).isSpecialName = _data['isSpecialName'];
            (<any>this).isClass = _data['isClass'];
            (<any>this).isNestedAssembly = _data['isNestedAssembly'];
            (<any>this).isNestedFamANDAssem = _data['isNestedFamANDAssem'];
            (<any>this).isNestedFamily = _data['isNestedFamily'];
            (<any>this).isNestedFamORAssem = _data['isNestedFamORAssem'];
            (<any>this).isNestedPrivate = _data['isNestedPrivate'];
            (<any>this).isNestedPublic = _data['isNestedPublic'];
            (<any>this).isNotPublic = _data['isNotPublic'];
            (<any>this).isPublic = _data['isPublic'];
            (<any>this).isAutoLayout = _data['isAutoLayout'];
            (<any>this).isExplicitLayout = _data['isExplicitLayout'];
            (<any>this).isLayoutSequential = _data['isLayoutSequential'];
            (<any>this).isAnsiClass = _data['isAnsiClass'];
            (<any>this).isAutoClass = _data['isAutoClass'];
            (<any>this).isUnicodeClass = _data['isUnicodeClass'];
            (<any>this).isCOMObject = _data['isCOMObject'];
            (<any>this).isContextful = _data['isContextful'];
            (<any>this).isEnum = _data['isEnum'];
            (<any>this).isMarshalByRef = _data['isMarshalByRef'];
            (<any>this).isPrimitive = _data['isPrimitive'];
            (<any>this).isValueType = _data['isValueType'];
            (<any>this).isSignatureType = _data['isSignatureType'];
            (<any>this).isSecurityCritical = _data['isSecurityCritical'];
            (<any>this).isSecuritySafeCritical = _data['isSecuritySafeCritical'];
            (<any>this).isSecurityTransparent = _data['isSecurityTransparent'];
            this.structLayoutAttribute = _data['structLayoutAttribute']
                ? StructLayoutAttribute.fromJS(_data['structLayoutAttribute'])
                : <any>undefined;
            this.typeInitializer = _data['typeInitializer'] ? ConstructorInfo.fromJS(_data['typeInitializer']) : <any>undefined;
            this.typeHandle = _data['typeHandle'] ? RuntimeTypeHandle.fromJS(_data['typeHandle']) : <any>undefined;
            (<any>this).guid = _data['guid'];
            this.baseType = _data['baseType'] ? Type.fromJS(_data['baseType']) : <any>undefined;
            (<any>this).isSerializable = _data['isSerializable'];
            (<any>this).containsGenericParameters = _data['containsGenericParameters'];
            (<any>this).isVisible = _data['isVisible'];
        }
    }

    static fromJS(data: any): Type {
        data = typeof data === 'object' ? data : {};
        let result = new Type();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        if (Array.isArray(this.customAttributes)) {
            data['customAttributes'] = [];
            for (let item of this.customAttributes) data['customAttributes'].push(item.toJSON());
        }
        data['isCollectible'] = this.isCollectible;
        data['metadataToken'] = this.metadataToken;
        data['isInterface'] = this.isInterface;
        data['memberType'] = this.memberType;
        data['namespace'] = this.namespace;
        data['assemblyQualifiedName'] = this.assemblyQualifiedName;
        data['fullName'] = this.fullName;
        data['assembly'] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data['module'] = this.module ? this.module.toJSON() : <any>undefined;
        data['isNested'] = this.isNested;
        data['declaringType'] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data['declaringMethod'] = this.declaringMethod ? this.declaringMethod.toJSON() : <any>undefined;
        data['reflectedType'] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data['underlyingSystemType'] = this.underlyingSystemType ? this.underlyingSystemType.toJSON() : <any>undefined;
        data['isTypeDefinition'] = this.isTypeDefinition;
        data['isArray'] = this.isArray;
        data['isByRef'] = this.isByRef;
        data['isPointer'] = this.isPointer;
        data['isConstructedGenericType'] = this.isConstructedGenericType;
        data['isGenericParameter'] = this.isGenericParameter;
        data['isGenericTypeParameter'] = this.isGenericTypeParameter;
        data['isGenericMethodParameter'] = this.isGenericMethodParameter;
        data['isGenericType'] = this.isGenericType;
        data['isGenericTypeDefinition'] = this.isGenericTypeDefinition;
        data['isSZArray'] = this.isSZArray;
        data['isVariableBoundArray'] = this.isVariableBoundArray;
        data['isByRefLike'] = this.isByRefLike;
        data['hasElementType'] = this.hasElementType;
        if (Array.isArray(this.genericTypeArguments)) {
            data['genericTypeArguments'] = [];
            for (let item of this.genericTypeArguments) data['genericTypeArguments'].push(item.toJSON());
        }
        data['genericParameterPosition'] = this.genericParameterPosition;
        data['genericParameterAttributes'] = this.genericParameterAttributes;
        data['attributes'] = this.attributes;
        data['isAbstract'] = this.isAbstract;
        data['isImport'] = this.isImport;
        data['isSealed'] = this.isSealed;
        data['isSpecialName'] = this.isSpecialName;
        data['isClass'] = this.isClass;
        data['isNestedAssembly'] = this.isNestedAssembly;
        data['isNestedFamANDAssem'] = this.isNestedFamANDAssem;
        data['isNestedFamily'] = this.isNestedFamily;
        data['isNestedFamORAssem'] = this.isNestedFamORAssem;
        data['isNestedPrivate'] = this.isNestedPrivate;
        data['isNestedPublic'] = this.isNestedPublic;
        data['isNotPublic'] = this.isNotPublic;
        data['isPublic'] = this.isPublic;
        data['isAutoLayout'] = this.isAutoLayout;
        data['isExplicitLayout'] = this.isExplicitLayout;
        data['isLayoutSequential'] = this.isLayoutSequential;
        data['isAnsiClass'] = this.isAnsiClass;
        data['isAutoClass'] = this.isAutoClass;
        data['isUnicodeClass'] = this.isUnicodeClass;
        data['isCOMObject'] = this.isCOMObject;
        data['isContextful'] = this.isContextful;
        data['isEnum'] = this.isEnum;
        data['isMarshalByRef'] = this.isMarshalByRef;
        data['isPrimitive'] = this.isPrimitive;
        data['isValueType'] = this.isValueType;
        data['isSignatureType'] = this.isSignatureType;
        data['isSecurityCritical'] = this.isSecurityCritical;
        data['isSecuritySafeCritical'] = this.isSecuritySafeCritical;
        data['isSecurityTransparent'] = this.isSecurityTransparent;
        data['structLayoutAttribute'] = this.structLayoutAttribute ? this.structLayoutAttribute.toJSON() : <any>undefined;
        data['typeInitializer'] = this.typeInitializer ? this.typeInitializer.toJSON() : <any>undefined;
        data['typeHandle'] = this.typeHandle ? this.typeHandle.toJSON() : <any>undefined;
        data['guid'] = this.guid;
        data['baseType'] = this.baseType ? this.baseType.toJSON() : <any>undefined;
        data['isSerializable'] = this.isSerializable;
        data['containsGenericParameters'] = this.containsGenericParameters;
        data['isVisible'] = this.isVisible;
        return data;
    }
}

export interface IType {
    name: string | undefined;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    isInterface: boolean;
    memberType: MemberTypes;
    namespace: string | undefined;
    assemblyQualifiedName: string | undefined;
    fullName: string | undefined;
    assembly: Assembly;
    module: Module;
    isNested: boolean;
    declaringType: Type;
    declaringMethod: MethodBase;
    reflectedType: Type;
    underlyingSystemType: Type;
    isTypeDefinition: boolean;
    isArray: boolean;
    isByRef: boolean;
    isPointer: boolean;
    isConstructedGenericType: boolean;
    isGenericParameter: boolean;
    isGenericTypeParameter: boolean;
    isGenericMethodParameter: boolean;
    isGenericType: boolean;
    isGenericTypeDefinition: boolean;
    isSZArray: boolean;
    isVariableBoundArray: boolean;
    isByRefLike: boolean;
    hasElementType: boolean;
    genericTypeArguments: Type[] | undefined;
    genericParameterPosition: number;
    genericParameterAttributes: GenericParameterAttributes;
    attributes: TypeAttributes;
    isAbstract: boolean;
    isImport: boolean;
    isSealed: boolean;
    isSpecialName: boolean;
    isClass: boolean;
    isNestedAssembly: boolean;
    isNestedFamANDAssem: boolean;
    isNestedFamily: boolean;
    isNestedFamORAssem: boolean;
    isNestedPrivate: boolean;
    isNestedPublic: boolean;
    isNotPublic: boolean;
    isPublic: boolean;
    isAutoLayout: boolean;
    isExplicitLayout: boolean;
    isLayoutSequential: boolean;
    isAnsiClass: boolean;
    isAutoClass: boolean;
    isUnicodeClass: boolean;
    isCOMObject: boolean;
    isContextful: boolean;
    isEnum: boolean;
    isMarshalByRef: boolean;
    isPrimitive: boolean;
    isValueType: boolean;
    isSignatureType: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    structLayoutAttribute: StructLayoutAttribute;
    typeInitializer: ConstructorInfo;
    typeHandle: RuntimeTypeHandle;
    guid: string;
    baseType: Type;
    isSerializable: boolean;
    containsGenericParameters: boolean;
    isVisible: boolean;
}

export enum TypeAttributes {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
    _8 = 8,
    _16 = 16,
    _24 = 24,
    _32 = 32,
    _128 = 128,
    _256 = 256,
    _1024 = 1024,
    _2048 = 2048,
    _4096 = 4096,
    _8192 = 8192,
    _16384 = 16384,
    _65536 = 65536,
    _131072 = 131072,
    _196608 = 196608,
    _262144 = 262144,
    _264192 = 264192,
    _1048576 = 1048576,
    _12582912 = 12582912
}

export class TypeInfo implements ITypeInfo {
    readonly name: string | undefined;
    readonly customAttributes: CustomAttributeData[] | undefined;
    readonly isCollectible: boolean;
    readonly metadataToken: number;
    readonly isInterface: boolean;
    memberType: MemberTypes;
    readonly namespace: string | undefined;
    readonly assemblyQualifiedName: string | undefined;
    readonly fullName: string | undefined;
    assembly: Assembly;
    module: Module;
    readonly isNested: boolean;
    declaringType: Type;
    declaringMethod: MethodBase;
    reflectedType: Type;
    underlyingSystemType: Type;
    readonly isTypeDefinition: boolean;
    readonly isArray: boolean;
    readonly isByRef: boolean;
    readonly isPointer: boolean;
    readonly isConstructedGenericType: boolean;
    readonly isGenericParameter: boolean;
    readonly isGenericTypeParameter: boolean;
    readonly isGenericMethodParameter: boolean;
    readonly isGenericType: boolean;
    readonly isGenericTypeDefinition: boolean;
    readonly isSZArray: boolean;
    readonly isVariableBoundArray: boolean;
    readonly isByRefLike: boolean;
    readonly hasElementType: boolean;
    readonly genericTypeArguments: Type[] | undefined;
    readonly genericParameterPosition: number;
    genericParameterAttributes: GenericParameterAttributes;
    attributes: TypeAttributes;
    readonly isAbstract: boolean;
    readonly isImport: boolean;
    readonly isSealed: boolean;
    readonly isSpecialName: boolean;
    readonly isClass: boolean;
    readonly isNestedAssembly: boolean;
    readonly isNestedFamANDAssem: boolean;
    readonly isNestedFamily: boolean;
    readonly isNestedFamORAssem: boolean;
    readonly isNestedPrivate: boolean;
    readonly isNestedPublic: boolean;
    readonly isNotPublic: boolean;
    readonly isPublic: boolean;
    readonly isAutoLayout: boolean;
    readonly isExplicitLayout: boolean;
    readonly isLayoutSequential: boolean;
    readonly isAnsiClass: boolean;
    readonly isAutoClass: boolean;
    readonly isUnicodeClass: boolean;
    readonly isCOMObject: boolean;
    readonly isContextful: boolean;
    readonly isEnum: boolean;
    readonly isMarshalByRef: boolean;
    readonly isPrimitive: boolean;
    readonly isValueType: boolean;
    readonly isSignatureType: boolean;
    readonly isSecurityCritical: boolean;
    readonly isSecuritySafeCritical: boolean;
    readonly isSecurityTransparent: boolean;
    structLayoutAttribute: StructLayoutAttribute;
    typeInitializer: ConstructorInfo;
    typeHandle: RuntimeTypeHandle;
    readonly guid: string;
    baseType: Type;
    readonly isSerializable: boolean;
    readonly containsGenericParameters: boolean;
    readonly isVisible: boolean;
    readonly genericTypeParameters: Type[] | undefined;
    readonly declaredConstructors: ConstructorInfo[] | undefined;
    readonly declaredEvents: EventInfo[] | undefined;
    readonly declaredFields: FieldInfo[] | undefined;
    readonly declaredMembers: MemberInfo[] | undefined;
    readonly declaredMethods: MethodInfo[] | undefined;
    readonly declaredNestedTypes: TypeInfo[] | undefined;
    readonly declaredProperties: PropertyInfo[] | undefined;
    readonly implementedInterfaces: Type[] | undefined;

    constructor(data?: ITypeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data['name'];
            if (Array.isArray(_data['customAttributes'])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data['customAttributes']) (<any>this).customAttributes.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data['isCollectible'];
            (<any>this).metadataToken = _data['metadataToken'];
            (<any>this).isInterface = _data['isInterface'];
            this.memberType = _data['memberType'];
            (<any>this).namespace = _data['namespace'];
            (<any>this).assemblyQualifiedName = _data['assemblyQualifiedName'];
            (<any>this).fullName = _data['fullName'];
            this.assembly = _data['assembly'] ? Assembly.fromJS(_data['assembly']) : <any>undefined;
            this.module = _data['module'] ? Module.fromJS(_data['module']) : <any>undefined;
            (<any>this).isNested = _data['isNested'];
            this.declaringType = _data['declaringType'] ? Type.fromJS(_data['declaringType']) : <any>undefined;
            this.declaringMethod = _data['declaringMethod'] ? MethodBase.fromJS(_data['declaringMethod']) : <any>undefined;
            this.reflectedType = _data['reflectedType'] ? Type.fromJS(_data['reflectedType']) : <any>undefined;
            this.underlyingSystemType = _data['underlyingSystemType'] ? Type.fromJS(_data['underlyingSystemType']) : <any>undefined;
            (<any>this).isTypeDefinition = _data['isTypeDefinition'];
            (<any>this).isArray = _data['isArray'];
            (<any>this).isByRef = _data['isByRef'];
            (<any>this).isPointer = _data['isPointer'];
            (<any>this).isConstructedGenericType = _data['isConstructedGenericType'];
            (<any>this).isGenericParameter = _data['isGenericParameter'];
            (<any>this).isGenericTypeParameter = _data['isGenericTypeParameter'];
            (<any>this).isGenericMethodParameter = _data['isGenericMethodParameter'];
            (<any>this).isGenericType = _data['isGenericType'];
            (<any>this).isGenericTypeDefinition = _data['isGenericTypeDefinition'];
            (<any>this).isSZArray = _data['isSZArray'];
            (<any>this).isVariableBoundArray = _data['isVariableBoundArray'];
            (<any>this).isByRefLike = _data['isByRefLike'];
            (<any>this).hasElementType = _data['hasElementType'];
            if (Array.isArray(_data['genericTypeArguments'])) {
                (<any>this).genericTypeArguments = [] as any;
                for (let item of _data['genericTypeArguments']) (<any>this).genericTypeArguments.push(Type.fromJS(item));
            }
            (<any>this).genericParameterPosition = _data['genericParameterPosition'];
            this.genericParameterAttributes = _data['genericParameterAttributes'];
            this.attributes = _data['attributes'];
            (<any>this).isAbstract = _data['isAbstract'];
            (<any>this).isImport = _data['isImport'];
            (<any>this).isSealed = _data['isSealed'];
            (<any>this).isSpecialName = _data['isSpecialName'];
            (<any>this).isClass = _data['isClass'];
            (<any>this).isNestedAssembly = _data['isNestedAssembly'];
            (<any>this).isNestedFamANDAssem = _data['isNestedFamANDAssem'];
            (<any>this).isNestedFamily = _data['isNestedFamily'];
            (<any>this).isNestedFamORAssem = _data['isNestedFamORAssem'];
            (<any>this).isNestedPrivate = _data['isNestedPrivate'];
            (<any>this).isNestedPublic = _data['isNestedPublic'];
            (<any>this).isNotPublic = _data['isNotPublic'];
            (<any>this).isPublic = _data['isPublic'];
            (<any>this).isAutoLayout = _data['isAutoLayout'];
            (<any>this).isExplicitLayout = _data['isExplicitLayout'];
            (<any>this).isLayoutSequential = _data['isLayoutSequential'];
            (<any>this).isAnsiClass = _data['isAnsiClass'];
            (<any>this).isAutoClass = _data['isAutoClass'];
            (<any>this).isUnicodeClass = _data['isUnicodeClass'];
            (<any>this).isCOMObject = _data['isCOMObject'];
            (<any>this).isContextful = _data['isContextful'];
            (<any>this).isEnum = _data['isEnum'];
            (<any>this).isMarshalByRef = _data['isMarshalByRef'];
            (<any>this).isPrimitive = _data['isPrimitive'];
            (<any>this).isValueType = _data['isValueType'];
            (<any>this).isSignatureType = _data['isSignatureType'];
            (<any>this).isSecurityCritical = _data['isSecurityCritical'];
            (<any>this).isSecuritySafeCritical = _data['isSecuritySafeCritical'];
            (<any>this).isSecurityTransparent = _data['isSecurityTransparent'];
            this.structLayoutAttribute = _data['structLayoutAttribute']
                ? StructLayoutAttribute.fromJS(_data['structLayoutAttribute'])
                : <any>undefined;
            this.typeInitializer = _data['typeInitializer'] ? ConstructorInfo.fromJS(_data['typeInitializer']) : <any>undefined;
            this.typeHandle = _data['typeHandle'] ? RuntimeTypeHandle.fromJS(_data['typeHandle']) : <any>undefined;
            (<any>this).guid = _data['guid'];
            this.baseType = _data['baseType'] ? Type.fromJS(_data['baseType']) : <any>undefined;
            (<any>this).isSerializable = _data['isSerializable'];
            (<any>this).containsGenericParameters = _data['containsGenericParameters'];
            (<any>this).isVisible = _data['isVisible'];
            if (Array.isArray(_data['genericTypeParameters'])) {
                (<any>this).genericTypeParameters = [] as any;
                for (let item of _data['genericTypeParameters']) (<any>this).genericTypeParameters.push(Type.fromJS(item));
            }
            if (Array.isArray(_data['declaredConstructors'])) {
                (<any>this).declaredConstructors = [] as any;
                for (let item of _data['declaredConstructors']) (<any>this).declaredConstructors.push(ConstructorInfo.fromJS(item));
            }
            if (Array.isArray(_data['declaredEvents'])) {
                (<any>this).declaredEvents = [] as any;
                for (let item of _data['declaredEvents']) (<any>this).declaredEvents.push(EventInfo.fromJS(item));
            }
            if (Array.isArray(_data['declaredFields'])) {
                (<any>this).declaredFields = [] as any;
                for (let item of _data['declaredFields']) (<any>this).declaredFields.push(FieldInfo.fromJS(item));
            }
            if (Array.isArray(_data['declaredMembers'])) {
                (<any>this).declaredMembers = [] as any;
                for (let item of _data['declaredMembers']) (<any>this).declaredMembers.push(MemberInfo.fromJS(item));
            }
            if (Array.isArray(_data['declaredMethods'])) {
                (<any>this).declaredMethods = [] as any;
                for (let item of _data['declaredMethods']) (<any>this).declaredMethods.push(MethodInfo.fromJS(item));
            }
            if (Array.isArray(_data['declaredNestedTypes'])) {
                (<any>this).declaredNestedTypes = [] as any;
                for (let item of _data['declaredNestedTypes']) (<any>this).declaredNestedTypes.push(TypeInfo.fromJS(item));
            }
            if (Array.isArray(_data['declaredProperties'])) {
                (<any>this).declaredProperties = [] as any;
                for (let item of _data['declaredProperties']) (<any>this).declaredProperties.push(PropertyInfo.fromJS(item));
            }
            if (Array.isArray(_data['implementedInterfaces'])) {
                (<any>this).implementedInterfaces = [] as any;
                for (let item of _data['implementedInterfaces']) (<any>this).implementedInterfaces.push(Type.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TypeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TypeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['name'] = this.name;
        if (Array.isArray(this.customAttributes)) {
            data['customAttributes'] = [];
            for (let item of this.customAttributes) data['customAttributes'].push(item.toJSON());
        }
        data['isCollectible'] = this.isCollectible;
        data['metadataToken'] = this.metadataToken;
        data['isInterface'] = this.isInterface;
        data['memberType'] = this.memberType;
        data['namespace'] = this.namespace;
        data['assemblyQualifiedName'] = this.assemblyQualifiedName;
        data['fullName'] = this.fullName;
        data['assembly'] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data['module'] = this.module ? this.module.toJSON() : <any>undefined;
        data['isNested'] = this.isNested;
        data['declaringType'] = this.declaringType ? this.declaringType.toJSON() : <any>undefined;
        data['declaringMethod'] = this.declaringMethod ? this.declaringMethod.toJSON() : <any>undefined;
        data['reflectedType'] = this.reflectedType ? this.reflectedType.toJSON() : <any>undefined;
        data['underlyingSystemType'] = this.underlyingSystemType ? this.underlyingSystemType.toJSON() : <any>undefined;
        data['isTypeDefinition'] = this.isTypeDefinition;
        data['isArray'] = this.isArray;
        data['isByRef'] = this.isByRef;
        data['isPointer'] = this.isPointer;
        data['isConstructedGenericType'] = this.isConstructedGenericType;
        data['isGenericParameter'] = this.isGenericParameter;
        data['isGenericTypeParameter'] = this.isGenericTypeParameter;
        data['isGenericMethodParameter'] = this.isGenericMethodParameter;
        data['isGenericType'] = this.isGenericType;
        data['isGenericTypeDefinition'] = this.isGenericTypeDefinition;
        data['isSZArray'] = this.isSZArray;
        data['isVariableBoundArray'] = this.isVariableBoundArray;
        data['isByRefLike'] = this.isByRefLike;
        data['hasElementType'] = this.hasElementType;
        if (Array.isArray(this.genericTypeArguments)) {
            data['genericTypeArguments'] = [];
            for (let item of this.genericTypeArguments) data['genericTypeArguments'].push(item.toJSON());
        }
        data['genericParameterPosition'] = this.genericParameterPosition;
        data['genericParameterAttributes'] = this.genericParameterAttributes;
        data['attributes'] = this.attributes;
        data['isAbstract'] = this.isAbstract;
        data['isImport'] = this.isImport;
        data['isSealed'] = this.isSealed;
        data['isSpecialName'] = this.isSpecialName;
        data['isClass'] = this.isClass;
        data['isNestedAssembly'] = this.isNestedAssembly;
        data['isNestedFamANDAssem'] = this.isNestedFamANDAssem;
        data['isNestedFamily'] = this.isNestedFamily;
        data['isNestedFamORAssem'] = this.isNestedFamORAssem;
        data['isNestedPrivate'] = this.isNestedPrivate;
        data['isNestedPublic'] = this.isNestedPublic;
        data['isNotPublic'] = this.isNotPublic;
        data['isPublic'] = this.isPublic;
        data['isAutoLayout'] = this.isAutoLayout;
        data['isExplicitLayout'] = this.isExplicitLayout;
        data['isLayoutSequential'] = this.isLayoutSequential;
        data['isAnsiClass'] = this.isAnsiClass;
        data['isAutoClass'] = this.isAutoClass;
        data['isUnicodeClass'] = this.isUnicodeClass;
        data['isCOMObject'] = this.isCOMObject;
        data['isContextful'] = this.isContextful;
        data['isEnum'] = this.isEnum;
        data['isMarshalByRef'] = this.isMarshalByRef;
        data['isPrimitive'] = this.isPrimitive;
        data['isValueType'] = this.isValueType;
        data['isSignatureType'] = this.isSignatureType;
        data['isSecurityCritical'] = this.isSecurityCritical;
        data['isSecuritySafeCritical'] = this.isSecuritySafeCritical;
        data['isSecurityTransparent'] = this.isSecurityTransparent;
        data['structLayoutAttribute'] = this.structLayoutAttribute ? this.structLayoutAttribute.toJSON() : <any>undefined;
        data['typeInitializer'] = this.typeInitializer ? this.typeInitializer.toJSON() : <any>undefined;
        data['typeHandle'] = this.typeHandle ? this.typeHandle.toJSON() : <any>undefined;
        data['guid'] = this.guid;
        data['baseType'] = this.baseType ? this.baseType.toJSON() : <any>undefined;
        data['isSerializable'] = this.isSerializable;
        data['containsGenericParameters'] = this.containsGenericParameters;
        data['isVisible'] = this.isVisible;
        if (Array.isArray(this.genericTypeParameters)) {
            data['genericTypeParameters'] = [];
            for (let item of this.genericTypeParameters) data['genericTypeParameters'].push(item.toJSON());
        }
        if (Array.isArray(this.declaredConstructors)) {
            data['declaredConstructors'] = [];
            for (let item of this.declaredConstructors) data['declaredConstructors'].push(item.toJSON());
        }
        if (Array.isArray(this.declaredEvents)) {
            data['declaredEvents'] = [];
            for (let item of this.declaredEvents) data['declaredEvents'].push(item.toJSON());
        }
        if (Array.isArray(this.declaredFields)) {
            data['declaredFields'] = [];
            for (let item of this.declaredFields) data['declaredFields'].push(item.toJSON());
        }
        if (Array.isArray(this.declaredMembers)) {
            data['declaredMembers'] = [];
            for (let item of this.declaredMembers) data['declaredMembers'].push(item.toJSON());
        }
        if (Array.isArray(this.declaredMethods)) {
            data['declaredMethods'] = [];
            for (let item of this.declaredMethods) data['declaredMethods'].push(item.toJSON());
        }
        if (Array.isArray(this.declaredNestedTypes)) {
            data['declaredNestedTypes'] = [];
            for (let item of this.declaredNestedTypes) data['declaredNestedTypes'].push(item.toJSON());
        }
        if (Array.isArray(this.declaredProperties)) {
            data['declaredProperties'] = [];
            for (let item of this.declaredProperties) data['declaredProperties'].push(item.toJSON());
        }
        if (Array.isArray(this.implementedInterfaces)) {
            data['implementedInterfaces'] = [];
            for (let item of this.implementedInterfaces) data['implementedInterfaces'].push(item.toJSON());
        }
        return data;
    }
}

export interface ITypeInfo {
    name: string | undefined;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
    isInterface: boolean;
    memberType: MemberTypes;
    namespace: string | undefined;
    assemblyQualifiedName: string | undefined;
    fullName: string | undefined;
    assembly: Assembly;
    module: Module;
    isNested: boolean;
    declaringType: Type;
    declaringMethod: MethodBase;
    reflectedType: Type;
    underlyingSystemType: Type;
    isTypeDefinition: boolean;
    isArray: boolean;
    isByRef: boolean;
    isPointer: boolean;
    isConstructedGenericType: boolean;
    isGenericParameter: boolean;
    isGenericTypeParameter: boolean;
    isGenericMethodParameter: boolean;
    isGenericType: boolean;
    isGenericTypeDefinition: boolean;
    isSZArray: boolean;
    isVariableBoundArray: boolean;
    isByRefLike: boolean;
    hasElementType: boolean;
    genericTypeArguments: Type[] | undefined;
    genericParameterPosition: number;
    genericParameterAttributes: GenericParameterAttributes;
    attributes: TypeAttributes;
    isAbstract: boolean;
    isImport: boolean;
    isSealed: boolean;
    isSpecialName: boolean;
    isClass: boolean;
    isNestedAssembly: boolean;
    isNestedFamANDAssem: boolean;
    isNestedFamily: boolean;
    isNestedFamORAssem: boolean;
    isNestedPrivate: boolean;
    isNestedPublic: boolean;
    isNotPublic: boolean;
    isPublic: boolean;
    isAutoLayout: boolean;
    isExplicitLayout: boolean;
    isLayoutSequential: boolean;
    isAnsiClass: boolean;
    isAutoClass: boolean;
    isUnicodeClass: boolean;
    isCOMObject: boolean;
    isContextful: boolean;
    isEnum: boolean;
    isMarshalByRef: boolean;
    isPrimitive: boolean;
    isValueType: boolean;
    isSignatureType: boolean;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    structLayoutAttribute: StructLayoutAttribute;
    typeInitializer: ConstructorInfo;
    typeHandle: RuntimeTypeHandle;
    guid: string;
    baseType: Type;
    isSerializable: boolean;
    containsGenericParameters: boolean;
    isVisible: boolean;
    genericTypeParameters: Type[] | undefined;
    declaredConstructors: ConstructorInfo[] | undefined;
    declaredEvents: EventInfo[] | undefined;
    declaredFields: FieldInfo[] | undefined;
    declaredMembers: MemberInfo[] | undefined;
    declaredMethods: MethodInfo[] | undefined;
    declaredNestedTypes: TypeInfo[] | undefined;
    declaredProperties: PropertyInfo[] | undefined;
    implementedInterfaces: Type[] | undefined;
}

export class UiCustomizationFooterSettingsEditDto implements IUiCustomizationFooterSettingsEditDto {
    fixedFooter: boolean;

    constructor(data?: IUiCustomizationFooterSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedFooter = _data['fixedFooter'];
        }
    }

    static fromJS(data: any): UiCustomizationFooterSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationFooterSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['fixedFooter'] = this.fixedFooter;
        return data;
    }
}

export interface IUiCustomizationFooterSettingsEditDto {
    fixedFooter: boolean;
}

export class UiCustomizationHeaderSettingsEditDto implements IUiCustomizationHeaderSettingsEditDto {
    desktopFixedHeader: boolean;
    desktopMinimizeMode: string | undefined;
    mobileFixedHeader: boolean;
    dropdownSkinDesktop: string | undefined;
    displaySubmenuArrowDesktop: boolean;
    dropdownSkin: string | undefined;

    constructor(data?: IUiCustomizationHeaderSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.desktopFixedHeader = _data['desktopFixedHeader'];
            this.desktopMinimizeMode = _data['desktopMinimizeMode'];
            this.mobileFixedHeader = _data['mobileFixedHeader'];
            this.dropdownSkinDesktop = _data['dropdownSkinDesktop'];
            this.displaySubmenuArrowDesktop = _data['displaySubmenuArrowDesktop'];
            this.dropdownSkin = _data['dropdownSkin'];
        }
    }

    static fromJS(data: any): UiCustomizationHeaderSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationHeaderSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['desktopFixedHeader'] = this.desktopFixedHeader;
        data['desktopMinimizeMode'] = this.desktopMinimizeMode;
        data['mobileFixedHeader'] = this.mobileFixedHeader;
        data['dropdownSkinDesktop'] = this.dropdownSkinDesktop;
        data['displaySubmenuArrowDesktop'] = this.displaySubmenuArrowDesktop;
        data['dropdownSkin'] = this.dropdownSkin;
        return data;
    }
}

export interface IUiCustomizationHeaderSettingsEditDto {
    desktopFixedHeader: boolean;
    desktopMinimizeMode: string | undefined;
    mobileFixedHeader: boolean;
    dropdownSkinDesktop: string | undefined;
    displaySubmenuArrowDesktop: boolean;
    dropdownSkin: string | undefined;
}

export class UiCustomizationLayoutSettingsEditDto implements IUiCustomizationLayoutSettingsEditDto {
    layoutType: string | undefined;
    contentSkin: string | undefined;

    constructor(data?: IUiCustomizationLayoutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layoutType = _data['layoutType'];
            this.contentSkin = _data['contentSkin'];
        }
    }

    static fromJS(data: any): UiCustomizationLayoutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationLayoutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['layoutType'] = this.layoutType;
        data['contentSkin'] = this.contentSkin;
        return data;
    }
}

export interface IUiCustomizationLayoutSettingsEditDto {
    layoutType: string | undefined;
    contentSkin: string | undefined;
}

export class UiCustomizationMenuSettingsEditDto implements IUiCustomizationMenuSettingsEditDto {
    position: string | undefined;
    asideSkin: string | undefined;
    fixedAside: boolean;
    allowAsideMinimizing: boolean;
    defaultMinimizedAside: boolean;
    allowAsideHiding: boolean;
    defaultHiddenAside: boolean;
    submenuToggle: string | undefined;
    dropdownSubmenuSkin: string | undefined;
    dropdownSubmenuArrow: boolean;

    constructor(data?: IUiCustomizationMenuSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data['position'];
            this.asideSkin = _data['asideSkin'];
            this.fixedAside = _data['fixedAside'];
            this.allowAsideMinimizing = _data['allowAsideMinimizing'];
            this.defaultMinimizedAside = _data['defaultMinimizedAside'];
            this.allowAsideHiding = _data['allowAsideHiding'];
            this.defaultHiddenAside = _data['defaultHiddenAside'];
            this.submenuToggle = _data['submenuToggle'];
            this.dropdownSubmenuSkin = _data['dropdownSubmenuSkin'];
            this.dropdownSubmenuArrow = _data['dropdownSubmenuArrow'];
        }
    }

    static fromJS(data: any): UiCustomizationMenuSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationMenuSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['position'] = this.position;
        data['asideSkin'] = this.asideSkin;
        data['fixedAside'] = this.fixedAside;
        data['allowAsideMinimizing'] = this.allowAsideMinimizing;
        data['defaultMinimizedAside'] = this.defaultMinimizedAside;
        data['allowAsideHiding'] = this.allowAsideHiding;
        data['defaultHiddenAside'] = this.defaultHiddenAside;
        data['submenuToggle'] = this.submenuToggle;
        data['dropdownSubmenuSkin'] = this.dropdownSubmenuSkin;
        data['dropdownSubmenuArrow'] = this.dropdownSubmenuArrow;
        return data;
    }
}

export interface IUiCustomizationMenuSettingsEditDto {
    position: string | undefined;
    asideSkin: string | undefined;
    fixedAside: boolean;
    allowAsideMinimizing: boolean;
    defaultMinimizedAside: boolean;
    allowAsideHiding: boolean;
    defaultHiddenAside: boolean;
    submenuToggle: string | undefined;
    dropdownSubmenuSkin: string | undefined;
    dropdownSubmenuArrow: boolean;
}

export class UiCustomizationSettingsEditDto implements IUiCustomizationSettingsEditDto {
    layout: UiCustomizationLayoutSettingsEditDto;
    header: UiCustomizationHeaderSettingsEditDto;
    menu: UiCustomizationMenuSettingsEditDto;
    footer: UiCustomizationFooterSettingsEditDto;
    vision: VisionSettingsEditDto;

    constructor(data?: IUiCustomizationSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layout = _data['layout'] ? UiCustomizationLayoutSettingsEditDto.fromJS(_data['layout']) : <any>undefined;
            this.header = _data['header'] ? UiCustomizationHeaderSettingsEditDto.fromJS(_data['header']) : <any>undefined;
            this.menu = _data['menu'] ? UiCustomizationMenuSettingsEditDto.fromJS(_data['menu']) : <any>undefined;
            this.footer = _data['footer'] ? UiCustomizationFooterSettingsEditDto.fromJS(_data['footer']) : <any>undefined;
            this.vision = _data['vision'] ? VisionSettingsEditDto.fromJS(_data['vision']) : <any>undefined;
        }
    }

    static fromJS(data: any): UiCustomizationSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['layout'] = this.layout ? this.layout.toJSON() : <any>undefined;
        data['header'] = this.header ? this.header.toJSON() : <any>undefined;
        data['menu'] = this.menu ? this.menu.toJSON() : <any>undefined;
        data['footer'] = this.footer ? this.footer.toJSON() : <any>undefined;
        data['vision'] = this.vision ? this.vision.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUiCustomizationSettingsEditDto {
    layout: UiCustomizationLayoutSettingsEditDto;
    header: UiCustomizationHeaderSettingsEditDto;
    menu: UiCustomizationMenuSettingsEditDto;
    footer: UiCustomizationFooterSettingsEditDto;
    vision: VisionSettingsEditDto;
}

export class UnblockUserInput implements IUnblockUserInput {
    userId: number;
    tenantId: number | undefined;

    constructor(data?: IUnblockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data['userId'];
            this.tenantId = _data['tenantId'];
        }
    }

    static fromJS(data: any): UnblockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnblockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['userId'] = this.userId;
        data['tenantId'] = this.tenantId;
        return data;
    }
}

export interface IUnblockUserInput {
    userId: number;
    tenantId: number | undefined;
}

export class UnlinkUserInput implements IUnlinkUserInput {
    tenantId: number | undefined;
    userId: number;

    constructor(data?: IUnlinkUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data['tenantId'];
            this.userId = _data['userId'];
        }
    }

    static fromJS(data: any): UnlinkUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnlinkUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenantId'] = this.tenantId;
        data['userId'] = this.userId;
        return data;
    }
}

export interface IUnlinkUserInput {
    tenantId: number | undefined;
    userId: number;
}

export class UpdateGoogleAuthenticatorKeyOutput implements IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string | undefined;

    constructor(data?: IUpdateGoogleAuthenticatorKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrCodeSetupImageUrl = _data['qrCodeSetupImageUrl'];
        }
    }

    static fromJS(data: any): UpdateGoogleAuthenticatorKeyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['qrCodeSetupImageUrl'] = this.qrCodeSetupImageUrl;
        return data;
    }
}

export interface IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string | undefined;
}

export class UpdateLanguageTextInput implements IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;

    constructor(data?: IUpdateLanguageTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data['languageName'];
            this.sourceName = _data['sourceName'];
            this.key = _data['key'];
            this.value = _data['value'];
        }
    }

    static fromJS(data: any): UpdateLanguageTextInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLanguageTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['languageName'] = this.languageName;
        data['sourceName'] = this.sourceName;
        data['key'] = this.key;
        data['value'] = this.value;
        return data;
    }
}

export interface IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;
}

export class UpdateNotificationSettingsInput implements IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[] | undefined;

    constructor(data?: IUpdateNotificationSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data['receiveNotifications'];
            if (Array.isArray(_data['notifications'])) {
                this.notifications = [] as any;
                for (let item of _data['notifications']) this.notifications.push(NotificationSubscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNotificationSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['receiveNotifications'] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data['notifications'] = [];
            for (let item of this.notifications) data['notifications'].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[] | undefined;
}

export class UpdateOrganizationUnitInput implements IUpdateOrganizationUnitInput {
    id: number;
    displayName: string;

    constructor(data?: IUpdateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.displayName = _data['displayName'];
        }
    }

    static fromJS(data: any): UpdateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['displayName'] = this.displayName;
        return data;
    }
}

export interface IUpdateOrganizationUnitInput {
    id: number;
    displayName: string;
}

export class UpdateProcedureDto implements IUpdateProcedureDto {
    procedureId: string | undefined;
    waitingListId: string | undefined;
    order: number;
    estimatedTime: number | undefined;
    isRemoved: boolean;

    constructor(data?: IUpdateProcedureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.procedureId = _data['procedureId'];
            this.waitingListId = _data['waitingListId'];
            this.order = _data['order'];
            this.estimatedTime = _data['estimatedTime'];
            this.isRemoved = _data['isRemoved'];
        }
    }

    static fromJS(data: any): UpdateProcedureDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProcedureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['procedureId'] = this.procedureId;
        data['waitingListId'] = this.waitingListId;
        data['order'] = this.order;
        data['estimatedTime'] = this.estimatedTime;
        data['isRemoved'] = this.isRemoved;
        return data;
    }
}

export interface IUpdateProcedureDto {
    procedureId: string | undefined;
    waitingListId: string | undefined;
    order: number;
    estimatedTime: number | undefined;
    isRemoved: boolean;
}

export class UpdateProfilePictureInput implements IUpdateProfilePictureInput {
    fileName: string;
    x: number;
    y: number;
    width: number;
    height: number;

    constructor(data?: IUpdateProfilePictureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data['fileName'];
            this.x = _data['x'];
            this.y = _data['y'];
            this.width = _data['width'];
            this.height = _data['height'];
        }
    }

    static fromJS(data: any): UpdateProfilePictureInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfilePictureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['fileName'] = this.fileName;
        data['x'] = this.x;
        data['y'] = this.y;
        data['width'] = this.width;
        data['height'] = this.height;
        return data;
    }
}

export interface IUpdateProfilePictureInput {
    fileName: string;
    x: number;
    y: number;
    width: number;
    height: number;
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[];

    constructor(data?: IUpdateTenantFeaturesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            if (Array.isArray(_data['featureValues'])) {
                this.featureValues = [] as any;
                for (let item of _data['featureValues']) this.featureValues.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTenantFeaturesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        if (Array.isArray(this.featureValues)) {
            data['featureValues'] = [];
            for (let item of this.featureValues) data['featureValues'].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[];
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[];

    constructor(data?: IUpdateUserPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            if (Array.isArray(_data['grantedPermissionNames'])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data['grantedPermissionNames']) this.grantedPermissionNames.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserPermissionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        if (Array.isArray(this.grantedPermissionNames)) {
            data['grantedPermissionNames'] = [];
            for (let item of this.grantedPermissionNames) data['grantedPermissionNames'].push(item);
        }
        return data;
    }
}

export interface IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[];
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
    signInToken: string | undefined;
    encodedUserId: string | undefined;
    encodedTenantId: string | undefined;

    constructor(data?: IUpdateUserSignInTokenOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signInToken = _data['signInToken'];
            this.encodedUserId = _data['encodedUserId'];
            this.encodedTenantId = _data['encodedTenantId'];
        }
    }

    static fromJS(data: any): UpdateUserSignInTokenOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['signInToken'] = this.signInToken;
        data['encodedUserId'] = this.encodedUserId;
        data['encodedTenantId'] = this.encodedTenantId;
        return data;
    }
}

export interface IUpdateUserSignInTokenOutput {
    signInToken: string | undefined;
    encodedUserId: string | undefined;
    encodedTenantId: string | undefined;
}

export class User implements IUser {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    authenticationSource: string | undefined;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    readonly fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    profilePictureId: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    signInTokenExpireTimeUtc: moment.Moment | undefined;
    signInToken: string | undefined;
    googleAuthenticatorKey: string | undefined;
    title: string | undefined;
    pooled: boolean | undefined;
    employees: Employee[] | undefined;
    speciality: Speciality;
    specialityId: number | undefined;
    failedTwoFactorAuthenticationCount: number;
    lastSuccessfulTwoFactorProvider: string | undefined;
    isSmsAuthenticationEnabled: boolean;
    userName: string;
    normalizedUserName: string;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
            this.lastModifierUserId = _data['lastModifierUserId'];
            this.isDeleted = _data['isDeleted'];
            this.deleterUserId = _data['deleterUserId'];
            this.deletionTime = _data['deletionTime'] ? moment(_data['deletionTime'].toString()) : <any>undefined;
            this.authenticationSource = _data['authenticationSource'];
            this.tenantId = _data['tenantId'];
            this.emailAddress = _data['emailAddress'];
            this.name = _data['name'];
            this.surname = _data['surname'];
            (<any>this).fullName = _data['fullName'];
            this.password = _data['password'];
            this.emailConfirmationCode = _data['emailConfirmationCode'];
            this.passwordResetCode = _data['passwordResetCode'];
            this.lockoutEndDateUtc = _data['lockoutEndDateUtc'] ? moment(_data['lockoutEndDateUtc'].toString()) : <any>undefined;
            this.accessFailedCount = _data['accessFailedCount'];
            this.isLockoutEnabled = _data['isLockoutEnabled'];
            this.phoneNumber = _data['phoneNumber'];
            this.isPhoneNumberConfirmed = _data['isPhoneNumberConfirmed'];
            this.securityStamp = _data['securityStamp'];
            this.isTwoFactorEnabled = _data['isTwoFactorEnabled'];
            if (Array.isArray(_data['logins'])) {
                this.logins = [] as any;
                for (let item of _data['logins']) this.logins.push(UserLogin.fromJS(item));
            }
            if (Array.isArray(_data['roles'])) {
                this.roles = [] as any;
                for (let item of _data['roles']) this.roles.push(UserRole.fromJS(item));
            }
            if (Array.isArray(_data['claims'])) {
                this.claims = [] as any;
                for (let item of _data['claims']) this.claims.push(UserClaim.fromJS(item));
            }
            if (Array.isArray(_data['permissions'])) {
                this.permissions = [] as any;
                for (let item of _data['permissions']) this.permissions.push(UserPermissionSetting.fromJS(item));
            }
            if (Array.isArray(_data['settings'])) {
                this.settings = [] as any;
                for (let item of _data['settings']) this.settings.push(Setting.fromJS(item));
            }
            this.isEmailConfirmed = _data['isEmailConfirmed'];
            this.isActive = _data['isActive'];
            this.normalizedEmailAddress = _data['normalizedEmailAddress'];
            this.concurrencyStamp = _data['concurrencyStamp'];
            if (Array.isArray(_data['tokens'])) {
                this.tokens = [] as any;
                for (let item of _data['tokens']) this.tokens.push(UserToken.fromJS(item));
            }
            this.deleterUser = _data['deleterUser'] ? User.fromJS(_data['deleterUser']) : <any>undefined;
            this.creatorUser = _data['creatorUser'] ? User.fromJS(_data['creatorUser']) : <any>undefined;
            this.lastModifierUser = _data['lastModifierUser'] ? User.fromJS(_data['lastModifierUser']) : <any>undefined;
            this.profilePictureId = _data['profilePictureId'];
            this.shouldChangePasswordOnNextLogin = _data['shouldChangePasswordOnNextLogin'];
            this.signInTokenExpireTimeUtc = _data['signInTokenExpireTimeUtc']
                ? moment(_data['signInTokenExpireTimeUtc'].toString())
                : <any>undefined;
            this.signInToken = _data['signInToken'];
            this.googleAuthenticatorKey = _data['googleAuthenticatorKey'];
            this.title = _data['title'];
            this.pooled = _data['pooled'];
            if (Array.isArray(_data['employees'])) {
                this.employees = [] as any;
                for (let item of _data['employees']) this.employees.push(Employee.fromJS(item));
            }
            this.speciality = _data['speciality'] ? Speciality.fromJS(_data['speciality']) : <any>undefined;
            this.specialityId = _data['specialityId'];
            this.failedTwoFactorAuthenticationCount = _data['failedTwoFactorAuthenticationCount'];
            this.lastSuccessfulTwoFactorProvider = _data['lastSuccessfulTwoFactorProvider'];
            this.isSmsAuthenticationEnabled = _data['isSmsAuthenticationEnabled'];
            this.userName = _data['userName'];
            this.normalizedUserName = _data['normalizedUserName'];
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data['lastModifierUserId'] = this.lastModifierUserId;
        data['isDeleted'] = this.isDeleted;
        data['deleterUserId'] = this.deleterUserId;
        data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data['authenticationSource'] = this.authenticationSource;
        data['tenantId'] = this.tenantId;
        data['emailAddress'] = this.emailAddress;
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['fullName'] = this.fullName;
        data['password'] = this.password;
        data['emailConfirmationCode'] = this.emailConfirmationCode;
        data['passwordResetCode'] = this.passwordResetCode;
        data['lockoutEndDateUtc'] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : <any>undefined;
        data['accessFailedCount'] = this.accessFailedCount;
        data['isLockoutEnabled'] = this.isLockoutEnabled;
        data['phoneNumber'] = this.phoneNumber;
        data['isPhoneNumberConfirmed'] = this.isPhoneNumberConfirmed;
        data['securityStamp'] = this.securityStamp;
        data['isTwoFactorEnabled'] = this.isTwoFactorEnabled;
        if (Array.isArray(this.logins)) {
            data['logins'] = [];
            for (let item of this.logins) data['logins'].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data['roles'] = [];
            for (let item of this.roles) data['roles'].push(item.toJSON());
        }
        if (Array.isArray(this.claims)) {
            data['claims'] = [];
            for (let item of this.claims) data['claims'].push(item.toJSON());
        }
        if (Array.isArray(this.permissions)) {
            data['permissions'] = [];
            for (let item of this.permissions) data['permissions'].push(item.toJSON());
        }
        if (Array.isArray(this.settings)) {
            data['settings'] = [];
            for (let item of this.settings) data['settings'].push(item.toJSON());
        }
        data['isEmailConfirmed'] = this.isEmailConfirmed;
        data['isActive'] = this.isActive;
        data['normalizedEmailAddress'] = this.normalizedEmailAddress;
        data['concurrencyStamp'] = this.concurrencyStamp;
        if (Array.isArray(this.tokens)) {
            data['tokens'] = [];
            for (let item of this.tokens) data['tokens'].push(item.toJSON());
        }
        data['deleterUser'] = this.deleterUser ? this.deleterUser.toJSON() : <any>undefined;
        data['creatorUser'] = this.creatorUser ? this.creatorUser.toJSON() : <any>undefined;
        data['lastModifierUser'] = this.lastModifierUser ? this.lastModifierUser.toJSON() : <any>undefined;
        data['profilePictureId'] = this.profilePictureId;
        data['shouldChangePasswordOnNextLogin'] = this.shouldChangePasswordOnNextLogin;
        data['signInTokenExpireTimeUtc'] = this.signInTokenExpireTimeUtc ? this.signInTokenExpireTimeUtc.toISOString() : <any>undefined;
        data['signInToken'] = this.signInToken;
        data['googleAuthenticatorKey'] = this.googleAuthenticatorKey;
        data['title'] = this.title;
        data['pooled'] = this.pooled;
        if (Array.isArray(this.employees)) {
            data['employees'] = [];
            for (let item of this.employees) data['employees'].push(item.toJSON());
        }
        data['speciality'] = this.speciality ? this.speciality.toJSON() : <any>undefined;
        data['specialityId'] = this.specialityId;
        data['failedTwoFactorAuthenticationCount'] = this.failedTwoFactorAuthenticationCount;
        data['lastSuccessfulTwoFactorProvider'] = this.lastSuccessfulTwoFactorProvider;
        data['isSmsAuthenticationEnabled'] = this.isSmsAuthenticationEnabled;
        data['userName'] = this.userName;
        data['normalizedUserName'] = this.normalizedUserName;
        return data;
    }
}

export interface IUser {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    lastModificationTime: moment.Moment | undefined;
    lastModifierUserId: number | undefined;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: moment.Moment | undefined;
    authenticationSource: string | undefined;
    tenantId: number | undefined;
    emailAddress: string;
    name: string;
    surname: string;
    fullName: string | undefined;
    password: string;
    emailConfirmationCode: string | undefined;
    passwordResetCode: string | undefined;
    lockoutEndDateUtc: moment.Moment | undefined;
    accessFailedCount: number;
    isLockoutEnabled: boolean;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    securityStamp: string | undefined;
    isTwoFactorEnabled: boolean;
    logins: UserLogin[] | undefined;
    roles: UserRole[] | undefined;
    claims: UserClaim[] | undefined;
    permissions: UserPermissionSetting[] | undefined;
    settings: Setting[] | undefined;
    isEmailConfirmed: boolean;
    isActive: boolean;
    normalizedEmailAddress: string;
    concurrencyStamp: string | undefined;
    tokens: UserToken[] | undefined;
    deleterUser: User;
    creatorUser: User;
    lastModifierUser: User;
    profilePictureId: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    signInTokenExpireTimeUtc: moment.Moment | undefined;
    signInToken: string | undefined;
    googleAuthenticatorKey: string | undefined;
    title: string | undefined;
    pooled: boolean | undefined;
    employees: Employee[] | undefined;
    speciality: Speciality;
    specialityId: number | undefined;
    failedTwoFactorAuthenticationCount: number;
    lastSuccessfulTwoFactorProvider: string | undefined;
    isSmsAuthenticationEnabled: boolean;
    userName: string;
    normalizedUserName: string;
}

export class UserClaim implements IUserClaim {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;

    constructor(data?: IUserClaim) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.tenantId = _data['tenantId'];
            this.userId = _data['userId'];
            this.claimType = _data['claimType'];
            this.claimValue = _data['claimValue'];
        }
    }

    static fromJS(data: any): UserClaim {
        data = typeof data === 'object' ? data : {};
        let result = new UserClaim();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['tenantId'] = this.tenantId;
        data['userId'] = this.userId;
        data['claimType'] = this.claimType;
        data['claimValue'] = this.claimValue;
        return data;
    }
}

export interface IUserClaim {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    claimType: string | undefined;
    claimValue: string | undefined;
}

export class UserEditDto implements IUserEditDto {
    id: number | undefined;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    title: string | undefined;
    pooled: boolean | undefined;
    specialtyId: number | undefined;
    password: string | undefined;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
    theatreImportedEmployee: EmployeeDto;
    ptlImportedEmployee: EmployeeDto;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.userName = _data['userName'];
            this.emailAddress = _data['emailAddress'];
            this.phoneNumber = _data['phoneNumber'];
            this.title = _data['title'];
            this.pooled = _data['pooled'];
            this.specialtyId = _data['specialtyId'];
            this.password = _data['password'];
            this.isActive = _data['isActive'];
            this.shouldChangePasswordOnNextLogin = _data['shouldChangePasswordOnNextLogin'];
            this.isTwoFactorEnabled = _data['isTwoFactorEnabled'];
            this.isLockoutEnabled = _data['isLockoutEnabled'];
            this.theatreImportedEmployee = _data['theatreImportedEmployee']
                ? EmployeeDto.fromJS(_data['theatreImportedEmployee'])
                : <any>undefined;
            this.ptlImportedEmployee = _data['ptlImportedEmployee'] ? EmployeeDto.fromJS(_data['ptlImportedEmployee']) : <any>undefined;
        }
    }

    static fromJS(data: any): UserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['userName'] = this.userName;
        data['emailAddress'] = this.emailAddress;
        data['phoneNumber'] = this.phoneNumber;
        data['title'] = this.title;
        data['pooled'] = this.pooled;
        data['specialtyId'] = this.specialtyId;
        data['password'] = this.password;
        data['isActive'] = this.isActive;
        data['shouldChangePasswordOnNextLogin'] = this.shouldChangePasswordOnNextLogin;
        data['isTwoFactorEnabled'] = this.isTwoFactorEnabled;
        data['isLockoutEnabled'] = this.isLockoutEnabled;
        data['theatreImportedEmployee'] = this.theatreImportedEmployee ? this.theatreImportedEmployee.toJSON() : <any>undefined;
        data['ptlImportedEmployee'] = this.ptlImportedEmployee ? this.ptlImportedEmployee.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserEditDto {
    id: number | undefined;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    title: string | undefined;
    pooled: boolean | undefined;
    specialtyId: number | undefined;
    password: string | undefined;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
    theatreImportedEmployee: EmployeeDto;
    ptlImportedEmployee: EmployeeDto;
}

export class UserListDto implements IUserListDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
    isEmailConfirmed: boolean;
    roles: UserListRoleDto[] | undefined;
    lastLoginTime: moment.Moment | undefined;
    isActive: boolean;
    creationTime: moment.Moment;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.userName = _data['userName'];
            this.emailAddress = _data['emailAddress'];
            this.phoneNumber = _data['phoneNumber'];
            this.profilePictureId = _data['profilePictureId'];
            this.isEmailConfirmed = _data['isEmailConfirmed'];
            if (Array.isArray(_data['roles'])) {
                this.roles = [] as any;
                for (let item of _data['roles']) this.roles.push(UserListRoleDto.fromJS(item));
            }
            this.lastLoginTime = _data['lastLoginTime'] ? moment(_data['lastLoginTime'].toString()) : <any>undefined;
            this.isActive = _data['isActive'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['userName'] = this.userName;
        data['emailAddress'] = this.emailAddress;
        data['phoneNumber'] = this.phoneNumber;
        data['profilePictureId'] = this.profilePictureId;
        data['isEmailConfirmed'] = this.isEmailConfirmed;
        if (Array.isArray(this.roles)) {
            data['roles'] = [];
            for (let item of this.roles) data['roles'].push(item.toJSON());
        }
        data['lastLoginTime'] = this.lastLoginTime ? this.lastLoginTime.toISOString() : <any>undefined;
        data['isActive'] = this.isActive;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserListDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
    isEmailConfirmed: boolean;
    roles: UserListRoleDto[] | undefined;
    lastLoginTime: moment.Moment | undefined;
    isActive: boolean;
    creationTime: moment.Moment;
}

export class UserListDtoPagedResultDto implements IUserListDtoPagedResultDto {
    items: UserListDto[] | undefined;
    totalCount: number;

    constructor(data?: IUserListDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(UserListDto.fromJS(item));
            }
            this.totalCount = _data['totalCount'];
        }
    }

    static fromJS(data: any): UserListDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        data['totalCount'] = this.totalCount;
        return data;
    }
}

export interface IUserListDtoPagedResultDto {
    items: UserListDto[] | undefined;
    totalCount: number;
}

export class UserListRoleDto implements IUserListRoleDto {
    roleId: number;
    roleName: string | undefined;

    constructor(data?: IUserListRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data['roleId'];
            this.roleName = _data['roleName'];
        }
    }

    static fromJS(data: any): UserListRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['roleId'] = this.roleId;
        data['roleName'] = this.roleName;
        return data;
    }
}

export interface IUserListRoleDto {
    roleId: number;
    roleName: string | undefined;
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
    isEnabled: boolean;
    maxFailedAccessAttemptsBeforeLockout: number;
    defaultAccountLockoutSeconds: number;

    constructor(data?: IUserLockOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data['isEnabled'];
            this.maxFailedAccessAttemptsBeforeLockout = _data['maxFailedAccessAttemptsBeforeLockout'];
            this.defaultAccountLockoutSeconds = _data['defaultAccountLockoutSeconds'];
        }
    }

    static fromJS(data: any): UserLockOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['isEnabled'] = this.isEnabled;
        data['maxFailedAccessAttemptsBeforeLockout'] = this.maxFailedAccessAttemptsBeforeLockout;
        data['defaultAccountLockoutSeconds'] = this.defaultAccountLockoutSeconds;
        return data;
    }
}

export interface IUserLockOutSettingsEditDto {
    isEnabled: boolean;
    maxFailedAccessAttemptsBeforeLockout: number;
    defaultAccountLockoutSeconds: number;
}

export class UserLogin implements IUserLogin {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;

    constructor(data?: IUserLogin) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.tenantId = _data['tenantId'];
            this.userId = _data['userId'];
            this.loginProvider = _data['loginProvider'];
            this.providerKey = _data['providerKey'];
        }
    }

    static fromJS(data: any): UserLogin {
        data = typeof data === 'object' ? data : {};
        let result = new UserLogin();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['tenantId'] = this.tenantId;
        data['userId'] = this.userId;
        data['loginProvider'] = this.loginProvider;
        data['providerKey'] = this.providerKey;
        return data;
    }
}

export interface IUserLogin {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string;
    providerKey: string;
}

export class UserLoginAttemptDto implements IUserLoginAttemptDto {
    tenancyName: string | undefined;
    userNameOrEmail: string | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    result: string | undefined;
    creationTime: moment.Moment;

    constructor(data?: IUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data['tenancyName'];
            this.userNameOrEmail = _data['userNameOrEmail'];
            this.clientIpAddress = _data['clientIpAddress'];
            this.clientName = _data['clientName'];
            this.browserInfo = _data['browserInfo'];
            this.result = _data['result'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['tenancyName'] = this.tenancyName;
        data['userNameOrEmail'] = this.userNameOrEmail;
        data['clientIpAddress'] = this.clientIpAddress;
        data['clientName'] = this.clientName;
        data['browserInfo'] = this.browserInfo;
        data['result'] = this.result;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserLoginAttemptDto {
    tenancyName: string | undefined;
    userNameOrEmail: string | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    result: string | undefined;
    creationTime: moment.Moment;
}

export class UserLoginAttemptDtoListResultDto implements IUserLoginAttemptDtoListResultDto {
    items: UserLoginAttemptDto[] | undefined;

    constructor(data?: IUserLoginAttemptDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['items'])) {
                this.items = [] as any;
                for (let item of _data['items']) this.items.push(UserLoginAttemptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserLoginAttemptDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAttemptDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data['items'] = [];
            for (let item of this.items) data['items'].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserLoginAttemptDtoListResultDto {
    items: UserLoginAttemptDto[] | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id: number;
    title: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.title = _data['title'];
            this.name = _data['name'];
            this.surname = _data['surname'];
            this.userName = _data['userName'];
            this.emailAddress = _data['emailAddress'];
            this.profilePictureId = _data['profilePictureId'];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['title'] = this.title;
        data['name'] = this.name;
        data['surname'] = this.surname;
        data['userName'] = this.userName;
        data['emailAddress'] = this.emailAddress;
        data['profilePictureId'] = this.profilePictureId;
        return data;
    }
}

export interface IUserLoginInfoDto {
    id: number;
    title: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
}

export class UserNotification implements IUserNotification {
    id: string;
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.tenantId = _data['tenantId'];
            this.userId = _data['userId'];
            this.state = _data['state'];
            this.notification = _data['notification'] ? TenantNotification.fromJS(_data['notification']) : <any>undefined;
        }
    }

    static fromJS(data: any): UserNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['tenantId'] = this.tenantId;
        data['userId'] = this.userId;
        data['state'] = this.state;
        data['notification'] = this.notification ? this.notification.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserNotification {
    id: string;
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification;
}

export enum UserNotificationState {
    _0 = 0,
    _1 = 1
}

export class UserPermissionSetting implements IUserPermissionSetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    userId: number;

    constructor(data?: IUserPermissionSetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.tenantId = _data['tenantId'];
            this.name = _data['name'];
            this.isGranted = _data['isGranted'];
            this.userId = _data['userId'];
        }
    }

    static fromJS(data: any): UserPermissionSetting {
        data = typeof data === 'object' ? data : {};
        let result = new UserPermissionSetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['tenantId'] = this.tenantId;
        data['name'] = this.name;
        data['isGranted'] = this.isGranted;
        data['userId'] = this.userId;
        return data;
    }
}

export interface IUserPermissionSetting {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    name: string;
    isGranted: boolean;
    userId: number;
}

export class UserRole implements IUserRole {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    roleId: number;

    constructor(data?: IUserRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.creatorUserId = _data['creatorUserId'];
            this.tenantId = _data['tenantId'];
            this.userId = _data['userId'];
            this.roleId = _data['roleId'];
        }
    }

    static fromJS(data: any): UserRole {
        data = typeof data === 'object' ? data : {};
        let result = new UserRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['creatorUserId'] = this.creatorUserId;
        data['tenantId'] = this.tenantId;
        data['userId'] = this.userId;
        data['roleId'] = this.roleId;
        return data;
    }
}

export interface IUserRole {
    id: number;
    creationTime: moment.Moment;
    creatorUserId: number | undefined;
    tenantId: number | undefined;
    userId: number;
    roleId: number;
}

export class UserRoleDto implements IUserRoleDto {
    roleId: number;
    roleName: string | undefined;
    roleDisplayName: string | undefined;
    isAssigned: boolean;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data['roleId'];
            this.roleName = _data['roleName'];
            this.roleDisplayName = _data['roleDisplayName'];
            this.isAssigned = _data['isAssigned'];
        }
    }

    static fromJS(data: any): UserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['roleId'] = this.roleId;
        data['roleName'] = this.roleName;
        data['roleDisplayName'] = this.roleDisplayName;
        data['isAssigned'] = this.isAssigned;
        return data;
    }
}

export interface IUserRoleDto {
    roleId: number;
    roleName: string | undefined;
    roleDisplayName: string | undefined;
    isAssigned: boolean;
}

export class UsersToOrganizationUnitInput implements IUsersToOrganizationUnitInput {
    userIds: number[] | undefined;
    organizationUnitId: number;

    constructor(data?: IUsersToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['userIds'])) {
                this.userIds = [] as any;
                for (let item of _data['userIds']) this.userIds.push(item);
            }
            this.organizationUnitId = _data['organizationUnitId'];
        }
    }

    static fromJS(data: any): UsersToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UsersToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data['userIds'] = [];
            for (let item of this.userIds) data['userIds'].push(item);
        }
        data['organizationUnitId'] = this.organizationUnitId;
        return data;
    }
}

export interface IUsersToOrganizationUnitInput {
    userIds: number[] | undefined;
    organizationUnitId: number;
}

export class UserToken implements IUserToken {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;

    constructor(data?: IUserToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.tenantId = _data['tenantId'];
            this.userId = _data['userId'];
            this.loginProvider = _data['loginProvider'];
            this.name = _data['name'];
            this.value = _data['value'];
            this.expireDate = _data['expireDate'] ? moment(_data['expireDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserToken {
        data = typeof data === 'object' ? data : {};
        let result = new UserToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['tenantId'] = this.tenantId;
        data['userId'] = this.userId;
        data['loginProvider'] = this.loginProvider;
        data['name'] = this.name;
        data['value'] = this.value;
        data['expireDate'] = this.expireDate ? this.expireDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserToken {
    id: number;
    tenantId: number | undefined;
    userId: number;
    loginProvider: string | undefined;
    name: string | undefined;
    value: string | undefined;
    expireDate: moment.Moment | undefined;
}

export class UtilisationDto implements IUtilisationDto {
    utilisation: number;
    listsCount: number;
    consultantStaffingCount: number;
    anaesthetistStaffingCount: number;
    patientsCount: number;
    preAssessedPatientsCount: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;

    constructor(data?: IUtilisationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utilisation = _data['utilisation'];
            this.listsCount = _data['listsCount'];
            this.consultantStaffingCount = _data['consultantStaffingCount'];
            this.anaesthetistStaffingCount = _data['anaesthetistStaffingCount'];
            this.patientsCount = _data['patientsCount'];
            this.preAssessedPatientsCount = _data['preAssessedPatientsCount'];
            this.fromDate = _data['fromDate'] ? moment(_data['fromDate'].toString()) : <any>undefined;
            this.toDate = _data['toDate'] ? moment(_data['toDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UtilisationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UtilisationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['utilisation'] = this.utilisation;
        data['listsCount'] = this.listsCount;
        data['consultantStaffingCount'] = this.consultantStaffingCount;
        data['anaesthetistStaffingCount'] = this.anaesthetistStaffingCount;
        data['patientsCount'] = this.patientsCount;
        data['preAssessedPatientsCount'] = this.preAssessedPatientsCount;
        data['fromDate'] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data['toDate'] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUtilisationDto {
    utilisation: number;
    listsCount: number;
    consultantStaffingCount: number;
    anaesthetistStaffingCount: number;
    patientsCount: number;
    preAssessedPatientsCount: number;
    fromDate: moment.Moment;
    toDate: moment.Moment;
}

export class VerifySmsCodeInputDto implements IVerifySmsCodeInputDto {
    code: string | undefined;

    constructor(data?: IVerifySmsCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data['code'];
        }
    }

    static fromJS(data: any): VerifySmsCodeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifySmsCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['code'] = this.code;
        return data;
    }
}

export interface IVerifySmsCodeInputDto {
    code: string | undefined;
}

export class VisionSettingsEditDto implements IVisionSettingsEditDto {
    lowThresholdPoint: number;
    highThresholdPoint: number;

    constructor(data?: IVisionSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lowThresholdPoint = _data['lowThresholdPoint'];
            this.highThresholdPoint = _data['highThresholdPoint'];
        }
    }

    static fromJS(data: any): VisionSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new VisionSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['lowThresholdPoint'] = this.lowThresholdPoint;
        data['highThresholdPoint'] = this.highThresholdPoint;
        return data;
    }
}

export interface IVisionSettingsEditDto {
    lowThresholdPoint: number;
    highThresholdPoint: number;
}

export class WaitingList implements IWaitingList {
    id: string | undefined;
    referalDate: moment.Moment | undefined;
    daysWaiting: number | undefined;
    weeksWaiting: number | undefined;
    pathwayStartDate: moment.Moment | undefined;
    pathwayEndDate: moment.Moment | undefined;
    appointmentDate: moment.Moment | undefined;
    admissionDate: moment.Moment | undefined;
    ipListDate: moment.Moment | undefined;
    breachDate: moment.Moment | undefined;
    currentStatusCode: number | undefined;
    currentStatusDate: moment.Moment | undefined;
    sharedBreach: boolean | undefined;
    procedureId: string | undefined;
    suggestedTime: number | undefined;
    suggestedTimeCalculationType: SuggestedTimeCalculationType;
    isPreassessed: boolean | undefined;
    comment: string | undefined;
    intendedProcedureCode: OpcsCode;
    pathway: Pathway;
    workflowStatus: WorkflowStatus;
    patient: Patient;
    speciality: Speciality;
    consultant: Employee;
    excluded: ExcludedWaitingList[] | undefined;
    site: Site;
    metadataValues: MetadataValue[] | undefined;
    admission: Admission;
    cohort: Cohort;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IWaitingList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.referalDate = _data['referalDate'] ? moment(_data['referalDate'].toString()) : <any>undefined;
            this.daysWaiting = _data['daysWaiting'];
            this.weeksWaiting = _data['weeksWaiting'];
            this.pathwayStartDate = _data['pathwayStartDate'] ? moment(_data['pathwayStartDate'].toString()) : <any>undefined;
            this.pathwayEndDate = _data['pathwayEndDate'] ? moment(_data['pathwayEndDate'].toString()) : <any>undefined;
            this.appointmentDate = _data['appointmentDate'] ? moment(_data['appointmentDate'].toString()) : <any>undefined;
            this.admissionDate = _data['admissionDate'] ? moment(_data['admissionDate'].toString()) : <any>undefined;
            this.ipListDate = _data['ipListDate'] ? moment(_data['ipListDate'].toString()) : <any>undefined;
            this.breachDate = _data['breachDate'] ? moment(_data['breachDate'].toString()) : <any>undefined;
            this.currentStatusCode = _data['currentStatusCode'];
            this.currentStatusDate = _data['currentStatusDate'] ? moment(_data['currentStatusDate'].toString()) : <any>undefined;
            this.sharedBreach = _data['sharedBreach'];
            this.procedureId = _data['procedureId'];
            this.suggestedTime = _data['suggestedTime'];
            this.suggestedTimeCalculationType = _data['suggestedTimeCalculationType'];
            this.isPreassessed = _data['isPreassessed'];
            this.comment = _data['comment'];
            this.intendedProcedureCode = _data['intendedProcedureCode'] ? OpcsCode.fromJS(_data['intendedProcedureCode']) : <any>undefined;
            this.pathway = _data['pathway'] ? Pathway.fromJS(_data['pathway']) : <any>undefined;
            this.workflowStatus = _data['workflowStatus'] ? WorkflowStatus.fromJS(_data['workflowStatus']) : <any>undefined;
            this.patient = _data['patient'] ? Patient.fromJS(_data['patient']) : <any>undefined;
            this.speciality = _data['speciality'] ? Speciality.fromJS(_data['speciality']) : <any>undefined;
            this.consultant = _data['consultant'] ? Employee.fromJS(_data['consultant']) : <any>undefined;
            if (Array.isArray(_data['excluded'])) {
                this.excluded = [] as any;
                for (let item of _data['excluded']) this.excluded.push(ExcludedWaitingList.fromJS(item));
            }
            this.site = _data['site'] ? Site.fromJS(_data['site']) : <any>undefined;
            if (Array.isArray(_data['metadataValues'])) {
                this.metadataValues = [] as any;
                for (let item of _data['metadataValues']) this.metadataValues.push(MetadataValue.fromJS(item));
            }
            this.admission = _data['admission'] ? Admission.fromJS(_data['admission']) : <any>undefined;
            this.cohort = _data['cohort'] ? Cohort.fromJS(_data['cohort']) : <any>undefined;
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WaitingList {
        data = typeof data === 'object' ? data : {};
        let result = new WaitingList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['referalDate'] = this.referalDate ? this.referalDate.toISOString() : <any>undefined;
        data['daysWaiting'] = this.daysWaiting;
        data['weeksWaiting'] = this.weeksWaiting;
        data['pathwayStartDate'] = this.pathwayStartDate ? this.pathwayStartDate.toISOString() : <any>undefined;
        data['pathwayEndDate'] = this.pathwayEndDate ? this.pathwayEndDate.toISOString() : <any>undefined;
        data['appointmentDate'] = this.appointmentDate ? this.appointmentDate.toISOString() : <any>undefined;
        data['admissionDate'] = this.admissionDate ? this.admissionDate.toISOString() : <any>undefined;
        data['ipListDate'] = this.ipListDate ? this.ipListDate.toISOString() : <any>undefined;
        data['breachDate'] = this.breachDate ? this.breachDate.toISOString() : <any>undefined;
        data['currentStatusCode'] = this.currentStatusCode;
        data['currentStatusDate'] = this.currentStatusDate ? this.currentStatusDate.toISOString() : <any>undefined;
        data['sharedBreach'] = this.sharedBreach;
        data['procedureId'] = this.procedureId;
        data['suggestedTime'] = this.suggestedTime;
        data['suggestedTimeCalculationType'] = this.suggestedTimeCalculationType;
        data['isPreassessed'] = this.isPreassessed;
        data['comment'] = this.comment;
        data['intendedProcedureCode'] = this.intendedProcedureCode ? this.intendedProcedureCode.toJSON() : <any>undefined;
        data['pathway'] = this.pathway ? this.pathway.toJSON() : <any>undefined;
        data['workflowStatus'] = this.workflowStatus ? this.workflowStatus.toJSON() : <any>undefined;
        data['patient'] = this.patient ? this.patient.toJSON() : <any>undefined;
        data['speciality'] = this.speciality ? this.speciality.toJSON() : <any>undefined;
        data['consultant'] = this.consultant ? this.consultant.toJSON() : <any>undefined;
        if (Array.isArray(this.excluded)) {
            data['excluded'] = [];
            for (let item of this.excluded) data['excluded'].push(item.toJSON());
        }
        data['site'] = this.site ? this.site.toJSON() : <any>undefined;
        if (Array.isArray(this.metadataValues)) {
            data['metadataValues'] = [];
            for (let item of this.metadataValues) data['metadataValues'].push(item.toJSON());
        }
        data['admission'] = this.admission ? this.admission.toJSON() : <any>undefined;
        data['cohort'] = this.cohort ? this.cohort.toJSON() : <any>undefined;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWaitingList {
    id: string | undefined;
    referalDate: moment.Moment | undefined;
    daysWaiting: number | undefined;
    weeksWaiting: number | undefined;
    pathwayStartDate: moment.Moment | undefined;
    pathwayEndDate: moment.Moment | undefined;
    appointmentDate: moment.Moment | undefined;
    admissionDate: moment.Moment | undefined;
    ipListDate: moment.Moment | undefined;
    breachDate: moment.Moment | undefined;
    currentStatusCode: number | undefined;
    currentStatusDate: moment.Moment | undefined;
    sharedBreach: boolean | undefined;
    procedureId: string | undefined;
    suggestedTime: number | undefined;
    suggestedTimeCalculationType: SuggestedTimeCalculationType;
    isPreassessed: boolean | undefined;
    comment: string | undefined;
    intendedProcedureCode: OpcsCode;
    pathway: Pathway;
    workflowStatus: WorkflowStatus;
    patient: Patient;
    speciality: Speciality;
    consultant: Employee;
    excluded: ExcludedWaitingList[] | undefined;
    site: Site;
    metadataValues: MetadataValue[] | undefined;
    admission: Admission;
    cohort: Cohort;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class WaitingListDto implements IWaitingListDto {
    id: string | undefined;
    patient: PatientDto;
    consultant: EmployeeDto;
    pathway: Pathway;
    weeksWaiting: number | undefined;
    daysWaiting: number | undefined;
    suggestedTime: number | undefined;
    suggestedTimeCalculationType: SuggestedTimeCalculationType;
    isPreassessed: boolean | undefined;
    urgency: ThresholdTypes;
    daysToBreach: number | undefined;
    admission: string | undefined;
    comment: string | undefined;
    referalDate: moment.Moment | undefined;
    appointmentDate: moment.Moment | undefined;

    constructor(data?: IWaitingListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.patient = _data['patient'] ? PatientDto.fromJS(_data['patient']) : <any>undefined;
            this.consultant = _data['consultant'] ? EmployeeDto.fromJS(_data['consultant']) : <any>undefined;
            this.pathway = _data['pathway'] ? Pathway.fromJS(_data['pathway']) : <any>undefined;
            this.weeksWaiting = _data['weeksWaiting'];
            this.daysWaiting = _data['daysWaiting'];
            this.suggestedTime = _data['suggestedTime'];
            this.suggestedTimeCalculationType = _data['suggestedTimeCalculationType'];
            this.isPreassessed = _data['isPreassessed'];
            this.urgency = _data['urgency'];
            this.daysToBreach = _data['daysToBreach'];
            this.admission = _data['admission'];
            this.comment = _data['comment'];
            this.referalDate = _data['referalDate'] ? moment(_data['referalDate'].toString()) : <any>undefined;
            this.appointmentDate = _data['appointmentDate'] ? moment(_data['appointmentDate'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WaitingListDto {
        data = typeof data === 'object' ? data : {};
        let result = new WaitingListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['patient'] = this.patient ? this.patient.toJSON() : <any>undefined;
        data['consultant'] = this.consultant ? this.consultant.toJSON() : <any>undefined;
        data['pathway'] = this.pathway ? this.pathway.toJSON() : <any>undefined;
        data['weeksWaiting'] = this.weeksWaiting;
        data['daysWaiting'] = this.daysWaiting;
        data['suggestedTime'] = this.suggestedTime;
        data['suggestedTimeCalculationType'] = this.suggestedTimeCalculationType;
        data['isPreassessed'] = this.isPreassessed;
        data['urgency'] = this.urgency;
        data['daysToBreach'] = this.daysToBreach;
        data['admission'] = this.admission;
        data['comment'] = this.comment;
        data['referalDate'] = this.referalDate ? this.referalDate.toISOString() : <any>undefined;
        data['appointmentDate'] = this.appointmentDate ? this.appointmentDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWaitingListDto {
    id: string | undefined;
    patient: PatientDto;
    consultant: EmployeeDto;
    pathway: Pathway;
    weeksWaiting: number | undefined;
    daysWaiting: number | undefined;
    suggestedTime: number | undefined;
    suggestedTimeCalculationType: SuggestedTimeCalculationType;
    isPreassessed: boolean | undefined;
    urgency: ThresholdTypes;
    daysToBreach: number | undefined;
    admission: string | undefined;
    comment: string | undefined;
    referalDate: moment.Moment | undefined;
    appointmentDate: moment.Moment | undefined;
}

export class WaitingListFiltersDto implements IWaitingListFiltersDto {
    siteIds: number[] | undefined;
    specialityIds: number[] | undefined;
    consultantIds: number[] | undefined;
    selectedConsultantId: number | undefined;
    excludeScheduled: boolean;
    daycaseOnly: boolean;
    inpatientOnly: boolean;
    paediatricsOnly: boolean;
    adultsOnly: boolean;
    sessionVisitDate: moment.Moment | undefined;
    metadataFilters: { [key: string]: string } | undefined;
    cohortIds: number[] | undefined;

    constructor(data?: IWaitingListFiltersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data['siteIds'])) {
                this.siteIds = [] as any;
                for (let item of _data['siteIds']) this.siteIds.push(item);
            }
            if (Array.isArray(_data['specialityIds'])) {
                this.specialityIds = [] as any;
                for (let item of _data['specialityIds']) this.specialityIds.push(item);
            }
            if (Array.isArray(_data['consultantIds'])) {
                this.consultantIds = [] as any;
                for (let item of _data['consultantIds']) this.consultantIds.push(item);
            }
            this.selectedConsultantId = _data['selectedConsultantId'];
            this.excludeScheduled = _data['excludeScheduled'];
            this.daycaseOnly = _data['daycaseOnly'];
            this.inpatientOnly = _data['inpatientOnly'];
            this.paediatricsOnly = _data['paediatricsOnly'];
            this.adultsOnly = _data['adultsOnly'];
            this.sessionVisitDate = _data['sessionVisitDate'] ? moment(_data['sessionVisitDate'].toString()) : <any>undefined;
            if (_data['metadataFilters']) {
                this.metadataFilters = {} as any;
                for (let key in _data['metadataFilters']) {
                    if (_data['metadataFilters'].hasOwnProperty(key)) (<any>this.metadataFilters)[key] = _data['metadataFilters'][key];
                }
            }
            if (Array.isArray(_data['cohortIds'])) {
                this.cohortIds = [] as any;
                for (let item of _data['cohortIds']) this.cohortIds.push(item);
            }
        }
    }

    static fromJS(data: any): WaitingListFiltersDto {
        data = typeof data === 'object' ? data : {};
        let result = new WaitingListFiltersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.siteIds)) {
            data['siteIds'] = [];
            for (let item of this.siteIds) data['siteIds'].push(item);
        }
        if (Array.isArray(this.specialityIds)) {
            data['specialityIds'] = [];
            for (let item of this.specialityIds) data['specialityIds'].push(item);
        }
        if (Array.isArray(this.consultantIds)) {
            data['consultantIds'] = [];
            for (let item of this.consultantIds) data['consultantIds'].push(item);
        }
        data['selectedConsultantId'] = this.selectedConsultantId;
        data['excludeScheduled'] = this.excludeScheduled;
        data['daycaseOnly'] = this.daycaseOnly;
        data['inpatientOnly'] = this.inpatientOnly;
        data['paediatricsOnly'] = this.paediatricsOnly;
        data['adultsOnly'] = this.adultsOnly;
        data['sessionVisitDate'] = this.sessionVisitDate ? this.sessionVisitDate.toISOString() : <any>undefined;
        if (this.metadataFilters) {
            data['metadataFilters'] = {};
            for (let key in this.metadataFilters) {
                if (this.metadataFilters.hasOwnProperty(key)) (<any>data['metadataFilters'])[key] = (<any>this.metadataFilters)[key];
            }
        }
        if (Array.isArray(this.cohortIds)) {
            data['cohortIds'] = [];
            for (let item of this.cohortIds) data['cohortIds'].push(item);
        }
        return data;
    }
}

export interface IWaitingListFiltersDto {
    siteIds: number[] | undefined;
    specialityIds: number[] | undefined;
    consultantIds: number[] | undefined;
    selectedConsultantId: number | undefined;
    excludeScheduled: boolean;
    daycaseOnly: boolean;
    inpatientOnly: boolean;
    paediatricsOnly: boolean;
    adultsOnly: boolean;
    sessionVisitDate: moment.Moment | undefined;
    metadataFilters: { [key: string]: string } | undefined;
    cohortIds: number[] | undefined;
}

export class WorkflowStatus implements IWorkflowStatus {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;

    constructor(data?: IWorkflowStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data['id'];
            this.name = _data['name'];
            this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
            this.lastModificationTime = _data['lastModificationTime'] ? moment(_data['lastModificationTime'].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WorkflowStatus {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data['id'] = this.id;
        data['name'] = this.name;
        data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data['lastModificationTime'] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IWorkflowStatus {
    id: number;
    name: string;
    creationTime: moment.Moment;
    lastModificationTime: moment.Moment | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any }, result?: any): Observable<any> {
    if (result !== null && result !== undefined) return Observable.throw(result);
    else return Observable.throw(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next('');
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = (event) => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}




// WEBPACK FOOTER //
// ./src/shared/service-proxies/service-proxies.ts